import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  JSON: any;
  Upload: any;
};

export type AffectedPanelBookingsDateInput = {
  first_week?: InputMaybe<Scalars['String']>;
  last_week?: InputMaybe<Scalars['String']>;
  panelId: Scalars['ID'];
  status: Scalars['String'];
};

export type Ambient = {
  __typename?: 'Ambient';
  ambientType?: Maybe<AmbientType>;
  campaignComponent?: Maybe<CampaignComponent>;
  creation_id?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  regionType?: Maybe<RegionType>;
  start_date?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


export type AmbientAmbientTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AmbientRegionTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type AmbientType = {
  __typename?: 'AmbientType';
  creation_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type AreaBooking = {
  __typename?: 'AreaBooking';
  areaBookingItems?: Maybe<Array<Maybe<AreaBookingItem>>>;
  bay_number?: Maybe<Scalars['Int']>;
  campaign?: Maybe<Campaign>;
  creation_id?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  first_up?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_photo_paid_ab?: Maybe<Scalars['String']>;
  last_down?: Maybe<Scalars['String']>;
  london_instructions?: Maybe<Scalars['String']>;
  num_posters?: Maybe<Scalars['Int']>;
  num_weeks?: Maybe<Scalars['Int']>;
  posterSize?: Maybe<PosterSize>;
  poster_size?: Maybe<Scalars['Int']>;
  posters_received?: Maybe<Scalars['String']>;
  price_divisor?: Maybe<Scalars['Int']>;
  rating?: Maybe<Scalars['Int']>;
  regionType?: Maybe<RegionType>;
  special_instructions?: Maybe<Scalars['String']>;
  total_value?: Maybe<Scalars['Int']>;
  unit_value?: Maybe<Scalars['Int']>;
  unit_value_local?: Maybe<Scalars['Int']>;
  unit_value_prescribed?: Maybe<Scalars['Int']>;
  unit_value_prescribed_local?: Maybe<Scalars['Int']>;
};


export type AreaBookingCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AreaBookingPosterSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AreaBookingRegionTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type AreaBookingItem = {
  __typename?: 'AreaBookingItem';
  areaBooking?: Maybe<AreaBooking>;
  areaBookingZone?: Maybe<AreaBookingZone>;
  campaign?: Maybe<Campaign>;
  campaignComponent?: Maybe<CampaignComponent>;
  created_at?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  currency_id?: Maybe<Scalars['ID']>;
  date_down?: Maybe<Scalars['String']>;
  date_up?: Maybe<Scalars['String']>;
  deal_price?: Maybe<Scalars['Int']>;
  distributor?: Maybe<Distributor>;
  id: Scalars['ID'];
  is_completed?: Maybe<Scalars['Boolean']>;
  is_distributed?: Maybe<Scalars['Boolean']>;
  is_received?: Maybe<Scalars['Boolean']>;
  is_subcontracted?: Maybe<Scalars['Boolean']>;
  notes?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  qty_posters_per_site?: Maybe<Scalars['Int']>;
  qty_sites?: Maybe<Scalars['Int']>;
  quantity_distributed?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  unit_value?: Maybe<Scalars['Int']>;
  unit_value_local?: Maybe<Scalars['Int']>;
};


export type AreaBookingItemDistributorArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AreaBookingItemRegionArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type AreaBookingPricing = {
  __typename?: 'AreaBookingPricing';
  creation_id?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  posterSize?: Maybe<PosterSize>;
  regionType?: Maybe<RegionType>;
  unit_value?: Maybe<Scalars['Int']>;
};


export type AreaBookingPricingCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AreaBookingPricingPosterSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AreaBookingPricingRegionTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type AreaBookingRegionPricing = {
  __typename?: 'AreaBookingRegionPricing';
  creation_id?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  posterSize?: Maybe<PosterSize>;
  region?: Maybe<Region>;
  unit_value?: Maybe<Scalars['Int']>;
};


export type AreaBookingRegionPricingCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AreaBookingRegionPricingPosterSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type AreaBookingRegionPricingRegionArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type AreaBookingZone = {
  __typename?: 'AreaBookingZone';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type AuthPayload = {
  __typename?: 'AuthPayload';
  access_token: Scalars['String'];
  expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token_type: Scalars['String'];
  user: User;
};

export type AuthenticatorCode = {
  __typename?: 'AuthenticatorCode';
  code?: Maybe<Scalars['String']>;
};

export type Borough = {
  __typename?: 'Borough';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of Borough items. */
export type BoroughPaginator = {
  __typename?: 'BoroughPaginator';
  /** A list of Borough items. */
  data: Array<Borough>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Campaign = {
  __typename?: 'Campaign';
  ambients?: Maybe<Array<Maybe<Ambient>>>;
  areaBookings?: Maybe<Array<Maybe<AreaBooking>>>;
  artworkFiles?: Maybe<Array<Maybe<File>>>;
  artwork_received_date?: Maybe<Scalars['String']>;
  authorizationFiles?: Maybe<Array<Maybe<File>>>;
  campaignExchangeRates?: Maybe<Array<Maybe<CampaignExchangeRate>>>;
  campaignFiles?: Maybe<Array<Maybe<File>>>;
  campaignSignatures?: Maybe<Array<Maybe<CampaignSignature>>>;
  clientCompany?: Maybe<ClientCompany>;
  clientCompanyContact?: Maybe<ClientCompanyContact>;
  clientSubType?: Maybe<ClientSubType>;
  clientType?: Maybe<ClientType>;
  completion_date?: Maybe<Scalars['String']>;
  components?: Maybe<Array<Maybe<CampaignComponent>>>;
  confirmationEntry?: Maybe<LogEntry>;
  contractSections?: Maybe<Array<Maybe<ContractSection>>>;
  costs?: Maybe<Array<Maybe<Cost>>>;
  created_at?: Maybe<Scalars['String']>;
  creativeStudio?: Maybe<Array<Maybe<CreativeStudio>>>;
  creativeStudioEntries?: Maybe<Array<Maybe<CreativeStudioEntry>>>;
  currencies?: Maybe<Array<Maybe<Currency>>>;
  currency?: Maybe<Currency>;
  digitalBookings?: Maybe<Array<Maybe<DigitalBooking>>>;
  discount_final?: Maybe<Scalars['Int']>;
  discount_percentage?: Maybe<Scalars['Float']>;
  discountableTotal?: Maybe<Scalars['Int']>;
  duration?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  epos_artwork_reviewed?: Maybe<Scalars['Boolean']>;
  event?: Maybe<Scalars['String']>;
  experientials?: Maybe<Array<Maybe<Experiential>>>;
  externalPortfolioUrl?: Maybe<Scalars['String']>;
  fringe_user_email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inboundChallenges?: Maybe<Array<Maybe<CampaignChallenge>>>;
  inboundFiles?: Maybe<Array<Maybe<File>>>;
  invoice?: Maybe<Scalars['String']>;
  invoiceFiles?: Maybe<Array<Maybe<File>>>;
  is_locked?: Maybe<Scalars['Boolean']>;
  is_purchase_order_required?: Maybe<Scalars['Boolean']>;
  is_vat_exempt?: Maybe<Scalars['Boolean']>;
  job_reference?: Maybe<Scalars['String']>;
  manually_unlocked?: Maybe<Scalars['Boolean']>;
  margin?: Maybe<Scalars['String']>;
  mediaProductions?: Maybe<Array<Maybe<MediaProduction>>>;
  media_production_notes?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextcloud_pops_view_url?: Maybe<Scalars['String']>;
  nextcloud_share_url?: Maybe<Scalars['String']>;
  nextcloud_view_url?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  ourContact?: Maybe<User>;
  outboundChallenges?: Maybe<Array<Maybe<CampaignChallenge>>>;
  outboundFiles?: Maybe<Array<Maybe<File>>>;
  paid_date?: Maybe<Scalars['String']>;
  panelBookings?: Maybe<Array<Maybe<PanelBooking>>>;
  paymentTerms?: Maybe<PaymentTerm>;
  payment_bank?: Maybe<Scalars['String']>;
  photoPaidTotal: Scalars['Int'];
  photo_paid_total?: Maybe<Scalars['Int']>;
  popsFiles?: Maybe<Array<Maybe<File>>>;
  pops_url?: Maybe<Scalars['String']>;
  portfolio_hash?: Maybe<Scalars['String']>;
  portfolio_paris_insurance?: Maybe<Scalars['Boolean']>;
  portfolio_show_impacts?: Maybe<Scalars['Boolean']>;
  portfolio_small_sites?: Maybe<Scalars['Boolean']>;
  portfolio_summary?: Maybe<Scalars['String']>;
  portfolio_title?: Maybe<Scalars['String']>;
  posters_received?: Maybe<Scalars['String']>;
  previewTags?: Maybe<Array<Maybe<CampaignTag>>>;
  purchase_order?: Maybe<Scalars['String']>;
  regionalAmAllocation?: Maybe<Region>;
  reportingCurrency?: Maybe<Currency>;
  rigging_down_at?: Maybe<Scalars['DateTime']>;
  rigging_up_at?: Maybe<Scalars['DateTime']>;
  salesTeam?: Maybe<SalesTeam>;
  sales_job_ref?: Maybe<Scalars['String']>;
  start_date?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  sub_teams_scotland?: Maybe<Scalars['String']>;
  sundries?: Maybe<Array<Maybe<Sundry>>>;
  totalCost?: Maybe<Scalars['Int']>;
  totalCostReporting?: Maybe<Scalars['Int']>;
  totalCosts?: Maybe<Scalars['Int']>;
  totalCostsReporting?: Maybe<Scalars['Int']>;
  total_price?: Maybe<Scalars['Int']>;
  total_price_reporting?: Maybe<Scalars['Int']>;
  totals?: Maybe<CampaignTotals>;
  totalsReporting?: Maybe<CampaignTotals>;
  type?: Maybe<Scalars['String']>;
  undiscountableTotal?: Maybe<Scalars['Int']>;
};


export type CampaignClientCompanyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignClientCompanyContactArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignClientSubTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignClientTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignCurrenciesArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignOurContactArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignPanelBookingsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type CampaignRegionalAmAllocationArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignSalesTeamArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type CampaignChallenge = {
  __typename?: 'CampaignChallenge';
  bookingChallenges?: Maybe<Array<Maybe<CampaignChallengeBooking>>>;
  campaign?: Maybe<Campaign>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inboundRecent?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  outboundRecent?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type CampaignChallengeBooking = {
  __typename?: 'CampaignChallengeBooking';
  date_end?: Maybe<Scalars['String']>;
  date_start?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  sourcePanelBooking?: Maybe<PanelBooking>;
  status?: Maybe<Scalars['String']>;
  targetCampaign?: Maybe<Campaign>;
  targetPanelBooking?: Maybe<PanelBooking>;
  user?: Maybe<User>;
  week_end?: Maybe<Scalars['Int']>;
  week_start?: Maybe<Scalars['Int']>;
};

export type CampaignComponent = {
  __typename?: 'CampaignComponent';
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  price_divisor?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  regionType?: Maybe<RegionType>;
  total?: Maybe<Scalars['Int']>;
  total_local?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  unit_value?: Maybe<Scalars['Int']>;
  unit_value_actual?: Maybe<Scalars['Int']>;
  unit_value_estimated?: Maybe<Scalars['Int']>;
  unit_value_estimated_local?: Maybe<Scalars['Int']>;
  unit_value_local?: Maybe<Scalars['Int']>;
  unit_value_prescribed?: Maybe<Scalars['Int']>;
  unit_value_prescribed_local?: Maybe<Scalars['Int']>;
};


export type CampaignComponentCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignComponentRegionArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignComponentRegionTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type CampaignComponentInput = {
  currency?: InputMaybe<UpdateRelation>;
  id: Scalars['ID'];
  price_divisor?: InputMaybe<Scalars['Int']>;
  qty?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<UpdateRelation>;
  regionType?: InputMaybe<UpdateRelation>;
  unit_value_actual?: InputMaybe<Scalars['Int']>;
  unit_value_estimated_local?: InputMaybe<Scalars['Int']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
  unit_value_prescribed_local?: InputMaybe<Scalars['Int']>;
};

export type CampaignExchangeRate = {
  __typename?: 'CampaignExchangeRate';
  from?: Maybe<Scalars['ID']>;
  rate?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['ID']>;
};

/** A paginated list of Campaign items. */
export type CampaignPaginator = {
  __typename?: 'CampaignPaginator';
  /** A list of Campaign items. */
  data: Array<Campaign>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CampaignSignature = {
  __typename?: 'CampaignSignature';
  campaign?: Maybe<Campaign>;
  createdBy?: Maybe<User>;
  created_at?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  first_accessed?: Maybe<Scalars['String']>;
  graphqlContractUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_manual?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  signed_on?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};


export type CampaignSignatureCampaignArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CampaignSignatureCreatedByArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type CampaignTag = {
  __typename?: 'CampaignTag';
  code?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  section_code?: Maybe<Scalars['String']>;
};

/** A paginated list of CampaignTag items. */
export type CampaignTagPaginator = {
  __typename?: 'CampaignTagPaginator';
  /** A list of CampaignTag items. */
  data: Array<CampaignTag>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CampaignTotals = {
  __typename?: 'CampaignTotals';
  ambient?: Maybe<Scalars['Int']>;
  area_booking?: Maybe<Scalars['Int']>;
  creativestudio?: Maybe<Scalars['Int']>;
  digital_booking?: Maybe<Scalars['Int']>;
  experiential?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  media_production?: Maybe<Scalars['Int']>;
  panel_booking?: Maybe<Scalars['Int']>;
  sundry?: Maybe<Scalars['Int']>;
};

export type ChallengePanelBookingArrayInput = {
  challenges?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ClientCompany = {
  __typename?: 'ClientCompany';
  accounts_account_code?: Maybe<Scalars['String']>;
  accounts_address?: Maybe<Scalars['String']>;
  accounts_comments?: Maybe<Scalars['String']>;
  accounts_company?: Maybe<Scalars['String']>;
  accounts_contact?: Maybe<Scalars['String']>;
  accounts_email?: Maybe<Scalars['String']>;
  accounts_phone?: Maybe<Scalars['String']>;
  accounts_postcode?: Maybe<Scalars['String']>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  clientCompanyGroup?: Maybe<ClientCompanyGroup>;
  clientType?: Maybe<ClientType>;
  contacts?: Maybe<Array<Maybe<ClientCompanyContact>>>;
  credit_limit?: Maybe<Scalars['Int']>;
  current_credit?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  invoice_factored?: Maybe<Scalars['Boolean']>;
  is_po_required?: Maybe<Scalars['Boolean']>;
  is_vat_exempt?: Maybe<Scalars['Boolean']>;
  other_contacts?: Maybe<Scalars['String']>;
  sales_address?: Maybe<Scalars['String']>;
  sales_company?: Maybe<Scalars['String']>;
  sales_contact?: Maybe<Scalars['String']>;
  sales_mobile?: Maybe<Scalars['String']>;
  sales_phone?: Maybe<Scalars['String']>;
  sales_postcode?: Maybe<Scalars['String']>;
  sales_title?: Maybe<Scalars['String']>;
  sales_type?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type ClientCompanyClientCompanyGroupArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type ClientCompanyClientTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type ClientCompanyContactsArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type ClientCompanyContact = {
  __typename?: 'ClientCompanyContact';
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  clientCompany?: Maybe<ClientCompany>;
  comments?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_mailchimp?: Maybe<Scalars['Boolean']>;
  is_marketing?: Maybe<Scalars['Boolean']>;
  is_sales?: Maybe<Scalars['Boolean']>;
  job_sheet_info?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phone_alt?: Maybe<Scalars['String']>;
  salesTeam?: Maybe<SalesTeam>;
  title?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type ClientCompanyContactClientCompanyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type ClientCompanyContactSalesTeamArgs = {
  trashed?: InputMaybe<Trashed>;
};

/** A paginated list of ClientCompanyContact items. */
export type ClientCompanyContactPaginator = {
  __typename?: 'ClientCompanyContactPaginator';
  /** A list of ClientCompanyContact items. */
  data: Array<ClientCompanyContact>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClientCompanyGroup = {
  __typename?: 'ClientCompanyGroup';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of ClientCompanyGroup items. */
export type ClientCompanyGroupPaginator = {
  __typename?: 'ClientCompanyGroupPaginator';
  /** A list of ClientCompanyGroup items. */
  data: Array<ClientCompanyGroup>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of ClientCompany items. */
export type ClientCompanyPaginator = {
  __typename?: 'ClientCompanyPaginator';
  /** A list of ClientCompany items. */
  data: Array<ClientCompany>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClientSubType = {
  __typename?: 'ClientSubType';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sales_team_prefix?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of ClientSubType items. */
export type ClientSubTypePaginator = {
  __typename?: 'ClientSubTypePaginator';
  /** A list of ClientSubType items. */
  data: Array<ClientSubType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ClientType = {
  __typename?: 'ClientType';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  supports_commission?: Maybe<Scalars['Boolean']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of ClientType items. */
export type ClientTypePaginator = {
  __typename?: 'ClientTypePaginator';
  /** A list of ClientType items. */
  data: Array<ClientType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ContractBlock = {
  __typename?: 'ContractBlock';
  content?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  files?: Maybe<Array<Maybe<File>>>;
  id: Scalars['ID'];
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ContractSection = {
  __typename?: 'ContractSection';
  blocks?: Maybe<Array<Maybe<ContractBlock>>>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  new_page?: Maybe<Scalars['Boolean']>;
  show_title?: Maybe<Scalars['Boolean']>;
  sort?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type ContractTemplate = {
  __typename?: 'ContractTemplate';
  creation_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  sections?: Maybe<Array<Maybe<ContractSection>>>;
  sort?: Maybe<Scalars['Int']>;
};

export type ContractVersion = {
  __typename?: 'ContractVersion';
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  tree?: Maybe<Scalars['JSON']>;
  user?: Maybe<User>;
};

export type ContractVersionSummary = {
  __typename?: 'ContractVersionSummary';
  id: Scalars['ID'];
  occurredAt: Scalars['String'];
  user?: Maybe<User>;
};

export type Cost = {
  __typename?: 'Cost';
  campaign?: Maybe<Campaign>;
  campaignComponent?: Maybe<CampaignComponent>;
  costSupplier?: Maybe<CostSupplier>;
  cost_type?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice_number?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  supplier_code?: Maybe<Scalars['String']>;
};


export type CostCostSupplierArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type CostSupplier = {
  __typename?: 'CostSupplier';
  code?: Maybe<Scalars['String']>;
  costSupplierCategory?: Maybe<CostSupplierCategory>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type CostSupplierCostSupplierCategoryArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type CostSupplierCategory = {
  __typename?: 'CostSupplierCategory';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of CostSupplierCategory items. */
export type CostSupplierCategoryPaginator = {
  __typename?: 'CostSupplierCategoryPaginator';
  /** A list of CostSupplierCategory items. */
  data: Array<CostSupplierCategory>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** A paginated list of CostSupplier items. */
export type CostSupplierPaginator = {
  __typename?: 'CostSupplierPaginator';
  /** A list of CostSupplier items. */
  data: Array<CostSupplier>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type CreateAmbientInput = {
  ambientType?: InputMaybe<UpdateRelation>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  end_date: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  start_date: Scalars['String'];
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type CreateAmbientTypeInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateAreaBookingInput = {
  areaBookingItems?: InputMaybe<UpdateAreaBookingItems>;
  bay_number?: InputMaybe<Scalars['Int']>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<UpdateRelation>;
  currency_id?: InputMaybe<Scalars['ID']>;
  first_up?: InputMaybe<Scalars['String']>;
  is_photo_paid_ab?: InputMaybe<Scalars['String']>;
  last_down?: InputMaybe<Scalars['String']>;
  london_instructions?: InputMaybe<Scalars['String']>;
  num_posters?: InputMaybe<Scalars['Int']>;
  num_weeks?: InputMaybe<Scalars['Int']>;
  posterSize?: InputMaybe<UpdateRelation>;
  posters_received?: InputMaybe<Scalars['String']>;
  price_divisor?: InputMaybe<Scalars['Int']>;
  qty_posters_per_site?: InputMaybe<Scalars['Int']>;
  qty_sites?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
  regionType?: InputMaybe<UpdateRelation>;
  special_instructions?: InputMaybe<Scalars['String']>;
  total_value?: InputMaybe<Scalars['Int']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
  unit_value_prescribed_local?: InputMaybe<Scalars['Int']>;
};

export type CreateAreaBookingItemInput = {
  areaBookingZone?: InputMaybe<UpdateRelation>;
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  date_down?: InputMaybe<Scalars['String']>;
  date_up?: InputMaybe<Scalars['String']>;
  deal_price?: InputMaybe<Scalars['Int']>;
  distributor?: InputMaybe<UpdateRelation>;
  is_completed?: InputMaybe<Scalars['Boolean']>;
  is_distributed?: InputMaybe<Scalars['Boolean']>;
  is_received?: InputMaybe<Scalars['Boolean']>;
  is_subcontracted?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  qty_posters_per_site?: InputMaybe<Scalars['Int']>;
  qty_sites?: InputMaybe<Scalars['Int']>;
  quantity_distributed?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
};

export type CreateAreaBookingRegionPricing = {
  currency?: InputMaybe<UpdateRelation>;
  posterSize?: InputMaybe<UpdateRelation>;
  region?: InputMaybe<UpdateRelation>;
  unit_value?: InputMaybe<Scalars['Int']>;
};

export type CreateBoroughInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateCampaignChallengeInput = {
  campaign_id?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  panelBookings?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type CreateCampaignInput = {
  ambients?: InputMaybe<UpdateAmbients>;
  areaBookings?: InputMaybe<UpdateAreaBookings>;
  artworkFiles?: InputMaybe<UpdateFiles>;
  artwork_received_date?: InputMaybe<Scalars['String']>;
  authorizationFiles?: InputMaybe<UpdateFiles>;
  clientCompany?: InputMaybe<UpdateRelation>;
  clientCompanyContact?: InputMaybe<UpdateRelation>;
  clientSubType?: InputMaybe<UpdateRelation>;
  clientType?: InputMaybe<UpdateRelation>;
  completion_date?: InputMaybe<Scalars['String']>;
  contractSections?: InputMaybe<UpdateContractSections>;
  costs?: InputMaybe<UpdateCosts>;
  creativeStudio?: InputMaybe<UpdateCreativeStudio>;
  creativeStudioEntries?: InputMaybe<UpdateCreativeStudioEntries>;
  currencies?: InputMaybe<UpdateRelationArray>;
  currency?: InputMaybe<UpdateRelation>;
  digitalBookings?: InputMaybe<UpdateDigitalBookings>;
  discount_final?: InputMaybe<Scalars['Int']>;
  discount_percentage?: InputMaybe<Scalars['Float']>;
  discountableTotal?: InputMaybe<Scalars['Int']>;
  epos_artwork_reviewed?: InputMaybe<Scalars['Boolean']>;
  event?: InputMaybe<Scalars['String']>;
  experientials?: InputMaybe<UpdateExperientials>;
  fringe_user_email?: InputMaybe<Scalars['String']>;
  invoice?: InputMaybe<Scalars['String']>;
  invoiceFiles?: InputMaybe<UpdateFiles>;
  is_purchase_order_required?: InputMaybe<Scalars['Boolean']>;
  is_vat_exempt?: InputMaybe<Scalars['Boolean']>;
  job_reference?: InputMaybe<Scalars['String']>;
  job_reference_displayed?: InputMaybe<Scalars['String']>;
  mediaProductions?: InputMaybe<UpdateMediaProductions>;
  media_production_notes?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ourContact?: InputMaybe<UpdateRelation>;
  panelBookings?: InputMaybe<UpdatePanelBookings>;
  paymentTerms?: InputMaybe<UpdateRelation>;
  popsFiles?: InputMaybe<UpdateFiles>;
  portfolio_hash?: InputMaybe<Scalars['String']>;
  portfolio_paris_insurance?: InputMaybe<Scalars['Boolean']>;
  portfolio_show_impacts?: InputMaybe<Scalars['Boolean']>;
  portfolio_small_sites?: InputMaybe<Scalars['Boolean']>;
  portfolio_summary?: InputMaybe<Scalars['String']>;
  portfolio_title?: InputMaybe<Scalars['String']>;
  posters_received?: InputMaybe<Scalars['String']>;
  previewTags?: InputMaybe<UpdateRelationArray>;
  purchase_order?: InputMaybe<Scalars['String']>;
  region_id?: InputMaybe<Scalars['ID']>;
  regionalAmAllocation?: InputMaybe<UpdateRelation>;
  rigging_down_at?: InputMaybe<Scalars['DateTime']>;
  rigging_up_at?: InputMaybe<Scalars['DateTime']>;
  salesTeam?: InputMaybe<UpdateRelation>;
  sales_job_ref?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  sub_teams_scotland?: InputMaybe<Scalars['String']>;
  sundries?: InputMaybe<UpdateSundries>;
  totalCost?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  undiscountableTotal?: InputMaybe<Scalars['Int']>;
};

export type CreateCampaignSignatureInput = {
  campaign_id?: InputMaybe<Scalars['ID']>;
  creation_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
};

export type CreateCampaignTagInput = {
  code?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  section_code?: InputMaybe<Scalars['String']>;
};

export type CreateClientCompanyContactInput = {
  clientCompany?: InputMaybe<UpdateRelation>;
  comments?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  is_mailchimp?: InputMaybe<Scalars['Boolean']>;
  is_marketing?: InputMaybe<Scalars['Boolean']>;
  is_sales?: InputMaybe<Scalars['Boolean']>;
  job_sheet_info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_alt?: InputMaybe<Scalars['String']>;
  salesTeam?: InputMaybe<UpdateRelation>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateClientCompanyGroupInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateClientCompanyInput = {
  accounts_account_code?: InputMaybe<Scalars['String']>;
  accounts_address?: InputMaybe<Scalars['String']>;
  accounts_comments?: InputMaybe<Scalars['String']>;
  accounts_company?: InputMaybe<Scalars['String']>;
  accounts_contact?: InputMaybe<Scalars['String']>;
  accounts_email?: InputMaybe<Scalars['String']>;
  accounts_phone?: InputMaybe<Scalars['String']>;
  accounts_postcode?: InputMaybe<Scalars['String']>;
  clientCompanyGroup?: InputMaybe<UpdateRelation>;
  clientType?: InputMaybe<UpdateRelation>;
  credit_limit?: InputMaybe<Scalars['Int']>;
  current_credit?: InputMaybe<Scalars['Int']>;
  invoice_factored?: InputMaybe<Scalars['Boolean']>;
  is_po_required?: InputMaybe<Scalars['Boolean']>;
  is_vat_exempt?: InputMaybe<Scalars['Boolean']>;
  other_contacts?: InputMaybe<Scalars['String']>;
  sales_address?: InputMaybe<Scalars['String']>;
  sales_company?: InputMaybe<Scalars['String']>;
  sales_contact?: InputMaybe<Scalars['String']>;
  sales_mobile?: InputMaybe<Scalars['String']>;
  sales_phone?: InputMaybe<Scalars['String']>;
  sales_postcode?: InputMaybe<Scalars['String']>;
  sales_title?: InputMaybe<Scalars['String']>;
  sales_type?: InputMaybe<Scalars['String']>;
};

export type CreateClientSubTypeInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateContractBlockInput = {
  content?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<UpdateFiles>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateContractSectionInput = {
  blocks?: InputMaybe<UpdateContractBlocks>;
  creation_id?: InputMaybe<Scalars['String']>;
  new_page?: InputMaybe<Scalars['Boolean']>;
  show_title?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CreateContractTemplateInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<UpdateContractSections>;
  sort?: InputMaybe<Scalars['Int']>;
};

export type CreateCostInput = {
  costSupplier?: InputMaybe<UpdateRelation>;
  cost_type?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  supplier_code?: InputMaybe<Scalars['String']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type CreateCostSupplierCategoryInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateCostSupplierInput = {
  code?: InputMaybe<Scalars['String']>;
  costSupplierCategory?: InputMaybe<UpdateRelation>;
  creation_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateCreativeStudioEntryInput = {
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['ID']>;
  qty?: InputMaybe<Scalars['Int']>;
  unit_value_actual?: InputMaybe<Scalars['Int']>;
  unit_value_estimated_local?: InputMaybe<Scalars['Int']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type CreateCreativeStudioInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  creativeStudioType?: InputMaybe<UpdateRelation>;
  creativeStudioTypeDetail?: InputMaybe<UpdateRelation>;
  currency_id?: InputMaybe<Scalars['ID']>;
  end_date: Scalars['String'];
  notes?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  start_date: Scalars['String'];
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type CreateCurrencyInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  glyph?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateDigitalBookingInput = {
  agency_discount?: InputMaybe<Scalars['Int']>;
  campaign_id: Scalars['ID'];
  cost_type: Scalars['String'];
  days: Scalars['Int'];
  end_date: Scalars['String'];
  region_id: Scalars['ID'];
  region_type_id: Scalars['ID'];
  site_id: Scalars['ID'];
  start_date: Scalars['String'];
  unit_value_local: Scalars['Int'];
};

export type CreateDistributorInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateExchangeRateInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  from?: InputMaybe<UpdateRelation>;
  rate?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<UpdateRelation>;
};

export type CreateExperientialInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  end_date: Scalars['String'];
  experientialType?: InputMaybe<UpdateRelation>;
  name?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  start_date: Scalars['String'];
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type CreateExperientialTypeInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateMaintenanceInspectionInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  last_inspection_date?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  site: UpdateRelation;
  siteMaintenanceInspectionType?: InputMaybe<UpdateRelation>;
};

export type CreateMaintenanceInspectionNestedInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  last_inspection_date?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  siteMaintenanceInspectionType?: InputMaybe<UpdateRelation>;
};

export type CreateMediaProductionInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  mediaType?: InputMaybe<UpdateRelation>;
  notes?: InputMaybe<Scalars['String']>;
  price_divisor?: InputMaybe<Scalars['Int']>;
  qty: Scalars['Int'];
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  size?: InputMaybe<UpdateRelation>;
  unit_value_local: Scalars['Int'];
};

export type CreateMediaTypeInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateOptionInput = {
  bool_value?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  int_value?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  text_value?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreatePackInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<UpdateRelation>;
};

export type CreatePanelAvailabilityInput = {
  availability?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  first_week?: InputMaybe<Scalars['String']>;
  last_week?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type CreatePanelBooking = {
  campaignId?: InputMaybe<Scalars['ID']>;
  isSlot?: InputMaybe<Scalars['Boolean']>;
  numWeeks?: InputMaybe<Scalars['Int']>;
  panelId?: InputMaybe<Scalars['ID']>;
  posterSizeId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  weekNumber?: InputMaybe<Scalars['Int']>;
};

export type CreatePanelBookingInput = {
  campaign?: InputMaybe<UpdateRelation>;
  creation_id?: InputMaybe<Scalars['String']>;
  first_week?: InputMaybe<Scalars['String']>;
  free?: InputMaybe<FreeType>;
  instructions?: InputMaybe<Scalars['String']>;
  is_pencil?: InputMaybe<Scalars['Boolean']>;
  is_photo_paid?: InputMaybe<Scalars['String']>;
  is_received?: InputMaybe<Scalars['Boolean']>;
  is_slot?: InputMaybe<Scalars['Boolean']>;
  last_week?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  panel?: InputMaybe<UpdateRelation>;
  posterSize?: InputMaybe<UpdateRelation>;
  qty?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  unit_value?: InputMaybe<Scalars['Int']>;
  value?: InputMaybe<Scalars['Int']>;
  weeks?: InputMaybe<Scalars['Int']>;
};

export type CreatePanelInput = {
  code?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  number_of_slots?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<Scalars['String']>;
  pack?: InputMaybe<UpdateRelation>;
  panel?: InputMaybe<Scalars['String']>;
  panelAvailabilities?: InputMaybe<UpdatePanelAvailabilities>;
  postInstruction?: InputMaybe<UpdateRelation>;
  posters_per_slot?: InputMaybe<Scalars['Int']>;
  restriction?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<UpdateRelation>;
  status?: InputMaybe<Scalars['String']>;
};

export type CreatePosterSizeInput = {
  actual_60_40?: InputMaybe<Scalars['Float']>;
  creation_id?: InputMaybe<Scalars['String']>;
  customer_name?: InputMaybe<Scalars['String']>;
  dc_type?: InputMaybe<Scalars['String']>;
  effective_poster_count?: InputMaybe<Scalars['Int']>;
  festivalCurrencyId?: InputMaybe<Scalars['ID']>;
  festivalPricing?: InputMaybe<Scalars['Int']>;
  image_caption?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<UpdateFiles>;
  internationalCurrencyId?: InputMaybe<Scalars['Int']>;
  internationalPricing?: InputMaybe<Scalars['Int']>;
  is_60_40?: InputMaybe<Scalars['Int']>;
  is_larger_than_4?: InputMaybe<Scalars['Boolean']>;
  is_media_type?: InputMaybe<Scalars['Boolean']>;
  is_panel_poster?: InputMaybe<Scalars['Boolean']>;
  is_street_poster?: InputMaybe<Scalars['Boolean']>;
  londonCurrencyId?: InputMaybe<Scalars['ID']>;
  londonPricing?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionalCurrencyId?: InputMaybe<Scalars['ID']>;
  regionalPricing?: InputMaybe<Scalars['Int']>;
  slotPosterSize?: InputMaybe<UpdateRelation>;
  slot_poster_count?: InputMaybe<Scalars['Int']>;
};

export type CreateRegionInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  example_map_string?: InputMaybe<Scalars['String']>;
  is_area_booking?: InputMaybe<Scalars['Boolean']>;
  is_panel_booking?: InputMaybe<Scalars['Boolean']>;
  manual_area_booking_pricing?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  regionType?: InputMaybe<UpdateRelation>;
};

export type CreateRegionTypeInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  has_poster_pricing?: InputMaybe<Scalars['Boolean']>;
  has_regional_pricing?: InputMaybe<Scalars['Boolean']>;
  has_split_qty?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  pricing_model?: InputMaybe<Scalars['String']>;
};

export type CreateRoleInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<UpdateRelationArray>;
};

export type CreateSalesTeamInput = {
  city?: InputMaybe<Scalars['String']>;
  commission_financial_notes?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  current_job_number?: InputMaybe<Scalars['Int']>;
  defaultCurrency?: InputMaybe<UpdateRelation>;
  disclaimer_commission?: InputMaybe<Scalars['String']>;
  document_footer?: InputMaybe<Scalars['String']>;
  has_tax?: InputMaybe<Scalars['Boolean']>;
  include_dashboard_all?: InputMaybe<Scalars['Boolean']>;
  include_dashboard_core?: InputMaybe<Scalars['Boolean']>;
  logos?: InputMaybe<UpdateFiles>;
  manager?: InputMaybe<UpdateRelation>;
  name?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  proposalOptions?: InputMaybe<UpdateRelationArray>;
  reportingCurrency?: InputMaybe<UpdateRelation>;
  street_address?: InputMaybe<Scalars['String']>;
  supports_commission?: InputMaybe<Scalars['Boolean']>;
  supports_regional_am_allocation?: InputMaybe<Scalars['Boolean']>;
  tax_amount?: InputMaybe<Scalars['Int']>;
  tel?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type CreateSiteBuildAndRepairsInput = {
  additional_info?: InputMaybe<Scalars['String']>;
  buildContractor?: InputMaybe<UpdateRelation>;
  buildType?: InputMaybe<UpdateRelation>;
  cancelled?: InputMaybe<Scalars['String']>;
  completion_date?: InputMaybe<Scalars['String']>;
  completion_deadline?: InputMaybe<Scalars['String']>;
  costs_1?: InputMaybe<Scalars['Int']>;
  costs_2?: InputMaybe<Scalars['Int']>;
  costs_3?: InputMaybe<Scalars['Int']>;
  costs_4?: InputMaybe<Scalars['Int']>;
  costs_5?: InputMaybe<Scalars['Int']>;
  costs_comments_1?: InputMaybe<Scalars['String']>;
  costs_comments_2?: InputMaybe<Scalars['String']>;
  costs_comments_3?: InputMaybe<Scalars['String']>;
  costs_comments_4?: InputMaybe<Scalars['String']>;
  costs_comments_5?: InputMaybe<Scalars['String']>;
  costs_excluding_vat?: InputMaybe<Scalars['Int']>;
  creation_id?: InputMaybe<Scalars['String']>;
  invoice_number?: InputMaybe<Scalars['String']>;
  issued_by?: InputMaybe<Scalars['String']>;
  panel?: InputMaybe<Scalars['String']>;
  po_number?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type CreateSiteBuildContractorInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateSiteDigitalBookingPricingInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  days: Scalars['ID'];
  net: Scalars['Int'];
};

export type CreateSiteHealthAndSafetyInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  healthAndSafetyType?: InputMaybe<UpdateRelation>;
  last_inspection_date?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type CreateSiteInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  borough?: InputMaybe<UpdateRelation>;
  build_date?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  distributor?: InputMaybe<UpdateRelation>;
  galleryImages?: InputMaybe<UpdateFiles>;
  impacts?: InputMaybe<Scalars['Int']>;
  is_3p?: InputMaybe<Scalars['Boolean']>;
  is_dashboard_site?: InputMaybe<Scalars['Boolean']>;
  is_dynamic?: InputMaybe<Scalars['Boolean']>;
  is_illumination?: InputMaybe<Scalars['Boolean']>;
  is_regional?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['String']>;
  layoutImages?: InputMaybe<UpdateFiles>;
  longitude?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  panels?: InputMaybe<UpdatePanels>;
  photo_archive_url?: InputMaybe<Scalars['String']>;
  pops_url?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  poster_portfolio_url?: InputMaybe<Scalars['String']>;
  rate_card_url?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<UpdateRelation>;
  road_number?: InputMaybe<Scalars['String']>;
  siteBuildAndRepairs?: InputMaybe<UpdateSiteBuildAndRepairs>;
  siteDigitalBookingPricing?: InputMaybe<UpdateSiteDigitalBookingPricing>;
  siteFiles?: InputMaybe<UpdateFiles>;
  siteFilesOther?: InputMaybe<UpdateFiles>;
  siteHealthAndSafeties?: InputMaybe<UpdateSiteHealthAndSafety>;
  siteImages?: InputMaybe<UpdateFiles>;
  sitePayments?: InputMaybe<UpdateSitePayment>;
  sitePlannings?: InputMaybe<UpdateSitePlannings>;
  sitePricing?: InputMaybe<UpdateRelation>;
  siteRentals?: InputMaybe<UpdateSiteRentals>;
  siteStructure?: InputMaybe<UpdateRelation>;
  siteStructureType?: InputMaybe<UpdateRelation>;
  site_code?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<UpdateRelation>;
  subletter?: InputMaybe<UpdateRelation>;
  tags?: InputMaybe<UpdateRelationArray>;
  takeoverSite?: InputMaybe<UpdateRelation>;
  three_words?: InputMaybe<Scalars['String']>;
  tvArea?: InputMaybe<UpdateRelation>;
};

export type CreateSitePaymentInput = {
  amount: Scalars['Float'];
  creation_id: Scalars['String'];
  currency?: InputMaybe<UpdateRelation>;
  date: Scalars['String'];
};

export type CreateSitePlanningInput = {
  amount?: InputMaybe<Scalars['Int']>;
  creation_id?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  outcome_date?: InputMaybe<Scalars['String']>;
  outcome_notes?: InputMaybe<Scalars['String']>;
  planningOutcome?: InputMaybe<UpdateRelation>;
  planningStage?: InputMaybe<UpdateRelation>;
  planning_date?: InputMaybe<Scalars['String']>;
};

export type CreateSitePricingInput = {
  comment?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<UpdateRelation>;
  label?: InputMaybe<Scalars['String']>;
  panel?: InputMaybe<Scalars['Int']>;
};

export type CreateSiteRentalInput = {
  amount?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contact_code?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['String']>;
  freeholder?: InputMaybe<Scalars['Boolean']>;
  increase_date?: InputMaybe<Scalars['String']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_rolling?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  paymentFrequency?: InputMaybe<UpdateRelation>;
  paymentMethod?: InputMaybe<UpdateRelation>;
  rentalType?: InputMaybe<UpdateRelation>;
  start_date?: InputMaybe<Scalars['String']>;
};

export type CreateSiteStructureInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  posterSize?: InputMaybe<UpdateRelation>;
  siteStructureGroup?: InputMaybe<UpdateRelation>;
  slotPosterSize?: InputMaybe<UpdateRelation>;
};

export type CreateSiteStructureTypeInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateSiteTagInput = {
  code?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
};

export type CreateStyleInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  is_pack_style?: InputMaybe<Scalars['Boolean']>;
  is_site_style?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
};

export type CreateSubletterInput = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_2?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  telephone_1?: InputMaybe<Scalars['String']>;
  telephone_2?: InputMaybe<Scalars['String']>;
};

export type CreateSundryInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  date_down?: InputMaybe<Scalars['String']>;
  date_up?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  sundryType?: InputMaybe<UpdateRelation>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
  use_global_discount?: InputMaybe<Scalars['Boolean']>;
};

export type CreateSundryTypeInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  proxyUser?: InputMaybe<UpdateRelation>;
  role?: InputMaybe<UpdateRelation>;
  salesTeams?: InputMaybe<UpdateRelationArray>;
};

export type CreateUserOptionInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  search_name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type CreativeStudio = {
  __typename?: 'CreativeStudio';
  campaign?: Maybe<Campaign>;
  campaignComponent?: Maybe<CampaignComponent>;
  creation_id?: Maybe<Scalars['String']>;
  creativeStudioType?: Maybe<CreativeStudioType>;
  creativeStudioTypeDetail?: Maybe<CreativeStudioTypeDetail>;
  end_date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['String']>;
};


export type CreativeStudioCreativeStudioTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type CreativeStudioCreativeStudioTypeDetailArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type CreativeStudioEntry = {
  __typename?: 'CreativeStudioEntry';
  campaign?: Maybe<Campaign>;
  campaignComponent?: Maybe<CampaignComponent>;
  children?: Maybe<Array<Maybe<CreativeStudioEntry>>>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['ID']>;
  qty?: Maybe<Scalars['Int']>;
  unit_value_actual?: Maybe<Scalars['Int']>;
  unit_value_estimated_local?: Maybe<Scalars['Int']>;
  unit_value_local?: Maybe<Scalars['Int']>;
};

export type CreativeStudioType = {
  __typename?: 'CreativeStudioType';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CreativeStudioTypeDetail = {
  __typename?: 'CreativeStudioTypeDetail';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type Currency = {
  __typename?: 'Currency';
  creation_id?: Maybe<Scalars['String']>;
  glyph?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type DateRange = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type Daybook = {
  __typename?: 'Daybook';
  abSplitAmounts?: Maybe<Scalars['Boolean']>;
  areaBookingPricingModels?: Maybe<Array<Maybe<DaybookAreaBookingPricingRule>>>;
  assetUrl?: Maybe<Scalars['String']>;
  baseUrl?: Maybe<Scalars['String']>;
  challengeEnabled?: Maybe<Scalars['Boolean']>;
  defaultSiteCurrency?: Maybe<Currency>;
  hasSalesTax?: Maybe<Scalars['Boolean']>;
  isFringebook?: Maybe<Scalars['Boolean']>;
  jobListDefaultDistributor?: Maybe<Scalars['String']>;
  previewUrl?: Maybe<Scalars['String']>;
  pusherConfig?: Maybe<DaybookPusherConfig>;
  regionAreaBookingPricing?: Maybe<Scalars['Boolean']>;
  salesTaxAmount?: Maybe<Scalars['Float']>;
  salesTaxLabel?: Maybe<Scalars['String']>;
  siteTitle?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  useAreaBookingToggle?: Maybe<Scalars['Boolean']>;
  useCreativeStudio?: Maybe<Scalars['Boolean']>;
};

export type DaybookAreaBookingPricingRule = {
  __typename?: 'DaybookAreaBookingPricingRule';
  baseWeeks?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  locationsLessThanPercentage?: Maybe<Scalars['Int']>;
  locationsLessThanTrigger?: Maybe<Scalars['Int']>;
  priority?: Maybe<Scalars['Int']>;
  weekOverrides?: Maybe<Array<Maybe<DaybookWeekOverride>>>;
  where?: Maybe<DaybookAreaBookingPricingRuleWhere>;
};

export type DaybookAreaBookingPricingRuleWhere = {
  __typename?: 'DaybookAreaBookingPricingRuleWhere';
  campaignField?: Maybe<Scalars['String']>;
  compare?: Maybe<Scalars['String']>;
  rowField?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DaybookPusherConfig = {
  __typename?: 'DaybookPusherConfig';
  appId?: Maybe<Scalars['String']>;
  forceTLS?: Maybe<Scalars['Boolean']>;
  key?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  wsHost?: Maybe<Scalars['String']>;
  wsPort?: Maybe<Scalars['Int']>;
  wssPort?: Maybe<Scalars['Int']>;
};

export type DaybookWeekOverride = {
  __typename?: 'DaybookWeekOverride';
  multiplier?: Maybe<Scalars['Float']>;
  overrideWeeks?: Maybe<Scalars['Int']>;
  weeks?: Maybe<Scalars['Int']>;
};

export type DeleteDigitalBookingArrayInput = {
  deletes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type DeleteDigitalBookingError = {
  __typename?: 'DeleteDigitalBookingError';
  message?: Maybe<Scalars['String']>;
};

export type DeleteDigitalBookingOutput = {
  __typename?: 'DeleteDigitalBookingOutput';
  deleteDigitalBookingErrors?: Maybe<Array<Maybe<DeleteDigitalBookingError>>>;
  digitalBookings?: Maybe<Array<Maybe<DigitalBooking>>>;
};

export type DeletePanelBookingArrayInput = {
  deletes?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type DeletePanelBookingError = {
  __typename?: 'DeletePanelBookingError';
  message?: Maybe<Scalars['String']>;
};

export type DeletePanelBookingOutput = {
  __typename?: 'DeletePanelBookingOutput';
  deletePanelBookingErrors?: Maybe<Array<Maybe<DeletePanelBookingError>>>;
  panelBookings?: Maybe<Array<Maybe<PanelBooking>>>;
};

export type DigitalBooking = {
  __typename?: 'DigitalBooking';
  campaign?: Maybe<Campaign>;
  campaignComponent?: Maybe<CampaignComponent>;
  cost_type: Scalars['String'];
  days: Scalars['Int'];
  end_date: Scalars['String'];
  id: Scalars['ID'];
  is_photo_paid?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  start_date: Scalars['String'];
  status: Scalars['String'];
};

export type Distributor = {
  __typename?: 'Distributor';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_inhouse?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type DistributorConnectInput = {
  connect?: InputMaybe<Scalars['ID']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

/** A paginated list of Distributor items. */
export type DistributorPaginator = {
  __typename?: 'DistributorPaginator';
  /** A list of Distributor items. */
  data: Array<Distributor>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ExchangeRate = {
  __typename?: 'ExchangeRate';
  creation_id?: Maybe<Scalars['String']>;
  from?: Maybe<Currency>;
  id: Scalars['ID'];
  rate?: Maybe<Scalars['Float']>;
  to?: Maybe<Currency>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type ExchangeRateFromArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type ExchangeRateToArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type Experiential = {
  __typename?: 'Experiential';
  campaignComponent?: Maybe<CampaignComponent>;
  creation_id?: Maybe<Scalars['String']>;
  end_date?: Maybe<Scalars['String']>;
  experientialType?: Maybe<ExperientialType>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  start_date?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unit_value?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};


export type ExperientialExperientialTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type ExperientialType = {
  __typename?: 'ExperientialType';
  creation_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type File = {
  __typename?: 'File';
  campaign?: Maybe<Campaign>;
  creation_id?: Maybe<Scalars['String']>;
  distributor?: Maybe<Distributor>;
  file_type?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mime_type?: Maybe<Scalars['String']>;
  original_name?: Maybe<Scalars['String']>;
  thumbnail_url?: Maybe<Scalars['String']>;
  uploaded?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type FileInput = {
  clone_id?: InputMaybe<Scalars['ID']>;
  creation_id?: InputMaybe<Scalars['String']>;
  distributor?: InputMaybe<DistributorConnectInput>;
  file_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  mime_type?: InputMaybe<Scalars['String']>;
  original_name?: InputMaybe<Scalars['String']>;
  rawFile?: InputMaybe<Scalars['Upload']>;
  rawThumb?: InputMaybe<Scalars['Upload']>;
  size?: InputMaybe<Scalars['String']>;
  thumbnail_url?: InputMaybe<Scalars['String']>;
  uploaded?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export enum FreeType {
  Ccp = 'CCP',
  Free = 'Free',
  Paid = 'Paid'
}

export type ImportFileResult = {
  __typename?: 'ImportFileResult';
  failedJobs: Array<Maybe<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type IntRange = {
  from?: InputMaybe<Scalars['ID']>;
  to?: InputMaybe<Scalars['ID']>;
};

export type LogEntry = {
  __typename?: 'LogEntry';
  archived: Scalars['Boolean'];
  fields?: Maybe<Array<Maybe<LogField>>>;
  id: Scalars['ID'];
  kind: LogEntryKind;
  label?: Maybe<Scalars['String']>;
  occurredAt: Scalars['String'];
  payload?: Maybe<Scalars['JSON']>;
  status?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<Scalars['Int']>;
  totalPriceWithVat?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
};

export enum LogEntryKind {
  Change = 'CHANGE',
  Event = 'EVENT'
}

export type LogField = {
  __typename?: 'LogField';
  field?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};

export type LoginInput = {
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type MediaProduction = {
  __typename?: 'MediaProduction';
  campaignComponent?: Maybe<CampaignComponent>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mediaType?: Maybe<MediaType>;
  notes?: Maybe<Scalars['String']>;
  price_divisor?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  regionType?: Maybe<RegionType>;
  size?: Maybe<PosterSize>;
  unit_value_local?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};


export type MediaProductionMediaTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type MediaProductionRegionTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type MediaProductionSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type MediaType = {
  __typename?: 'MediaType';
  creation_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of MediaType items. */
export type MediaTypePaginator = {
  __typename?: 'MediaTypePaginator';
  /** A list of MediaType items. */
  data: Array<MediaType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type Mutation = {
  __typename?: 'Mutation';
  addAuthenticatorCode?: Maybe<AuthenticatorCode>;
  affectedPanelBookings?: Maybe<Array<Maybe<PanelBooking>>>;
  campaignAreaBookingReport?: Maybe<ReportOutput>;
  campaignChangeSalesTeam?: Maybe<Campaign>;
  campaignCostsReport?: Maybe<ReportOutput>;
  campaignCreativeReport?: Maybe<ReportOutput>;
  campaignDeletePanelBooking?: Maybe<DeletePanelBookingOutput>;
  campaignDigitalReport?: Maybe<ReportOutput>;
  campaignSundriesReport?: Maybe<ReportOutput>;
  campaignUpdatePanelBooking?: Maybe<TweakPanelBookingOutput>;
  createCampaign?: Maybe<Campaign>;
  createCampaignChallenge?: Maybe<CampaignChallenge>;
  createCampaignSignature?: Maybe<CampaignSignature>;
  createClientCompany?: Maybe<ClientCompany>;
  createClientCompanyContact?: Maybe<ClientCompanyContact>;
  createCompany?: Maybe<ClientCompany>;
  createContractTemplate?: Maybe<ContractTemplate>;
  createDigitalBookings: DigitalBooking;
  createDistributor?: Maybe<Distributor>;
  createMaintenanceInspectionLog?: Maybe<SiteMaintenanceInspection>;
  createOption?: Maybe<Option>;
  createPanelBooking?: Maybe<Array<Maybe<PanelBookingDateSummary>>>;
  createRole?: Maybe<Role>;
  createSalesTeam?: Maybe<SalesTeam>;
  createSite?: Maybe<Site>;
  createSubletter?: Maybe<Subletter>;
  createUser?: Maybe<User>;
  deleteCampaign?: Maybe<Campaign>;
  deleteContractTemplate?: Maybe<ContractTemplate>;
  deleteDigitalBooking?: Maybe<DeleteDigitalBookingOutput>;
  deletePanelBooking?: Maybe<Array<Maybe<PanelBookingDateSummary>>>;
  emailLogin?: Maybe<SuccessResult>;
  emailLoginRequest?: Maybe<SuccessResult>;
  forgotPassword: ForgotPasswordResponse;
  importFileData?: Maybe<ImportFileResult>;
  importInvoiceData?: Maybe<Scalars['Boolean']>;
  importPopsData?: Maybe<Scalars['Boolean']>;
  jobListReport?: Maybe<ReportOutput>;
  jobSheetReport?: Maybe<ReportOutput>;
  login: AuthPayload;
  logout: LogoutResponse;
  mailChimpReport?: Maybe<ReportOutput>;
  passkeyDelete?: Maybe<SuccessResult>;
  passkeyLogin: PasskeyAuthPayload;
  passkeyLoginRequest: PasskeyLoginRequest;
  passkeyRegister: PasskeyCredential;
  passkeyRegisterRequest: PasskeyRegisterRequest;
  passkeyRename: PasskeyCredential;
  pdfDownload?: Maybe<PdfOutput>;
  proPhotosReport?: Maybe<ReportOutput>;
  proPhotosReportAreaBooking?: Maybe<ReportOutput>;
  proPhotosReportDigital?: Maybe<ReportOutput>;
  quantitiesReport?: Maybe<ReportOutput>;
  refreshToken: AuthPayload;
  regenerateCampaignNextcloud?: Maybe<Campaign>;
  regionalRevenueReport?: Maybe<ReportOutput>;
  removeOtherUserProxy?: Maybe<User>;
  respondToCampaignChallenge?: Maybe<CampaignChallenge>;
  siteHSReport?: Maybe<ReportOutput>;
  siteMainExportReport?: Maybe<ReportOutput>;
  siteMaintenanceReport?: Maybe<ReportOutput>;
  siteReport?: Maybe<ReportOutput>;
  siteRevenueReport?: Maybe<ReportOutput>;
  siteStatusReport?: Maybe<ReportOutput>;
  toggleDashboardSite?: Maybe<Site>;
  tweakDigitalBookings?: Maybe<TweakDigitalBookingOutput>;
  twoFactorLogin?: Maybe<SuccessResult>;
  twoFactorReset?: Maybe<SuccessResult>;
  updateAmbientTypes?: Maybe<Array<Maybe<AmbientType>>>;
  updateAreaBookingRegionPricing?: Maybe<Array<Maybe<AreaBookingRegionPricing>>>;
  updateBoroughs?: Maybe<Array<Maybe<Borough>>>;
  updateCampaign?: Maybe<Campaign>;
  updateCampaignChallenge?: Maybe<CampaignChallenge>;
  updateCampaignTags?: Maybe<Array<Maybe<CampaignTag>>>;
  updateClientCompanies?: Maybe<Array<Maybe<ClientCompany>>>;
  updateClientCompany?: Maybe<ClientCompany>;
  updateClientCompanyContact?: Maybe<ClientCompanyContact>;
  updateClientCompanyContacts?: Maybe<Array<Maybe<ClientCompanyContact>>>;
  updateClientCompanyGroups?: Maybe<Array<Maybe<ClientCompanyGroup>>>;
  updateClientSubTypes?: Maybe<Array<Maybe<ClientSubType>>>;
  updateContractTemplate?: Maybe<ContractTemplate>;
  updateCostSupplierCategories?: Maybe<Array<Maybe<CostSupplierCategory>>>;
  updateCostSuppliers?: Maybe<Array<Maybe<CostSupplier>>>;
  updateCurrencies?: Maybe<Array<Maybe<Currency>>>;
  updateDistributor?: Maybe<Distributor>;
  updateDistributors?: Maybe<Array<Maybe<Distributor>>>;
  updateExchangeRates?: Maybe<Array<Maybe<ExchangeRate>>>;
  updateExperientialTypes?: Maybe<Array<Maybe<ExperientialType>>>;
  updateForgottenPassword: ForgotPasswordResponse;
  updateMe?: Maybe<User>;
  updateMediaTypes?: Maybe<Array<Maybe<MediaType>>>;
  updateOption?: Maybe<Option>;
  updateOptions?: Maybe<Array<Maybe<Option>>>;
  updatePacks?: Maybe<Array<Maybe<Pack>>>;
  updatePanelBooking?: Maybe<Array<Maybe<PanelBookingDateSummary>>>;
  updatePanelBookingDate?: Maybe<Array<Maybe<PanelBookingDateSummary>>>;
  updatePosterSize?: Maybe<PosterSize>;
  updatePosterSizes?: Maybe<Array<Maybe<PosterSize>>>;
  updateRegionTypes?: Maybe<Array<Maybe<RegionType>>>;
  updateRegions?: Maybe<Array<Maybe<Region>>>;
  updateRole?: Maybe<Role>;
  updateRoles?: Maybe<Array<Maybe<Role>>>;
  updateSalesTeam?: Maybe<SalesTeam>;
  updateSalesTeams?: Maybe<Array<Maybe<SalesTeam>>>;
  updateSite?: Maybe<Site>;
  updateSiteBuildContractors?: Maybe<Array<Maybe<SiteBuildContractor>>>;
  updateSitePricings?: Maybe<Array<Maybe<SitePricing>>>;
  updateSiteStructure?: Maybe<Array<Maybe<SiteStructure>>>;
  updateSiteStructureType?: Maybe<Array<Maybe<SiteStructureType>>>;
  updateSiteTags?: Maybe<Array<Maybe<SiteTag>>>;
  updateSites?: Maybe<Array<Maybe<Site>>>;
  updateSubletter?: Maybe<Subletter>;
  updateSubletters?: Maybe<Array<Maybe<Subletter>>>;
  updateSundryTypes?: Maybe<Array<Maybe<SundryType>>>;
  updateUser?: Maybe<User>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
};


export type MutationAffectedPanelBookingsArgs = {
  input?: InputMaybe<Array<InputMaybe<AffectedPanelBookingsDateInput>>>;
};


export type MutationCampaignAreaBookingReportArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCampaignChangeSalesTeamArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
  campaignRef?: InputMaybe<Scalars['String']>;
  salesTeamId?: InputMaybe<Scalars['ID']>;
};


export type MutationCampaignCostsReportArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCampaignCreativeReportArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCampaignDeletePanelBookingArgs = {
  input: DeletePanelBookingArrayInput;
};


export type MutationCampaignDigitalReportArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCampaignSundriesReportArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationCampaignUpdatePanelBookingArgs = {
  input: TweakPanelBookingArrayInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCampaignChallengeArgs = {
  input?: InputMaybe<CreateCampaignChallengeInput>;
};


export type MutationCreateCampaignSignatureArgs = {
  input?: InputMaybe<CreateCampaignSignatureInput>;
};


export type MutationCreateClientCompanyArgs = {
  input?: InputMaybe<CreateClientCompanyInput>;
};


export type MutationCreateClientCompanyContactArgs = {
  input?: InputMaybe<CreateClientCompanyContactInput>;
};


export type MutationCreateCompanyArgs = {
  accounts_address?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
};


export type MutationCreateContractTemplateArgs = {
  input: CreateContractTemplateInput;
};


export type MutationCreateDigitalBookingsArgs = {
  input: CreateDigitalBookingInput;
};


export type MutationCreateDistributorArgs = {
  input: CreateDistributorInput;
};


export type MutationCreateMaintenanceInspectionLogArgs = {
  input: CreateMaintenanceInspectionInput;
};


export type MutationCreateOptionArgs = {
  input: CreateOptionInput;
};


export type MutationCreatePanelBookingArgs = {
  input?: InputMaybe<CreatePanelBooking>;
};


export type MutationCreateRoleArgs = {
  input?: InputMaybe<CreateRoleInput>;
};


export type MutationCreateSalesTeamArgs = {
  input: CreateSalesTeamInput;
};


export type MutationCreateSiteArgs = {
  input: CreateSiteInput;
};


export type MutationCreateSubletterArgs = {
  input: CreateSubletterInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteContractTemplateArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDigitalBookingArgs = {
  input: DeleteDigitalBookingArrayInput;
};


export type MutationDeletePanelBookingArgs = {
  id: Scalars['ID'];
};


export type MutationEmailLoginArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type MutationForgotPasswordArgs = {
  data: ForgotPasswordInput;
};


export type MutationImportFileDataArgs = {
  file: Scalars['Upload'];
};


export type MutationImportInvoiceDataArgs = {
  file: Scalars['Upload'];
};


export type MutationImportPopsDataArgs = {
  file: Scalars['Upload'];
};


export type MutationJobListReportArgs = {
  date?: InputMaybe<Scalars['String']>;
  distributor?: InputMaybe<Scalars['ID']>;
  landscape?: InputMaybe<Scalars['Boolean']>;
  ongoing?: InputMaybe<Scalars['Boolean']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  special_announcement?: InputMaybe<Scalars['String']>;
};


export type MutationJobSheetReportArgs = {
  boroughs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  campaigns?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  date?: InputMaybe<Scalars['String']>;
  distributorId?: InputMaybe<Scalars['ID']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  landscape?: InputMaybe<Scalars['Boolean']>;
  regionId?: InputMaybe<Scalars['ID']>;
  regionTypeId?: InputMaybe<Scalars['ID']>;
};


export type MutationLoginArgs = {
  data?: InputMaybe<LoginInput>;
};


export type MutationPasskeyDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationPasskeyLoginArgs = {
  credential: Scalars['JSON'];
};


export type MutationPasskeyRegisterArgs = {
  credential: Scalars['JSON'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationPasskeyRegisterRequestArgs = {
  name?: InputMaybe<Scalars['String']>;
};


export type MutationPasskeyRenameArgs = {
  id: Scalars['ID'];
  name: Scalars['String'];
};


export type MutationPdfDownloadArgs = {
  expectText?: InputMaybe<Scalars['String']>;
  host?: InputMaybe<Scalars['String']>;
  outline?: InputMaybe<Scalars['Boolean']>;
  url?: InputMaybe<Scalars['String']>;
};


export type MutationProPhotosReportArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
};


export type MutationProPhotosReportAreaBookingArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};


export type MutationProPhotosReportDigitalArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
};


export type MutationQuantitiesReportArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
};


export type MutationRefreshTokenArgs = {
  data?: InputMaybe<RefreshTokenInput>;
};


export type MutationRegenerateCampaignNextcloudArgs = {
  campaignId: Scalars['ID'];
};


export type MutationRegionalRevenueReportArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  includeClientType?: InputMaybe<Scalars['Boolean']>;
  includeQuoteCurrency?: InputMaybe<Scalars['Boolean']>;
  salesTeam_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type MutationRemoveOtherUserProxyArgs = {
  input: RemoveUserProxyInput;
};


export type MutationRespondToCampaignChallengeArgs = {
  input?: InputMaybe<RespondToChallengeInput>;
};


export type MutationSiteHsReportArgs = {
  selectedIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSiteMainExportReportArgs = {
  selectedIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSiteMaintenanceReportArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  selectedIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSiteReportArgs = {
  hide_header_footer?: InputMaybe<Scalars['Boolean']>;
  landscape?: InputMaybe<Scalars['Boolean']>;
  siteId?: InputMaybe<Scalars['ID']>;
};


export type MutationSiteRevenueReportArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  selectedIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationSiteStatusReportArgs = {
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  selectedIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationToggleDashboardSiteArgs = {
  id: Scalars['ID'];
  is_dashboard_site: Scalars['Boolean'];
};


export type MutationTweakDigitalBookingsArgs = {
  input: TweakDigitalBookingArrayInput;
};


export type MutationTwoFactorLoginArgs = {
  code?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateAmbientTypesArgs = {
  input?: InputMaybe<UpdateAmbientTypesInput>;
};


export type MutationUpdateAreaBookingRegionPricingArgs = {
  input?: InputMaybe<UpdateAreaBookingRegionPricings>;
};


export type MutationUpdateBoroughsArgs = {
  input?: InputMaybe<UpdateBorough>;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignChallengeArgs = {
  input?: InputMaybe<UpdateCampaignChallengeInput>;
};


export type MutationUpdateCampaignTagsArgs = {
  input?: InputMaybe<UpdateCampaignTag>;
};


export type MutationUpdateClientCompaniesArgs = {
  input?: InputMaybe<UpdateClientCompany>;
};


export type MutationUpdateClientCompanyArgs = {
  input?: InputMaybe<UpdateClientCompanyInput>;
};


export type MutationUpdateClientCompanyContactArgs = {
  input?: InputMaybe<UpdateClientCompanyContactInput>;
};


export type MutationUpdateClientCompanyContactsArgs = {
  input?: InputMaybe<UpdateClientCompanyContact>;
};


export type MutationUpdateClientCompanyGroupsArgs = {
  input?: InputMaybe<UpdateClientCompanyGroup>;
};


export type MutationUpdateClientSubTypesArgs = {
  input?: InputMaybe<UpdateClientSubTypes>;
};


export type MutationUpdateContractTemplateArgs = {
  input: UpdateContractTemplateInput;
};


export type MutationUpdateCostSupplierCategoriesArgs = {
  input?: InputMaybe<UpdateCostSupplierCategoriesInput>;
};


export type MutationUpdateCostSuppliersArgs = {
  input?: InputMaybe<UpdateCostSuppliersInput>;
};


export type MutationUpdateCurrenciesArgs = {
  input?: InputMaybe<UpdateCurrencies>;
};


export type MutationUpdateDistributorArgs = {
  input: UpdateDistributorInput;
};


export type MutationUpdateDistributorsArgs = {
  input: UpdateDistributor;
};


export type MutationUpdateExchangeRatesArgs = {
  input: UpdateExchangeRates;
};


export type MutationUpdateExperientialTypesArgs = {
  input?: InputMaybe<UpdateExperientialTypesInput>;
};


export type MutationUpdateForgottenPasswordArgs = {
  data?: InputMaybe<NewPasswordWithCodeInput>;
};


export type MutationUpdateMeArgs = {
  input: UpdateMeInput;
};


export type MutationUpdateMediaTypesArgs = {
  input?: InputMaybe<UpdateMediaTypes>;
};


export type MutationUpdateOptionArgs = {
  input: UpdateOptionInput;
};


export type MutationUpdateOptionsArgs = {
  input?: InputMaybe<UpdateOptions>;
};


export type MutationUpdatePacksArgs = {
  input?: InputMaybe<UpdatePacks>;
};


export type MutationUpdatePanelBookingArgs = {
  input?: InputMaybe<TweakPanelBookingInput>;
};


export type MutationUpdatePanelBookingDateArgs = {
  input?: InputMaybe<TweakPanelBookingDateInput>;
};


export type MutationUpdatePosterSizeArgs = {
  input?: InputMaybe<UpdatePosterSizeInput>;
};


export type MutationUpdatePosterSizesArgs = {
  input?: InputMaybe<UpdatePosterSize>;
};


export type MutationUpdateRegionTypesArgs = {
  input?: InputMaybe<UpdateRegionTypesInput>;
};


export type MutationUpdateRegionsArgs = {
  input?: InputMaybe<UpdateRegion>;
};


export type MutationUpdateRoleArgs = {
  input?: InputMaybe<UpdateRoleInput>;
};


export type MutationUpdateRolesArgs = {
  input: UpdateRoles;
};


export type MutationUpdateSalesTeamArgs = {
  input: UpdateSalesTeamInput;
};


export type MutationUpdateSalesTeamsArgs = {
  input: UpdateSalesTeam;
};


export type MutationUpdateSiteArgs = {
  input: UpdateSiteInput;
};


export type MutationUpdateSiteBuildContractorsArgs = {
  input: UpdateSiteBuildContractor;
};


export type MutationUpdateSitePricingsArgs = {
  input?: InputMaybe<UpdateSitePricings>;
};


export type MutationUpdateSiteStructureArgs = {
  input?: InputMaybe<UpdateSiteStructure>;
};


export type MutationUpdateSiteStructureTypeArgs = {
  input?: InputMaybe<UpdateSiteStructureTypesInput>;
};


export type MutationUpdateSiteTagsArgs = {
  input?: InputMaybe<UpdateSiteTag>;
};


export type MutationUpdateSitesArgs = {
  input: UpdateSites;
};


export type MutationUpdateSubletterArgs = {
  input: UpdateSubletterInput;
};


export type MutationUpdateSublettersArgs = {
  input?: InputMaybe<UpdateSubletter>;
};


export type MutationUpdateSundryTypesArgs = {
  input?: InputMaybe<UpdateSundryTypesInput>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUsersArgs = {
  input: UpdateUser;
};

export type NewPasswordWithCodeInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  password_confirmation: Scalars['String'];
  token: Scalars['String'];
};

export type Option = {
  __typename?: 'Option';
  bool_value?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  int_value?: Maybe<Scalars['Int']>;
  label?: Maybe<Scalars['String']>;
  text_value?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type PbcsDetail = {
  __typename?: 'PBCSDetail';
  booking?: Maybe<PanelBooking>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type Pack = {
  __typename?: 'Pack';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  style?: Maybe<Style>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type PackStyleArgs = {
  trashed?: InputMaybe<Trashed>;
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type Panel = {
  __typename?: 'Panel';
  affectedBookings?: Maybe<Array<Maybe<PanelBooking>>>;
  code?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  number_of_slots?: Maybe<Scalars['Int']>;
  owner?: Maybe<Scalars['String']>;
  pack?: Maybe<Pack>;
  packRaw?: Maybe<Pack>;
  panel?: Maybe<Scalars['String']>;
  panelAvailabilities?: Maybe<Array<Maybe<PanelAvailability>>>;
  panelBookingDatesSummary?: Maybe<Array<Maybe<PanelBookingDateSummary>>>;
  panelBookings?: Maybe<Array<Maybe<PanelBooking>>>;
  postInstruction?: Maybe<PostInstruction>;
  posters_per_slot?: Maybe<Scalars['Int']>;
  restriction?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteRaw?: Maybe<Site>;
};


export type PanelAffectedBookingsArgs = {
  first_week?: InputMaybe<Scalars['String']>;
  last_week?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type PanelPackArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type PanelPostInstructionArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type PanelSiteArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type PanelAvailability = {
  __typename?: 'PanelAvailability';
  availability?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  first_week?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_week?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  reason?: Maybe<Scalars['String']>;
};

export type PanelBooking = {
  __typename?: 'PanelBooking';
  campaign?: Maybe<Campaign>;
  campaignComponent?: Maybe<CampaignComponent>;
  challengeable_status?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  down_date?: Maybe<Scalars['String']>;
  first_week?: Maybe<Scalars['String']>;
  free?: Maybe<FreeType>;
  id: Scalars['ID'];
  inboundChallenges?: Maybe<Array<Maybe<CampaignChallenge>>>;
  inbound_challenge_status?: Maybe<Scalars['String']>;
  instructions?: Maybe<Scalars['String']>;
  isOutboundChallenging?: Maybe<Scalars['Boolean']>;
  isPole?: Maybe<Scalars['Boolean']>;
  is_pencil?: Maybe<Scalars['Boolean']>;
  is_photo_paid?: Maybe<Scalars['String']>;
  is_received?: Maybe<Scalars['Boolean']>;
  is_slot?: Maybe<Scalars['Boolean']>;
  lastDate?: Maybe<Scalars['String']>;
  last_week?: Maybe<Scalars['String']>;
  outbound_challenge_status?: Maybe<Scalars['String']>;
  panel?: Maybe<Panel>;
  poleBookings?: Maybe<Array<Maybe<PanelBooking>>>;
  posterSize?: Maybe<PosterSize>;
  qty?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  unit_value?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  weeks?: Maybe<Scalars['Int']>;
};


export type PanelBookingPanelArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type PanelBookingPosterSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type PanelBookingChallengeStatus = {
  __typename?: 'PanelBookingChallengeStatus';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  notPole?: Maybe<Scalars['Int']>;
  notPoleChallengeable?: Maybe<Scalars['Int']>;
  notPoleUnchallengeable?: Maybe<Scalars['Int']>;
  notPoleUnderChallenge?: Maybe<Scalars['Int']>;
  pole?: Maybe<Scalars['Int']>;
  poles?: Maybe<Array<Maybe<PbcsDetail>>>;
};

export type PanelBookingDate = {
  __typename?: 'PanelBookingDate';
  booking_date?: Maybe<Scalars['String']>;
  hasPole?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  panel?: Maybe<Panel>;
  panelBooking?: Maybe<PanelBooking>;
  panel_id?: Maybe<Scalars['ID']>;
  priority?: Maybe<Scalars['Int']>;
  week_number?: Maybe<Scalars['Int']>;
};

export type PanelBookingDateCampaign = {
  __typename?: 'PanelBookingDateCampaign';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  priority?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type PanelBookingDateDetails = {
  __typename?: 'PanelBookingDateDetails';
  campaignName?: Maybe<Scalars['String']>;
  week?: Maybe<Scalars['Int']>;
};

/** A paginated list of PanelBookingDate items. */
export type PanelBookingDatePaginator = {
  __typename?: 'PanelBookingDatePaginator';
  /** A list of PanelBookingDate items. */
  data: Array<PanelBookingDate>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PanelBookingDateSummary = {
  __typename?: 'PanelBookingDateSummary';
  campaignName?: Maybe<Scalars['String']>;
  campaign_challenge_booking_id?: Maybe<Scalars['Int']>;
  campaigns?: Maybe<Array<Maybe<PanelBookingDateCampaign>>>;
  count?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  instruction?: Maybe<Scalars['String']>;
  panelStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  weekNumber?: Maybe<Scalars['Int']>;
};

/** A paginated list of Panel items. */
export type PanelPaginator = {
  __typename?: 'PanelPaginator';
  /** A list of Panel items. */
  data: Array<Panel>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PanelStatus = {
  __typename?: 'PanelStatus';
  id: Scalars['ID'];
  is_multiple_allowed?: Maybe<Scalars['Boolean']>;
  number_of_slots?: Maybe<Scalars['Int']>;
  pi_short?: Maybe<Scalars['String']>;
  posters_per_slot?: Maybe<Scalars['Int']>;
  weeks?: Maybe<Array<Maybe<PanelStatusWeek>>>;
};

export type PanelStatusWeek = {
  __typename?: 'PanelStatusWeek';
  bookings?: Maybe<Array<Maybe<PanelBooking>>>;
  week?: Maybe<Scalars['String']>;
};

export type PasskeyAuthPayload = {
  __typename?: 'PasskeyAuthPayload';
  access_token: Scalars['String'];
  expires_in: Scalars['Int'];
  refresh_token?: Maybe<Scalars['String']>;
  token_type: Scalars['String'];
  user: User;
};

export type PasskeyCredential = {
  __typename?: 'PasskeyCredential';
  backup_eligible?: Maybe<Scalars['Boolean']>;
  backup_status?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['DateTime']>;
  credential_id: Scalars['String'];
  id: Scalars['ID'];
  last_used_at?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  sign_count?: Maybe<Scalars['Int']>;
  uv_initialized?: Maybe<Scalars['Boolean']>;
};

export type PasskeyLoginRequest = {
  __typename?: 'PasskeyLoginRequest';
  challenge: Scalars['String'];
  options: Scalars['JSON'];
};

export type PasskeyRegisterRequest = {
  __typename?: 'PasskeyRegisterRequest';
  challenge: Scalars['String'];
  options: Scalars['JSON'];
};

export type PaymentTerm = {
  __typename?: 'PaymentTerm';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type PdfOutput = {
  __typename?: 'PdfOutput';
  data?: Maybe<Scalars['String']>;
};

export type Permission = {
  __typename?: 'Permission';
  category?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  enable_section?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  role?: Maybe<Array<Maybe<Role>>>;
};


export type PermissionRoleArgs = {
  trashed?: InputMaybe<Trashed>;
};

/** A paginated list of Permission items. */
export type PermissionPaginator = {
  __typename?: 'PermissionPaginator';
  /** A list of Permission items. */
  data: Array<Permission>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type PingResult = {
  __typename?: 'PingResult';
  JSVersion?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type PostInstruction = {
  __typename?: 'PostInstruction';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_archived?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type PosterSize = {
  __typename?: 'PosterSize';
  actual_60_40?: Maybe<Scalars['Float']>;
  areaBookingRegionPricing?: Maybe<Array<Maybe<AreaBookingRegionPricing>>>;
  creation_id?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  dc_type?: Maybe<Scalars['String']>;
  effective_poster_count?: Maybe<Scalars['Int']>;
  festivalCurrencyId?: Maybe<Scalars['Int']>;
  festivalPricing?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  image_caption?: Maybe<Scalars['String']>;
  images?: Maybe<Array<Maybe<File>>>;
  internationalCurrencyId?: Maybe<Scalars['Int']>;
  internationalPricing?: Maybe<Scalars['Int']>;
  is_60_40?: Maybe<Scalars['Int']>;
  is_larger_than_4?: Maybe<Scalars['Boolean']>;
  is_media_type?: Maybe<Scalars['Boolean']>;
  is_panel_poster?: Maybe<Scalars['Boolean']>;
  is_street_poster?: Maybe<Scalars['Boolean']>;
  londonCurrencyId?: Maybe<Scalars['Int']>;
  londonPricing?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  regionTypePricing?: Maybe<Array<Maybe<AreaBookingPricing>>>;
  regionalCurrencyId?: Maybe<Scalars['Int']>;
  regionalPricing?: Maybe<Scalars['Int']>;
  slotPosterSize?: Maybe<PosterSize>;
  slot_poster_count?: Maybe<Scalars['Int']>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type PosterSizeAreaBookingRegionPricingArgs = {
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type PosterSizeSlotPosterSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type ProposalOption = {
  __typename?: 'ProposalOption';
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  label?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  ambientTypes?: Maybe<Array<Maybe<AmbientType>>>;
  areaBookingZone?: Maybe<Array<Maybe<AreaBookingZone>>>;
  boroughs: BoroughPaginator;
  campaign?: Maybe<Campaign>;
  campaignChallenges?: Maybe<Array<Maybe<CampaignChallenge>>>;
  campaignTags: CampaignTagPaginator;
  campaigns: CampaignPaginator;
  clientCompanies: ClientCompanyPaginator;
  clientCompany?: Maybe<ClientCompany>;
  clientCompanyContact?: Maybe<ClientCompanyContact>;
  clientCompanyContacts: ClientCompanyContactPaginator;
  clientCompanyGroups: ClientCompanyGroupPaginator;
  clientSubTypes: ClientSubTypePaginator;
  clientTypes: ClientTypePaginator;
  contractTemplates?: Maybe<Array<Maybe<ContractTemplate>>>;
  contractVersion?: Maybe<ContractVersion>;
  contractVersions?: Maybe<Array<Maybe<ContractVersion>>>;
  costSupplierCategories: CostSupplierCategoryPaginator;
  costSuppliers: CostSupplierPaginator;
  creativeStudioTypeDetails: Array<CreativeStudioTypeDetail>;
  creativeStudioTypes: Array<CreativeStudioType>;
  currencies?: Maybe<Array<Maybe<Currency>>>;
  daybook?: Maybe<Daybook>;
  distributor?: Maybe<Distributor>;
  distributors: DistributorPaginator;
  exchangeRates?: Maybe<Array<Maybe<ExchangeRate>>>;
  experientialTypes?: Maybe<Array<Maybe<ExperientialType>>>;
  getAreaBookingRegionPricings?: Maybe<Array<Maybe<AreaBookingRegionPricing>>>;
  getCampaignChallenge?: Maybe<CampaignChallenge>;
  getCampaignDigitalBookings?: Maybe<Array<DigitalBooking>>;
  getContractTemplate?: Maybe<ContractTemplate>;
  getSiteDigitalBookings?: Maybe<Array<DigitalBooking>>;
  inspectionTypes: Array<SiteMaintenanceInspectionType>;
  logEntries?: Maybe<Array<Maybe<LogEntry>>>;
  logEntryDetail?: Maybe<LogEntry>;
  me?: Maybe<User>;
  mediaTypes: MediaTypePaginator;
  nextcloudEnabled: Scalars['Boolean'];
  option?: Maybe<Option>;
  options?: Maybe<Array<Maybe<Option>>>;
  packs?: Maybe<Array<Maybe<Pack>>>;
  panel?: Maybe<Panel>;
  panelBookingDates: PanelBookingDatePaginator;
  panelSearch?: Maybe<Array<Maybe<Panel>>>;
  panels: PanelPaginator;
  paymentTerm?: Maybe<Array<Maybe<PaymentTerm>>>;
  permissions: PermissionPaginator;
  ping?: Maybe<PingResult>;
  postInstructions?: Maybe<Array<Maybe<PostInstruction>>>;
  posterSize?: Maybe<PosterSize>;
  posterSizes?: Maybe<Array<Maybe<PosterSize>>>;
  proposalOptions?: Maybe<Array<Maybe<ProposalOption>>>;
  regionTypePosterPricing?: Maybe<AreaBookingPricing>;
  regionTypes: RegionTypePaginator;
  regions: RegionPaginator;
  role?: Maybe<Role>;
  roles: RolePaginator;
  salesTeam?: Maybe<SalesTeam>;
  salesTeams?: Maybe<Array<Maybe<SalesTeam>>>;
  site?: Maybe<Site>;
  siteBuildContractors?: Maybe<Array<Maybe<SiteBuildContractor>>>;
  siteBuildTypes?: Maybe<Array<Maybe<SiteBuildType>>>;
  siteHealthAndSafetyTypes?: Maybe<Array<Maybe<SiteHealthAndSafetyType>>>;
  sitePlanningOutcomes?: Maybe<Array<Maybe<SitePlanningOutcome>>>;
  sitePlanningStages?: Maybe<Array<Maybe<SitePlanningStage>>>;
  sitePricings?: Maybe<Array<Maybe<SitePricing>>>;
  siteRentalPaymentFrequencies?: Maybe<Array<Maybe<SiteRentalPaymentFrequency>>>;
  siteRentalPaymentMethods?: Maybe<Array<Maybe<SiteRentalPaymentMethod>>>;
  siteRentalTypes?: Maybe<Array<Maybe<SiteRentalType>>>;
  siteStructure?: Maybe<SiteStructure>;
  siteStructureGroups?: Maybe<Array<Maybe<SiteStructureGroup>>>;
  siteStructureTypes?: Maybe<Array<Maybe<SiteStructureType>>>;
  siteStructures?: Maybe<Array<Maybe<SiteStructure>>>;
  siteTags: SiteTagPaginator;
  sites?: Maybe<Array<Maybe<Site>>>;
  styles?: Maybe<Array<Maybe<Style>>>;
  subletter?: Maybe<Subletter>;
  subletters?: Maybe<Array<Maybe<Subletter>>>;
  sundryTypes?: Maybe<Array<Maybe<SundryType>>>;
  tvAreas?: Maybe<Array<Maybe<TvArea>>>;
  ukRegionTypes: RegionTypePaginator;
  user?: Maybe<User>;
  users?: Maybe<Array<Maybe<User>>>;
};


export type QueryAmbientTypesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryAreaBookingZoneArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryBoroughsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCampaignArgs = {
  id?: InputMaybe<Scalars['ID']>;
  ref?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignChallengesArgs = {
  campaign_id?: InputMaybe<Scalars['ID']>;
  direction?: InputMaybe<Scalars['String']>;
  markViewed?: InputMaybe<Scalars['Boolean']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryCampaignTagsArgs = {
  first: Scalars['Int'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  section_code?: InputMaybe<Scalars['String']>;
};


export type QueryCampaignsArgs = {
  area_booking_date_down_between?: InputMaybe<DateRange>;
  area_booking_date_up_between?: InputMaybe<DateRange>;
  area_booking_distributor_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  area_booking_poster_size_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  area_booking_region_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  artwork_received_date_between?: InputMaybe<DateRange>;
  client_company_contact_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  client_company_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  client_company_name?: InputMaybe<Scalars['String']>;
  client_sub_type_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  completion_date_between?: InputMaybe<DateRange>;
  completion_date_in?: InputMaybe<Array<InputMaybe<DateRange>>>;
  discount_percentage?: InputMaybe<Scalars['Float']>;
  exclude_invoice_number?: InputMaybe<Scalars['Boolean']>;
  first: Scalars['Int'];
  invoice?: InputMaybe<Scalars['String']>;
  job_reference?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  name_or_reference?: InputMaybe<Scalars['String']>;
  only_active?: InputMaybe<Scalars['Boolean']>;
  our_contact_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  page?: InputMaybe<Scalars['Int']>;
  purchase_order?: InputMaybe<Scalars['String']>;
  regional_am_revenue_id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sales_job_ref?: InputMaybe<Scalars['String']>;
  sales_team_all?: InputMaybe<Scalars['Boolean']>;
  sales_team_core?: InputMaybe<Scalars['Boolean']>;
  sales_team_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sales_team_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  start_date_between?: InputMaybe<DateRange>;
  status_in?: InputMaybe<Array<Scalars['String']>>;
  total_price?: InputMaybe<Scalars['ID']>;
  total_price_between?: InputMaybe<IntRange>;
  total_price_vat?: InputMaybe<Scalars['ID']>;
  total_price_vat_between?: InputMaybe<IntRange>;
  type_in?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryClientCompaniesArgs = {
  accountsAddress_like?: InputMaybe<Scalars['String']>;
  accountsCode_exact?: InputMaybe<Scalars['String']>;
  accountsCompany_like?: InputMaybe<Scalars['String']>;
  clientCompanyType_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  credit_limit_between?: InputMaybe<IntRange>;
  first: Scalars['Int'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  salesAddress_like?: InputMaybe<Scalars['String']>;
  salesCompany_like?: InputMaybe<Scalars['String']>;
  trashed?: InputMaybe<Trashed>;
};


export type QueryClientCompanyArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryClientCompanyContactArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryClientCompanyContactsArgs = {
  accountsAddress_like?: InputMaybe<Scalars['String']>;
  accountsCode_exact?: InputMaybe<Scalars['String']>;
  accountsCompany_exact?: InputMaybe<Scalars['String']>;
  accountsCompany_like?: InputMaybe<Scalars['String']>;
  contactName_like?: InputMaybe<Scalars['String']>;
  credit_limit_between?: InputMaybe<IntRange>;
  first: Scalars['Int'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  pairsOnly?: InputMaybe<Scalars['Boolean']>;
  salesAddress_like?: InputMaybe<Scalars['String']>;
  salesCompany_exact?: InputMaybe<Scalars['String']>;
  salesCompany_like?: InputMaybe<Scalars['String']>;
  salesTeam_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  user_exact?: InputMaybe<Scalars['ID']>;
  user_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryClientCompanyGroupsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryClientSubTypesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryClientTypesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryContractTemplatesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryContractVersionArgs = {
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryContractVersionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  campaignId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryCostSupplierCategoriesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCostSuppliersArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryCreativeStudioTypeDetailsArgs = {
  creativeStudioTypeId?: InputMaybe<Scalars['ID']>;
};


export type QueryCurrenciesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryDistributorArgs = {
  id: Scalars['ID'];
};


export type QueryDistributorsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryExperientialTypesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryGetAreaBookingRegionPricingsArgs = {
  poster_size_id?: InputMaybe<Scalars['ID']>;
  region_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetCampaignChallengeArgs = {
  id: Scalars['ID'];
};


export type QueryGetCampaignDigitalBookingsArgs = {
  campaign_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetContractTemplateArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetSiteDigitalBookingsArgs = {
  site_id: Scalars['ID'];
};


export type QueryLogEntriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  campaignId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
};


export type QueryLogEntryDetailArgs = {
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryMediaTypesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryOptionArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryOptionsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryPacksArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryPanelArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPanelBookingDatesArgs = {
  first: Scalars['Int'];
  page?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['ID']>;
  week_number?: InputMaybe<Scalars['Int']>;
};


export type QueryPanelSearchArgs = {
  borough?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  campaign_name?: InputMaybe<Scalars['String']>;
  distributor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  end_date?: InputMaybe<Scalars['String']>;
  frozen_key?: InputMaybe<Scalars['String']>;
  frozen_week?: InputMaybe<Scalars['Int']>;
  num_weeks?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  pack?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  pack_not?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  panel?: InputMaybe<Scalars['String']>;
  panel_search_type?: InputMaybe<Scalars['String']>;
  panel_search_type_weeks?: InputMaybe<Scalars['ID']>;
  postcode?: InputMaybe<Scalars['String']>;
  postcode_rlike?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  region_type?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  site_id?: InputMaybe<Scalars['ID']>;
  site_name?: InputMaybe<Scalars['String']>;
  site_structure?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  site_structure_group?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  site_structure_like?: InputMaybe<Scalars['String']>;
  site_tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  start_date?: InputMaybe<Scalars['String']>;
  start_week?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryPanelsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPaymentTermArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryPermissionsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryPostInstructionsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryPosterSizeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryPosterSizesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryProposalOptionsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryRegionTypePosterPricingArgs = {
  posterSizeId: Scalars['ID'];
  regionTypeId: Scalars['ID'];
};


export type QueryRegionTypesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryRegionsArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
};


export type QueryRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryRolesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QuerySalesTeamArgs = {
  id: Scalars['ID'];
};


export type QuerySalesTeamsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteArgs = {
  id?: InputMaybe<Scalars['ID']>;
  site_code?: InputMaybe<Scalars['String']>;
};


export type QuerySiteBuildContractorsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteBuildTypesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteHealthAndSafetyTypesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySitePlanningOutcomesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySitePlanningStagesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySitePricingsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteRentalPaymentFrequenciesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteRentalPaymentMethodsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteRentalTypesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteStructureArgs = {
  id: Scalars['ID'];
};


export type QuerySiteStructureGroupsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteStructureTypesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteStructuresArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySiteTagsArgs = {
  first: Scalars['Int'];
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QuerySitesArgs = {
  address1?: InputMaybe<Scalars['String']>;
  borough?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  build_date_between?: InputMaybe<DateRange>;
  digital_search_default?: InputMaybe<Scalars['Boolean']>;
  distributor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  frameId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  is_dashboard_site?: InputMaybe<Scalars['Boolean']>;
  m4?: InputMaybe<Scalars['String']>;
  maintenance_inspection_region_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Array<OrderByClause>>;
  pack?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  postcode?: InputMaybe<Scalars['String']>;
  postcode_rlike?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  region_type_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  site_code?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  structureId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  structureType?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  subletterId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  tvArea?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryStylesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySubletterArgs = {
  id: Scalars['ID'];
};


export type QuerySublettersArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QuerySundryTypesArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryTvAreasArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};


export type QueryUkRegionTypesArgs = {
  first: Scalars['Int'];
  orderBy?: InputMaybe<Array<OrderByClause>>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryUsersArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
};

export type RefreshTokenInput = {
  refresh_token?: InputMaybe<Scalars['String']>;
};

export type Region = {
  __typename?: 'Region';
  creation_id?: Maybe<Scalars['String']>;
  example_map_string?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_area_booking?: Maybe<Scalars['Boolean']>;
  is_panel_booking?: Maybe<Scalars['Boolean']>;
  manual_area_booking_pricing?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  regionType?: Maybe<RegionType>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type RegionRegionTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

/** A paginated list of Region items. */
export type RegionPaginator = {
  __typename?: 'RegionPaginator';
  /** A list of Region items. */
  data: Array<Region>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type RegionType = {
  __typename?: 'RegionType';
  creation_id?: Maybe<Scalars['String']>;
  festivalPricing?: Maybe<Scalars['Int']>;
  has_poster_pricing?: Maybe<Scalars['Boolean']>;
  has_regional_pricing?: Maybe<Scalars['Boolean']>;
  has_split_qty?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  londonPricing?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  posterPricing?: Maybe<Array<Maybe<AreaBookingPricing>>>;
  pricing_model?: Maybe<Scalars['String']>;
  regionalPricing?: Maybe<Scalars['Int']>;
  regions?: Maybe<Array<Maybe<Region>>>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type RegionTypeRegionsArgs = {
  orderBy?: InputMaybe<Array<OrderByClause>>;
  trashed?: InputMaybe<Trashed>;
};

/** A paginated list of RegionType items. */
export type RegionTypePaginator = {
  __typename?: 'RegionTypePaginator';
  /** A list of RegionType items. */
  data: Array<RegionType>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type ReleasePanelPoleBookingInput = {
  campaignBookingId?: InputMaybe<Scalars['ID']>;
  panelBookingId?: InputMaybe<Scalars['ID']>;
};

export type ReleasePanelPoleInput = {
  bookings?: InputMaybe<Array<InputMaybe<ReleasePanelPoleBookingInput>>>;
  job_reference?: InputMaybe<Scalars['String']>;
};

export type ReleasePanelPoleResponse = {
  __typename?: 'ReleasePanelPoleResponse';
  message?: Maybe<Scalars['String']>;
  released?: Maybe<Scalars['Int']>;
};

export type RemoveUserProxyInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type ReportOutput = {
  __typename?: 'ReportOutput';
  reportData?: Maybe<Scalars['String']>;
};

export type RespondToChallengeInput = {
  id: Scalars['ID'];
  message?: InputMaybe<Scalars['String']>;
  responses?: InputMaybe<Array<InputMaybe<ResponseToBookingChallengeInput>>>;
};

export type ResponseToBookingChallengeInput = {
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of Role items. */
export type RolePaginator = {
  __typename?: 'RolePaginator';
  /** A list of Role items. */
  data: Array<Role>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

export type SalesTeam = {
  __typename?: 'SalesTeam';
  city?: Maybe<Scalars['String']>;
  commission_financial_notes?: Maybe<Scalars['String']>;
  contact_email?: Maybe<Scalars['String']>;
  current_job_number?: Maybe<Scalars['Int']>;
  defaultCurrency?: Maybe<Currency>;
  disclaimer_commission?: Maybe<Scalars['String']>;
  document_footer?: Maybe<Scalars['String']>;
  has_tax?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  include_dashboard_all?: Maybe<Scalars['Boolean']>;
  include_dashboard_core?: Maybe<Scalars['Boolean']>;
  logos?: Maybe<Array<Maybe<File>>>;
  manager?: Maybe<User>;
  name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  proposalOptions?: Maybe<Array<Maybe<ProposalOption>>>;
  reportingCurrency?: Maybe<Currency>;
  street_address?: Maybe<Scalars['String']>;
  supports_commission?: Maybe<Scalars['Boolean']>;
  supports_regional_am_allocation?: Maybe<Scalars['Boolean']>;
  tax_amount?: Maybe<Scalars['Int']>;
  tel?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  url?: Maybe<Scalars['String']>;
};


export type SalesTeamDefaultCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SalesTeamManagerArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SalesTeamReportingCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type Site = {
  __typename?: 'Site';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  borough?: Maybe<Borough>;
  boroughOrRegion?: Maybe<Scalars['String']>;
  boroughOrRegionRaw?: Maybe<Scalars['String']>;
  build_date?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionHTML?: Maybe<Scalars['String']>;
  distributor?: Maybe<Distributor>;
  externalLink?: Maybe<Scalars['String']>;
  externalThumbnail?: Maybe<Scalars['String']>;
  galleryImages?: Maybe<Array<Maybe<File>>>;
  id: Scalars['ID'];
  impacts?: Maybe<Scalars['Int']>;
  is_3p?: Maybe<Scalars['Boolean']>;
  is_dashboard_site?: Maybe<Scalars['Boolean']>;
  is_dynamic?: Maybe<Scalars['Boolean']>;
  is_illumination?: Maybe<Scalars['Boolean']>;
  is_regional?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['String']>;
  layoutImages?: Maybe<Array<Maybe<File>>>;
  longitude?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  numPanels?: Maybe<Scalars['Int']>;
  panels?: Maybe<Array<Maybe<Panel>>>;
  photo_archive_url?: Maybe<Scalars['String']>;
  pops_url?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  poster_portfolio_url?: Maybe<Scalars['String']>;
  rate_card_url?: Maybe<Scalars['String']>;
  rates?: Maybe<Scalars['Int']>;
  region?: Maybe<Region>;
  rental?: Maybe<Scalars['Int']>;
  rental_end?: Maybe<Scalars['String']>;
  rental_start?: Maybe<Scalars['String']>;
  road_number?: Maybe<Scalars['String']>;
  siteBuildAndRepairs?: Maybe<Array<Maybe<SiteBuildAndRepairs>>>;
  siteDigitalBookingPricing?: Maybe<Array<Maybe<SiteDigitalBookingPricing>>>;
  siteFiles?: Maybe<Array<Maybe<File>>>;
  siteFilesOther?: Maybe<Array<Maybe<File>>>;
  siteHealthAndSafeties?: Maybe<Array<Maybe<SiteHealthAndSafety>>>;
  siteImages?: Maybe<Array<Maybe<File>>>;
  siteMaintenanceInspection?: Maybe<Array<Maybe<SiteMaintenanceInspection>>>;
  sitePayments?: Maybe<Array<Maybe<SitePayment>>>;
  sitePlannings?: Maybe<Array<Maybe<SitePlanning>>>;
  sitePricing?: Maybe<SitePricing>;
  siteRentals?: Maybe<Array<Maybe<SiteRental>>>;
  siteStructure?: Maybe<SiteStructure>;
  siteStructureType?: Maybe<SiteStructureType>;
  site_code?: Maybe<Scalars['String']>;
  style?: Maybe<Style>;
  styleRaw?: Maybe<Style>;
  subletter?: Maybe<Subletter>;
  tags?: Maybe<Array<Maybe<SiteTag>>>;
  takeoverSite?: Maybe<Site>;
  takeoverSitesManagedByThis?: Maybe<Array<Maybe<Site>>>;
  three_words?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
  tvArea?: Maybe<TvArea>;
};


export type SiteBoroughArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteDistributorArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SitePanelsArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteRegionArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteSitePricingArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteSiteStructureArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteSiteStructureTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteStyleArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteSubletterArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteTvAreaArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SiteBuildAndRepairs = {
  __typename?: 'SiteBuildAndRepairs';
  additional_info?: Maybe<Scalars['String']>;
  buildContractor?: Maybe<SiteBuildContractor>;
  buildType?: Maybe<SiteBuildType>;
  cancelled?: Maybe<Scalars['String']>;
  completion_date?: Maybe<Scalars['String']>;
  completion_deadline?: Maybe<Scalars['String']>;
  costs_1?: Maybe<Scalars['Int']>;
  costs_2?: Maybe<Scalars['Int']>;
  costs_3?: Maybe<Scalars['Int']>;
  costs_4?: Maybe<Scalars['Int']>;
  costs_5?: Maybe<Scalars['Int']>;
  costs_comments_1?: Maybe<Scalars['String']>;
  costs_comments_2?: Maybe<Scalars['String']>;
  costs_comments_3?: Maybe<Scalars['String']>;
  costs_comments_4?: Maybe<Scalars['String']>;
  costs_comments_5?: Maybe<Scalars['String']>;
  costs_excluding_vat?: Maybe<Scalars['Int']>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice_number?: Maybe<Scalars['String']>;
  issued_by?: Maybe<Scalars['String']>;
  panel?: Maybe<Scalars['String']>;
  po_number?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
};


export type SiteBuildAndRepairsBuildContractorArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteBuildAndRepairsBuildTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SiteBuildContractor = {
  __typename?: 'SiteBuildContractor';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SiteBuildType = {
  __typename?: 'SiteBuildType';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SiteDigitalBookingPricing = {
  __typename?: 'SiteDigitalBookingPricing';
  creation_id?: Maybe<Scalars['String']>;
  days: Scalars['Int'];
  id: Scalars['ID'];
  net: Scalars['Int'];
};

export type SiteHealthAndSafety = {
  __typename?: 'SiteHealthAndSafety';
  creation_id?: Maybe<Scalars['String']>;
  healthAndSafetyType?: Maybe<SiteHealthAndSafetyType>;
  id: Scalars['ID'];
  last_inspection_date?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
};


export type SiteHealthAndSafetyHealthAndSafetyTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SiteHealthAndSafetyType = {
  __typename?: 'SiteHealthAndSafetyType';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SiteMaintenanceInspection = {
  __typename?: 'SiteMaintenanceInspection';
  created_at?: Maybe<Scalars['DateTime']>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  last_inspection_date?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  site?: Maybe<Site>;
  siteMaintenanceInspectionType?: Maybe<SiteMaintenanceInspectionType>;
  updated_at?: Maybe<Scalars['DateTime']>;
};

export type SiteMaintenanceInspectionType = {
  __typename?: 'SiteMaintenanceInspectionType';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
};

export type SitePayment = {
  __typename?: 'SitePayment';
  amount?: Maybe<Scalars['Float']>;
  creation_id?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  date?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};


export type SitePaymentCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SitePlanning = {
  __typename?: 'SitePlanning';
  amount?: Maybe<Scalars['Int']>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  outcome_date?: Maybe<Scalars['String']>;
  outcome_notes?: Maybe<Scalars['String']>;
  planningOutcome?: Maybe<SitePlanningOutcome>;
  planningStage?: Maybe<SitePlanningStage>;
  planning_date?: Maybe<Scalars['String']>;
};


export type SitePlanningPlanningOutcomeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SitePlanningPlanningStageArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SitePlanningOutcome = {
  __typename?: 'SitePlanningOutcome';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SitePlanningStage = {
  __typename?: 'SitePlanningStage';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SitePricing = {
  __typename?: 'SitePricing';
  comment?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  currency?: Maybe<Currency>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  panel?: Maybe<Scalars['Int']>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type SitePricingCurrencyArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SiteRental = {
  __typename?: 'SiteRental';
  amount?: Maybe<Scalars['Int']>;
  comments?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contact_code?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  expiry_date?: Maybe<Scalars['String']>;
  freeholder?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  increase_date?: Maybe<Scalars['String']>;
  is_cancelled?: Maybe<Scalars['Boolean']>;
  is_rolling?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  paymentFrequency?: Maybe<SiteRentalPaymentFrequency>;
  paymentMethod?: Maybe<SiteRentalPaymentMethod>;
  rentalType?: Maybe<SiteRentalType>;
  start_date?: Maybe<Scalars['String']>;
};


export type SiteRentalPaymentFrequencyArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteRentalPaymentMethodArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteRentalRentalTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SiteRentalPaymentFrequency = {
  __typename?: 'SiteRentalPaymentFrequency';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SiteRentalPaymentMethod = {
  __typename?: 'SiteRentalPaymentMethod';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SiteRentalType = {
  __typename?: 'SiteRentalType';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SiteStructure = {
  __typename?: 'SiteStructure';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  posterSize?: Maybe<PosterSize>;
  siteStructureGroup?: Maybe<SiteStructureGroup>;
  slotPosterSize?: Maybe<PosterSize>;
  trashed?: Maybe<Scalars['Boolean']>;
};


export type SiteStructurePosterSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type SiteStructureSlotPosterSizeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SiteStructureGroup = {
  __typename?: 'SiteStructureGroup';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type SiteStructureType = {
  __typename?: 'SiteStructureType';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SiteTag = {
  __typename?: 'SiteTag';
  code?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** A paginated list of SiteTag items. */
export type SiteTagPaginator = {
  __typename?: 'SiteTagPaginator';
  /** A list of SiteTag items. */
  data: Array<SiteTag>;
  /** Pagination information about the list of items. */
  paginatorInfo: PaginatorInfo;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type Style = {
  __typename?: 'Style';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_pack_style?: Maybe<Scalars['Boolean']>;
  is_site_style?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type Subletter = {
  __typename?: 'Subletter';
  address_1?: Maybe<Scalars['String']>;
  address_2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  creation_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  email_2?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  telephone_1?: Maybe<Scalars['String']>;
  telephone_2?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type SuccessResult = {
  __typename?: 'SuccessResult';
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Sundry = {
  __typename?: 'Sundry';
  campaignComponent?: Maybe<CampaignComponent>;
  creation_id?: Maybe<Scalars['String']>;
  date_down?: Maybe<Scalars['String']>;
  date_up?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  sundryType?: Maybe<SundryType>;
  unit_value_local?: Maybe<Scalars['Int']>;
  use_global_discount?: Maybe<Scalars['Boolean']>;
  value?: Maybe<Scalars['Int']>;
};


export type SundrySundryTypeArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type SundryType = {
  __typename?: 'SundryType';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

export type TvArea = {
  __typename?: 'TVArea';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type TweakDigitalBookingArrayInput = {
  tweak?: InputMaybe<Array<InputMaybe<TweakDigitalBookingInput>>>;
};

export type TweakDigitalBookingError = {
  __typename?: 'TweakDigitalBookingError';
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type TweakDigitalBookingInput = {
  id: Scalars['ID'];
  status: Scalars['String'];
};

export type TweakDigitalBookingOutput = {
  __typename?: 'TweakDigitalBookingOutput';
  tweakErrors?: Maybe<Array<Maybe<TweakDigitalBookingError>>>;
  updatedDigitalBookings?: Maybe<Array<Maybe<DigitalBooking>>>;
};

export type TweakPanelBookingArrayInput = {
  tweaks?: InputMaybe<Array<InputMaybe<TweakPanelBookingInput>>>;
};

export type TweakPanelBookingDateInput = {
  id?: InputMaybe<Scalars['ID']>;
  increasePriority?: InputMaybe<Scalars['Boolean']>;
};

export type TweakPanelBookingError = {
  __typename?: 'TweakPanelBookingError';
  category?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
};

export type TweakPanelBookingInput = {
  id?: InputMaybe<Scalars['ID']>;
  ignore_loss_of_pole?: InputMaybe<Scalars['Boolean']>;
  increase_priority?: InputMaybe<Scalars['Int']>;
  num_weeks?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  trim?: InputMaybe<Scalars['Int']>;
  week_number?: InputMaybe<Scalars['Int']>;
};

export type TweakPanelBookingOutput = {
  __typename?: 'TweakPanelBookingOutput';
  panelBookings?: Maybe<Array<Maybe<PanelBooking>>>;
  tweakPanelBookingErrors?: Maybe<Array<Maybe<TweakPanelBookingError>>>;
};

export type UpdateAmbientInput = {
  ambientType?: InputMaybe<UpdateRelation>;
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  end_date?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<UpdateRelation>;
  regionType?: InputMaybe<UpdateRelation>;
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['String']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type UpdateAmbientTypeInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateAmbientTypesInput = {
  create?: InputMaybe<Array<InputMaybe<CreateAmbientTypeInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateAmbientTypeInput>>>;
};

export type UpdateAmbients = {
  create?: InputMaybe<Array<CreateAmbientInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateAmbientInput>>;
};

export type UpdateAreaBookingInput = {
  areaBookingItems?: InputMaybe<UpdateAreaBookingItems>;
  bay_number?: InputMaybe<Scalars['Int']>;
  currency?: InputMaybe<UpdateRelation>;
  currency_id?: InputMaybe<Scalars['ID']>;
  first_up?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  is_photo_paid_ab?: InputMaybe<Scalars['String']>;
  last_down?: InputMaybe<Scalars['String']>;
  london_instructions?: InputMaybe<Scalars['String']>;
  num_posters?: InputMaybe<Scalars['Int']>;
  num_weeks?: InputMaybe<Scalars['Int']>;
  posterSize?: InputMaybe<UpdateRelation>;
  posters_received?: InputMaybe<Scalars['String']>;
  price_divisor?: InputMaybe<Scalars['Int']>;
  rating?: InputMaybe<Scalars['Int']>;
  regionType?: InputMaybe<UpdateRelation>;
  special_instructions?: InputMaybe<Scalars['String']>;
  total_value?: InputMaybe<Scalars['Int']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
  unit_value_prescribed_local?: InputMaybe<Scalars['Int']>;
};

export type UpdateAreaBookingItemInput = {
  areaBookingZone?: InputMaybe<UpdateRelation>;
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  date_down?: InputMaybe<Scalars['String']>;
  date_up?: InputMaybe<Scalars['String']>;
  deal_price?: InputMaybe<Scalars['Int']>;
  distributor?: InputMaybe<UpdateRelation>;
  id: Scalars['ID'];
  is_completed?: InputMaybe<Scalars['Boolean']>;
  is_distributed?: InputMaybe<Scalars['Boolean']>;
  is_received?: InputMaybe<Scalars['Boolean']>;
  is_subcontracted?: InputMaybe<Scalars['Boolean']>;
  notes?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  qty_posters_per_site?: InputMaybe<Scalars['Int']>;
  qty_sites?: InputMaybe<Scalars['Int']>;
  quantity_distributed?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
};

export type UpdateAreaBookingItems = {
  create?: InputMaybe<Array<CreateAreaBookingItemInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateAreaBookingItemInput>>;
};

export type UpdateAreaBookingRegionPricing = {
  currency?: InputMaybe<UpdateRelation>;
  id: Scalars['ID'];
  posterSize?: InputMaybe<UpdateRelation>;
  region?: InputMaybe<UpdateRelation>;
  unit_value?: InputMaybe<Scalars['Int']>;
};

export type UpdateAreaBookingRegionPricings = {
  create?: InputMaybe<Array<InputMaybe<CreateAreaBookingRegionPricing>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateAreaBookingRegionPricing>>>;
};

export type UpdateAreaBookings = {
  create?: InputMaybe<Array<CreateAreaBookingInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateAreaBookingInput>>;
};

export type UpdateBorough = {
  create?: InputMaybe<Array<InputMaybe<CreateBoroughInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateBoroughInput>>>;
};

export type UpdateBoroughInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignChallengeInput = {
  cancelPanelBookings?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  hide?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateCampaignComponent = {
  update?: InputMaybe<CampaignComponentInput>;
};

export type UpdateCampaignInput = {
  ambients?: InputMaybe<UpdateAmbients>;
  areaBookings?: InputMaybe<UpdateAreaBookings>;
  artworkFiles?: InputMaybe<UpdateFiles>;
  artwork_received_date?: InputMaybe<Scalars['String']>;
  authorizationFiles?: InputMaybe<UpdateFiles>;
  auto_upgrade?: InputMaybe<Scalars['Boolean']>;
  clientCompany?: InputMaybe<UpdateRelation>;
  clientCompanyContact?: InputMaybe<UpdateRelation>;
  clientSubType?: InputMaybe<UpdateRelation>;
  clientType?: InputMaybe<UpdateRelation>;
  completion_date?: InputMaybe<Scalars['String']>;
  contractSections?: InputMaybe<UpdateContractSections>;
  costs?: InputMaybe<UpdateCosts>;
  creativeStudio?: InputMaybe<UpdateCreativeStudio>;
  creativeStudioEntries?: InputMaybe<UpdateCreativeStudioEntries>;
  currencies?: InputMaybe<UpdateRelationArray>;
  currency?: InputMaybe<UpdateRelation>;
  digitalBookings?: InputMaybe<UpdateDigitalBookings>;
  discount_final?: InputMaybe<Scalars['Int']>;
  discount_percentage?: InputMaybe<Scalars['Float']>;
  discountableTotal?: InputMaybe<Scalars['Int']>;
  epos_artwork_reviewed?: InputMaybe<Scalars['Boolean']>;
  event?: InputMaybe<Scalars['String']>;
  experientials?: InputMaybe<UpdateExperientials>;
  fringe_user_email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice?: InputMaybe<Scalars['String']>;
  invoiceFiles?: InputMaybe<UpdateFiles>;
  is_locked?: InputMaybe<Scalars['Boolean']>;
  is_purchase_order_required?: InputMaybe<Scalars['Boolean']>;
  is_vat_exempt?: InputMaybe<Scalars['Boolean']>;
  job_reference?: InputMaybe<Scalars['String']>;
  job_reference_displayed?: InputMaybe<Scalars['String']>;
  manually_unlocked?: InputMaybe<Scalars['Boolean']>;
  mediaProductions?: InputMaybe<UpdateMediaProductions>;
  media_production_notes?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  ourContact?: InputMaybe<UpdateRelation>;
  paid_date?: InputMaybe<Scalars['String']>;
  panelBookings?: InputMaybe<UpdatePanelBookings>;
  paymentTerms?: InputMaybe<UpdateRelation>;
  payment_bank?: InputMaybe<Scalars['String']>;
  popsFiles?: InputMaybe<UpdateFiles>;
  portfolio_hash?: InputMaybe<Scalars['String']>;
  portfolio_paris_insurance?: InputMaybe<Scalars['Boolean']>;
  portfolio_show_impacts?: InputMaybe<Scalars['Boolean']>;
  portfolio_small_sites?: InputMaybe<Scalars['Boolean']>;
  portfolio_summary?: InputMaybe<Scalars['String']>;
  portfolio_title?: InputMaybe<Scalars['String']>;
  posters_received?: InputMaybe<Scalars['String']>;
  previewTags?: InputMaybe<UpdateRelationArray>;
  purchase_order?: InputMaybe<Scalars['String']>;
  region_id?: InputMaybe<Scalars['ID']>;
  regionalAmAllocation?: InputMaybe<UpdateRelation>;
  rigging_down_at?: InputMaybe<Scalars['DateTime']>;
  rigging_up_at?: InputMaybe<Scalars['DateTime']>;
  salesTeam?: InputMaybe<UpdateRelation>;
  sales_job_ref?: InputMaybe<Scalars['String']>;
  start_date?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  sub_teams_scotland?: InputMaybe<Scalars['String']>;
  sundries?: InputMaybe<UpdateSundries>;
  totalCost?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  undiscountableTotal?: InputMaybe<Scalars['Int']>;
};

export type UpdateCampaignTag = {
  create?: InputMaybe<Array<InputMaybe<CreateCampaignTagInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateCampaignTagInput>>>;
};

export type UpdateCampaignTagInput = {
  code?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  section_code?: InputMaybe<Scalars['String']>;
};

export type UpdateClientCompany = {
  create?: InputMaybe<Array<InputMaybe<CreateClientCompanyInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateClientCompanyInput>>>;
};

export type UpdateClientCompanyContact = {
  create?: InputMaybe<Array<InputMaybe<CreateClientCompanyContactInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateClientCompanyContactInput>>>;
};

export type UpdateClientCompanyContactInput = {
  clientCompany?: InputMaybe<UpdateRelation>;
  comments?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  is_mailchimp?: InputMaybe<Scalars['Boolean']>;
  is_marketing?: InputMaybe<Scalars['Boolean']>;
  is_sales?: InputMaybe<Scalars['Boolean']>;
  job_sheet_info?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phone_alt?: InputMaybe<Scalars['String']>;
  salesTeam?: InputMaybe<UpdateRelation>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateClientCompanyGroup = {
  create?: InputMaybe<Array<InputMaybe<CreateClientCompanyGroupInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateClientCompanyGroupInput>>>;
};

export type UpdateClientCompanyGroupInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateClientCompanyInput = {
  accounts_account_code?: InputMaybe<Scalars['String']>;
  accounts_address?: InputMaybe<Scalars['String']>;
  accounts_comments?: InputMaybe<Scalars['String']>;
  accounts_company?: InputMaybe<Scalars['String']>;
  accounts_contact?: InputMaybe<Scalars['String']>;
  accounts_email?: InputMaybe<Scalars['String']>;
  accounts_phone?: InputMaybe<Scalars['String']>;
  accounts_postcode?: InputMaybe<Scalars['String']>;
  clientCompanyGroup?: InputMaybe<UpdateRelation>;
  clientType?: InputMaybe<UpdateRelation>;
  credit_limit?: InputMaybe<Scalars['Int']>;
  current_credit?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  invoice_factored?: InputMaybe<Scalars['Boolean']>;
  is_po_required?: InputMaybe<Scalars['Boolean']>;
  is_vat_exempt?: InputMaybe<Scalars['Boolean']>;
  other_contacts?: InputMaybe<Scalars['String']>;
  sales_address?: InputMaybe<Scalars['String']>;
  sales_company?: InputMaybe<Scalars['String']>;
  sales_contact?: InputMaybe<Scalars['String']>;
  sales_mobile?: InputMaybe<Scalars['String']>;
  sales_phone?: InputMaybe<Scalars['String']>;
  sales_postcode?: InputMaybe<Scalars['String']>;
  sales_title?: InputMaybe<Scalars['String']>;
  sales_type?: InputMaybe<Scalars['String']>;
};

export type UpdateClientSubTypeInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateClientSubTypeRelation = {
  connect?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateClientSubTypes = {
  create?: InputMaybe<Array<InputMaybe<CreateClientSubTypeInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateClientSubTypeInput>>>;
};

export type UpdateContractBlockInput = {
  content?: InputMaybe<Scalars['String']>;
  creation_id?: InputMaybe<Scalars['String']>;
  files?: InputMaybe<UpdateFiles>;
  id: Scalars['ID'];
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateContractBlocks = {
  create?: InputMaybe<Array<CreateContractBlockInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateContractBlockInput>>;
};

export type UpdateContractSectionInput = {
  blocks?: InputMaybe<UpdateContractBlocks>;
  creation_id?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  new_page?: InputMaybe<Scalars['Boolean']>;
  show_title?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateContractSections = {
  create?: InputMaybe<Array<CreateContractSectionInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateContractSectionInput>>;
};

export type UpdateContractTemplateInput = {
  creation_id?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sections?: InputMaybe<UpdateContractSections>;
  sort?: InputMaybe<Scalars['Int']>;
};

export type UpdateCostInput = {
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  costSupplier?: InputMaybe<UpdateRelation>;
  cost_type?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  invoice_number?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  supplier_code?: InputMaybe<Scalars['String']>;
};

export type UpdateCostSupplierCategoriesInput = {
  create?: InputMaybe<Array<CreateCostSupplierCategoryInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateCostSupplierCategoryInput>>;
};

export type UpdateCostSupplierCategoryInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateCostSupplierInput = {
  code?: InputMaybe<Scalars['String']>;
  costSupplierCategory?: InputMaybe<UpdateRelation>;
  creation_id?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateCostSuppliersInput = {
  create?: InputMaybe<Array<CreateCostSupplierInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateCostSupplierInput>>;
};

export type UpdateCosts = {
  create?: InputMaybe<Array<CreateCostInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateCostInput>>;
};

export type UpdateCreativeStudio = {
  create?: InputMaybe<Array<CreateCreativeStudioInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateCreativeStudioInput>>;
};

export type UpdateCreativeStudioEntries = {
  create?: InputMaybe<Array<CreateCreativeStudioEntryInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateCreativeStudioEntryInput>>;
};

export type UpdateCreativeStudioEntryInput = {
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  creation_id?: InputMaybe<Scalars['String']>;
  currency_id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  mode?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  parent_id?: InputMaybe<Scalars['ID']>;
  qty?: InputMaybe<Scalars['Int']>;
  unit_value_actual?: InputMaybe<Scalars['Int']>;
  unit_value_estimated_local?: InputMaybe<Scalars['Int']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type UpdateCreativeStudioInput = {
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  creation_id?: InputMaybe<Scalars['String']>;
  creativeStudioType?: InputMaybe<UpdateRelation>;
  creativeStudioTypeDetail?: InputMaybe<UpdateRelation>;
  currency_id?: InputMaybe<Scalars['ID']>;
  end_date?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['String']>;
  unit_value_local?: InputMaybe<Scalars['Int']>;
};

export type UpdateCurrencies = {
  create?: InputMaybe<Array<InputMaybe<CreateCurrencyInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateCurrencyInput>>>;
};

export type UpdateCurrencyInput = {
  glyph?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateDigitalBookingInput = {
  id: Scalars['ID'];
  is_photo_paid?: InputMaybe<Scalars['String']>;
};

export type UpdateDigitalBookings = {
  create?: InputMaybe<Array<CreateDigitalBookingInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateDigitalBookingInput>>;
};

export type UpdateDistributor = {
  create?: InputMaybe<Array<InputMaybe<CreateDistributorInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateDistributorInput>>>;
};

export type UpdateDistributorInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateExchangeRateInput = {
  from?: InputMaybe<UpdateRelation>;
  id: Scalars['ID'];
  rate?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<UpdateRelation>;
};

export type UpdateExchangeRates = {
  create?: InputMaybe<Array<CreateExchangeRateInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateExchangeRateInput>>;
};

export type UpdateExperientialInput = {
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  end_date?: InputMaybe<Scalars['String']>;
  experientialType?: InputMaybe<UpdateRelation>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  region_id?: InputMaybe<Scalars['ID']>;
  region_type_id?: InputMaybe<Scalars['ID']>;
  start_date?: InputMaybe<Scalars['String']>;
};

export type UpdateExperientialTypeInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateExperientialTypesInput = {
  create?: InputMaybe<Array<InputMaybe<CreateExperientialTypeInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateExperientialTypeInput>>>;
};

export type UpdateExperientials = {
  create?: InputMaybe<Array<CreateExperientialInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateExperientialInput>>;
};

export type UpdateFiles = {
  create?: InputMaybe<Array<FileInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<FileInput>>;
};

export type UpdateMaintenanceInspectionInput = {
  id: Scalars['ID'];
  last_inspection_date?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  siteMaintenanceInspectionType?: InputMaybe<UpdateRelation>;
};

export type UpdateMaintenanceInspections = {
  create?: InputMaybe<Array<InputMaybe<CreateMaintenanceInspectionNestedInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateMaintenanceInspectionInput>>>;
};

export type UpdateMeInput = {
  campaignShortcuts?: InputMaybe<UpdateRelationArray>;
  options?: InputMaybe<UpdateUserOptions>;
  password?: InputMaybe<Scalars['String']>;
  proxyUser?: InputMaybe<UpdateRelation>;
};

export type UpdateMediaProductionInput = {
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  id: Scalars['ID'];
  mediaType?: InputMaybe<UpdateRelation>;
  notes?: InputMaybe<Scalars['String']>;
  size?: InputMaybe<UpdateRelation>;
};

export type UpdateMediaProductions = {
  create?: InputMaybe<Array<CreateMediaProductionInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateMediaProductionInput>>;
};

export type UpdateMediaTypeInput = {
  id?: InputMaybe<Scalars['ID']>;
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateMediaTypes = {
  create?: InputMaybe<Array<CreateMediaTypeInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateMediaTypeInput>>;
};

export type UpdateOptionInput = {
  bool_value?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  int_value?: InputMaybe<Scalars['Int']>;
  label?: InputMaybe<Scalars['String']>;
  text_value?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type UpdateOptions = {
  create?: InputMaybe<Array<CreateOptionInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateOptionInput>>;
};

export type UpdatePackInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<UpdateRelation>;
};

export type UpdatePacks = {
  create?: InputMaybe<Array<CreatePackInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdatePackInput>>;
};

export type UpdatePanelAvailabilities = {
  create?: InputMaybe<Array<CreatePanelAvailabilityInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdatePanelAvailabilityInput>>;
};

export type UpdatePanelAvailabilityInput = {
  availability?: InputMaybe<Scalars['String']>;
  first_week?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  last_week?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
};

export type UpdatePanelBookingInput = {
  campaign?: InputMaybe<UpdateRelation>;
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  first_week?: InputMaybe<Scalars['String']>;
  free?: InputMaybe<FreeType>;
  id: Scalars['ID'];
  instructions?: InputMaybe<Scalars['String']>;
  is_pencil?: InputMaybe<Scalars['Boolean']>;
  is_photo_paid?: InputMaybe<Scalars['String']>;
  is_received?: InputMaybe<Scalars['Boolean']>;
  is_slot?: InputMaybe<Scalars['Boolean']>;
  last_week?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  panel?: InputMaybe<UpdateRelation>;
  posterSize?: InputMaybe<UpdateRelation>;
  status?: InputMaybe<Scalars['String']>;
  weeks?: InputMaybe<Scalars['Int']>;
};

export type UpdatePanelBookings = {
  create?: InputMaybe<Array<CreatePanelBookingInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdatePanelBookingInput>>;
};

export type UpdatePanelInput = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  number_of_slots?: InputMaybe<Scalars['Int']>;
  owner?: InputMaybe<Scalars['String']>;
  pack?: InputMaybe<UpdateRelation>;
  panel?: InputMaybe<Scalars['String']>;
  panelAvailabilities?: InputMaybe<UpdatePanelAvailabilities>;
  postInstruction?: InputMaybe<UpdateRelation>;
  posters_per_slot?: InputMaybe<Scalars['Int']>;
  restriction?: InputMaybe<Scalars['String']>;
  site?: InputMaybe<UpdateRelation>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdatePanels = {
  create?: InputMaybe<Array<CreatePanelInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdatePanelInput>>;
};

export type UpdatePosterSize = {
  create?: InputMaybe<Array<InputMaybe<CreatePosterSizeInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdatePosterSizeInput>>>;
};

export type UpdatePosterSizeInput = {
  actual_60_40?: InputMaybe<Scalars['Float']>;
  areaBookingRegionPricing?: InputMaybe<UpdateAreaBookingRegionPricings>;
  customer_name?: InputMaybe<Scalars['String']>;
  dc_type?: InputMaybe<Scalars['String']>;
  effective_poster_count?: InputMaybe<Scalars['Int']>;
  festivalCurrencyId?: InputMaybe<Scalars['ID']>;
  festivalPricing?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  image_caption?: InputMaybe<Scalars['String']>;
  images?: InputMaybe<UpdateFiles>;
  internationalCurrencyId?: InputMaybe<Scalars['Int']>;
  internationalPricing?: InputMaybe<Scalars['Int']>;
  is_60_40?: InputMaybe<Scalars['Int']>;
  is_larger_than_4?: InputMaybe<Scalars['Boolean']>;
  is_media_type?: InputMaybe<Scalars['Boolean']>;
  is_panel_poster?: InputMaybe<Scalars['Boolean']>;
  is_street_poster?: InputMaybe<Scalars['Boolean']>;
  londonCurrencyId?: InputMaybe<Scalars['ID']>;
  londonPricing?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  regionalCurrencyId?: InputMaybe<Scalars['ID']>;
  regionalPricing?: InputMaybe<Scalars['Int']>;
  slotPosterSize?: InputMaybe<UpdateRelation>;
  slot_poster_count?: InputMaybe<Scalars['Int']>;
};

export type UpdateRegion = {
  create?: InputMaybe<Array<InputMaybe<CreateRegionInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateRegionInput>>>;
};

export type UpdateRegionInput = {
  example_map_string?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  is_area_booking?: InputMaybe<Scalars['Boolean']>;
  is_panel_booking?: InputMaybe<Scalars['Boolean']>;
  manual_area_booking_pricing?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  regionType?: InputMaybe<UpdateRelation>;
};

export type UpdateRegionTypeInput = {
  has_poster_pricing?: InputMaybe<Scalars['Boolean']>;
  has_regional_pricing?: InputMaybe<Scalars['Boolean']>;
  has_split_qty?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  pricing_model?: InputMaybe<Scalars['String']>;
  trashed?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRegionTypesInput = {
  create?: InputMaybe<Array<InputMaybe<CreateRegionTypeInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateRegionTypeInput>>>;
};

export type UpdateRelation = {
  connect?: InputMaybe<Scalars['ID']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateRelationArray = {
  connect?: InputMaybe<Array<Scalars['ID']>>;
  disconnect?: InputMaybe<Array<Scalars['ID']>>;
  sync?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateRoleInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<UpdateRelationArray>;
};

export type UpdateRoles = {
  create?: InputMaybe<Array<InputMaybe<CreateRoleInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateRoleInput>>>;
};

export type UpdateSalesTeam = {
  create?: InputMaybe<Array<InputMaybe<CreateDistributorInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSalesTeamInput>>>;
};

export type UpdateSalesTeamInput = {
  city?: InputMaybe<Scalars['String']>;
  commission_financial_notes?: InputMaybe<Scalars['String']>;
  contact_email?: InputMaybe<Scalars['String']>;
  current_job_number?: InputMaybe<Scalars['Int']>;
  defaultCurrency?: InputMaybe<UpdateRelation>;
  disclaimer_commission?: InputMaybe<Scalars['String']>;
  document_footer?: InputMaybe<Scalars['String']>;
  has_tax?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  include_dashboard_all?: InputMaybe<Scalars['Boolean']>;
  include_dashboard_core?: InputMaybe<Scalars['Boolean']>;
  logos?: InputMaybe<UpdateFiles>;
  manager?: InputMaybe<UpdateRelation>;
  name?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
  proposalOptions?: InputMaybe<UpdateRelationArray>;
  reportingCurrency?: InputMaybe<UpdateRelation>;
  street_address?: InputMaybe<Scalars['String']>;
  supports_commission?: InputMaybe<Scalars['Boolean']>;
  supports_regional_am_allocation?: InputMaybe<Scalars['Boolean']>;
  tax_amount?: InputMaybe<Scalars['Float']>;
  tel?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type UpdateSiteBuildAndRepairs = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteBuildAndRepairsInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteBuildAndRepairsInput>>>;
};

export type UpdateSiteBuildAndRepairsInput = {
  additional_info?: InputMaybe<Scalars['String']>;
  buildContractor?: InputMaybe<UpdateRelation>;
  buildType?: InputMaybe<UpdateRelation>;
  cancelled?: InputMaybe<Scalars['String']>;
  completion_date?: InputMaybe<Scalars['String']>;
  completion_deadline?: InputMaybe<Scalars['String']>;
  costs_1?: InputMaybe<Scalars['Int']>;
  costs_2?: InputMaybe<Scalars['Int']>;
  costs_3?: InputMaybe<Scalars['Int']>;
  costs_4?: InputMaybe<Scalars['Int']>;
  costs_5?: InputMaybe<Scalars['Int']>;
  costs_comments_1?: InputMaybe<Scalars['String']>;
  costs_comments_2?: InputMaybe<Scalars['String']>;
  costs_comments_3?: InputMaybe<Scalars['String']>;
  costs_comments_4?: InputMaybe<Scalars['String']>;
  costs_comments_5?: InputMaybe<Scalars['String']>;
  costs_excluding_vat?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  invoice_number?: InputMaybe<Scalars['String']>;
  issued_by?: InputMaybe<Scalars['String']>;
  panel?: InputMaybe<Scalars['String']>;
  po_number?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

export type UpdateSiteBuildContractor = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteBuildContractorInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteBuildContractorInput>>>;
};

export type UpdateSiteBuildContractorInput = {
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateSiteDigitalBookingPricing = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteDigitalBookingPricingInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteDigitalBookingPricingInput>>>;
};

export type UpdateSiteDigitalBookingPricingInput = {
  days?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  net?: InputMaybe<Scalars['Int']>;
};

export type UpdateSiteHealthAndSafety = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteHealthAndSafetyInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteHealthAndSafetyInput>>>;
};

export type UpdateSiteHealthAndSafetyInput = {
  healthAndSafetyType?: InputMaybe<UpdateRelation>;
  id: Scalars['ID'];
  last_inspection_date?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type UpdateSiteInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  borough?: InputMaybe<UpdateRelation>;
  build_date?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  distributor?: InputMaybe<UpdateRelation>;
  galleryImages?: InputMaybe<UpdateFiles>;
  id: Scalars['ID'];
  impacts?: InputMaybe<Scalars['Int']>;
  is_3p?: InputMaybe<Scalars['Boolean']>;
  is_dashboard_site?: InputMaybe<Scalars['Boolean']>;
  is_dynamic?: InputMaybe<Scalars['Boolean']>;
  is_illumination?: InputMaybe<Scalars['Boolean']>;
  is_regional?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['String']>;
  layoutImages?: InputMaybe<UpdateFiles>;
  longitude?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  panels?: InputMaybe<UpdatePanels>;
  photo_archive_url?: InputMaybe<Scalars['String']>;
  pops_url?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  poster_portfolio_url?: InputMaybe<Scalars['String']>;
  rate_card_url?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<UpdateRelation>;
  road_number?: InputMaybe<Scalars['String']>;
  siteBuildAndRepairs?: InputMaybe<UpdateSiteBuildAndRepairs>;
  siteDigitalBookingPricing?: InputMaybe<UpdateSiteDigitalBookingPricing>;
  siteFiles?: InputMaybe<UpdateFiles>;
  siteFilesOther?: InputMaybe<UpdateFiles>;
  siteHealthAndSafeties?: InputMaybe<UpdateSiteHealthAndSafety>;
  siteImages?: InputMaybe<UpdateFiles>;
  siteMaintenanceInspection?: InputMaybe<UpdateMaintenanceInspections>;
  sitePayments?: InputMaybe<UpdateSitePayment>;
  sitePlannings?: InputMaybe<UpdateSitePlannings>;
  sitePricing?: InputMaybe<UpdateRelation>;
  siteRentals?: InputMaybe<UpdateSiteRentals>;
  siteStructure?: InputMaybe<UpdateRelation>;
  siteStructureType?: InputMaybe<UpdateRelation>;
  site_code?: InputMaybe<Scalars['String']>;
  style?: InputMaybe<UpdateRelation>;
  subletter?: InputMaybe<UpdateRelation>;
  tags?: InputMaybe<UpdateRelationArray>;
  takeoverSite?: InputMaybe<UpdateRelation>;
  tvArea?: InputMaybe<UpdateRelation>;
};

export type UpdateSitePayment = {
  create?: InputMaybe<Array<InputMaybe<CreateSitePaymentInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSitePaymentInput>>>;
};

export type UpdateSitePaymentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  currency?: InputMaybe<UpdateRelation>;
  date?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type UpdateSitePlanningInput = {
  amount?: InputMaybe<Scalars['Int']>;
  id: Scalars['ID'];
  notes?: InputMaybe<Scalars['String']>;
  outcome_date?: InputMaybe<Scalars['String']>;
  outcome_notes?: InputMaybe<Scalars['String']>;
  planningOutcome?: InputMaybe<UpdateRelation>;
  planningStage?: InputMaybe<UpdateRelation>;
  planning_date?: InputMaybe<Scalars['String']>;
};

export type UpdateSitePlannings = {
  create?: InputMaybe<Array<InputMaybe<CreateSitePlanningInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSitePlanningInput>>>;
};

export type UpdateSitePricingInput = {
  comment?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<UpdateRelation>;
  id: Scalars['ID'];
  label?: InputMaybe<Scalars['String']>;
  panel?: InputMaybe<Scalars['Int']>;
};

export type UpdateSitePricings = {
  create?: InputMaybe<Array<InputMaybe<CreateSitePricingInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSitePricingInput>>>;
};

export type UpdateSiteRentalInput = {
  amount?: InputMaybe<Scalars['Int']>;
  comments?: InputMaybe<Scalars['String']>;
  contact?: InputMaybe<Scalars['String']>;
  contact_code?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['String']>;
  freeholder?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  increase_date?: InputMaybe<Scalars['String']>;
  is_cancelled?: InputMaybe<Scalars['Boolean']>;
  is_rolling?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  paymentFrequency?: InputMaybe<UpdateRelation>;
  paymentMethod?: InputMaybe<UpdateRelation>;
  rentalType?: InputMaybe<UpdateRelation>;
  start_date?: InputMaybe<Scalars['String']>;
};

export type UpdateSiteRentals = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteRentalInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteRentalInput>>>;
};

export type UpdateSiteStructure = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteStructureInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteStructureInput>>>;
};

export type UpdateSiteStructureInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  posterSize?: InputMaybe<UpdateRelation>;
  siteStructureGroup?: InputMaybe<UpdateRelation>;
  slotPosterSize?: InputMaybe<UpdateRelation>;
};

export type UpdateSiteStructureTypeInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSiteStructureTypesInput = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteStructureTypeInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteStructureTypeInput>>>;
};

export type UpdateSiteTag = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteTagInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteTagInput>>>;
};

export type UpdateSiteTagInput = {
  code?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
};

export type UpdateSites = {
  create?: InputMaybe<Array<InputMaybe<CreateSiteInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSiteInput>>>;
};

export type UpdateStyle = {
  create?: InputMaybe<Array<InputMaybe<CreateStyleInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateStyleInput>>>;
};

export type UpdateStyleInput = {
  id: Scalars['ID'];
  is_pack_style?: InputMaybe<Scalars['Boolean']>;
  is_site_style?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
};

export type UpdateSubletter = {
  create?: InputMaybe<Array<InputMaybe<CreateSubletterInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateSubletterInput>>>;
};

export type UpdateSubletterInput = {
  address_1?: InputMaybe<Scalars['String']>;
  address_2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  contact_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  email_2?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  postcode?: InputMaybe<Scalars['String']>;
  telephone_1?: InputMaybe<Scalars['String']>;
  telephone_2?: InputMaybe<Scalars['String']>;
};

export type UpdateSundries = {
  create?: InputMaybe<Array<CreateSundryInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateSundryInput>>;
};

export type UpdateSundryInput = {
  campaignComponent?: InputMaybe<UpdateCampaignComponent>;
  date_down?: InputMaybe<Scalars['String']>;
  date_up?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  sundryType?: InputMaybe<UpdateRelation>;
  use_global_discount?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateSundryTypeInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSundryTypesInput = {
  create?: InputMaybe<Array<CreateSundryTypeInput>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<UpdateSundryTypeInput>>;
};

export type UpdateUser = {
  create?: InputMaybe<Array<InputMaybe<CreateUserInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateUserInput>>>;
};

export type UpdateUserInput = {
  campaignShortcuts?: InputMaybe<UpdateRelationArray>;
  email?: InputMaybe<Scalars['String']>;
  hasAuthenticatorQrCode?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lockout_until?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<UpdateUserOptions>;
  password?: InputMaybe<Scalars['String']>;
  proxyUser?: InputMaybe<UpdateRelation>;
  role?: InputMaybe<UpdateRelation>;
  salesTeams?: InputMaybe<UpdateRelationArray>;
};

export type UpdateUserOptionInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  search_name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateUserOptions = {
  create?: InputMaybe<Array<InputMaybe<CreateUserOptionInput>>>;
  delete?: InputMaybe<Array<Scalars['ID']>>;
  update?: InputMaybe<Array<InputMaybe<UpdateUserOptionInput>>>;
};

export type User = {
  __typename?: 'User';
  activeChallengeCountInbound?: Maybe<Scalars['Int']>;
  activeChallengeCountOutbound?: Maybe<Scalars['Int']>;
  campaignShortcuts?: Maybe<Array<Maybe<Campaign>>>;
  challengeCountInboundNew?: Maybe<Scalars['Int']>;
  challengeCountOutboundNew?: Maybe<Scalars['Int']>;
  creation_id?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  failed_2fa_count?: Maybe<Scalars['Int']>;
  failed_password_count?: Maybe<Scalars['Int']>;
  hasAuthenticatorQrCode?: Maybe<Scalars['Boolean']>;
  hasPasskey?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lockout_until?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  options?: Maybe<Array<Maybe<UserOption>>>;
  passkeys?: Maybe<Array<PasskeyCredential>>;
  password?: Maybe<Scalars['String']>;
  proxyUser?: Maybe<User>;
  role?: Maybe<Role>;
  salesTeams?: Maybe<Array<Maybe<SalesTeam>>>;
  token?: Maybe<Scalars['String']>;
  trashed?: Maybe<Scalars['Boolean']>;
  userNotifications?: Maybe<Array<Maybe<UserNotification>>>;
  usersIProxy?: Maybe<Array<Maybe<User>>>;
};


export type UserRoleArgs = {
  trashed?: InputMaybe<Trashed>;
};


export type UserSalesTeamsArgs = {
  trashed?: InputMaybe<Trashed>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  campaign?: Maybe<Campaign>;
  campaign_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  source?: Maybe<CampaignChallenge>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserOption = {
  __typename?: 'UserOption';
  creation_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  search_name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type DaybookQueryVariables = Exact<{ [key: string]: never; }>;


export type DaybookQuery = { __typename?: 'Query', daybook?: { __typename?: 'Daybook', siteTitle?: string | null, abSplitAmounts?: boolean | null, hasSalesTax?: boolean | null, salesTaxAmount?: number | null, salesTaxLabel?: string | null, regionAreaBookingPricing?: boolean | null, assetUrl?: string | null, baseUrl?: string | null, previewUrl?: string | null, theme?: string | null, challengeEnabled?: boolean | null, jobListDefaultDistributor?: string | null, useCreativeStudio?: boolean | null, useAreaBookingToggle?: boolean | null, isFringebook?: boolean | null, defaultSiteCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, areaBookingPricingModels?: Array<{ __typename?: 'DaybookAreaBookingPricingRule', id?: string | null, code?: string | null, priority?: number | null, locationsLessThanTrigger?: number | null, baseWeeks?: number | null, locationsLessThanPercentage?: number | null, where?: { __typename?: 'DaybookAreaBookingPricingRuleWhere', campaignField?: string | null, rowField?: string | null, compare?: string | null, value?: string | null } | null, weekOverrides?: Array<{ __typename?: 'DaybookWeekOverride', multiplier?: number | null, overrideWeeks?: number | null, weeks?: number | null } | null> | null } | null> | null, pusherConfig?: { __typename?: 'DaybookPusherConfig', wsPort?: number | null, wssPort?: number | null, wsHost?: string | null, forceTLS?: boolean | null, secret?: string | null, key?: string | null, appId?: string | null } | null } | null };

export type AddAuthenticatorMutationVariables = Exact<{ [key: string]: never; }>;


export type AddAuthenticatorMutation = { __typename?: 'Mutation', addAuthenticatorCode?: { __typename?: 'AuthenticatorCode', code?: string | null } | null };

export type AddShortcutMutationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type AddShortcutMutationMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'User', id: string, campaignShortcuts?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null } | null> | null } | null };

export type EmailLoginRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type EmailLoginRequestMutation = { __typename?: 'Mutation', emailLoginRequest?: { __typename?: 'SuccessResult', success?: boolean | null, error?: string | null } | null };

export type EmailLoginMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type EmailLoginMutation = { __typename?: 'Mutation', emailLogin?: { __typename?: 'SuccessResult', success?: boolean | null, error?: string | null } | null };

export type MeDetailsFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, hasAuthenticatorQrCode?: boolean | null, hasPasskey?: boolean | null, activeChallengeCountInbound?: number | null, activeChallengeCountOutbound?: number | null, challengeCountOutboundNew?: number | null, challengeCountInboundNew?: number | null, token?: string | null, passkeys?: Array<{ __typename?: 'PasskeyCredential', id: string, credential_id: string, name?: string | null, sign_count?: number | null, backup_eligible?: boolean | null, backup_status?: boolean | null, uv_initialized?: boolean | null, last_used_at?: any | null, created_at?: any | null }> | null, userNotifications?: Array<{ __typename?: 'UserNotification', id: string, type?: string | null, status?: string | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null } | null> | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null } | null> | null, campaignShortcuts?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, is_locked?: boolean | null } | null> | null, options?: Array<{ __typename?: 'UserOption', id: string, name?: string | null, search_name?: string | null, value?: string | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null, usersIProxy?: Array<{ __typename?: 'User', id: string, name?: string | null } | null> | null };

export type GetMeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQueryQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, hasAuthenticatorQrCode?: boolean | null, hasPasskey?: boolean | null, activeChallengeCountInbound?: number | null, activeChallengeCountOutbound?: number | null, challengeCountOutboundNew?: number | null, challengeCountInboundNew?: number | null, token?: string | null, passkeys?: Array<{ __typename?: 'PasskeyCredential', id: string, credential_id: string, name?: string | null, sign_count?: number | null, backup_eligible?: boolean | null, backup_status?: boolean | null, uv_initialized?: boolean | null, last_used_at?: any | null, created_at?: any | null }> | null, userNotifications?: Array<{ __typename?: 'UserNotification', id: string, type?: string | null, status?: string | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null } | null> | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null } | null> | null, campaignShortcuts?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, is_locked?: boolean | null } | null> | null, options?: Array<{ __typename?: 'UserOption', id: string, name?: string | null, search_name?: string | null, value?: string | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null, usersIProxy?: Array<{ __typename?: 'User', id: string, name?: string | null } | null> | null } | null };

export type LoginMutationMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutationMutation = { __typename?: 'Mutation', login: { __typename?: 'AuthPayload', token_type: string, access_token: string, refresh_token: string, expires_in: number } };

export type LogoutMutationMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutationMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutResponse', status: string, message?: string | null } };

export type PasskeyDeleteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PasskeyDeleteMutation = { __typename?: 'Mutation', passkeyDelete?: { __typename?: 'SuccessResult', success?: boolean | null, error?: string | null } | null };

export type PasskeyLoginRequestMutationVariables = Exact<{ [key: string]: never; }>;


export type PasskeyLoginRequestMutation = { __typename?: 'Mutation', passkeyLoginRequest: { __typename?: 'PasskeyLoginRequest', options: any, challenge: string } };

export type PasskeyLoginMutationVariables = Exact<{
  credential: Scalars['JSON'];
}>;


export type PasskeyLoginMutation = { __typename?: 'Mutation', passkeyLogin: { __typename?: 'PasskeyAuthPayload', access_token: string, refresh_token?: string | null, expires_in: number, token_type: string, user: { __typename?: 'User', id: string, name?: string | null, email?: string | null } } };

export type PasskeyRegisterRequestMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type PasskeyRegisterRequestMutation = { __typename?: 'Mutation', passkeyRegisterRequest: { __typename?: 'PasskeyRegisterRequest', options: any, challenge: string } };

export type PasskeyRegisterMutationVariables = Exact<{
  credential: Scalars['JSON'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type PasskeyRegisterMutation = { __typename?: 'Mutation', passkeyRegister: { __typename?: 'PasskeyCredential', id: string, credential_id: string, name?: string | null, sign_count?: number | null, backup_eligible?: boolean | null, backup_status?: boolean | null, uv_initialized?: boolean | null, last_used_at?: any | null, created_at?: any | null } };

export type PasskeyRenameMutationVariables = Exact<{
  id: Scalars['ID'];
  name: Scalars['String'];
}>;


export type PasskeyRenameMutation = { __typename?: 'Mutation', passkeyRename: { __typename?: 'PasskeyCredential', id: string, name?: string | null } };

export type RefreshTokenMutationMutationVariables = Exact<{
  refresh_token?: InputMaybe<Scalars['String']>;
}>;


export type RefreshTokenMutationMutation = { __typename?: 'Mutation', refreshToken: { __typename?: 'AuthPayload', token_type: string, access_token: string, refresh_token: string, expires_in: number } };

export type RemoveShortcutMutationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveShortcutMutationMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'User', id: string, campaignShortcuts?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null } | null> | null } | null };

export type TwoFactorLoginMutationVariables = Exact<{
  code?: InputMaybe<Scalars['String']>;
}>;


export type TwoFactorLoginMutation = { __typename?: 'Mutation', twoFactorLogin?: { __typename?: 'SuccessResult', success?: boolean | null, error?: string | null } | null };

export type TwoFactorResetMutationVariables = Exact<{ [key: string]: never; }>;


export type TwoFactorResetMutation = { __typename?: 'Mutation', twoFactorReset?: { __typename?: 'SuccessResult', success?: boolean | null, error?: string | null } | null };

export type UpdateOptionsMutationMutationVariables = Exact<{
  options?: InputMaybe<UpdateUserOptions>;
}>;


export type UpdateOptionsMutationMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'User', id: string, options?: Array<{ __typename?: 'UserOption', id: string, name?: string | null, value?: string | null, search_name?: string | null } | null> | null } | null };

export type CurrenciesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrenciesQueryQuery = { __typename?: 'Query', currencies?: Array<{ __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null> | null };

export type CostSupplierQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CostSupplierQueryQuery = { __typename?: 'Query', costSuppliers: { __typename?: 'CostSupplierPaginator', data: Array<{ __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, trashed?: boolean | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null }> } };

export type CostSupplierCategoriesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CostSupplierCategoriesQueryQuery = { __typename?: 'Query', costSupplierCategories: { __typename?: 'CostSupplierCategoryPaginator', data: Array<{ __typename?: 'CostSupplierCategory', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null }> } };

export type AmbientTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AmbientTypeQueryQuery = { __typename?: 'Query', ambientTypes?: Array<{ __typename?: 'AmbientType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null> | null };

export type TvAreaQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type TvAreaQueryQuery = { __typename?: 'Query', tvAreas?: Array<{ __typename?: 'TVArea', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type BoroughQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BoroughQueryQuery = { __typename?: 'Query', boroughs: { __typename?: 'BoroughPaginator', data: Array<{ __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null }> } };

export type ClientCompanyGroupQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientCompanyGroupQueryQuery = { __typename?: 'Query', clientCompanyGroups: { __typename?: 'ClientCompanyGroupPaginator', data: Array<{ __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null }> } };

export type MediaTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MediaTypeQueryQuery = { __typename?: 'Query', mediaTypes: { __typename?: 'MediaTypePaginator', data: Array<{ __typename?: 'MediaType', id?: string | null, label?: string | null, trashed?: boolean | null }> } };

export type ContactsQueryQueryVariables = Exact<{
  accountsCompany_like?: InputMaybe<Scalars['String']>;
  salesCompany_like?: InputMaybe<Scalars['String']>;
  contactName_like?: InputMaybe<Scalars['String']>;
  salesTeam_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  user_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  credit_limit_between?: InputMaybe<IntRange>;
  salesAddress_like?: InputMaybe<Scalars['String']>;
  accountsCode_exact?: InputMaybe<Scalars['String']>;
  accountsAddress_like?: InputMaybe<Scalars['String']>;
}>;


export type ContactsQueryQuery = { __typename?: 'Query', clientCompanyContacts: { __typename?: 'ClientCompanyContactPaginator', data: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null, phone?: string | null, email?: string | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null }> } };

export type ClientQueryQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type ClientQueryQuery = { __typename?: 'Query', clientCompanyContacts: { __typename?: 'ClientCompanyContactPaginator', data: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null }> } };

export type QuickExchangeRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickExchangeRatesQuery = { __typename?: 'Query', exchangeRates?: Array<{ __typename?: 'ExchangeRate', id: string, rate?: number | null, from?: { __typename?: 'Currency', id: string } | null, to?: { __typename?: 'Currency', id: string } | null } | null> | null };

export type ExchangeRatesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExchangeRatesQuery = { __typename?: 'Query', exchangeRates?: Array<{ __typename?: 'ExchangeRate', id: string, rate?: number | null, from?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, to?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null };

export type ExchangeRatesMutationMutationVariables = Exact<{
  update: UpdateExchangeRates;
}>;


export type ExchangeRatesMutationMutation = { __typename?: 'Mutation', updateExchangeRates?: Array<{ __typename?: 'ExchangeRate', id: string, rate?: number | null, from?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, to?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null };

export type ClientCompaniesQueryQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_type_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  salesCompany_like?: InputMaybe<Scalars['String']>;
  accountsCompany_like?: InputMaybe<Scalars['String']>;
  credit_limit_between?: InputMaybe<IntRange>;
  accountsAddress_like?: InputMaybe<Scalars['String']>;
  salesAddress_like?: InputMaybe<Scalars['String']>;
  accountsCode_exact?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type ClientCompaniesQueryQuery = { __typename?: 'Query', clientCompanies: { __typename?: 'ClientCompanyPaginator', data: Array<{ __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null }> } };

export type ClientCompanyExtraQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientCompanyExtraQuery = { __typename?: 'Query', clientCompany?: { __typename?: 'ClientCompany', id: string, accounts_account_code?: string | null, accounts_address?: string | null, accounts_comments?: string | null, accounts_company?: string | null, accounts_contact?: string | null, accounts_phone?: string | null, accounts_email?: string | null, accounts_postcode?: string | null, credit_limit?: number | null, current_credit?: number | null, is_po_required?: boolean | null, is_vat_exempt?: boolean | null, other_contacts?: string | null, sales_address?: string | null, sales_company?: string | null, sales_contact?: string | null, sales_mobile?: string | null, sales_phone?: string | null, sales_postcode?: string | null, sales_title?: string | null, sales_type?: string | null, invoice_factored?: boolean | null, trashed?: boolean | null, contacts?: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null } | null> | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null } | null, clientCompanyGroup?: { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null };

export type ClientCompaniesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type ClientCompaniesQuery = { __typename?: 'Query', clientCompanies: { __typename?: 'ClientCompanyPaginator', data: Array<{ __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null }> } };

export type ClientCompanyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClientCompanyQuery = { __typename?: 'Query', clientCompany?: { __typename?: 'ClientCompany', id: string, accounts_account_code?: string | null, accounts_address?: string | null, accounts_comments?: string | null, accounts_company?: string | null, accounts_contact?: string | null, accounts_phone?: string | null, accounts_email?: string | null, accounts_postcode?: string | null, credit_limit?: number | null, current_credit?: number | null, is_po_required?: boolean | null, is_vat_exempt?: boolean | null, other_contacts?: string | null, sales_address?: string | null, sales_company?: string | null, sales_contact?: string | null, sales_mobile?: string | null, sales_phone?: string | null, sales_postcode?: string | null, sales_title?: string | null, sales_type?: string | null, invoice_factored?: boolean | null, trashed?: boolean | null, contacts?: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null } | null> | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null } | null, clientCompanyGroup?: { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null };

export type ClientCompanyContactQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type ClientCompanyContactQueryQuery = { __typename?: 'Query', clientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, comments?: string | null, is_marketing?: boolean | null, is_sales?: boolean | null, is_mailchimp?: boolean | null, job_sheet_info?: string | null, phone?: string | null, phone_alt?: string | null, title?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null } | null };

export type ClientCompanyContactListQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type ClientCompanyContactListQuery = { __typename?: 'Query', clientCompanyContacts: { __typename?: 'ClientCompanyContactPaginator', data: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null }> } };

export type ClientTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientTypeQueryQuery = { __typename?: 'Query', clientTypes: { __typename?: 'ClientTypePaginator', data: Array<{ __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null }> } };

export type ClientSubTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientSubTypeQueryQuery = { __typename?: 'Query', clientSubTypes: { __typename?: 'ClientSubTypePaginator', data: Array<{ __typename?: 'ClientSubType', id: string, name?: string | null, sales_team_prefix?: string | null, trashed?: boolean | null }> } };

export type DistributorsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DistributorsQueryQuery = { __typename?: 'Query', distributors: { __typename?: 'DistributorPaginator', data: Array<{ __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null }> } };

export type AreaBookingZoneQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AreaBookingZoneQueryQuery = { __typename?: 'Query', areaBookingZone?: Array<{ __typename?: 'AreaBookingZone', id: string, name: string } | null> | null };

export type ExperientialTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ExperientialTypeQueryQuery = { __typename?: 'Query', experientialTypes?: Array<{ __typename?: 'ExperientialType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null> | null };

export type PackQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PackQueryQuery = { __typename?: 'Query', packs?: Array<{ __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null } | null> | null };

export type PostInstructionQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PostInstructionQueryQuery = { __typename?: 'Query', postInstructions?: Array<{ __typename?: 'PostInstruction', id: string, label?: string | null, code?: string | null, trashed?: boolean | null } | null> | null };

export type StylesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type StylesQueryQuery = { __typename?: 'Query', styles?: Array<{ __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null> | null };

export type PosterSizeQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type PosterSizeQuery = { __typename?: 'Query', posterSize?: { __typename?: 'PosterSize', id: string, areaBookingRegionPricing?: Array<{ __typename?: 'AreaBookingRegionPricing', id: string, unit_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string } | null } | null> | null } | null };

export type PosterSizesQueryQueryVariables = Exact<{
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type PosterSizesQueryQuery = { __typename?: 'Query', posterSizes?: Array<{ __typename?: 'PosterSize', id: string, name?: string | null, dc_type?: string | null, is_larger_than_4?: boolean | null, is_panel_poster?: boolean | null, is_street_poster?: boolean | null, is_media_type?: boolean | null, customer_name?: string | null, londonCurrencyId?: number | null, regionalCurrencyId?: number | null, festivalCurrencyId?: number | null, internationalCurrencyId?: number | null, londonPricing?: number | null, regionalPricing?: number | null, festivalPricing?: number | null, internationalPricing?: number | null, slot_poster_count?: number | null, effective_poster_count?: number | null, trashed?: boolean | null, areaBookingRegionPricing?: Array<{ __typename?: 'AreaBookingRegionPricing', id: string, unit_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string } | null } | null> | null, regionTypePricing?: Array<{ __typename?: 'AreaBookingPricing', id: string, unit_value?: number | null, regionType?: { __typename?: 'RegionType', id: string } | null } | null> | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null> | null };

export type RegionSelectGroupedQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionSelectGroupedQueryQuery = { __typename?: 'Query', regionTypes: { __typename?: 'RegionTypePaginator', data: Array<{ __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null> | null }> } };

export type RegionTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionTypesQueryQuery = { __typename?: 'Query', regionTypes: { __typename?: 'RegionTypePaginator', data: Array<{ __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null> | null }> } };

export type RegionsQueryQueryVariables = Exact<{
  regionTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type RegionsQueryQuery = { __typename?: 'Query', regions: { __typename?: 'RegionPaginator', data: Array<{ __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null }> } };

export type CreativeStudioTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type CreativeStudioTypesQueryQuery = { __typename?: 'Query', creativeStudioTypes: Array<{ __typename?: 'CreativeStudioType', id: string, name: string }> };

export type CreativeStudioTypesDetailsQueryQueryVariables = Exact<{
  creativeStudioTypeId?: InputMaybe<Scalars['ID']>;
}>;


export type CreativeStudioTypesDetailsQueryQuery = { __typename?: 'Query', creativeStudioTypeDetails: Array<{ __typename?: 'CreativeStudioTypeDetail', id: string, name: string }> };

export type UpdateAreaBookingRegionPricingMutationVariables = Exact<{
  update?: InputMaybe<UpdateAreaBookingRegionPricings>;
}>;


export type UpdateAreaBookingRegionPricingMutation = { __typename?: 'Mutation', updateAreaBookingRegionPricing?: Array<{ __typename?: 'AreaBookingRegionPricing', id: string, unit_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string } | null } | null> | null };

export type CostSuppliersMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateCostSuppliersInput>;
}>;


export type CostSuppliersMutationMutation = { __typename?: 'Mutation', updateCostSuppliers?: Array<{ __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, trashed?: boolean | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null> | null };

export type CostSupplierCategoriesMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateCostSupplierCategoriesInput>;
}>;


export type CostSupplierCategoriesMutationMutation = { __typename?: 'Mutation', updateCostSupplierCategories?: Array<{ __typename?: 'CostSupplierCategory', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null> | null };

export type SitesMutationMutationVariables = Exact<{
  input: UpdateSites;
}>;


export type SitesMutationMutation = { __typename?: 'Mutation', updateSites?: Array<{ __typename?: 'Site', address1?: string | null, address2?: string | null, photo_archive_url?: string | null, pops_url?: string | null, build_date?: string | null, description?: string | null, id: string, impacts?: number | null, name?: string | null, notes?: string | null, latitude?: string | null, longitude?: string | null, three_words?: string | null, is_illumination?: boolean | null, is_3p?: boolean | null, is_dynamic?: boolean | null, is_dashboard_site?: boolean | null, postcode?: string | null, road_number?: string | null, site_code?: string | null, poster_portfolio_url?: string | null, rate_card_url?: string | null, tvArea?: { __typename?: 'TVArea', id: string, label?: string | null, trashed?: boolean | null } | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null, panels?: Array<{ __typename?: 'Panel', id: string, code?: string | null, restriction?: string | null, number_of_slots?: number | null, owner?: string | null, notes?: string | null, panel?: string | null, posters_per_slot?: number | null, creation_id?: string | null, pack?: { __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null } | null, postInstruction?: { __typename?: 'PostInstruction', id: string, label?: string | null, code?: string | null, trashed?: boolean | null } | null, panelAvailabilities?: Array<{ __typename?: 'PanelAvailability', id: string, first_week?: string | null, last_week?: string | null, availability?: string | null, reason?: string | null, creation_id?: string | null } | null> | null } | null> | null, sitePricing?: { __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, tags?: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null } | null> | null, takeoverSite?: { __typename?: 'Site', id: string, name?: string | null } | null, takeoverSitesManagedByThis?: Array<{ __typename?: 'Site', id: string, name?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null } | null, siteStructureType?: { __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null } | null, siteImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteFilesOther?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteBuildAndRepairs?: Array<{ __typename?: 'SiteBuildAndRepairs', id: string, creation_id?: string | null, panel?: string | null, cancelled?: string | null, costs_excluding_vat?: number | null, costs_1?: number | null, costs_2?: number | null, costs_3?: number | null, costs_4?: number | null, costs_5?: number | null, costs_comments_1?: string | null, costs_comments_2?: string | null, costs_comments_3?: string | null, costs_comments_4?: string | null, costs_comments_5?: string | null, quantity?: number | null, issued_by?: string | null, additional_info?: string | null, completion_deadline?: string | null, completion_date?: string | null, invoice_number?: string | null, po_number?: string | null, buildType?: { __typename?: 'SiteBuildType', id: string, label?: string | null, trashed?: boolean | null } | null, buildContractor?: { __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteMaintenanceInspection?: Array<{ __typename?: 'SiteMaintenanceInspection', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, siteMaintenanceInspectionType?: { __typename?: 'SiteMaintenanceInspectionType', id: string, label?: string | null } | null } | null> | null, siteRentals?: Array<{ __typename?: 'SiteRental', creation_id?: string | null, id: string, amount?: number | null, start_date?: string | null, expiry_date?: string | null, increase_date?: string | null, comments?: string | null, contact?: string | null, contact_code?: string | null, freeholder?: boolean | null, is_cancelled?: boolean | null, is_rolling?: boolean | null, rentalType?: { __typename?: 'SiteRentalType', id: string, label?: string | null, trashed?: boolean | null } | null, paymentMethod?: { __typename?: 'SiteRentalPaymentMethod', id: string, label?: string | null, trashed?: boolean | null } | null, paymentFrequency?: { __typename?: 'SiteRentalPaymentFrequency', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteHealthAndSafeties?: Array<{ __typename?: 'SiteHealthAndSafety', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, healthAndSafetyType?: { __typename?: 'SiteHealthAndSafetyType', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, sitePayments?: Array<{ __typename?: 'SitePayment', id: string, creation_id?: string | null, amount?: number | null, date?: string | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, siteDigitalBookingPricing?: Array<{ __typename?: 'SiteDigitalBookingPricing', id: string, creation_id?: string | null, days: number, net: number } | null> | null, sitePlannings?: Array<{ __typename?: 'SitePlanning', id: string, notes?: string | null, outcome_notes?: string | null, planning_date?: string | null, outcome_date?: string | null, amount?: number | null, creation_id?: string | null, planningStage?: { __typename?: 'SitePlanningStage', id: string, label?: string | null, trashed?: boolean | null } | null, planningOutcome?: { __typename?: 'SitePlanningOutcome', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, subletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, trashed?: boolean | null } | null, galleryImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, layoutImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null } | null> | null };

export type CreateRoleMutationVariables = Exact<{
  input?: InputMaybe<CreateRoleInput>;
}>;


export type CreateRoleMutation = { __typename?: 'Mutation', createRole?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null };

export type UpdateRoleMutationVariables = Exact<{
  input?: InputMaybe<UpdateRoleInput>;
}>;


export type UpdateRoleMutation = { __typename?: 'Mutation', updateRole?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null };

export type RolesMutationMutationVariables = Exact<{
  input: UpdateRoles;
}>;


export type RolesMutationMutation = { __typename?: 'Mutation', updateRoles?: Array<{ __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null> | null };

export type GetRoleQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetRoleQuery = { __typename?: 'Query', role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null };

export type LogEntriesQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  archived?: InputMaybe<Scalars['Boolean']>;
}>;


export type LogEntriesQueryQuery = { __typename?: 'Query', logEntries?: Array<{ __typename?: 'LogEntry', id: string, kind: LogEntryKind, label?: string | null, occurredAt: string, totalPrice?: number | null, totalPriceWithVat?: number | null, status?: string | null, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null> | null };

export type LogEntryDetailQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type LogEntryDetailQueryQuery = { __typename?: 'Query', logEntryDetail?: { __typename?: 'LogEntry', payload?: any | null, id: string, kind: LogEntryKind, label?: string | null, occurredAt: string, totalPrice?: number | null, totalPriceWithVat?: number | null, status?: string | null, fields?: Array<{ __typename?: 'LogField', subject?: string | null, field?: string | null, label?: string | null, oldValue?: string | null, newValue?: string | null } | null> | null, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null };

export type GetAreaBookingRegionPricingsQueryVariables = Exact<{
  region_id?: InputMaybe<Scalars['ID']>;
  poster_size_id?: InputMaybe<Scalars['ID']>;
}>;


export type GetAreaBookingRegionPricingsQuery = { __typename?: 'Query', getAreaBookingRegionPricings?: Array<{ __typename?: 'AreaBookingRegionPricing', id: string, unit_value?: number | null, region?: { __typename?: 'Region', id: string } | null, posterSize?: { __typename?: 'PosterSize', id: string } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null };

export type PermissionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsQueryQuery = { __typename?: 'Query', permissions: { __typename?: 'PermissionPaginator', data: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null }> } };

export type RolesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQueryQuery = { __typename?: 'Query', roles: { __typename?: 'RolePaginator', data: Array<{ __typename?: 'Role', id: string, name?: string | null }> } };

export type PaymentTermQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentTermQueryQuery = { __typename?: 'Query', paymentTerm?: Array<{ __typename?: 'PaymentTerm', id: string, name?: string | null } | null> | null };

export type SubletterQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SubletterQueryQuery = { __typename?: 'Query', subletters?: Array<{ __typename?: 'Subletter', id?: string | null, name?: string | null, trashed?: boolean | null } | null> | null };

export type SubletterMutationMutationVariables = Exact<{
  input?: InputMaybe<UpdateSubletter>;
}>;


export type SubletterMutationMutation = { __typename?: 'Mutation', updateSubletters?: Array<{ __typename?: 'Subletter', id?: string | null, name?: string | null, contact_name?: string | null, company?: string | null, email?: string | null, email_2?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, postcode?: string | null, telephone_1?: string | null, telephone_2?: string | null, trashed?: boolean | null } | null> | null };

export type ProposalOptionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ProposalOptionsQueryQuery = { __typename?: 'Query', proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null };

export type SalesTeamQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SalesTeamQueryQuery = { __typename?: 'Query', salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, prefix?: string | null, trashed?: boolean | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null> | null };

export type GetSalesTeamQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetSalesTeamQueryQuery = { __typename?: 'Query', salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null, prefix?: string | null, trashed?: boolean | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null };

export type SalesTeamMutationMutationVariables = Exact<{
  input: UpdateSalesTeam;
}>;


export type SalesTeamMutationMutation = { __typename?: 'Mutation', updateSalesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, prefix?: string | null, trashed?: boolean | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null> | null };

export type CreateSalesTeamMutationMutationVariables = Exact<{
  input: CreateSalesTeamInput;
}>;


export type CreateSalesTeamMutationMutation = { __typename?: 'Mutation', createSalesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null, prefix?: string | null, trashed?: boolean | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null };

export type UpdateSalesTeamMutationMutationVariables = Exact<{
  input: UpdateSalesTeamInput;
}>;


export type UpdateSalesTeamMutationMutation = { __typename?: 'Mutation', updateSalesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null, prefix?: string | null, trashed?: boolean | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null };

export type OptionsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type OptionsQueryQuery = { __typename?: 'Query', options?: Array<{ __typename?: 'Option', id: string, label?: string | null, type?: string | null } | null> | null };

export type UpdateDistributorsMutationMutationVariables = Exact<{
  input: UpdateDistributor;
}>;


export type UpdateDistributorsMutationMutation = { __typename?: 'Mutation', updateDistributors?: Array<{ __typename?: 'Distributor', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null> | null };

export type SiteHealthAndSafetyTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteHealthAndSafetyTypeQueryQuery = { __typename?: 'Query', siteHealthAndSafetyTypes?: Array<{ __typename?: 'SiteHealthAndSafetyType', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type SitePlanningOutcomeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SitePlanningOutcomeQueryQuery = { __typename?: 'Query', sitePlanningOutcomes?: Array<{ __typename?: 'SitePlanningOutcome', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type SitePlanningStagesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SitePlanningStagesQueryQuery = { __typename?: 'Query', sitePlanningStages?: Array<{ __typename?: 'SitePlanningStage', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type SitePricingsMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateSitePricings>;
}>;


export type SitePricingsMutationMutation = { __typename?: 'Mutation', updateSitePricings?: Array<{ __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null };

export type SitePricingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SitePricingQueryQuery = { __typename?: 'Query', sitePricings?: Array<{ __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null };

export type SiteRentalPaymentFrequenciesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteRentalPaymentFrequenciesQueryQuery = { __typename?: 'Query', siteRentalPaymentFrequencies?: Array<{ __typename?: 'SiteRentalPaymentFrequency', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type SiteRentalPaymentMethodsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteRentalPaymentMethodsQueryQuery = { __typename?: 'Query', siteRentalPaymentMethods?: Array<{ __typename?: 'SiteRentalPaymentMethod', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type SiteRentalTypesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteRentalTypesQueryQuery = { __typename?: 'Query', siteRentalTypes?: Array<{ __typename?: 'SiteRentalType', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type SiteStructureTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteStructureTypeQueryQuery = { __typename?: 'Query', siteStructureTypes?: Array<{ __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null } | null> | null };

export type SiteStructureGroupQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteStructureGroupQueryQuery = { __typename?: 'Query', siteStructureGroups?: Array<{ __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null> | null };

export type SiteStructureQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteStructureQueryQuery = { __typename?: 'Query', siteStructures?: Array<{ __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null } | null> | null };

export type SiteStructuresMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateSiteStructure>;
}>;


export type SiteStructuresMutationMutation = { __typename?: 'Mutation', updateSiteStructure?: Array<{ __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null } | null> | null };

export type SundryTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type SundryTypeQueryQuery = { __typename?: 'Query', sundryTypes?: Array<{ __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null } | null> | null };

export type BuildTypeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BuildTypeQueryQuery = { __typename?: 'Query', siteBuildTypes?: Array<{ __typename?: 'SiteBuildType', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type BuildContractorQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type BuildContractorQueryQuery = { __typename?: 'Query', siteBuildContractors?: Array<{ __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type UserQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type UserQueryQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null> | null };

export type GetUserQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetUserQueryQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, password?: string | null, lockout_until?: string | null, failed_2fa_count?: number | null, failed_password_count?: number | null, hasAuthenticatorQrCode?: boolean | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null } | null };

export type CreateUserMutationMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutationMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, password?: string | null, lockout_until?: string | null, failed_2fa_count?: number | null, failed_password_count?: number | null, hasAuthenticatorQrCode?: boolean | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null } | null };

export type UpdateUserMutationMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutationMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, password?: string | null, lockout_until?: string | null, failed_2fa_count?: number | null, failed_password_count?: number | null, hasAuthenticatorQrCode?: boolean | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null } | null };

export type PingQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQueryQuery = { __typename?: 'Query', ping?: { __typename?: 'PingResult', JSVersion?: number | null } | null };

export type UserMutationMutationVariables = Exact<{
  input: UpdateUser;
}>;


export type UserMutationMutation = { __typename?: 'Mutation', updateUsers?: Array<{ __typename?: 'User', id: string, name?: string | null, email?: string | null, password?: string | null, lockout_until?: string | null, failed_2fa_count?: number | null, failed_password_count?: number | null, hasAuthenticatorQrCode?: boolean | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null } | null> | null };

export type ChangeCompanyMutationMutationVariables = Exact<{
  contact?: InputMaybe<UpdateClientCompanyContactInput>;
}>;


export type ChangeCompanyMutationMutation = { __typename?: 'Mutation', updateClientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, comments?: string | null, is_marketing?: boolean | null, is_sales?: boolean | null, is_mailchimp?: boolean | null, job_sheet_info?: string | null, phone?: string | null, phone_alt?: string | null, title?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null } | null };

export type CompaniesMutationMutationVariables = Exact<{
  input?: InputMaybe<UpdateClientCompany>;
}>;


export type CompaniesMutationMutation = { __typename?: 'Mutation', updateClientCompanies?: Array<{ __typename?: 'ClientCompany', id: string, accounts_account_code?: string | null, accounts_address?: string | null, accounts_comments?: string | null, accounts_company?: string | null, accounts_contact?: string | null, accounts_phone?: string | null, accounts_email?: string | null, accounts_postcode?: string | null, credit_limit?: number | null, current_credit?: number | null, is_po_required?: boolean | null, is_vat_exempt?: boolean | null, other_contacts?: string | null, sales_address?: string | null, sales_company?: string | null, sales_contact?: string | null, sales_mobile?: string | null, sales_phone?: string | null, sales_postcode?: string | null, sales_title?: string | null, sales_type?: string | null, invoice_factored?: boolean | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null } | null, clientCompanyGroup?: { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null> | null };

export type BoroughsMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateBorough>;
}>;


export type BoroughsMutationMutation = { __typename?: 'Mutation', updateBoroughs?: Array<{ __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null> | null };

export type ClientCompanyGroupsMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateClientCompanyGroup>;
}>;


export type ClientCompanyGroupsMutationMutation = { __typename?: 'Mutation', updateClientCompanyGroups?: Array<{ __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null> | null };

export type MediaTypesMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateMediaTypes>;
}>;


export type MediaTypesMutationMutation = { __typename?: 'Mutation', updateMediaTypes?: Array<{ __typename?: 'MediaType', id?: string | null, label?: string | null, trashed?: boolean | null } | null> | null };

export type UpdateClientCompanyContactMutationVariables = Exact<{
  input?: InputMaybe<UpdateClientCompanyContactInput>;
}>;


export type UpdateClientCompanyContactMutation = { __typename?: 'Mutation', updateClientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, comments?: string | null, is_marketing?: boolean | null, is_sales?: boolean | null, is_mailchimp?: boolean | null, job_sheet_info?: string | null, phone?: string | null, phone_alt?: string | null, title?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null } | null };

export type CreateClientCompanyContactMutationVariables = Exact<{
  input?: InputMaybe<CreateClientCompanyContactInput>;
}>;


export type CreateClientCompanyContactMutation = { __typename?: 'Mutation', createClientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, comments?: string | null, is_marketing?: boolean | null, is_sales?: boolean | null, is_mailchimp?: boolean | null, job_sheet_info?: string | null, phone?: string | null, phone_alt?: string | null, title?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null } | null };

export type ContactsMutationNewMutationVariables = Exact<{
  input?: InputMaybe<UpdateClientCompanyContact>;
}>;


export type ContactsMutationNewMutation = { __typename?: 'Mutation', updateClientCompanyContacts?: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, comments?: string | null, is_marketing?: boolean | null, is_sales?: boolean | null, is_mailchimp?: boolean | null, job_sheet_info?: string | null, phone?: string | null, phone_alt?: string | null, title?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null } | null> | null };

export type ContactsMutationMutationVariables = Exact<{
  input?: InputMaybe<UpdateClientCompanyContact>;
}>;


export type ContactsMutationMutation = { __typename?: 'Mutation', updateClientCompanyContacts?: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, comments?: string | null, is_marketing?: boolean | null, is_sales?: boolean | null, is_mailchimp?: boolean | null, job_sheet_info?: string | null, phone?: string | null, phone_alt?: string | null, title?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null } | null> | null };

export type PosterSizesMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdatePosterSize>;
  regions?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type PosterSizesMutationMutation = { __typename?: 'Mutation', updatePosterSizes?: Array<{ __typename?: 'PosterSize', id: string, name?: string | null, dc_type?: string | null, is_larger_than_4?: boolean | null, is_panel_poster?: boolean | null, is_street_poster?: boolean | null, is_media_type?: boolean | null, customer_name?: string | null, londonCurrencyId?: number | null, regionalCurrencyId?: number | null, festivalCurrencyId?: number | null, internationalCurrencyId?: number | null, londonPricing?: number | null, regionalPricing?: number | null, festivalPricing?: number | null, internationalPricing?: number | null, slot_poster_count?: number | null, effective_poster_count?: number | null, trashed?: boolean | null, areaBookingRegionPricing?: Array<{ __typename?: 'AreaBookingRegionPricing', id: string, unit_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string } | null } | null> | null, regionTypePricing?: Array<{ __typename?: 'AreaBookingPricing', id: string, unit_value?: number | null, regionType?: { __typename?: 'RegionType', id: string } | null } | null> | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null> | null };

export type PacksMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdatePacks>;
}>;


export type PacksMutationMutation = { __typename?: 'Mutation', updatePacks?: Array<{ __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null } | null> | null };

export type OptionsMutationMutationVariables = Exact<{
  input?: InputMaybe<UpdateOptions>;
}>;


export type OptionsMutationMutation = { __typename?: 'Mutation', updateOptions?: Array<{ __typename?: 'Option', id: string, label?: string | null, code?: string | null, type?: string | null, int_value?: number | null, bool_value?: boolean | null, text_value?: string | null } | null> | null };

export type CreatePanelBookingMutationMutationVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
  weekNumber?: InputMaybe<Scalars['Int']>;
  numWeeks?: InputMaybe<Scalars['Int']>;
  panelId?: InputMaybe<Scalars['ID']>;
  isSlot?: InputMaybe<Scalars['Boolean']>;
  posterSizeId?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
}>;


export type CreatePanelBookingMutationMutation = { __typename?: 'Mutation', createPanelBooking?: Array<{ __typename?: 'PanelBookingDateSummary', id: string, weekNumber?: number | null, campaignName?: string | null, count?: number | null, status?: string | null, type?: string | null, panelStatus?: string | null, instruction?: string | null, campaign_challenge_booking_id?: number | null, campaigns?: Array<{ __typename?: 'PanelBookingDateCampaign', id: string, name?: string | null, status?: string | null } | null> | null } | null> | null };

export type SearchPanelsQueryQueryVariables = Exact<{
  region_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  region_type_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  site_name_like?: InputMaybe<Scalars['String']>;
  site_id?: InputMaybe<Scalars['ID']>;
  site_tags_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  site_structure_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  site_structure_like?: InputMaybe<Scalars['String']>;
  site_structure_group?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  campaign_like?: InputMaybe<Scalars['String']>;
  pack_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  pack_not?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  panel_number?: InputMaybe<Scalars['String']>;
  distributor_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  start_week?: InputMaybe<Scalars['Int']>;
  num_weeks?: InputMaybe<Scalars['Int']>;
  postcode_like?: InputMaybe<Scalars['String']>;
  postcode_rlike?: InputMaybe<Scalars['String']>;
  borough_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  panel_search_type_s?: InputMaybe<Scalars['String']>;
  panel_search_type_w?: InputMaybe<Scalars['ID']>;
  frozen_as?: InputMaybe<Scalars['String']>;
  frozen_week?: InputMaybe<Scalars['Int']>;
}>;


export type SearchPanelsQueryQuery = { __typename?: 'Query', panelSearch?: Array<{ __typename?: 'Panel', id: string, panel?: string | null, number_of_slots?: number | null, pack?: { __typename?: 'Pack', id: string, label?: string | null, style?: { __typename?: 'Style', id: string, label?: string | null } | null } | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, address2?: string | null, postcode?: string | null, site_code?: string | null, boroughOrRegion?: string | null, thumbnail?: string | null, externalLink?: string | null, descriptionHTML?: string | null, is_dashboard_site?: boolean | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null } | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null } | null, panelBookingDatesSummary?: Array<{ __typename?: 'PanelBookingDateSummary', id: string, weekNumber?: number | null, campaignName?: string | null, count?: number | null, status?: string | null, type?: string | null, panelStatus?: string | null, instruction?: string | null, campaign_challenge_booking_id?: number | null, campaigns?: Array<{ __typename?: 'PanelBookingDateCampaign', id: string, name?: string | null, status?: string | null } | null> | null } | null> | null } | null> | null };

export type GetSiteQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  site_code?: InputMaybe<Scalars['String']>;
}>;


export type GetSiteQueryQuery = { __typename?: 'Query', site?: { __typename?: 'Site', address1?: string | null, address2?: string | null, photo_archive_url?: string | null, pops_url?: string | null, build_date?: string | null, description?: string | null, id: string, impacts?: number | null, name?: string | null, notes?: string | null, latitude?: string | null, longitude?: string | null, three_words?: string | null, is_illumination?: boolean | null, is_3p?: boolean | null, is_dynamic?: boolean | null, is_dashboard_site?: boolean | null, postcode?: string | null, road_number?: string | null, site_code?: string | null, poster_portfolio_url?: string | null, rate_card_url?: string | null, tvArea?: { __typename?: 'TVArea', id: string, label?: string | null, trashed?: boolean | null } | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null, panels?: Array<{ __typename?: 'Panel', id: string, code?: string | null, restriction?: string | null, number_of_slots?: number | null, owner?: string | null, notes?: string | null, panel?: string | null, posters_per_slot?: number | null, creation_id?: string | null, pack?: { __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null } | null, postInstruction?: { __typename?: 'PostInstruction', id: string, label?: string | null, code?: string | null, trashed?: boolean | null } | null, panelAvailabilities?: Array<{ __typename?: 'PanelAvailability', id: string, first_week?: string | null, last_week?: string | null, availability?: string | null, reason?: string | null, creation_id?: string | null } | null> | null } | null> | null, sitePricing?: { __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, tags?: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null } | null> | null, takeoverSite?: { __typename?: 'Site', id: string, name?: string | null } | null, takeoverSitesManagedByThis?: Array<{ __typename?: 'Site', id: string, name?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null } | null, siteStructureType?: { __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null } | null, siteImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteFilesOther?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteBuildAndRepairs?: Array<{ __typename?: 'SiteBuildAndRepairs', id: string, creation_id?: string | null, panel?: string | null, cancelled?: string | null, costs_excluding_vat?: number | null, costs_1?: number | null, costs_2?: number | null, costs_3?: number | null, costs_4?: number | null, costs_5?: number | null, costs_comments_1?: string | null, costs_comments_2?: string | null, costs_comments_3?: string | null, costs_comments_4?: string | null, costs_comments_5?: string | null, quantity?: number | null, issued_by?: string | null, additional_info?: string | null, completion_deadline?: string | null, completion_date?: string | null, invoice_number?: string | null, po_number?: string | null, buildType?: { __typename?: 'SiteBuildType', id: string, label?: string | null, trashed?: boolean | null } | null, buildContractor?: { __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteMaintenanceInspection?: Array<{ __typename?: 'SiteMaintenanceInspection', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, siteMaintenanceInspectionType?: { __typename?: 'SiteMaintenanceInspectionType', id: string, label?: string | null } | null } | null> | null, siteRentals?: Array<{ __typename?: 'SiteRental', creation_id?: string | null, id: string, amount?: number | null, start_date?: string | null, expiry_date?: string | null, increase_date?: string | null, comments?: string | null, contact?: string | null, contact_code?: string | null, freeholder?: boolean | null, is_cancelled?: boolean | null, is_rolling?: boolean | null, rentalType?: { __typename?: 'SiteRentalType', id: string, label?: string | null, trashed?: boolean | null } | null, paymentMethod?: { __typename?: 'SiteRentalPaymentMethod', id: string, label?: string | null, trashed?: boolean | null } | null, paymentFrequency?: { __typename?: 'SiteRentalPaymentFrequency', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteHealthAndSafeties?: Array<{ __typename?: 'SiteHealthAndSafety', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, healthAndSafetyType?: { __typename?: 'SiteHealthAndSafetyType', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, sitePayments?: Array<{ __typename?: 'SitePayment', id: string, creation_id?: string | null, amount?: number | null, date?: string | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, siteDigitalBookingPricing?: Array<{ __typename?: 'SiteDigitalBookingPricing', id: string, creation_id?: string | null, days: number, net: number } | null> | null, sitePlannings?: Array<{ __typename?: 'SitePlanning', id: string, notes?: string | null, outcome_notes?: string | null, planning_date?: string | null, outcome_date?: string | null, amount?: number | null, creation_id?: string | null, planningStage?: { __typename?: 'SitePlanningStage', id: string, label?: string | null, trashed?: boolean | null } | null, planningOutcome?: { __typename?: 'SitePlanningOutcome', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, subletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, trashed?: boolean | null } | null, galleryImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, layoutImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null } | null };

export type UpdateSiteMutationMutationVariables = Exact<{
  input: UpdateSiteInput;
}>;


export type UpdateSiteMutationMutation = { __typename?: 'Mutation', updateSite?: { __typename?: 'Site', address1?: string | null, address2?: string | null, photo_archive_url?: string | null, pops_url?: string | null, build_date?: string | null, description?: string | null, id: string, impacts?: number | null, name?: string | null, notes?: string | null, latitude?: string | null, longitude?: string | null, three_words?: string | null, is_illumination?: boolean | null, is_3p?: boolean | null, is_dynamic?: boolean | null, is_dashboard_site?: boolean | null, postcode?: string | null, road_number?: string | null, site_code?: string | null, poster_portfolio_url?: string | null, rate_card_url?: string | null, tvArea?: { __typename?: 'TVArea', id: string, label?: string | null, trashed?: boolean | null } | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null, panels?: Array<{ __typename?: 'Panel', id: string, code?: string | null, restriction?: string | null, number_of_slots?: number | null, owner?: string | null, notes?: string | null, panel?: string | null, posters_per_slot?: number | null, creation_id?: string | null, pack?: { __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null } | null, postInstruction?: { __typename?: 'PostInstruction', id: string, label?: string | null, code?: string | null, trashed?: boolean | null } | null, panelAvailabilities?: Array<{ __typename?: 'PanelAvailability', id: string, first_week?: string | null, last_week?: string | null, availability?: string | null, reason?: string | null, creation_id?: string | null } | null> | null } | null> | null, sitePricing?: { __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, tags?: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null } | null> | null, takeoverSite?: { __typename?: 'Site', id: string, name?: string | null } | null, takeoverSitesManagedByThis?: Array<{ __typename?: 'Site', id: string, name?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null } | null, siteStructureType?: { __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null } | null, siteImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteFilesOther?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteBuildAndRepairs?: Array<{ __typename?: 'SiteBuildAndRepairs', id: string, creation_id?: string | null, panel?: string | null, cancelled?: string | null, costs_excluding_vat?: number | null, costs_1?: number | null, costs_2?: number | null, costs_3?: number | null, costs_4?: number | null, costs_5?: number | null, costs_comments_1?: string | null, costs_comments_2?: string | null, costs_comments_3?: string | null, costs_comments_4?: string | null, costs_comments_5?: string | null, quantity?: number | null, issued_by?: string | null, additional_info?: string | null, completion_deadline?: string | null, completion_date?: string | null, invoice_number?: string | null, po_number?: string | null, buildType?: { __typename?: 'SiteBuildType', id: string, label?: string | null, trashed?: boolean | null } | null, buildContractor?: { __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteMaintenanceInspection?: Array<{ __typename?: 'SiteMaintenanceInspection', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, siteMaintenanceInspectionType?: { __typename?: 'SiteMaintenanceInspectionType', id: string, label?: string | null } | null } | null> | null, siteRentals?: Array<{ __typename?: 'SiteRental', creation_id?: string | null, id: string, amount?: number | null, start_date?: string | null, expiry_date?: string | null, increase_date?: string | null, comments?: string | null, contact?: string | null, contact_code?: string | null, freeholder?: boolean | null, is_cancelled?: boolean | null, is_rolling?: boolean | null, rentalType?: { __typename?: 'SiteRentalType', id: string, label?: string | null, trashed?: boolean | null } | null, paymentMethod?: { __typename?: 'SiteRentalPaymentMethod', id: string, label?: string | null, trashed?: boolean | null } | null, paymentFrequency?: { __typename?: 'SiteRentalPaymentFrequency', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteHealthAndSafeties?: Array<{ __typename?: 'SiteHealthAndSafety', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, healthAndSafetyType?: { __typename?: 'SiteHealthAndSafetyType', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, sitePayments?: Array<{ __typename?: 'SitePayment', id: string, creation_id?: string | null, amount?: number | null, date?: string | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, siteDigitalBookingPricing?: Array<{ __typename?: 'SiteDigitalBookingPricing', id: string, creation_id?: string | null, days: number, net: number } | null> | null, sitePlannings?: Array<{ __typename?: 'SitePlanning', id: string, notes?: string | null, outcome_notes?: string | null, planning_date?: string | null, outcome_date?: string | null, amount?: number | null, creation_id?: string | null, planningStage?: { __typename?: 'SitePlanningStage', id: string, label?: string | null, trashed?: boolean | null } | null, planningOutcome?: { __typename?: 'SitePlanningOutcome', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, subletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, trashed?: boolean | null } | null, galleryImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, layoutImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null } | null };

export type SiteMaintenanceInspectionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteMaintenanceInspectionTypesQuery = { __typename?: 'Query', inspectionTypes: Array<{ __typename?: 'SiteMaintenanceInspectionType', id: string, label?: string | null }> };

export type CreateMaintenanceInspectionLogMutationVariables = Exact<{
  input: CreateMaintenanceInspectionInput;
}>;


export type CreateMaintenanceInspectionLogMutation = { __typename?: 'Mutation', createMaintenanceInspectionLog?: { __typename?: 'SiteMaintenanceInspection', id: string } | null };

export type CreateSiteMutationMutationVariables = Exact<{
  input: CreateSiteInput;
}>;


export type CreateSiteMutationMutation = { __typename?: 'Mutation', createSite?: { __typename?: 'Site', address1?: string | null, address2?: string | null, photo_archive_url?: string | null, pops_url?: string | null, build_date?: string | null, description?: string | null, id: string, impacts?: number | null, name?: string | null, notes?: string | null, latitude?: string | null, longitude?: string | null, three_words?: string | null, is_illumination?: boolean | null, is_3p?: boolean | null, is_dynamic?: boolean | null, is_dashboard_site?: boolean | null, postcode?: string | null, road_number?: string | null, site_code?: string | null, poster_portfolio_url?: string | null, rate_card_url?: string | null, tvArea?: { __typename?: 'TVArea', id: string, label?: string | null, trashed?: boolean | null } | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null, panels?: Array<{ __typename?: 'Panel', id: string, code?: string | null, restriction?: string | null, number_of_slots?: number | null, owner?: string | null, notes?: string | null, panel?: string | null, posters_per_slot?: number | null, creation_id?: string | null, pack?: { __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null } | null, postInstruction?: { __typename?: 'PostInstruction', id: string, label?: string | null, code?: string | null, trashed?: boolean | null } | null, panelAvailabilities?: Array<{ __typename?: 'PanelAvailability', id: string, first_week?: string | null, last_week?: string | null, availability?: string | null, reason?: string | null, creation_id?: string | null } | null> | null } | null> | null, sitePricing?: { __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, tags?: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null } | null> | null, takeoverSite?: { __typename?: 'Site', id: string, name?: string | null } | null, takeoverSitesManagedByThis?: Array<{ __typename?: 'Site', id: string, name?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null } | null, siteStructureType?: { __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null } | null, siteImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteFilesOther?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteBuildAndRepairs?: Array<{ __typename?: 'SiteBuildAndRepairs', id: string, creation_id?: string | null, panel?: string | null, cancelled?: string | null, costs_excluding_vat?: number | null, costs_1?: number | null, costs_2?: number | null, costs_3?: number | null, costs_4?: number | null, costs_5?: number | null, costs_comments_1?: string | null, costs_comments_2?: string | null, costs_comments_3?: string | null, costs_comments_4?: string | null, costs_comments_5?: string | null, quantity?: number | null, issued_by?: string | null, additional_info?: string | null, completion_deadline?: string | null, completion_date?: string | null, invoice_number?: string | null, po_number?: string | null, buildType?: { __typename?: 'SiteBuildType', id: string, label?: string | null, trashed?: boolean | null } | null, buildContractor?: { __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteMaintenanceInspection?: Array<{ __typename?: 'SiteMaintenanceInspection', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, siteMaintenanceInspectionType?: { __typename?: 'SiteMaintenanceInspectionType', id: string, label?: string | null } | null } | null> | null, siteRentals?: Array<{ __typename?: 'SiteRental', creation_id?: string | null, id: string, amount?: number | null, start_date?: string | null, expiry_date?: string | null, increase_date?: string | null, comments?: string | null, contact?: string | null, contact_code?: string | null, freeholder?: boolean | null, is_cancelled?: boolean | null, is_rolling?: boolean | null, rentalType?: { __typename?: 'SiteRentalType', id: string, label?: string | null, trashed?: boolean | null } | null, paymentMethod?: { __typename?: 'SiteRentalPaymentMethod', id: string, label?: string | null, trashed?: boolean | null } | null, paymentFrequency?: { __typename?: 'SiteRentalPaymentFrequency', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteHealthAndSafeties?: Array<{ __typename?: 'SiteHealthAndSafety', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, healthAndSafetyType?: { __typename?: 'SiteHealthAndSafetyType', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, sitePayments?: Array<{ __typename?: 'SitePayment', id: string, creation_id?: string | null, amount?: number | null, date?: string | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, siteDigitalBookingPricing?: Array<{ __typename?: 'SiteDigitalBookingPricing', id: string, creation_id?: string | null, days: number, net: number } | null> | null, sitePlannings?: Array<{ __typename?: 'SitePlanning', id: string, notes?: string | null, outcome_notes?: string | null, planning_date?: string | null, outcome_date?: string | null, amount?: number | null, creation_id?: string | null, planningStage?: { __typename?: 'SitePlanningStage', id: string, label?: string | null, trashed?: boolean | null } | null, planningOutcome?: { __typename?: 'SitePlanningOutcome', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, subletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, trashed?: boolean | null } | null, galleryImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, layoutImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null } | null };

export type CreateDigitalBookingMutationVariables = Exact<{
  input: CreateDigitalBookingInput;
}>;


export type CreateDigitalBookingMutation = { __typename?: 'Mutation', createDigitalBookings: { __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string } };

export type GetSiteDigitalBookingsQueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type GetSiteDigitalBookingsQuery = { __typename?: 'Query', getSiteDigitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, start_date: string, end_date: string, status: string, campaign?: { __typename?: 'Campaign', id: string, status?: string | null } | null, site?: { __typename?: 'Site', id: string, name?: string | null } | null }> | null };

export type GetCampaignDigitalBookingsQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignDigitalBookingsQuery = { __typename?: 'Query', getCampaignDigitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, start_date: string, end_date: string, status: string, campaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null } | null, site?: { __typename?: 'Site', id: string, name?: string | null } | null }> | null };

export type SitesQueryQueryVariables = Exact<{
  regionId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  region_type_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  subletterId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  postcode_like?: InputMaybe<Scalars['String']>;
  postcode_rlike?: InputMaybe<Scalars['String']>;
  borough_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  name_like?: InputMaybe<Scalars['String']>;
  structureId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  address1_like?: InputMaybe<Scalars['String']>;
  structureType_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  tvArea_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  pack_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  m4_like?: InputMaybe<Scalars['String']>;
  frameId_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  distributor_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  site_code_like?: InputMaybe<Scalars['String']>;
  tags_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  build_date_between?: InputMaybe<DateRange>;
  digital_search_default?: InputMaybe<Scalars['Boolean']>;
}>;


export type SitesQueryQuery = { __typename?: 'Query', sites?: Array<{ __typename?: 'Site', name?: string | null, id: string, numPanels?: number | null, postcode?: string | null, site_code?: string | null, rental?: number | null, rates?: number | null, rental_start?: string | null, rental_end?: string | null, externalThumbnail?: string | null, latitude?: string | null, longitude?: string | null, three_words?: string | null, externalLink?: string | null, region?: { __typename?: 'Region', id: string, name?: string | null } | null, borough?: { __typename?: 'Borough', id: string, label?: string | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null } | null, siteStructureType?: { __typename?: 'SiteStructureType', id: string, name?: string | null } | null, subletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null, sitePricing?: { __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null };

export type SitesQueryShortQueryVariables = Exact<{ [key: string]: never; }>;


export type SitesQueryShortQuery = { __typename?: 'Query', sites?: Array<{ __typename?: 'Site', name?: string | null, id: string } | null> | null };

export type MaintenanceInspectionSitesQueryQueryVariables = Exact<{
  regionId_in?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type MaintenanceInspectionSitesQueryQuery = { __typename?: 'Query', sites?: Array<{ __typename?: 'Site', id: string, name?: string | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null } | null } | null> | null };

export type QuantitiesReportMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
}>;


export type QuantitiesReportMutation = { __typename?: 'Mutation', quantitiesReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type ProPhotosReportAreaBookingMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
}>;


export type ProPhotosReportAreaBookingMutation = { __typename?: 'Mutation', proPhotosReportAreaBooking?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type ProPhotosReportMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
}>;


export type ProPhotosReportMutation = { __typename?: 'Mutation', proPhotosReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type ProPhotosReportDigitalMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
}>;


export type ProPhotosReportDigitalMutation = { __typename?: 'Mutation', proPhotosReportDigital?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type MailChimpReportMutationVariables = Exact<{ [key: string]: never; }>;


export type MailChimpReportMutation = { __typename?: 'Mutation', mailChimpReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type RegionalRevenueReportMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  status_in?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  salesTeam_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  includeQuoteCurrency?: InputMaybe<Scalars['Boolean']>;
  includeClientType?: InputMaybe<Scalars['Boolean']>;
}>;


export type RegionalRevenueReportMutation = { __typename?: 'Mutation', regionalRevenueReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type SiteRevenueReportMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  selectedIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SiteRevenueReportMutation = { __typename?: 'Mutation', siteRevenueReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type SiteMaintenanceReportMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  selectedIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SiteMaintenanceReportMutation = { __typename?: 'Mutation', siteMaintenanceReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type SiteStatusReportMutationVariables = Exact<{
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  selectedIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SiteStatusReportMutation = { __typename?: 'Mutation', siteStatusReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type SiteHsReportMutationVariables = Exact<{
  selectedIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SiteHsReportMutation = { __typename?: 'Mutation', siteHSReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type SiteMainExportReportMutationVariables = Exact<{
  selectedIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type SiteMainExportReportMutation = { __typename?: 'Mutation', siteMainExportReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type CampaignCostsReportMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CampaignCostsReportMutation = { __typename?: 'Mutation', campaignCostsReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type CampaignCreativeReportMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CampaignCreativeReportMutation = { __typename?: 'Mutation', campaignCreativeReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type CampaignDigitalReportMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CampaignDigitalReportMutation = { __typename?: 'Mutation', campaignDigitalReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type CampaignAreaBookingReportMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CampaignAreaBookingReportMutation = { __typename?: 'Mutation', campaignAreaBookingReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type CampaignSundriesReportMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CampaignSundriesReportMutation = { __typename?: 'Mutation', campaignSundriesReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type JobListReportMutationVariables = Exact<{
  date?: InputMaybe<Scalars['String']>;
  special_announcement?: InputMaybe<Scalars['String']>;
  distributor?: InputMaybe<Scalars['ID']>;
  ongoing?: InputMaybe<Scalars['Boolean']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type JobListReportMutation = { __typename?: 'Mutation', jobListReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type JobSheetReportMutationVariables = Exact<{
  date?: InputMaybe<Scalars['String']>;
  regionId?: InputMaybe<Scalars['ID']>;
  distributorId?: InputMaybe<Scalars['ID']>;
  landscape?: InputMaybe<Scalars['Boolean']>;
  boroughs?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  isNew?: InputMaybe<Scalars['Boolean']>;
}>;


export type JobSheetReportMutation = { __typename?: 'Mutation', jobSheetReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type SiteReportMutationVariables = Exact<{
  siteId?: InputMaybe<Scalars['ID']>;
}>;


export type SiteReportMutation = { __typename?: 'Mutation', siteReport?: { __typename?: 'ReportOutput', reportData?: string | null } | null };

export type GetAffectedBookingsMutationVariables = Exact<{
  input?: InputMaybe<Array<InputMaybe<AffectedPanelBookingsDateInput>> | InputMaybe<AffectedPanelBookingsDateInput>>;
}>;


export type GetAffectedBookingsMutation = { __typename?: 'Mutation', affectedPanelBookings?: Array<{ __typename?: 'PanelBooking', id: string, first_week?: string | null, last_week?: string | null, panel?: { __typename?: 'Panel', site?: { __typename?: 'Site', name?: string | null } | null } | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null> | null };

export type PdfDownloadMutationVariables = Exact<{
  host?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  outline?: InputMaybe<Scalars['Boolean']>;
  expectText?: InputMaybe<Scalars['String']>;
}>;


export type PdfDownloadMutation = { __typename?: 'Mutation', pdfDownload?: { __typename?: 'PdfOutput', data?: string | null } | null };

export type DeletePanelBookingMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePanelBookingMutation = { __typename?: 'Mutation', deletePanelBooking?: Array<{ __typename?: 'PanelBookingDateSummary', id: string, weekNumber?: number | null, campaignName?: string | null, count?: number | null, status?: string | null, type?: string | null, panelStatus?: string | null, instruction?: string | null, campaign_challenge_booking_id?: number | null, campaigns?: Array<{ __typename?: 'PanelBookingDateCampaign', id: string, name?: string | null, status?: string | null } | null> | null } | null> | null };

export type GetPanelBookingDatesQueryVariables = Exact<{
  panel_id?: InputMaybe<Scalars['ID']>;
  week_number?: InputMaybe<Scalars['Int']>;
}>;


export type GetPanelBookingDatesQuery = { __typename?: 'Query', panel?: { __typename?: 'Panel', id: string, site?: { __typename?: 'Site', id: string, name?: string | null } | null } | null, panelBookingDates: { __typename?: 'PanelBookingDatePaginator', data: Array<{ __typename?: 'PanelBookingDate', id: string, week_number?: number | null, panel_id?: string | null, priority?: number | null, hasPole?: boolean | null, panelBooking?: { __typename?: 'PanelBooking', id: string, first_week?: string | null, last_week?: string | null, lastDate?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, panel?: { __typename?: 'Panel', id: string, number_of_slots?: number | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, status?: string | null, ourContact?: { __typename?: 'User', name?: string | null } | null } | null } | null }> } };

export type UpdatePanelBookingDateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  increasePriority?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePanelBookingDateMutation = { __typename?: 'Mutation', updatePanelBookingDate?: Array<{ __typename?: 'PanelBookingDateSummary', id: string, weekNumber?: number | null, campaignName?: string | null, count?: number | null, status?: string | null, type?: string | null, panelStatus?: string | null, instruction?: string | null, campaign_challenge_booking_id?: number | null, campaigns?: Array<{ __typename?: 'PanelBookingDateCampaign', id: string, name?: string | null, status?: string | null } | null> | null } | null> | null };

export type ContractVersionsQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type ContractVersionsQueryQuery = { __typename?: 'Query', contractVersions?: Array<{ __typename?: 'ContractVersion', id: string, occurredAt: string, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null> | null };

export type ContractVersionQueryQueryVariables = Exact<{
  campaignId: Scalars['ID'];
  id: Scalars['ID'];
}>;


export type ContractVersionQueryQuery = { __typename?: 'Query', contractVersion?: { __typename?: 'ContractVersion', id: string, occurredAt: string, tree?: any | null, user?: { __typename?: 'User', id: string, name?: string | null } | null } | null };

export type ClientCompanyAndContactLookupCompanyFragment = { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null };

export type ClientCompanyAndContactLookupContactFragment = { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, trashed?: boolean | null };

export type ClientCompanyAndContactLookupFragment = { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null };

export type ClientCompanyFullFragment = { __typename?: 'ClientCompany', id: string, accounts_account_code?: string | null, accounts_address?: string | null, accounts_comments?: string | null, accounts_company?: string | null, accounts_contact?: string | null, accounts_phone?: string | null, accounts_email?: string | null, accounts_postcode?: string | null, credit_limit?: number | null, current_credit?: number | null, is_po_required?: boolean | null, is_vat_exempt?: boolean | null, other_contacts?: string | null, sales_address?: string | null, sales_company?: string | null, sales_contact?: string | null, sales_mobile?: string | null, sales_phone?: string | null, sales_postcode?: string | null, sales_title?: string | null, sales_type?: string | null, invoice_factored?: boolean | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null } | null, clientCompanyGroup?: { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null };

export type ClientCompanyContactFullFragment = { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, comments?: string | null, is_marketing?: boolean | null, is_sales?: boolean | null, is_mailchimp?: boolean | null, job_sheet_info?: string | null, phone?: string | null, phone_alt?: string | null, title?: string | null, trashed?: boolean | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null };

export type ClientTypeFullFragment = { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null };

export type BoroughFullFragment = { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null };

export type ClientCompanyGroupFullFragment = { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null };

export type AmbientTypeFullFragment = { __typename?: 'AmbientType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null };

export type DistributorFullFragment = { __typename?: 'Distributor', id: string, name?: string | null, email?: string | null, trashed?: boolean | null };

export type DistributorMinimalFragment = { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null };

export type ExperientialTypeFullFragment = { __typename?: 'ExperientialType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null };

export type StyleFullFragment = { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null };

export type AreaBookingRegionPricingFullFragment = { __typename?: 'AreaBookingRegionPricing', id: string, unit_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string } | null };

export type PosterSizeFullFragment = { __typename?: 'PosterSize', id: string, name?: string | null, dc_type?: string | null, is_larger_than_4?: boolean | null, is_panel_poster?: boolean | null, is_street_poster?: boolean | null, is_media_type?: boolean | null, customer_name?: string | null, londonCurrencyId?: number | null, regionalCurrencyId?: number | null, festivalCurrencyId?: number | null, internationalCurrencyId?: number | null, londonPricing?: number | null, regionalPricing?: number | null, festivalPricing?: number | null, internationalPricing?: number | null, slot_poster_count?: number | null, effective_poster_count?: number | null, trashed?: boolean | null, areaBookingRegionPricing?: Array<{ __typename?: 'AreaBookingRegionPricing', id: string, unit_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string } | null } | null> | null, regionTypePricing?: Array<{ __typename?: 'AreaBookingPricing', id: string, unit_value?: number | null, regionType?: { __typename?: 'RegionType', id: string } | null } | null> | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null };

export type ExchangeRateFullFragment = { __typename?: 'ExchangeRate', id: string, rate?: number | null, from?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, to?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null };

export type ExchangeRateShortFragment = { __typename?: 'ExchangeRate', id: string, rate?: number | null, from?: { __typename?: 'Currency', id: string } | null, to?: { __typename?: 'Currency', id: string } | null };

export type ClientSubTypeFullFragment = { __typename?: 'ClientSubType', id: string, name?: string | null, sales_team_prefix?: string | null, trashed?: boolean | null };

export type CostSupplierCategoryFullFragment = { __typename?: 'CostSupplierCategory', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null };

export type CostSupplierFullFragment = { __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, trashed?: boolean | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null };

export type CurrencyFullFragment = { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null };

export type MediaTypeFullFragment = { __typename?: 'MediaType', id?: string | null, label?: string | null, trashed?: boolean | null };

export type TvAreaFullFragment = { __typename?: 'TVArea', id: string, label?: string | null, trashed?: boolean | null };

export type PackFullFragment = { __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null };

export type PostInstructionFullFragment = { __typename?: 'PostInstruction', id: string, label?: string | null, code?: string | null, trashed?: boolean | null };

export type RegionFullFragment = { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null };

export type RegionTypeFullWithRegionsFragment = { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null, regions?: Array<{ __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null> | null };

export type RegionTypeFullFragment = { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null };

export type LogEntryFragment = { __typename?: 'LogEntry', id: string, kind: LogEntryKind, label?: string | null, occurredAt: string, totalPrice?: number | null, totalPriceWithVat?: number | null, status?: string | null, user?: { __typename?: 'User', id: string, name?: string | null } | null };

export type PermissionFullFragment = { __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null };

export type ProposalOptionFullFragment = { __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null };

export type RoleFullFragment = { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null };

export type CampaignTagFullFragment = { __typename?: 'CampaignTag', id: string, name?: string | null, description?: string | null, section_code?: string | null };

export type SalesTeamFullFragment = { __typename?: 'SalesTeam', id: string, name?: string | null, prefix?: string | null, trashed?: boolean | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null };

export type SiteHealthAndSafetyTypeFullFragment = { __typename?: 'SiteHealthAndSafetyType', id: string, label?: string | null, trashed?: boolean | null };

export type SitePlanningOutcomeFullFragment = { __typename?: 'SitePlanningOutcome', id: string, label?: string | null, trashed?: boolean | null };

export type SitePlanningStageFullFragment = { __typename?: 'SitePlanningStage', id: string, label?: string | null, trashed?: boolean | null };

export type SitePricingFullFragment = { __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null };

export type SiteRentalPaymentFrequencyFullFragment = { __typename?: 'SiteRentalPaymentFrequency', id: string, label?: string | null, trashed?: boolean | null };

export type SiteRentalPaymentMethodFullFragment = { __typename?: 'SiteRentalPaymentMethod', id: string, label?: string | null, trashed?: boolean | null };

export type SiteRentalTypeFullFragment = { __typename?: 'SiteRentalType', id: string, label?: string | null, trashed?: boolean | null };

export type SubletterMinimalFragment = { __typename?: 'Subletter', id?: string | null, name?: string | null, trashed?: boolean | null };

export type SubletterFullFragment = { __typename?: 'Subletter', id?: string | null, name?: string | null, contact_name?: string | null, company?: string | null, email?: string | null, email_2?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, postcode?: string | null, telephone_1?: string | null, telephone_2?: string | null, trashed?: boolean | null };

export type SiteStructureTypeFullFragment = { __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null };

export type SiteStructureFullFragment = { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null };

export type SiteStructureFullWithPosterSizeFragment = { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null };

export type SundryTypeFullFragment = { __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null };

export type UserShortFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null };

export type UserFullFragment = { __typename?: 'User', id: string, name?: string | null, email?: string | null, password?: string | null, lockout_until?: string | null, failed_2fa_count?: number | null, failed_password_count?: number | null, hasAuthenticatorQrCode?: boolean | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null };

export type SiteBuildContractorFullFragment = { __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null };

export type SiteBuildTypeFullFragment = { __typename?: 'SiteBuildType', id: string, label?: string | null, trashed?: boolean | null };

export type OptionFullFragment = { __typename?: 'Option', id: string, label?: string | null, code?: string | null, type?: string | null, int_value?: number | null, bool_value?: boolean | null, text_value?: string | null };

export type PanelBookingDateSummaryFullFragment = { __typename?: 'PanelBookingDateSummary', id: string, weekNumber?: number | null, campaignName?: string | null, count?: number | null, status?: string | null, type?: string | null, panelStatus?: string | null, instruction?: string | null, campaign_challenge_booking_id?: number | null, campaigns?: Array<{ __typename?: 'PanelBookingDateCampaign', id: string, name?: string | null, status?: string | null } | null> | null };

export type UserNotificationFullFragment = { __typename?: 'UserNotification', id: string, type?: string | null, status?: string | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null };

export type SiteFullFragment = { __typename?: 'Site', address1?: string | null, address2?: string | null, photo_archive_url?: string | null, pops_url?: string | null, build_date?: string | null, description?: string | null, id: string, impacts?: number | null, name?: string | null, notes?: string | null, latitude?: string | null, longitude?: string | null, three_words?: string | null, is_illumination?: boolean | null, is_3p?: boolean | null, is_dynamic?: boolean | null, is_dashboard_site?: boolean | null, postcode?: string | null, road_number?: string | null, site_code?: string | null, poster_portfolio_url?: string | null, rate_card_url?: string | null, tvArea?: { __typename?: 'TVArea', id: string, label?: string | null, trashed?: boolean | null } | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null, style?: { __typename?: 'Style', id: string, label?: string | null, is_site_style?: boolean | null, is_pack_style?: boolean | null, trashed?: boolean | null } | null, panels?: Array<{ __typename?: 'Panel', id: string, code?: string | null, restriction?: string | null, number_of_slots?: number | null, owner?: string | null, notes?: string | null, panel?: string | null, posters_per_slot?: number | null, creation_id?: string | null, pack?: { __typename?: 'Pack', id: string, label?: string | null, trashed?: boolean | null } | null, postInstruction?: { __typename?: 'PostInstruction', id: string, label?: string | null, code?: string | null, trashed?: boolean | null } | null, panelAvailabilities?: Array<{ __typename?: 'PanelAvailability', id: string, first_week?: string | null, last_week?: string | null, availability?: string | null, reason?: string | null, creation_id?: string | null } | null> | null } | null> | null, sitePricing?: { __typename?: 'SitePricing', id: string, label?: string | null, panel?: number | null, comment?: string | null, trashed?: boolean | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, tags?: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null } | null> | null, takeoverSite?: { __typename?: 'Site', id: string, name?: string | null } | null, takeoverSitesManagedByThis?: Array<{ __typename?: 'Site', id: string, name?: string | null } | null> | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, siteStructureGroup?: { __typename?: 'SiteStructureGroup', id: string, name?: string | null } | null } | null, siteStructureType?: { __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null } | null, siteImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteFilesOther?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, siteBuildAndRepairs?: Array<{ __typename?: 'SiteBuildAndRepairs', id: string, creation_id?: string | null, panel?: string | null, cancelled?: string | null, costs_excluding_vat?: number | null, costs_1?: number | null, costs_2?: number | null, costs_3?: number | null, costs_4?: number | null, costs_5?: number | null, costs_comments_1?: string | null, costs_comments_2?: string | null, costs_comments_3?: string | null, costs_comments_4?: string | null, costs_comments_5?: string | null, quantity?: number | null, issued_by?: string | null, additional_info?: string | null, completion_deadline?: string | null, completion_date?: string | null, invoice_number?: string | null, po_number?: string | null, buildType?: { __typename?: 'SiteBuildType', id: string, label?: string | null, trashed?: boolean | null } | null, buildContractor?: { __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteMaintenanceInspection?: Array<{ __typename?: 'SiteMaintenanceInspection', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, siteMaintenanceInspectionType?: { __typename?: 'SiteMaintenanceInspectionType', id: string, label?: string | null } | null } | null> | null, siteRentals?: Array<{ __typename?: 'SiteRental', creation_id?: string | null, id: string, amount?: number | null, start_date?: string | null, expiry_date?: string | null, increase_date?: string | null, comments?: string | null, contact?: string | null, contact_code?: string | null, freeholder?: boolean | null, is_cancelled?: boolean | null, is_rolling?: boolean | null, rentalType?: { __typename?: 'SiteRentalType', id: string, label?: string | null, trashed?: boolean | null } | null, paymentMethod?: { __typename?: 'SiteRentalPaymentMethod', id: string, label?: string | null, trashed?: boolean | null } | null, paymentFrequency?: { __typename?: 'SiteRentalPaymentFrequency', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, siteHealthAndSafeties?: Array<{ __typename?: 'SiteHealthAndSafety', id: string, creation_id?: string | null, notes?: string | null, last_inspection_date?: string | null, healthAndSafetyType?: { __typename?: 'SiteHealthAndSafetyType', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, sitePayments?: Array<{ __typename?: 'SitePayment', id: string, creation_id?: string | null, amount?: number | null, date?: string | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, siteDigitalBookingPricing?: Array<{ __typename?: 'SiteDigitalBookingPricing', id: string, creation_id?: string | null, days: number, net: number } | null> | null, sitePlannings?: Array<{ __typename?: 'SitePlanning', id: string, notes?: string | null, outcome_notes?: string | null, planning_date?: string | null, outcome_date?: string | null, amount?: number | null, creation_id?: string | null, planningStage?: { __typename?: 'SitePlanningStage', id: string, label?: string | null, trashed?: boolean | null } | null, planningOutcome?: { __typename?: 'SitePlanningOutcome', id: string, label?: string | null, trashed?: boolean | null } | null } | null> | null, subletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, trashed?: boolean | null } | null, galleryImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null, layoutImages?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null };

export type AmbientTypesMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateAmbientTypesInput>;
}>;


export type AmbientTypesMutationMutation = { __typename?: 'Mutation', updateAmbientTypes?: Array<{ __typename?: 'AmbientType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null> | null };

export type GetCampaignChallengeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCampaignChallengeQuery = { __typename?: 'Query', getCampaignChallenge?: { __typename?: 'CampaignChallenge', id: string, message?: string | null, status?: string | null, user?: { __typename?: 'User', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', job_reference?: string | null, name?: string | null, start_date?: string | null, ourContact?: { __typename?: 'User', id: string, email?: string | null, name?: string | null } | null } | null, bookingChallenges?: Array<{ __typename?: 'CampaignChallengeBooking', id: string, date_start?: string | null, date_end?: string | null, status?: string | null, sourcePanelBooking?: { __typename?: 'PanelBooking', id: string } | null, targetCampaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null, targetPanelBooking?: { __typename?: 'PanelBooking', id: string, panel?: { __typename?: 'Panel', id: string, panel?: string | null, site?: { __typename?: 'Site', id: string, name?: string | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null } | null };

export type RespondToCampaignChallengeMutationVariables = Exact<{
  input: RespondToChallengeInput;
}>;


export type RespondToCampaignChallengeMutation = { __typename?: 'Mutation', respondToCampaignChallenge?: { __typename?: 'CampaignChallenge', id: string, message?: string | null, status?: string | null, campaign?: { __typename?: 'Campaign', job_reference?: string | null, name?: string | null, start_date?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null } | null } | null, user?: { __typename?: 'User', id: string, name?: string | null } | null, bookingChallenges?: Array<{ __typename?: 'CampaignChallengeBooking', id: string, week_end?: number | null, week_start?: number | null, status?: string | null, sourcePanelBooking?: { __typename?: 'PanelBooking', id: string } | null, targetPanelBooking?: { __typename?: 'PanelBooking', id: string, campaign?: { __typename?: 'Campaign', ourContact?: { __typename?: 'User', id: string, name?: string | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, site?: { __typename?: 'Site', id: string, name?: string | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null } | null };

export type CampaignChallengeFullFragment = { __typename?: 'CampaignChallenge', id: string, status?: string | null, created_at?: string | null, inboundRecent?: boolean | null, outboundRecent?: boolean | null, campaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null, bookingChallenges?: Array<{ __typename?: 'CampaignChallengeBooking', id: string, date_start?: string | null, date_end?: string | null, message?: string | null, status?: string | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, site?: { __typename?: 'Site', name?: string | null, region?: { __typename?: 'Region', id: string, name?: string | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null } | null } | null } | null } | null, targetCampaign?: { __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null } | null> | null };

export type CampaignChallengesQueryVariables = Exact<{
  user_id: Scalars['ID'];
  direction?: InputMaybe<Scalars['String']>;
  markViewed?: InputMaybe<Scalars['Boolean']>;
}>;


export type CampaignChallengesQuery = { __typename?: 'Query', campaignChallenges?: Array<{ __typename?: 'CampaignChallenge', id: string, status?: string | null, created_at?: string | null, inboundRecent?: boolean | null, outboundRecent?: boolean | null, campaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null, bookingChallenges?: Array<{ __typename?: 'CampaignChallengeBooking', id: string, date_start?: string | null, date_end?: string | null, message?: string | null, status?: string | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, site?: { __typename?: 'Site', name?: string | null, region?: { __typename?: 'Region', id: string, name?: string | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null } | null } | null } | null } | null, targetCampaign?: { __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null } | null> | null } | null> | null };

export type UpdateCampaignChallengeMutationVariables = Exact<{
  id: Scalars['ID'];
  hide?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  cancelPanelBookings?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type UpdateCampaignChallengeMutation = { __typename?: 'Mutation', updateCampaignChallenge?: { __typename?: 'CampaignChallenge', id: string, status?: string | null, created_at?: string | null, inboundRecent?: boolean | null, outboundRecent?: boolean | null, campaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null, bookingChallenges?: Array<{ __typename?: 'CampaignChallengeBooking', id: string, date_start?: string | null, date_end?: string | null, message?: string | null, status?: string | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, site?: { __typename?: 'Site', name?: string | null, region?: { __typename?: 'Region', id: string, name?: string | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null } | null } | null } | null } | null, targetCampaign?: { __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null } | null } | null } | null> | null } | null };

export type CampaignTagsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  section_code?: InputMaybe<Scalars['String']>;
}>;


export type CampaignTagsQuery = { __typename?: 'Query', campaignTags: { __typename?: 'CampaignTagPaginator', data: Array<{ __typename?: 'CampaignTag', id: string, name?: string | null, section_code?: string | null, description?: string | null, code?: string | null, creation_id?: string | null }> } };

export type CampaignTagsFullQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type CampaignTagsFullQuery = { __typename?: 'Query', campaignTags: { __typename?: 'CampaignTagPaginator', data: Array<{ __typename?: 'CampaignTag', id: string, name?: string | null, section_code?: string | null, description?: string | null, code?: string | null, creation_id?: string | null }> } };

export type UpdateCampaignTagsMutationVariables = Exact<{
  update?: InputMaybe<UpdateCampaignTag>;
}>;


export type UpdateCampaignTagsMutation = { __typename?: 'Mutation', updateCampaignTags?: Array<{ __typename?: 'CampaignTag', id: string, name?: string | null, section_code?: string | null, description?: string | null, code?: string | null, creation_id?: string | null } | null> | null };

export type PanelBookingFullFragment = { __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null };

export type CampaignPanelBookingsFullFragment = { __typename?: 'Campaign', id: string, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null };

export type CampaignSignaturesFragment = { __typename?: 'Campaign', id: string, clientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, email?: string | null } | null, campaignSignatures?: Array<{ __typename?: 'CampaignSignature', id: string, signed_on?: string | null, email?: string | null, first_accessed?: string | null, status?: string | null, created_at?: string | null, is_manual?: boolean | null, graphqlContractUrl?: string | null, createdBy?: { __typename?: 'User', name?: string | null } | null } | null> | null };

export type CampaignFullFragment = { __typename?: 'Campaign', id: string, job_reference?: string | null, created_at?: string | null, name?: string | null, event?: string | null, is_purchase_order_required?: boolean | null, completion_date?: string | null, start_date?: string | null, artwork_received_date?: string | null, purchase_order?: string | null, invoice?: string | null, notes?: string | null, posters_received?: string | null, sales_job_ref?: string | null, media_production_notes?: string | null, sub_teams_scotland?: string | null, photoPaidTotal: number, nextcloud_share_url?: string | null, nextcloud_view_url?: string | null, epos_artwork_reviewed?: boolean | null, externalPortfolioUrl?: string | null, is_vat_exempt?: boolean | null, totalCost?: number | null, discountableTotal?: number | null, undiscountableTotal?: number | null, discount_percentage?: number | null, discount_final?: number | null, status?: string | null, type?: string | null, paid_date?: string | null, payment_bank?: string | null, is_locked?: boolean | null, manually_unlocked?: boolean | null, rigging_up_at?: any | null, rigging_down_at?: any | null, portfolio_hash?: string | null, portfolio_show_impacts?: boolean | null, portfolio_small_sites?: boolean | null, portfolio_paris_insurance?: boolean | null, portfolio_summary?: string | null, portfolio_title?: string | null, paymentTerms?: { __typename?: 'PaymentTerm', id: string, name?: string | null } | null, regionalAmAllocation?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, currencies?: Array<{ __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null> | null, clientSubType?: { __typename?: 'ClientSubType', id: string, name?: string | null, trashed?: boolean | null } | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, clientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null, mediaProductions?: Array<{ __typename?: 'MediaProduction', id: string, creation_id?: string | null, notes?: string | null, mediaType?: { __typename?: 'MediaType', id?: string | null, label?: string | null, trashed?: boolean | null } | null, size?: { __typename?: 'PosterSize', id: string, name?: string | null, customer_name?: string | null, trashed?: boolean | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, price_divisor?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, creativeStudio?: Array<{ __typename?: 'CreativeStudio', id: string, creation_id?: string | null, notes?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, creativeStudioType?: { __typename?: 'CreativeStudioType', id: string, name: string } | null, creativeStudioTypeDetail?: { __typename?: 'CreativeStudioTypeDetail', id: string, name: string } | null } | null> | null, creativeStudioEntries?: Array<{ __typename?: 'CreativeStudioEntry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, parent_id?: string | null, mode?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, children?: Array<{ __typename?: 'CreativeStudioEntry', id: string, name?: string | null, notes?: string | null, parent_id?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null } | null> | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, digitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string, is_photo_paid?: string | null, status: string, site?: { __typename?: 'Site', id: string, name?: string | null, is_3p?: boolean | null, boroughOrRegion?: string | null, siteStructure?: { __typename?: 'SiteStructure', name?: string | null } | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null } | null> | null, experientials?: Array<{ __typename?: 'Experiential', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, experientialType?: { __typename?: 'ExperientialType', id?: string | null, name?: string | null, trashed?: boolean | null } | null } | null> | null, ambients?: Array<{ __typename?: 'Ambient', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, ambientType?: { __typename?: 'AmbientType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null> | null, sundries?: Array<{ __typename?: 'Sundry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, date_up?: string | null, date_down?: string | null, use_global_discount?: boolean | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, sundryType?: { __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null, costs?: Array<{ __typename?: 'Cost', id: string, creation_id?: string | null, supplier_code?: string | null, invoice_number?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, costSupplier?: { __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null } | null } | null } | null> | null, components?: Array<{ __typename?: 'CampaignComponent', id: string, type?: string | null, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, areaBookings?: Array<{ __typename?: 'AreaBooking', id: string, bay_number?: number | null, rating?: number | null, creation_id?: string | null, special_instructions?: string | null, london_instructions?: string | null, posters_received?: string | null, unit_value_local?: number | null, unit_value_prescribed_local?: number | null, is_photo_paid_ab?: string | null, num_weeks?: number | null, first_up?: string | null, last_down?: string | null, num_posters?: number | null, total_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, trashed?: boolean | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, areaBookingItems?: Array<{ __typename?: 'AreaBookingItem', id: string, creation_id?: string | null, date_up?: string | null, date_down?: string | null, notes?: string | null, qty_posters_per_site?: number | null, qty_sites?: number | null, is_received?: boolean | null, created_at?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_prescribed_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, areaBookingZone?: { __typename?: 'AreaBookingZone', id: string, name: string } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null } | null> | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null, salesTeam?: { __typename?: 'SalesTeam', trashed?: boolean | null, id: string, name?: string | null, prefix?: string | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null, authorizationFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, popsFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, invoiceFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, artworkFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null, inboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, outboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, campaignExchangeRates?: Array<{ __typename?: 'CampaignExchangeRate', from?: string | null, to?: string | null, rate?: number | null } | null> | null, previewTags?: Array<{ __typename?: 'CampaignTag', id: string, name?: string | null, description?: string | null, section_code?: string | null } | null> | null, contractSections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null };

export type GetCampaignPanelBookingsQueryQueryVariables = Exact<{
  ref?: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignPanelBookingsQueryQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null } | null };

export type GetCampaignDigitalBookingsQueryQueryVariables = Exact<{
  ref?: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignDigitalBookingsQueryQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', digitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string, status: string, is_photo_paid?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null } | null, site?: { __typename?: 'Site', id: string, name?: string | null, boroughOrRegion?: string | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null } | null } | null, campaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null } | null } | null> | null } | null };

export type GetCampaignCostPaneQueryQueryVariables = Exact<{
  ref?: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignCostPaneQueryQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', costs?: Array<{ __typename?: 'Cost', id: string, creation_id?: string | null, supplier_code?: string | null, invoice_number?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, costSupplier?: { __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null } | null } | null } | null> | null } | null };

export type GetCampaignSignaturesQueryQueryVariables = Exact<{
  ref?: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignSignaturesQueryQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, clientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, email?: string | null } | null, campaignSignatures?: Array<{ __typename?: 'CampaignSignature', id: string, signed_on?: string | null, email?: string | null, first_accessed?: string | null, status?: string | null, created_at?: string | null, is_manual?: boolean | null, graphqlContractUrl?: string | null, createdBy?: { __typename?: 'User', name?: string | null } | null } | null> | null } | null };

export type CreateCampaignSignatureMutationVariables = Exact<{
  campaign_id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  is_manual?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCampaignSignatureMutation = { __typename?: 'Mutation', createCampaignSignature?: { __typename?: 'CampaignSignature', id: string, graphqlContractUrl?: string | null } | null };

export type GetCampaignQueryQueryVariables = Exact<{
  ref?: InputMaybe<Scalars['String']>;
  withEstimated?: InputMaybe<Scalars['Boolean']>;
  withActual?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCampaignQueryQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null, created_at?: string | null, name?: string | null, event?: string | null, is_purchase_order_required?: boolean | null, completion_date?: string | null, start_date?: string | null, artwork_received_date?: string | null, purchase_order?: string | null, invoice?: string | null, notes?: string | null, posters_received?: string | null, sales_job_ref?: string | null, media_production_notes?: string | null, sub_teams_scotland?: string | null, photoPaidTotal: number, nextcloud_share_url?: string | null, nextcloud_view_url?: string | null, epos_artwork_reviewed?: boolean | null, externalPortfolioUrl?: string | null, is_vat_exempt?: boolean | null, totalCost?: number | null, discountableTotal?: number | null, undiscountableTotal?: number | null, discount_percentage?: number | null, discount_final?: number | null, status?: string | null, type?: string | null, paid_date?: string | null, payment_bank?: string | null, is_locked?: boolean | null, manually_unlocked?: boolean | null, rigging_up_at?: any | null, rigging_down_at?: any | null, portfolio_hash?: string | null, portfolio_show_impacts?: boolean | null, portfolio_small_sites?: boolean | null, portfolio_paris_insurance?: boolean | null, portfolio_summary?: string | null, portfolio_title?: string | null, paymentTerms?: { __typename?: 'PaymentTerm', id: string, name?: string | null } | null, regionalAmAllocation?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, currencies?: Array<{ __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null> | null, clientSubType?: { __typename?: 'ClientSubType', id: string, name?: string | null, trashed?: boolean | null } | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, clientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null, mediaProductions?: Array<{ __typename?: 'MediaProduction', id: string, creation_id?: string | null, notes?: string | null, mediaType?: { __typename?: 'MediaType', id?: string | null, label?: string | null, trashed?: boolean | null } | null, size?: { __typename?: 'PosterSize', id: string, name?: string | null, customer_name?: string | null, trashed?: boolean | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, price_divisor?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, creativeStudio?: Array<{ __typename?: 'CreativeStudio', id: string, creation_id?: string | null, notes?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, creativeStudioType?: { __typename?: 'CreativeStudioType', id: string, name: string } | null, creativeStudioTypeDetail?: { __typename?: 'CreativeStudioTypeDetail', id: string, name: string } | null } | null> | null, creativeStudioEntries?: Array<{ __typename?: 'CreativeStudioEntry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, parent_id?: string | null, mode?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, children?: Array<{ __typename?: 'CreativeStudioEntry', id: string, name?: string | null, notes?: string | null, parent_id?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null } | null> | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, digitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string, is_photo_paid?: string | null, status: string, site?: { __typename?: 'Site', id: string, name?: string | null, is_3p?: boolean | null, boroughOrRegion?: string | null, siteStructure?: { __typename?: 'SiteStructure', name?: string | null } | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null } | null> | null, experientials?: Array<{ __typename?: 'Experiential', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, experientialType?: { __typename?: 'ExperientialType', id?: string | null, name?: string | null, trashed?: boolean | null } | null } | null> | null, ambients?: Array<{ __typename?: 'Ambient', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, ambientType?: { __typename?: 'AmbientType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null> | null, sundries?: Array<{ __typename?: 'Sundry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, date_up?: string | null, date_down?: string | null, use_global_discount?: boolean | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, sundryType?: { __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null, costs?: Array<{ __typename?: 'Cost', id: string, creation_id?: string | null, supplier_code?: string | null, invoice_number?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, costSupplier?: { __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null } | null } | null } | null> | null, components?: Array<{ __typename?: 'CampaignComponent', id: string, type?: string | null, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, areaBookings?: Array<{ __typename?: 'AreaBooking', id: string, bay_number?: number | null, rating?: number | null, creation_id?: string | null, special_instructions?: string | null, london_instructions?: string | null, posters_received?: string | null, unit_value_local?: number | null, unit_value_prescribed_local?: number | null, is_photo_paid_ab?: string | null, num_weeks?: number | null, first_up?: string | null, last_down?: string | null, num_posters?: number | null, total_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, trashed?: boolean | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, areaBookingItems?: Array<{ __typename?: 'AreaBookingItem', id: string, creation_id?: string | null, date_up?: string | null, date_down?: string | null, notes?: string | null, qty_posters_per_site?: number | null, qty_sites?: number | null, is_received?: boolean | null, created_at?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_prescribed_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, areaBookingZone?: { __typename?: 'AreaBookingZone', id: string, name: string } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null } | null> | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null, salesTeam?: { __typename?: 'SalesTeam', trashed?: boolean | null, id: string, name?: string | null, prefix?: string | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null, authorizationFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, popsFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, invoiceFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, artworkFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null, inboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, outboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, campaignExchangeRates?: Array<{ __typename?: 'CampaignExchangeRate', from?: string | null, to?: string | null, rate?: number | null } | null> | null, previewTags?: Array<{ __typename?: 'CampaignTag', id: string, name?: string | null, description?: string | null, section_code?: string | null } | null> | null, contractSections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type UpdateCampaignMutationMutationVariables = Exact<{
  input: UpdateCampaignInput;
  withEstimated?: InputMaybe<Scalars['Boolean']>;
  withActual?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCampaignMutationMutation = { __typename?: 'Mutation', updateCampaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null, created_at?: string | null, name?: string | null, event?: string | null, is_purchase_order_required?: boolean | null, completion_date?: string | null, start_date?: string | null, artwork_received_date?: string | null, purchase_order?: string | null, invoice?: string | null, notes?: string | null, posters_received?: string | null, sales_job_ref?: string | null, media_production_notes?: string | null, sub_teams_scotland?: string | null, photoPaidTotal: number, nextcloud_share_url?: string | null, nextcloud_view_url?: string | null, epos_artwork_reviewed?: boolean | null, externalPortfolioUrl?: string | null, is_vat_exempt?: boolean | null, totalCost?: number | null, discountableTotal?: number | null, undiscountableTotal?: number | null, discount_percentage?: number | null, discount_final?: number | null, status?: string | null, type?: string | null, paid_date?: string | null, payment_bank?: string | null, is_locked?: boolean | null, manually_unlocked?: boolean | null, rigging_up_at?: any | null, rigging_down_at?: any | null, portfolio_hash?: string | null, portfolio_show_impacts?: boolean | null, portfolio_small_sites?: boolean | null, portfolio_paris_insurance?: boolean | null, portfolio_summary?: string | null, portfolio_title?: string | null, paymentTerms?: { __typename?: 'PaymentTerm', id: string, name?: string | null } | null, regionalAmAllocation?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, currencies?: Array<{ __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null> | null, clientSubType?: { __typename?: 'ClientSubType', id: string, name?: string | null, trashed?: boolean | null } | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, clientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null, mediaProductions?: Array<{ __typename?: 'MediaProduction', id: string, creation_id?: string | null, notes?: string | null, mediaType?: { __typename?: 'MediaType', id?: string | null, label?: string | null, trashed?: boolean | null } | null, size?: { __typename?: 'PosterSize', id: string, name?: string | null, customer_name?: string | null, trashed?: boolean | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, price_divisor?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, creativeStudio?: Array<{ __typename?: 'CreativeStudio', id: string, creation_id?: string | null, notes?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, creativeStudioType?: { __typename?: 'CreativeStudioType', id: string, name: string } | null, creativeStudioTypeDetail?: { __typename?: 'CreativeStudioTypeDetail', id: string, name: string } | null } | null> | null, creativeStudioEntries?: Array<{ __typename?: 'CreativeStudioEntry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, parent_id?: string | null, mode?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, children?: Array<{ __typename?: 'CreativeStudioEntry', id: string, name?: string | null, notes?: string | null, parent_id?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null } | null> | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, digitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string, is_photo_paid?: string | null, status: string, site?: { __typename?: 'Site', id: string, name?: string | null, is_3p?: boolean | null, boroughOrRegion?: string | null, siteStructure?: { __typename?: 'SiteStructure', name?: string | null } | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null } | null> | null, experientials?: Array<{ __typename?: 'Experiential', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, experientialType?: { __typename?: 'ExperientialType', id?: string | null, name?: string | null, trashed?: boolean | null } | null } | null> | null, ambients?: Array<{ __typename?: 'Ambient', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, ambientType?: { __typename?: 'AmbientType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null> | null, sundries?: Array<{ __typename?: 'Sundry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, date_up?: string | null, date_down?: string | null, use_global_discount?: boolean | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, sundryType?: { __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null, costs?: Array<{ __typename?: 'Cost', id: string, creation_id?: string | null, supplier_code?: string | null, invoice_number?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, costSupplier?: { __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null } | null } | null } | null> | null, components?: Array<{ __typename?: 'CampaignComponent', id: string, type?: string | null, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, areaBookings?: Array<{ __typename?: 'AreaBooking', id: string, bay_number?: number | null, rating?: number | null, creation_id?: string | null, special_instructions?: string | null, london_instructions?: string | null, posters_received?: string | null, unit_value_local?: number | null, unit_value_prescribed_local?: number | null, is_photo_paid_ab?: string | null, num_weeks?: number | null, first_up?: string | null, last_down?: string | null, num_posters?: number | null, total_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, trashed?: boolean | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, areaBookingItems?: Array<{ __typename?: 'AreaBookingItem', id: string, creation_id?: string | null, date_up?: string | null, date_down?: string | null, notes?: string | null, qty_posters_per_site?: number | null, qty_sites?: number | null, is_received?: boolean | null, created_at?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_prescribed_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, areaBookingZone?: { __typename?: 'AreaBookingZone', id: string, name: string } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null } | null> | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null, salesTeam?: { __typename?: 'SalesTeam', trashed?: boolean | null, id: string, name?: string | null, prefix?: string | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null, authorizationFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, popsFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, invoiceFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, artworkFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null, inboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, outboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, campaignExchangeRates?: Array<{ __typename?: 'CampaignExchangeRate', from?: string | null, to?: string | null, rate?: number | null } | null> | null, previewTags?: Array<{ __typename?: 'CampaignTag', id: string, name?: string | null, description?: string | null, section_code?: string | null } | null> | null, contractSections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type DeleteCampaignMutationMutationVariables = Exact<{
  input: Scalars['ID'];
}>;


export type DeleteCampaignMutationMutation = { __typename?: 'Mutation', deleteCampaign?: { __typename?: 'Campaign', id: string } | null };

export type CreateCampaignMutationMutationVariables = Exact<{
  input: CreateCampaignInput;
  withEstimated?: InputMaybe<Scalars['Boolean']>;
  withActual?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateCampaignMutationMutation = { __typename?: 'Mutation', createCampaign?: { __typename?: 'Campaign', id: string, job_reference?: string | null, created_at?: string | null, name?: string | null, event?: string | null, is_purchase_order_required?: boolean | null, completion_date?: string | null, start_date?: string | null, artwork_received_date?: string | null, purchase_order?: string | null, invoice?: string | null, notes?: string | null, posters_received?: string | null, sales_job_ref?: string | null, media_production_notes?: string | null, sub_teams_scotland?: string | null, photoPaidTotal: number, nextcloud_share_url?: string | null, nextcloud_view_url?: string | null, epos_artwork_reviewed?: boolean | null, externalPortfolioUrl?: string | null, is_vat_exempt?: boolean | null, totalCost?: number | null, discountableTotal?: number | null, undiscountableTotal?: number | null, discount_percentage?: number | null, discount_final?: number | null, status?: string | null, type?: string | null, paid_date?: string | null, payment_bank?: string | null, is_locked?: boolean | null, manually_unlocked?: boolean | null, rigging_up_at?: any | null, rigging_down_at?: any | null, portfolio_hash?: string | null, portfolio_show_impacts?: boolean | null, portfolio_small_sites?: boolean | null, portfolio_paris_insurance?: boolean | null, portfolio_summary?: string | null, portfolio_title?: string | null, paymentTerms?: { __typename?: 'PaymentTerm', id: string, name?: string | null } | null, regionalAmAllocation?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, currencies?: Array<{ __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null> | null, clientSubType?: { __typename?: 'ClientSubType', id: string, name?: string | null, trashed?: boolean | null } | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_company?: string | null, credit_limit?: number | null, current_credit?: number | null, is_vat_exempt?: boolean | null, accounts_address?: string | null, accounts_postcode?: string | null, accounts_account_code?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, clientCompanyContact?: { __typename?: 'ClientCompanyContact', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null, mediaProductions?: Array<{ __typename?: 'MediaProduction', id: string, creation_id?: string | null, notes?: string | null, mediaType?: { __typename?: 'MediaType', id?: string | null, label?: string | null, trashed?: boolean | null } | null, size?: { __typename?: 'PosterSize', id: string, name?: string | null, customer_name?: string | null, trashed?: boolean | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, price_divisor?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, creativeStudio?: Array<{ __typename?: 'CreativeStudio', id: string, creation_id?: string | null, notes?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, creativeStudioType?: { __typename?: 'CreativeStudioType', id: string, name: string } | null, creativeStudioTypeDetail?: { __typename?: 'CreativeStudioTypeDetail', id: string, name: string } | null } | null> | null, creativeStudioEntries?: Array<{ __typename?: 'CreativeStudioEntry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, parent_id?: string | null, mode?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, children?: Array<{ __typename?: 'CreativeStudioEntry', id: string, name?: string | null, notes?: string | null, parent_id?: string | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null } | null> | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, unit_value_estimated_local?: number | null, unit_value_actual?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, digitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string, is_photo_paid?: string | null, status: string, site?: { __typename?: 'Site', id: string, name?: string | null, is_3p?: boolean | null, boroughOrRegion?: string | null, siteStructure?: { __typename?: 'SiteStructure', name?: string | null } | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null } | null> | null, experientials?: Array<{ __typename?: 'Experiential', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, experientialType?: { __typename?: 'ExperientialType', id?: string | null, name?: string | null, trashed?: boolean | null } | null } | null> | null, ambients?: Array<{ __typename?: 'Ambient', id: string, creation_id?: string | null, start_date?: string | null, end_date?: string | null, name?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, ambientType?: { __typename?: 'AmbientType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null> | null, sundries?: Array<{ __typename?: 'Sundry', id: string, creation_id?: string | null, name?: string | null, notes?: string | null, date_up?: string | null, date_down?: string | null, use_global_discount?: boolean | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, sundryType?: { __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null, costs?: Array<{ __typename?: 'Cost', id: string, creation_id?: string | null, supplier_code?: string | null, invoice_number?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, costSupplier?: { __typename?: 'CostSupplier', id: string, label?: string | null, code?: string | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', id: string, label?: string | null } | null } | null } | null> | null, components?: Array<{ __typename?: 'CampaignComponent', id: string, type?: string | null, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null> | null, areaBookings?: Array<{ __typename?: 'AreaBooking', id: string, bay_number?: number | null, rating?: number | null, creation_id?: string | null, special_instructions?: string | null, london_instructions?: string | null, posters_received?: string | null, unit_value_local?: number | null, unit_value_prescribed_local?: number | null, is_photo_paid_ab?: string | null, num_weeks?: number | null, first_up?: string | null, last_down?: string | null, num_posters?: number | null, total_value?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, trashed?: boolean | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null, areaBookingItems?: Array<{ __typename?: 'AreaBookingItem', id: string, creation_id?: string | null, date_up?: string | null, date_down?: string | null, notes?: string | null, qty_posters_per_site?: number | null, qty_sites?: number | null, is_received?: boolean | null, created_at?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_prescribed_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, areaBookingZone?: { __typename?: 'AreaBookingZone', id: string, name: string } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null } | null } | null> | null } | null> | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null } | null> | null } | null, salesTeam?: { __typename?: 'SalesTeam', trashed?: boolean | null, id: string, name?: string | null, prefix?: string | null, current_job_number?: number | null, document_footer?: string | null, contact_email?: string | null, supports_commission?: boolean | null, supports_regional_am_allocation?: boolean | null, commission_financial_notes?: string | null, disclaimer_commission?: string | null, url?: string | null, include_dashboard_all?: boolean | null, include_dashboard_core?: boolean | null, street_address?: string | null, postal_code?: string | null, city?: string | null, tel?: string | null, has_tax?: boolean | null, tax_amount?: number | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null, logos?: Array<{ __typename?: 'File', id: string, file_type?: string | null, url?: string | null, thumbnail_url?: string | null } | null> | null, manager?: { __typename?: 'User', id: string, name?: string | null } | null, proposalOptions?: Array<{ __typename?: 'ProposalOption', id?: string | null, label?: string | null, code?: string | null } | null> | null } | null, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null, authorizationFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, popsFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null } | null> | null, invoiceFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, artworkFiles?: Array<{ __typename?: 'File', creation_id?: string | null, id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null, inboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, outboundFiles?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, uploaded?: string | null, thumbnail_url?: string | null } | null> | null, campaignExchangeRates?: Array<{ __typename?: 'CampaignExchangeRate', from?: string | null, to?: string | null, rate?: number | null } | null> | null, previewTags?: Array<{ __typename?: 'CampaignTag', id: string, name?: string | null, description?: string | null, section_code?: string | null } | null> | null, contractSections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type CampaignDeletePanelsMutationMutationVariables = Exact<{
  deletes?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CampaignDeletePanelsMutationMutation = { __typename?: 'Mutation', campaignDeletePanelBooking?: { __typename?: 'DeletePanelBookingOutput', deletePanelBookingErrors?: Array<{ __typename?: 'DeletePanelBookingError', message?: string | null } | null> | null, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null } | null };

export type DeleteDigitalBookingMutationVariables = Exact<{
  input: DeleteDigitalBookingArrayInput;
}>;


export type DeleteDigitalBookingMutation = { __typename?: 'Mutation', deleteDigitalBooking?: { __typename?: 'DeleteDigitalBookingOutput', digitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null> | null, deleteDigitalBookingErrors?: Array<{ __typename?: 'DeleteDigitalBookingError', message?: string | null } | null> | null } | null };

export type TweakDigitalBookingsMutationVariables = Exact<{
  input: TweakDigitalBookingArrayInput;
}>;


export type TweakDigitalBookingsMutation = { __typename?: 'Mutation', tweakDigitalBookings?: { __typename?: 'TweakDigitalBookingOutput', updatedDigitalBookings?: Array<{ __typename?: 'DigitalBooking', id: string, days: number, cost_type: string, start_date: string, end_date: string, status: string, is_photo_paid?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null } | null> | null, tweakErrors?: Array<{ __typename?: 'TweakDigitalBookingError', id?: string | null, message?: string | null } | null> | null } | null };

export type CampaignTweakPanelsMutationMutationVariables = Exact<{
  tweaks?: InputMaybe<Array<InputMaybe<TweakPanelBookingInput>> | InputMaybe<TweakPanelBookingInput>>;
}>;


export type CampaignTweakPanelsMutationMutation = { __typename?: 'Mutation', campaignUpdatePanelBooking?: { __typename?: 'TweakPanelBookingOutput', tweakPanelBookingErrors?: Array<{ __typename?: 'TweakPanelBookingError', id: string, message?: string | null, category?: string | null, siteName?: string | null } | null> | null, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, instructions?: string | null, is_received?: boolean | null, is_photo_paid?: string | null, isPole?: boolean | null, isOutboundChallenging?: boolean | null, first_week?: string | null, last_week?: string | null, down_date?: string | null, weeks?: number | null, status?: string | null, is_slot?: boolean | null, inbound_challenge_status?: string | null, campaignComponent?: { __typename?: 'CampaignComponent', id: string, unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, panel?: { __typename?: 'Panel', id: string, panel?: string | null, code?: string | null, posters_per_slot?: number | null, site?: { __typename?: 'Site', id: string, name?: string | null, address1?: string | null, externalLink?: string | null, boroughOrRegion?: string | null, postcode?: string | null, site_code?: string | null, latitude?: string | null, longitude?: string | null, borough?: { __typename?: 'Borough', id: string, label?: string | null, trashed?: boolean | null } | null, siteStructure?: { __typename?: 'SiteStructure', id: string, name?: string | null, trashed?: boolean | null } | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null, trashed?: boolean | null, is_inhouse?: boolean | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, is_60_40?: number | null, is_larger_than_4?: boolean | null, trashed?: boolean | null, actual_60_40?: number | null, effective_poster_count?: number | null, slot_poster_count?: number | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null } | null> | null } | null };

export type CampaignsNameAndRefQueryVariables = Exact<{
  name_or_reference_like?: InputMaybe<Scalars['String']>;
}>;


export type CampaignsNameAndRefQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginator', data: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, salesTeam?: { __typename?: 'SalesTeam', name?: string | null, id: string } | null }> } };

export type CampaignChangeSalesTeamMutationVariables = Exact<{
  campaign_id?: InputMaybe<Scalars['ID']>;
  campaign_ref?: InputMaybe<Scalars['String']>;
  sales_team_id?: InputMaybe<Scalars['ID']>;
}>;


export type CampaignChangeSalesTeamMutation = { __typename?: 'Mutation', campaignChangeSalesTeam?: { __typename?: 'Campaign', name?: string | null, job_reference?: string | null } | null };

export type CampaignsQueryQueryVariables = Exact<{
  name_like?: InputMaybe<Scalars['String']>;
  job_reference_like?: InputMaybe<Scalars['String']>;
  name_or_reference_like?: InputMaybe<Scalars['String']>;
  sales_job_ref_like?: InputMaybe<Scalars['String']>;
  completion_date_between?: InputMaybe<DateRange>;
  start_date_between?: InputMaybe<DateRange>;
  artwork_received_date_between?: InputMaybe<DateRange>;
  area_booking_date_up_between?: InputMaybe<DateRange>;
  area_booking_date_down_between?: InputMaybe<DateRange>;
  area_booking_distributor_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  area_booking_poster_size_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  area_booking_region_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status_in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  type_in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  purchase_order_exact?: InputMaybe<Scalars['String']>;
  invoice_exact?: InputMaybe<Scalars['String']>;
  total_price_exact?: InputMaybe<Scalars['ID']>;
  total_price_between?: InputMaybe<IntRange>;
  total_price_exact_no_vat?: InputMaybe<Scalars['ID']>;
  total_price_range_no_vat?: InputMaybe<IntRange>;
  discount_percentage?: InputMaybe<Scalars['Float']>;
  sales_team_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  our_contact_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_like?: InputMaybe<Scalars['String']>;
  contact_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_sub_type_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  regional_am_revenue_id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  with_costs?: InputMaybe<Scalars['Boolean']>;
  with_creative?: InputMaybe<Scalars['Boolean']>;
  with_digital?: InputMaybe<Scalars['Boolean']>;
  with_sundries?: InputMaybe<Scalars['Boolean']>;
  with_areaBooking?: InputMaybe<Scalars['Boolean']>;
}>;


export type CampaignsQueryQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginator', data: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, start_date?: string | null, status?: string | null, type?: string | null, total_price?: number | null, photo_paid_total?: number | null, purchase_order?: string | null, invoice?: string | null, completion_date?: string | null, posters_received?: string | null, discount_final?: number | null, discountableTotal?: number | null, discount_percentage?: number | null, sub_teams_scotland?: string | null, notes?: string | null, confirmationEntry?: { __typename?: 'LogEntry', occurredAt: string } | null, clientSubType?: { __typename?: 'ClientSubType', name?: string | null } | null, regionalAmAllocation?: { __typename?: 'Region', name?: string | null } | null, salesTeam?: { __typename?: 'SalesTeam', name?: string | null, id: string } | null, ourContact?: { __typename?: 'User', name?: string | null, id: string } | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, totals?: { __typename?: 'CampaignTotals', id: string, panel_booking?: number | null, experiential?: number | null, media_production?: number | null, creativestudio?: number | null, area_booking?: number | null, ambient?: number | null, sundry?: number | null, digital_booking?: number | null } | null, costs?: Array<{ __typename?: 'Cost', invoice_number?: string | null, costSupplier?: { __typename?: 'CostSupplier', label?: string | null, code?: string | null, costSupplierCategory?: { __typename?: 'CostSupplierCategory', label?: string | null } | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, digitalBookings?: Array<{ __typename?: 'DigitalBooking', days: number, start_date: string, end_date: string, cost_type: string, campaignComponent?: { __typename?: 'CampaignComponent', unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', name?: string | null } | null, regionType?: { __typename?: 'RegionType', name?: string | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null, site?: { __typename?: 'Site', name?: string | null, externalLink?: string | null, siteStructure?: { __typename?: 'SiteStructure', name?: string | null } | null, sitePricing?: { __typename?: 'SitePricing', label?: string | null } | null } | null } | null> | null, creativeStudio?: Array<{ __typename?: 'CreativeStudio', start_date?: string | null, end_date?: string | null, creativeStudioType?: { __typename?: 'CreativeStudioType', name: string } | null, creativeStudioTypeDetail?: { __typename?: 'CreativeStudioTypeDetail', name: string } | null, campaignComponent?: { __typename?: 'CampaignComponent', unit_value_local?: number | null, qty?: number | null, region?: { __typename?: 'Region', name?: string | null } | null, regionType?: { __typename?: 'RegionType', name?: string | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, areaBookings?: Array<{ __typename?: 'AreaBooking', areaBookingItems?: Array<{ __typename?: 'AreaBookingItem', campaignComponent?: { __typename?: 'CampaignComponent', total?: number | null, qty?: number | null, unit_value?: number | null, region?: { __typename?: 'Region', name?: string | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null } | null } | null> | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, trashed?: boolean | null } | null, regionType?: { __typename?: 'RegionType', name?: string | null } | null } | null> | null, sundries?: Array<{ __typename?: 'Sundry', name?: string | null, notes?: string | null, date_up?: string | null, date_down?: string | null, use_global_discount?: boolean | null, sundryType?: { __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null } | null, campaignComponent?: { __typename?: 'CampaignComponent', unit_value_local?: number | null, qty?: number | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, region?: { __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null } | null> | null }> } };

export type CampaignsSearchQueryQueryVariables = Exact<{
  name_like?: InputMaybe<Scalars['String']>;
  job_reference_like?: InputMaybe<Scalars['String']>;
  name_or_reference_like?: InputMaybe<Scalars['String']>;
  sales_job_ref_like?: InputMaybe<Scalars['String']>;
  completion_date_between?: InputMaybe<DateRange>;
  start_date_between?: InputMaybe<DateRange>;
  artwork_received_date_between?: InputMaybe<DateRange>;
  area_booking_date_up_between?: InputMaybe<DateRange>;
  area_booking_date_down_between?: InputMaybe<DateRange>;
  area_booking_distributor_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  area_booking_poster_size_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  area_booking_region_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status_in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  type_in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  purchase_order_exact?: InputMaybe<Scalars['String']>;
  invoice_exact?: InputMaybe<Scalars['String']>;
  total_price_exact?: InputMaybe<Scalars['ID']>;
  total_price_between?: InputMaybe<IntRange>;
  total_price_exact_no_vat?: InputMaybe<Scalars['ID']>;
  total_price_range_no_vat?: InputMaybe<IntRange>;
  discount_percentage?: InputMaybe<Scalars['Float']>;
  sales_team_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  our_contact_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_like?: InputMaybe<Scalars['String']>;
  contact_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_sub_type_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  regional_am_revenue_id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CampaignsSearchQueryQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginator', data: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, start_date?: string | null, status?: string | null, type?: string | null, total_price?: number | null, photo_paid_total?: number | null, purchase_order?: string | null, invoice?: string | null, completion_date?: string | null, posters_received?: string | null, discount_final?: number | null, discountableTotal?: number | null, discount_percentage?: number | null, sub_teams_scotland?: string | null, notes?: string | null, confirmationEntry?: { __typename?: 'LogEntry', occurredAt: string } | null, clientSubType?: { __typename?: 'ClientSubType', name?: string | null } | null, regionalAmAllocation?: { __typename?: 'Region', name?: string | null } | null, salesTeam?: { __typename?: 'SalesTeam', name?: string | null, id: string } | null, ourContact?: { __typename?: 'User', name?: string | null, id: string } | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, trashed?: boolean | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null } | null } | null, currency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, totals?: { __typename?: 'CampaignTotals', id: string, panel_booking?: number | null, experiential?: number | null, media_production?: number | null, creativestudio?: number | null, area_booking?: number | null, ambient?: number | null, sundry?: number | null, digital_booking?: number | null } | null }> } };

export type GetPanelBookingsForChallengeEmailQueryVariables = Exact<{
  ref?: InputMaybe<Scalars['String']>;
  bookings?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetPanelBookingsForChallengeEmailQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', job_reference?: string | null, id: string, name?: string | null, ourContact?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null, panelBookings?: Array<{ __typename?: 'PanelBooking', id: string, challengeable_status?: string | null, first_week?: string | null, last_week?: string | null, panel?: { __typename?: 'Panel', panel?: string | null, site?: { __typename?: 'Site', id: string, name?: string | null, region?: { __typename?: 'Region', id: string, name?: string | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null } | null } | null } | null } | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, slotPosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null } | null, poleBookings?: Array<{ __typename?: 'PanelBooking', id: string, first_week?: string | null, last_week?: string | null, posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null } | null, campaign?: { __typename?: 'Campaign', job_reference?: string | null, name?: string | null, id: string, ourContact?: { __typename?: 'User', id: string, name?: string | null, email?: string | null } | null } | null } | null> | null } | null> | null } | null };

export type CreateCampaignChallengeMutationVariables = Exact<{
  campaign_id?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  panelBookings?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CreateCampaignChallengeMutation = { __typename?: 'Mutation', createCampaignChallenge?: { __typename?: 'CampaignChallenge', id: string, campaign?: { __typename?: 'Campaign', job_reference?: string | null } | null, bookingChallenges?: Array<{ __typename?: 'CampaignChallengeBooking', id: string, week_end?: number | null, week_start?: number | null, sourcePanelBooking?: { __typename?: 'PanelBooking', id: string } | null, targetPanelBooking?: { __typename?: 'PanelBooking', id: string } | null } | null> | null } | null };

export type GetCampaignNextcloudUrlsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCampaignNextcloudUrlsQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, nextcloud_share_url?: string | null, nextcloud_view_url?: string | null } | null };

export type RegenerateCampaignNextcloudMutationVariables = Exact<{
  campaign_id: Scalars['ID'];
}>;


export type RegenerateCampaignNextcloudMutation = { __typename?: 'Mutation', regenerateCampaignNextcloud?: { __typename?: 'Campaign', id: string, nextcloud_share_url?: string | null, nextcloud_view_url?: string | null } | null };

export type GetNextcloudEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNextcloudEnabledQuery = { __typename?: 'Query', nextcloudEnabled: boolean };

export type UpdateClientSubTypeMutationVariables = Exact<{
  update?: InputMaybe<UpdateClientSubTypes>;
}>;


export type UpdateClientSubTypeMutation = { __typename?: 'Mutation', updateClientSubTypes?: Array<{ __typename?: 'ClientSubType', id: string, name?: string | null, sales_team_prefix?: string | null, trashed?: boolean | null } | null> | null };

export type CreateClientCompanyMutationVariables = Exact<{
  input?: InputMaybe<CreateClientCompanyInput>;
}>;


export type CreateClientCompanyMutation = { __typename?: 'Mutation', createClientCompany?: { __typename?: 'ClientCompany', id: string, accounts_account_code?: string | null, accounts_address?: string | null, accounts_comments?: string | null, accounts_company?: string | null, accounts_contact?: string | null, accounts_phone?: string | null, accounts_email?: string | null, accounts_postcode?: string | null, credit_limit?: number | null, current_credit?: number | null, is_po_required?: boolean | null, is_vat_exempt?: boolean | null, other_contacts?: string | null, sales_address?: string | null, sales_company?: string | null, sales_contact?: string | null, sales_mobile?: string | null, sales_phone?: string | null, sales_postcode?: string | null, sales_title?: string | null, sales_type?: string | null, invoice_factored?: boolean | null, trashed?: boolean | null, contacts?: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null } | null> | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null } | null, clientCompanyGroup?: { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null };

export type GetClientCompanyQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetClientCompanyQuery = { __typename?: 'Query', clientCompany?: { __typename?: 'ClientCompany', id: string, accounts_account_code?: string | null, accounts_address?: string | null, accounts_comments?: string | null, accounts_company?: string | null, accounts_contact?: string | null, accounts_phone?: string | null, accounts_email?: string | null, accounts_postcode?: string | null, credit_limit?: number | null, current_credit?: number | null, is_po_required?: boolean | null, is_vat_exempt?: boolean | null, other_contacts?: string | null, sales_address?: string | null, sales_company?: string | null, sales_contact?: string | null, sales_mobile?: string | null, sales_phone?: string | null, sales_postcode?: string | null, sales_title?: string | null, sales_type?: string | null, invoice_factored?: boolean | null, trashed?: boolean | null, contacts?: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null } | null> | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null } | null, clientCompanyGroup?: { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null };

export type UpdateClientCompanyMutationVariables = Exact<{
  input?: InputMaybe<UpdateClientCompanyInput>;
}>;


export type UpdateClientCompanyMutation = { __typename?: 'Mutation', updateClientCompany?: { __typename?: 'ClientCompany', id: string, accounts_account_code?: string | null, accounts_address?: string | null, accounts_comments?: string | null, accounts_company?: string | null, accounts_contact?: string | null, accounts_phone?: string | null, accounts_email?: string | null, accounts_postcode?: string | null, credit_limit?: number | null, current_credit?: number | null, is_po_required?: boolean | null, is_vat_exempt?: boolean | null, other_contacts?: string | null, sales_address?: string | null, sales_company?: string | null, sales_contact?: string | null, sales_mobile?: string | null, sales_phone?: string | null, sales_postcode?: string | null, sales_title?: string | null, sales_type?: string | null, invoice_factored?: boolean | null, trashed?: boolean | null, contacts?: Array<{ __typename?: 'ClientCompanyContact', id: string, name?: string | null } | null> | null, campaigns?: Array<{ __typename?: 'Campaign', id: string, job_reference?: string | null, name?: string | null } | null> | null, clientType?: { __typename?: 'ClientType', id: string, name?: string | null, supports_commission?: boolean | null, trashed?: boolean | null } | null, clientCompanyGroup?: { __typename?: 'ClientCompanyGroup', id: string, label?: string | null, trashed?: boolean | null, creation_id?: string | null } | null } | null };

export type ContractTemplateFullFragment = { __typename?: 'ContractTemplate', id: string, name?: string | null, description?: string | null, sort?: number | null, creation_id?: string | null, sections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null };

export type GetContractTemplatesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContractTemplatesQueryQuery = { __typename?: 'Query', contractTemplates?: Array<{ __typename?: 'ContractTemplate', id: string, name?: string | null, description?: string | null, sort?: number | null, creation_id?: string | null, sections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null> | null };

export type GetContractTemplateQueryQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type GetContractTemplateQueryQuery = { __typename?: 'Query', getContractTemplate?: { __typename?: 'ContractTemplate', id: string, name?: string | null, description?: string | null, sort?: number | null, creation_id?: string | null, sections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type CreateContractTemplateMutationVariables = Exact<{
  input: CreateContractTemplateInput;
}>;


export type CreateContractTemplateMutation = { __typename?: 'Mutation', createContractTemplate?: { __typename?: 'ContractTemplate', id: string, name?: string | null, description?: string | null, sort?: number | null, creation_id?: string | null, sections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type UpdateContractTemplateMutationVariables = Exact<{
  input: UpdateContractTemplateInput;
}>;


export type UpdateContractTemplateMutation = { __typename?: 'Mutation', updateContractTemplate?: { __typename?: 'ContractTemplate', id: string, name?: string | null, description?: string | null, sort?: number | null, creation_id?: string | null, sections?: Array<{ __typename?: 'ContractSection', id: string, title?: string | null, show_title?: boolean | null, new_page?: boolean | null, sort?: number | null, creation_id?: string | null, blocks?: Array<{ __typename?: 'ContractBlock', id: string, type?: string | null, title?: string | null, content?: string | null, sort?: number | null, creation_id?: string | null, files?: Array<{ __typename?: 'File', id: string, url?: string | null, thumbnail_url?: string | null, filename?: string | null, file_type?: string | null, creation_id?: string | null, distributor?: { __typename?: 'Distributor', id: string, name?: string | null } | null } | null> | null } | null> | null } | null> | null } | null };

export type DeleteContractTemplateMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteContractTemplateMutation = { __typename?: 'Mutation', deleteContractTemplate?: { __typename?: 'ContractTemplate', id: string } | null };

export type UpdateCurrenciesMutationVariables = Exact<{
  update?: InputMaybe<UpdateCurrencies>;
}>;


export type UpdateCurrenciesMutation = { __typename?: 'Mutation', updateCurrencies?: Array<{ __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null> | null };

export type SearchCrmQueryQueryVariables = Exact<{
  sales_team_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  account_manager_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_sub_type_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  contact_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  client_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  sales_team_all?: InputMaybe<Scalars['Boolean']>;
  sales_team_core?: InputMaybe<Scalars['Boolean']>;
  status_in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  completion_date_between?: InputMaybe<DateRange>;
  completion_date_in?: InputMaybe<Array<DateRange> | DateRange>;
}>;


export type SearchCrmQueryQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginator', data: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, start_date?: string | null, status?: string | null, total_price_reporting?: number | null, discount_percentage?: number | null, margin?: string | null, totalCostsReporting?: number | null, invoice?: string | null, purchase_order?: string | null, completion_date?: string | null, clientCompany?: { __typename?: 'ClientCompany', id: string, accounts_company?: string | null } | null, clientSubType?: { __typename?: 'ClientSubType', id: string, name?: string | null } | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null, prefix?: string | null, include_dashboard_core?: boolean | null } | null, ourContact?: { __typename?: 'User', name?: string | null } | null }> } };

export type DashboardSitesQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardSitesQueryQuery = { __typename?: 'Query', sites?: Array<{ __typename?: 'Site', id: string, name?: string | null, is_dashboard_site?: boolean | null, externalLink?: string | null, region?: { __typename?: 'Region', name?: string | null } | null, siteStructure?: { __typename?: 'SiteStructure', name?: string | null } | null } | null> | null };

export type ToggleDashboardSiteMutationMutationVariables = Exact<{
  id: Scalars['ID'];
  is_dashboard_site: Scalars['Boolean'];
}>;


export type ToggleDashboardSiteMutationMutation = { __typename?: 'Mutation', toggleDashboardSite?: { __typename?: 'Site', id: string, is_dashboard_site?: boolean | null } | null };

export type SearchCampaignQueryQueryVariables = Exact<{
  completion_date_between?: InputMaybe<DateRange>;
  sales_team_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  status_in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sales_team_all?: InputMaybe<Scalars['Boolean']>;
  sales_team_core?: InputMaybe<Scalars['Boolean']>;
  regional_am_revenue_id_in?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type SearchCampaignQueryQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginator', data: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, start_date?: string | null, status?: string | null, total_price_reporting?: number | null, discount_percentage?: number | null, margin?: string | null, totalCostsReporting?: number | null, invoice?: string | null, purchase_order?: string | null, completion_date?: string | null, clientCompany?: { __typename?: 'ClientCompany', accounts_company?: string | null, sales_company?: string | null } | null, reportingCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null, trashed?: boolean | null } | null, salesTeam?: { __typename?: 'SalesTeam', id: string, name?: string | null } | null, ourContact?: { __typename?: 'User', name?: string | null } | null }> } };

export type GetShortcutsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetShortcutsQueryQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, campaignShortcuts?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, status?: string | null, start_date?: string | null } | null> | null } | null };

export type CreateDistributorMutationVariables = Exact<{
  input: CreateDistributorInput;
}>;


export type CreateDistributorMutation = { __typename?: 'Mutation', createDistributor?: { __typename?: 'Distributor', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null };

export type GetDistributorQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetDistributorQuery = { __typename?: 'Query', distributor?: { __typename?: 'Distributor', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null };

export type UpdateDistributorMutationVariables = Exact<{
  input: UpdateDistributorInput;
}>;


export type UpdateDistributorMutation = { __typename?: 'Mutation', updateDistributor?: { __typename?: 'Distributor', id: string, name?: string | null, email?: string | null, trashed?: boolean | null } | null };

export type ExperientialTypesMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateExperientialTypesInput>;
}>;


export type ExperientialTypesMutationMutation = { __typename?: 'Mutation', updateExperientialTypes?: Array<{ __typename?: 'ExperientialType', id?: string | null, name?: string | null, trashed?: boolean | null, creation_id?: string | null } | null> | null };

export type ImportFileDataMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportFileDataMutation = { __typename?: 'Mutation', importFileData?: { __typename?: 'ImportFileResult', success: boolean, failedJobs: Array<string | null> } | null };

export type ImportInvoiceDataMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportInvoiceDataMutation = { __typename?: 'Mutation', importInvoiceData?: boolean | null };

export type ImportPopsDataMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type ImportPopsDataMutation = { __typename?: 'Mutation', importPopsData?: boolean | null };

export type CreateLandlordMutationVariables = Exact<{
  input: CreateSubletterInput;
}>;


export type CreateLandlordMutation = { __typename?: 'Mutation', createSubletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, contact_name?: string | null, company?: string | null, email?: string | null, email_2?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, postcode?: string | null, telephone_1?: string | null, telephone_2?: string | null, trashed?: boolean | null } | null };

export type GetLandlordQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLandlordQuery = { __typename?: 'Query', subletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, contact_name?: string | null, company?: string | null, email?: string | null, email_2?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, postcode?: string | null, telephone_1?: string | null, telephone_2?: string | null, trashed?: boolean | null } | null };

export type UpdateLandlordMutationVariables = Exact<{
  input: UpdateSubletterInput;
}>;


export type UpdateLandlordMutation = { __typename?: 'Mutation', updateSubletter?: { __typename?: 'Subletter', id?: string | null, name?: string | null, contact_name?: string | null, company?: string | null, email?: string | null, email_2?: string | null, address_1?: string | null, address_2?: string | null, city?: string | null, postcode?: string | null, telephone_1?: string | null, telephone_2?: string | null, trashed?: boolean | null } | null };

export type RemoveOtherUserProxyMutationVariables = Exact<{
  input: RemoveUserProxyInput;
}>;


export type RemoveOtherUserProxyMutation = { __typename?: 'Mutation', removeOtherUserProxy?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, hasAuthenticatorQrCode?: boolean | null, hasPasskey?: boolean | null, activeChallengeCountInbound?: number | null, activeChallengeCountOutbound?: number | null, challengeCountOutboundNew?: number | null, challengeCountInboundNew?: number | null, token?: string | null, passkeys?: Array<{ __typename?: 'PasskeyCredential', id: string, credential_id: string, name?: string | null, sign_count?: number | null, backup_eligible?: boolean | null, backup_status?: boolean | null, uv_initialized?: boolean | null, last_used_at?: any | null, created_at?: any | null }> | null, userNotifications?: Array<{ __typename?: 'UserNotification', id: string, type?: string | null, status?: string | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null } | null> | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null } | null> | null, campaignShortcuts?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, is_locked?: boolean | null } | null> | null, options?: Array<{ __typename?: 'UserOption', id: string, name?: string | null, search_name?: string | null, value?: string | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null, usersIProxy?: Array<{ __typename?: 'User', id: string, name?: string | null } | null> | null } | null };

export type UpdateMeMutationVariables = Exact<{
  input: UpdateMeInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'User', id: string, name?: string | null, email?: string | null, hasAuthenticatorQrCode?: boolean | null, hasPasskey?: boolean | null, activeChallengeCountInbound?: number | null, activeChallengeCountOutbound?: number | null, challengeCountOutboundNew?: number | null, challengeCountInboundNew?: number | null, token?: string | null, passkeys?: Array<{ __typename?: 'PasskeyCredential', id: string, credential_id: string, name?: string | null, sign_count?: number | null, backup_eligible?: boolean | null, backup_status?: boolean | null, uv_initialized?: boolean | null, last_used_at?: any | null, created_at?: any | null }> | null, userNotifications?: Array<{ __typename?: 'UserNotification', id: string, type?: string | null, status?: string | null, campaign?: { __typename?: 'Campaign', id: string, name?: string | null } | null } | null> | null, role?: { __typename?: 'Role', id: string, name?: string | null, trashed?: boolean | null, permissions?: Array<{ __typename?: 'Permission', id: string, category?: string | null, name?: string | null, code?: string | null, enable_section?: string | null } | null> | null } | null, salesTeams?: Array<{ __typename?: 'SalesTeam', id: string, name?: string | null, trashed?: boolean | null, defaultCurrency?: { __typename?: 'Currency', id: string, label?: string | null, glyph?: string | null } | null } | null> | null, campaignShortcuts?: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, is_locked?: boolean | null } | null> | null, options?: Array<{ __typename?: 'UserOption', id: string, name?: string | null, search_name?: string | null, value?: string | null } | null> | null, proxyUser?: { __typename?: 'User', id: string, name?: string | null } | null, usersIProxy?: Array<{ __typename?: 'User', id: string, name?: string | null } | null> | null } | null };

export type CreateOptionMutationVariables = Exact<{
  input: CreateOptionInput;
}>;


export type CreateOptionMutation = { __typename?: 'Mutation', createOption?: { __typename?: 'Option', id: string, label?: string | null, code?: string | null, type?: string | null, int_value?: number | null, bool_value?: boolean | null, text_value?: string | null } | null };

export type GetOptionQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
}>;


export type GetOptionQuery = { __typename?: 'Query', option?: { __typename?: 'Option', id: string, label?: string | null, code?: string | null, type?: string | null, int_value?: number | null, bool_value?: boolean | null, text_value?: string | null } | null };

export type UpdateOptionMutationVariables = Exact<{
  input: UpdateOptionInput;
}>;


export type UpdateOptionMutation = { __typename?: 'Mutation', updateOption?: { __typename?: 'Option', id: string, label?: string | null, code?: string | null, type?: string | null, int_value?: number | null, bool_value?: boolean | null, text_value?: string | null } | null };

export type SundryTypesMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateSundryTypesInput>;
}>;


export type SundryTypesMutationMutation = { __typename?: 'Mutation', updateSundryTypes?: Array<{ __typename?: 'SundryType', id: string, name?: string | null, trashed?: boolean | null } | null> | null };

export type UpdatePanelBookingMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  week_number?: InputMaybe<Scalars['Int']>;
  num_weeks?: InputMaybe<Scalars['Int']>;
  trim?: InputMaybe<Scalars['Int']>;
  ignore_loss_of_pole?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdatePanelBookingMutation = { __typename?: 'Mutation', updatePanelBooking?: Array<{ __typename?: 'PanelBookingDateSummary', id: string, weekNumber?: number | null, campaignName?: string | null, count?: number | null, status?: string | null, type?: string | null, panelStatus?: string | null, instruction?: string | null, campaign_challenge_booking_id?: number | null, campaigns?: Array<{ __typename?: 'PanelBookingDateCampaign', id: string, name?: string | null, status?: string | null } | null> | null } | null> | null };

export type GetPosterSizesForImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPosterSizesForImagesQuery = { __typename?: 'Query', posterSizes?: Array<{ __typename?: 'PosterSize', id: string, name?: string | null } | null> | null };

export type GetPosterSizeImageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPosterSizeImageQuery = { __typename?: 'Query', posterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, image_caption?: string | null, images?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null } | null };

export type UpdatePosterSizeMutationVariables = Exact<{
  input?: InputMaybe<UpdatePosterSizeInput>;
}>;


export type UpdatePosterSizeMutation = { __typename?: 'Mutation', updatePosterSize?: { __typename?: 'PosterSize', id: string, name?: string | null, image_caption?: string | null, images?: Array<{ __typename?: 'File', id: string, original_name?: string | null, url?: string | null, thumbnail_url?: string | null, uploaded?: string | null, creation_id?: string | null } | null> | null } | null };

export type ListRegionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ListRegionTypesQuery = { __typename?: 'Query', regionTypes: { __typename?: 'RegionTypePaginator', data: Array<{ __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null }> } };

export type UpdateRegionTypesMutationVariables = Exact<{
  update?: InputMaybe<UpdateRegionTypesInput>;
}>;


export type UpdateRegionTypesMutation = { __typename?: 'Mutation', updateRegionTypes?: Array<{ __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null> | null };

export type RegionsMutationMutationVariables = Exact<{
  update?: InputMaybe<UpdateRegion>;
}>;


export type RegionsMutationMutation = { __typename?: 'Mutation', updateRegions?: Array<{ __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null } | null> | null };

export type RegionsForListQueryVariables = Exact<{
  map_string?: InputMaybe<Scalars['String']>;
}>;


export type RegionsForListQuery = { __typename?: 'Query', regions: { __typename?: 'RegionPaginator', data: Array<{ __typename?: 'Region', id: string, name?: string | null, is_area_booking?: boolean | null, is_panel_booking?: boolean | null, manual_area_booking_pricing?: boolean | null, example_map_string?: string | null, trashed?: boolean | null, regionType?: { __typename?: 'RegionType', id: string, name?: string | null, pricing_model?: string | null, has_poster_pricing?: boolean | null, has_regional_pricing?: boolean | null, has_split_qty?: boolean | null, trashed?: boolean | null } | null }> } };

export type CampaignFinancialLookupQueryVariables = Exact<{
  completion_date_between?: InputMaybe<DateRange>;
  start_date_between?: InputMaybe<DateRange>;
  status_in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sales_team_id_in?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type CampaignFinancialLookupQuery = { __typename?: 'Query', campaigns: { __typename?: 'CampaignPaginator', data: Array<{ __typename?: 'Campaign', id: string, name?: string | null, job_reference?: string | null, start_date?: string | null, status?: string | null, total_price?: number | null, purchase_order?: string | null, clientCompany?: { __typename?: 'ClientCompany', id: string, sales_company?: string | null, accounts_account_code?: string | null, trashed?: boolean | null } | null }> } };

export type UpdateSiteBuildContractorMutationVariables = Exact<{
  update: UpdateSiteBuildContractor;
}>;


export type UpdateSiteBuildContractorMutation = { __typename?: 'Mutation', updateSiteBuildContractors?: Array<{ __typename?: 'SiteBuildContractor', id: string, label?: string | null, trashed?: boolean | null } | null> | null };

export type UpdateSiteStructureTypeMutationVariables = Exact<{
  update?: InputMaybe<UpdateSiteStructureTypesInput>;
}>;


export type UpdateSiteStructureTypeMutation = { __typename?: 'Mutation', updateSiteStructureType?: Array<{ __typename?: 'SiteStructureType', id: string, name?: string | null, trashed?: boolean | null } | null> | null };

export type PlanningReportQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type PlanningReportQuery = { __typename?: 'Query', sites?: Array<{ __typename?: 'Site', id: string, name?: string | null, sitePlannings?: Array<{ __typename?: 'SitePlanning', id: string, notes?: string | null, outcome_notes?: string | null, planning_date?: string | null, amount?: number | null, outcome_date?: string | null, planningStage?: { __typename?: 'SitePlanningStage', label?: string | null } | null, planningOutcome?: { __typename?: 'SitePlanningOutcome', label?: string | null } | null } | null> | null } | null> | null };

export type SiteTagsQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type SiteTagsQuery = { __typename?: 'Query', siteTags: { __typename?: 'SiteTagPaginator', data: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null, creation_id?: string | null }> } };

export type SiteTagsFullQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
}>;


export type SiteTagsFullQuery = { __typename?: 'Query', siteTags: { __typename?: 'SiteTagPaginator', data: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null, code?: string | null, creation_id?: string | null }> } };

export type UpdateSiteTagsMutationVariables = Exact<{
  update?: InputMaybe<UpdateSiteTag>;
}>;


export type UpdateSiteTagsMutation = { __typename?: 'Mutation', updateSiteTags?: Array<{ __typename?: 'SiteTag', id: string, name?: string | null, section?: string | null, code?: string | null, creation_id?: string | null } | null> | null };

export const UserNotificationFullFragmentDoc = gql`
    fragment UserNotificationFull on UserNotification {
  id
  campaign {
    id
    name
  }
  type
  status
}
    `;
export const PermissionFullFragmentDoc = gql`
    fragment PermissionFull on Permission {
  id
  category
  name
  code
  enable_section
}
    `;
export const RoleFullFragmentDoc = gql`
    fragment RoleFull on Role {
  id
  name
  permissions {
    ...PermissionFull
  }
  trashed
}
    ${PermissionFullFragmentDoc}`;
export const MeDetailsFragmentDoc = gql`
    fragment MeDetails on User {
  id
  name
  email
  hasAuthenticatorQrCode
  hasPasskey
  passkeys {
    id
    credential_id
    name
    sign_count
    backup_eligible
    backup_status
    uv_initialized
    last_used_at
    created_at
  }
  activeChallengeCountInbound
  activeChallengeCountOutbound
  challengeCountOutboundNew
  challengeCountInboundNew
  userNotifications {
    ...UserNotificationFull
  }
  role {
    ...RoleFull
  }
  token
  salesTeams {
    id
    name
    trashed
    defaultCurrency(trashed: WITH) {
      id
      label
      glyph
    }
  }
  campaignShortcuts {
    id
    name
    job_reference
    is_locked
  }
  options {
    id
    name
    search_name
    value
  }
  proxyUser {
    id
    name
  }
  usersIProxy {
    id
    name
  }
}
    ${UserNotificationFullFragmentDoc}
${RoleFullFragmentDoc}`;
export const ClientCompanyAndContactLookupContactFragmentDoc = gql`
    fragment ClientCompanyAndContactLookupContact on ClientCompanyContact {
  id
  name
  email
  trashed
}
    `;
export const ClientCompanyAndContactLookupCompanyFragmentDoc = gql`
    fragment ClientCompanyAndContactLookupCompany on ClientCompany {
  id
  sales_company
  accounts_company
  credit_limit
  current_credit
  is_vat_exempt
  accounts_address
  accounts_postcode
  accounts_account_code
  trashed
  clientType {
    id
    name
  }
}
    `;
export const ClientCompanyAndContactLookupFragmentDoc = gql`
    fragment ClientCompanyAndContactLookup on ClientCompanyContact {
  ...ClientCompanyAndContactLookupContact
  clientCompany {
    ...ClientCompanyAndContactLookupCompany
  }
}
    ${ClientCompanyAndContactLookupContactFragmentDoc}
${ClientCompanyAndContactLookupCompanyFragmentDoc}`;
export const ClientTypeFullFragmentDoc = gql`
    fragment ClientTypeFull on ClientType {
  id
  name
  supports_commission
  trashed
}
    `;
export const ClientCompanyGroupFullFragmentDoc = gql`
    fragment ClientCompanyGroupFull on ClientCompanyGroup {
  id
  label
  trashed
  creation_id
}
    `;
export const ClientCompanyFullFragmentDoc = gql`
    fragment ClientCompanyFull on ClientCompany {
  id
  accounts_account_code
  accounts_address
  accounts_comments
  accounts_company
  accounts_contact
  accounts_phone
  accounts_email
  accounts_postcode
  credit_limit
  current_credit
  is_po_required
  is_vat_exempt
  other_contacts
  sales_address
  sales_company
  sales_contact
  sales_mobile
  sales_phone
  sales_postcode
  sales_title
  sales_type
  invoice_factored
  clientType {
    ...ClientTypeFull
  }
  clientCompanyGroup {
    ...ClientCompanyGroupFull
  }
  trashed
}
    ${ClientTypeFullFragmentDoc}
${ClientCompanyGroupFullFragmentDoc}`;
export const ClientCompanyContactFullFragmentDoc = gql`
    fragment ClientCompanyContactFull on ClientCompanyContact {
  id
  name
  email
  comments
  email
  is_marketing
  is_sales
  is_mailchimp
  job_sheet_info
  name
  phone
  phone_alt
  title
  clientCompany {
    ...ClientCompanyAndContactLookupCompany
  }
  salesTeam {
    id
    name
  }
  trashed
}
    ${ClientCompanyAndContactLookupCompanyFragmentDoc}`;
export const DistributorFullFragmentDoc = gql`
    fragment DistributorFull on Distributor {
  id
  name
  email
  trashed
}
    `;
export const ExperientialTypeFullFragmentDoc = gql`
    fragment ExperientialTypeFull on ExperientialType {
  id
  name
  trashed
  creation_id
}
    `;
export const CurrencyFullFragmentDoc = gql`
    fragment CurrencyFull on Currency {
  id
  label
  glyph
  trashed
}
    `;
export const AreaBookingRegionPricingFullFragmentDoc = gql`
    fragment AreaBookingRegionPricingFull on AreaBookingRegionPricing {
  id
  currency {
    ...CurrencyFull
  }
  unit_value
  region {
    id
  }
}
    ${CurrencyFullFragmentDoc}`;
export const PosterSizeFullFragmentDoc = gql`
    fragment PosterSizeFull on PosterSize {
  id
  name
  dc_type
  is_larger_than_4
  is_panel_poster
  is_street_poster
  is_media_type
  customer_name
  londonCurrencyId
  regionalCurrencyId
  festivalCurrencyId
  internationalCurrencyId
  londonPricing
  regionalPricing
  festivalPricing
  internationalPricing
  areaBookingRegionPricing(regions: $regions) {
    ...AreaBookingRegionPricingFull
  }
  regionTypePricing {
    id
    regionType {
      id
    }
    unit_value
  }
  slotPosterSize {
    id
    name
  }
  slot_poster_count
  effective_poster_count
  trashed
}
    ${AreaBookingRegionPricingFullFragmentDoc}`;
export const ExchangeRateFullFragmentDoc = gql`
    fragment ExchangeRateFull on ExchangeRate {
  id
  from {
    ...CurrencyFull
  }
  to {
    ...CurrencyFull
  }
  rate
}
    ${CurrencyFullFragmentDoc}`;
export const ExchangeRateShortFragmentDoc = gql`
    fragment ExchangeRateShort on ExchangeRate {
  id
  from {
    id
  }
  to {
    id
  }
  rate
}
    `;
export const ClientSubTypeFullFragmentDoc = gql`
    fragment ClientSubTypeFull on ClientSubType {
  id
  name
  sales_team_prefix
  trashed
}
    `;
export const CostSupplierCategoryFullFragmentDoc = gql`
    fragment CostSupplierCategoryFull on CostSupplierCategory {
  id
  label
  trashed
  creation_id
}
    `;
export const CostSupplierFullFragmentDoc = gql`
    fragment CostSupplierFull on CostSupplier {
  id
  label
  code
  trashed
  costSupplierCategory {
    ...CostSupplierCategoryFull
  }
}
    ${CostSupplierCategoryFullFragmentDoc}`;
export const MediaTypeFullFragmentDoc = gql`
    fragment MediaTypeFull on MediaType {
  id
  label
  trashed
}
    `;
export const TvAreaFullFragmentDoc = gql`
    fragment TVAreaFull on TVArea {
  id
  label
  trashed
}
    `;
export const StyleFullFragmentDoc = gql`
    fragment StyleFull on Style {
  id
  label
  is_site_style
  is_pack_style
  trashed
}
    `;
export const PackFullFragmentDoc = gql`
    fragment PackFull on Pack {
  id
  label
  style(trashed: WITH) {
    ...StyleFull
  }
  trashed
}
    ${StyleFullFragmentDoc}`;
export const PostInstructionFullFragmentDoc = gql`
    fragment PostInstructionFull on PostInstruction {
  id
  label
  code
  trashed
}
    `;
export const RegionTypeFullFragmentDoc = gql`
    fragment RegionTypeFull on RegionType {
  id
  name
  pricing_model
  has_poster_pricing
  has_regional_pricing
  has_split_qty
  trashed
}
    `;
export const RegionFullFragmentDoc = gql`
    fragment RegionFull on Region {
  id
  name
  is_area_booking
  is_panel_booking
  manual_area_booking_pricing
  regionType(trashed: WITH) {
    ...RegionTypeFull
  }
  example_map_string
  trashed
}
    ${RegionTypeFullFragmentDoc}`;
export const RegionTypeFullWithRegionsFragmentDoc = gql`
    fragment RegionTypeFullWithRegions on RegionType {
  ...RegionTypeFull
  regions(orderBy: [{column: "name", order: ASC}]) {
    ...RegionFull
  }
}
    ${RegionTypeFullFragmentDoc}
${RegionFullFragmentDoc}`;
export const LogEntryFragmentDoc = gql`
    fragment LogEntry on LogEntry {
  id
  kind
  label
  occurredAt
  totalPrice
  totalPriceWithVat
  status
  user {
    id
    name
  }
}
    `;
export const ProposalOptionFullFragmentDoc = gql`
    fragment ProposalOptionFull on ProposalOption {
  id
  label
  code
}
    `;
export const SiteHealthAndSafetyTypeFullFragmentDoc = gql`
    fragment SiteHealthAndSafetyTypeFull on SiteHealthAndSafetyType {
  id
  label
  trashed
}
    `;
export const SitePlanningOutcomeFullFragmentDoc = gql`
    fragment SitePlanningOutcomeFull on SitePlanningOutcome {
  id
  label
  trashed
}
    `;
export const SitePlanningStageFullFragmentDoc = gql`
    fragment SitePlanningStageFull on SitePlanningStage {
  id
  label
  trashed
}
    `;
export const SiteRentalPaymentFrequencyFullFragmentDoc = gql`
    fragment SiteRentalPaymentFrequencyFull on SiteRentalPaymentFrequency {
  id
  label
  trashed
}
    `;
export const SiteRentalPaymentMethodFullFragmentDoc = gql`
    fragment SiteRentalPaymentMethodFull on SiteRentalPaymentMethod {
  id
  label
  trashed
}
    `;
export const SiteRentalTypeFullFragmentDoc = gql`
    fragment SiteRentalTypeFull on SiteRentalType {
  id
  label
  trashed
}
    `;
export const SubletterFullFragmentDoc = gql`
    fragment SubletterFull on Subletter {
  id
  name
  contact_name
  company
  email
  email_2
  address_1
  address_2
  city
  postcode
  telephone_1
  telephone_2
  trashed
}
    `;
export const SiteStructureFullFragmentDoc = gql`
    fragment SiteStructureFull on SiteStructure {
  id
  name
  trashed
}
    `;
export const UserShortFragmentDoc = gql`
    fragment UserShort on User {
  id
  name
  email
  role(trashed: WITH) {
    id
    name
    trashed
  }
  salesTeams(trashed: WITH) {
    id
    name
    trashed
  }
}
    `;
export const UserFullFragmentDoc = gql`
    fragment UserFull on User {
  id
  name
  email
  password
  role(trashed: WITH) {
    id
    name
    trashed
  }
  salesTeams(trashed: WITH) {
    id
    name
    trashed
  }
  lockout_until
  failed_2fa_count
  failed_password_count
  hasAuthenticatorQrCode
  proxyUser {
    ...UserShort
  }
}
    ${UserShortFragmentDoc}`;
export const SiteBuildContractorFullFragmentDoc = gql`
    fragment SiteBuildContractorFull on SiteBuildContractor {
  id
  label
  trashed
}
    `;
export const SiteBuildTypeFullFragmentDoc = gql`
    fragment SiteBuildTypeFull on SiteBuildType {
  id
  label
  trashed
}
    `;
export const OptionFullFragmentDoc = gql`
    fragment OptionFull on Option {
  id
  label
  code
  type
  int_value
  bool_value
  text_value
}
    `;
export const PanelBookingDateSummaryFullFragmentDoc = gql`
    fragment PanelBookingDateSummaryFull on PanelBookingDateSummary {
  id
  weekNumber
  campaignName
  count
  status
  type
  panelStatus
  instruction
  campaign_challenge_booking_id
  campaigns {
    id
    name
    status
  }
}
    `;
export const BoroughFullFragmentDoc = gql`
    fragment BoroughFull on Borough {
  id
  label
  trashed
  creation_id
}
    `;
export const DistributorMinimalFragmentDoc = gql`
    fragment DistributorMinimal on Distributor {
  id
  name
  trashed
}
    `;
export const SitePricingFullFragmentDoc = gql`
    fragment SitePricingFull on SitePricing {
  id
  label
  panel
  comment
  currency {
    ...CurrencyFull
  }
  trashed
}
    ${CurrencyFullFragmentDoc}`;
export const SiteStructureFullWithPosterSizeFragmentDoc = gql`
    fragment SiteStructureFullWithPosterSize on SiteStructure {
  id
  name
  trashed
  posterSize {
    id
    name
  }
  slotPosterSize {
    id
    name
  }
  siteStructureGroup {
    id
    name
  }
}
    `;
export const SiteStructureTypeFullFragmentDoc = gql`
    fragment SiteStructureTypeFull on SiteStructureType {
  id
  name
  trashed
}
    `;
export const SubletterMinimalFragmentDoc = gql`
    fragment SubletterMinimal on Subletter {
  id
  name
  trashed
}
    `;
export const SiteFullFragmentDoc = gql`
    fragment SiteFull on Site {
  address1
  address2
  photo_archive_url
  pops_url
  tvArea(trashed: WITH) {
    id
    label
    trashed
  }
  borough(trashed: WITH) {
    ...BoroughFull
  }
  build_date
  description
  distributor(trashed: WITH) {
    ...DistributorMinimal
  }
  id
  impacts
  name
  notes
  style(trashed: WITH) {
    ...StyleFull
  }
  panels {
    id
    code
    restriction
    number_of_slots
    owner
    notes
    pack(trashed: WITH) {
      id
      label
      trashed
    }
    panel
    postInstruction(trashed: WITH) {
      id
      label
      code
      trashed
    }
    posters_per_slot
    panelAvailabilities {
      id
      first_week
      last_week
      availability
      reason
      creation_id
    }
    creation_id
  }
  sitePricing(trashed: WITH) {
    ...SitePricingFull
  }
  tags {
    id
    name
    section
  }
  latitude
  longitude
  three_words
  notes
  description
  is_illumination
  is_3p
  is_dynamic
  is_dashboard_site
  postcode
  takeoverSite {
    id
    name
  }
  takeoverSitesManagedByThis {
    id
    name
  }
  region(trashed: WITH) {
    ...RegionFull
  }
  road_number
  site_code
  siteStructure(trashed: WITH) {
    ...SiteStructureFullWithPosterSize
  }
  siteStructureType(trashed: WITH) {
    ...SiteStructureTypeFull
  }
  siteImages {
    id
    original_name
    url
    thumbnail_url
    uploaded
    creation_id
  }
  siteFilesOther {
    id
    original_name
    url
    thumbnail_url
    uploaded
    creation_id
  }
  siteBuildAndRepairs {
    id
    creation_id
    buildType(trashed: WITH) {
      id
      label
      trashed
    }
    buildContractor(trashed: WITH) {
      id
      label
      trashed
    }
    panel
    cancelled
    costs_excluding_vat
    costs_1
    costs_2
    costs_3
    costs_4
    costs_5
    costs_comments_1
    costs_comments_2
    costs_comments_3
    costs_comments_4
    costs_comments_5
    quantity
    issued_by
    additional_info
    completion_deadline
    completion_date
    invoice_number
    po_number
  }
  siteMaintenanceInspection {
    id
    creation_id
    siteMaintenanceInspectionType {
      id
      label
    }
    notes
    last_inspection_date
  }
  siteRentals {
    creation_id
    id
    amount
    start_date
    expiry_date
    increase_date
    comments
    contact
    contact_code
    freeholder
    is_cancelled
    is_rolling
    rentalType(trashed: WITH) {
      id
      label
      trashed
    }
    paymentMethod(trashed: WITH) {
      id
      label
      trashed
    }
    paymentFrequency(trashed: WITH) {
      id
      label
      trashed
    }
  }
  siteHealthAndSafeties {
    id
    creation_id
    notes
    last_inspection_date
    healthAndSafetyType(trashed: WITH) {
      id
      label
      trashed
    }
  }
  sitePayments {
    id
    creation_id
    amount
    date
    currency {
      ...CurrencyFull
    }
  }
  siteDigitalBookingPricing {
    id
    creation_id
    days
    net
  }
  sitePlannings {
    id
    notes
    planningStage(trashed: WITH) {
      id
      label
      trashed
    }
    planningOutcome(trashed: WITH) {
      id
      label
      trashed
    }
    outcome_notes
    planning_date
    outcome_date
    amount
    creation_id
  }
  subletter(trashed: WITH) {
    ...SubletterMinimal
  }
  poster_portfolio_url
  rate_card_url
  galleryImages {
    id
    original_name
    url
    thumbnail_url
    uploaded
    creation_id
  }
  layoutImages {
    id
    original_name
    url
    thumbnail_url
    uploaded
    creation_id
  }
}
    ${BoroughFullFragmentDoc}
${DistributorMinimalFragmentDoc}
${StyleFullFragmentDoc}
${SitePricingFullFragmentDoc}
${RegionFullFragmentDoc}
${SiteStructureFullWithPosterSizeFragmentDoc}
${SiteStructureTypeFullFragmentDoc}
${CurrencyFullFragmentDoc}
${SubletterMinimalFragmentDoc}`;
export const CampaignChallengeFullFragmentDoc = gql`
    fragment campaignChallengeFull on CampaignChallenge {
  id
  status
  created_at
  inboundRecent
  outboundRecent
  campaign {
    id
    job_reference
    name
    ourContact {
      id
      name
      proxyUser {
        id
        name
      }
    }
  }
  bookingChallenges {
    id
    date_start
    date_end
    message
    panel {
      id
      panel
      site {
        name
        region {
          id
          name
          regionType {
            id
            name
          }
        }
      }
    }
    status
    targetCampaign {
      id
      name
      job_reference
      ourContact {
        id
        name
        proxyUser {
          id
          name
        }
      }
    }
  }
}
    `;
export const PanelBookingFullFragmentDoc = gql`
    fragment panelBookingFull on PanelBooking {
  id
  instructions
  is_received
  is_photo_paid
  isPole
  isOutboundChallenging
  campaignComponent {
    id
    unit_value_local
    currency {
      ...CurrencyFull
    }
    qty
    region(trashed: WITH) {
      ...RegionFull
    }
    regionType(trashed: WITH) {
      ...RegionTypeFull
    }
  }
  panel {
    id
    panel
    code
    posters_per_slot
    site {
      id
      name
      address1
      externalLink
      boroughOrRegion
      postcode
      site_code
      latitude
      longitude
      borough(trashed: WITH) {
        id
        label
        trashed
      }
      siteStructure(trashed: WITH) {
        id
        name
        trashed
      }
      distributor(trashed: WITH) {
        id
        name
        trashed
        is_inhouse
      }
    }
  }
  first_week
  last_week
  down_date
  weeks
  status
  posterSize(trashed: WITH) {
    id
    name
    is_60_40
    is_larger_than_4
    trashed
    actual_60_40
    effective_poster_count
    slot_poster_count
    slotPosterSize(trashed: WITH) {
      id
      name
    }
  }
  is_slot
  inbound_challenge_status
}
    ${CurrencyFullFragmentDoc}
${RegionFullFragmentDoc}
${RegionTypeFullFragmentDoc}`;
export const CampaignPanelBookingsFullFragmentDoc = gql`
    fragment campaignPanelBookingsFull on Campaign {
  id
  panelBookings {
    ...panelBookingFull
  }
}
    ${PanelBookingFullFragmentDoc}`;
export const CampaignSignaturesFragmentDoc = gql`
    fragment campaignSignatures on Campaign {
  id
  clientCompanyContact(trashed: WITH) {
    id
    email
  }
  campaignSignatures {
    id
    createdBy {
      name
    }
    signed_on
    email
    first_accessed
    status
    created_at
    is_manual
    graphqlContractUrl
  }
}
    `;
export const AmbientTypeFullFragmentDoc = gql`
    fragment AmbientTypeFull on AmbientType {
  id
  name
  trashed
  creation_id
}
    `;
export const SundryTypeFullFragmentDoc = gql`
    fragment SundryTypeFull on SundryType {
  id
  name
  trashed
}
    `;
export const SalesTeamFullFragmentDoc = gql`
    fragment SalesTeamFull on SalesTeam {
  id
  name
  prefix
  trashed
  current_job_number
  reportingCurrency(trashed: WITH) {
    id
    label
    glyph
  }
  defaultCurrency(trashed: WITH) {
    id
    label
    glyph
  }
  logos {
    id
    file_type
    url
    thumbnail_url
  }
  document_footer
  contact_email
  supports_commission
  supports_regional_am_allocation
  commission_financial_notes
  disclaimer_commission
  url
  manager {
    id
    name
  }
  include_dashboard_all
  include_dashboard_core
  proposalOptions {
    id
    label
    code
  }
  street_address
  postal_code
  city
  tel
  has_tax
  tax_amount
}
    `;
export const CampaignTagFullFragmentDoc = gql`
    fragment CampaignTagFull on CampaignTag {
  id
  name
  description
  section_code
}
    `;
export const CampaignFullFragmentDoc = gql`
    fragment campaignFull on Campaign {
  id
  job_reference
  created_at
  name
  event
  is_purchase_order_required
  completion_date
  start_date
  artwork_received_date
  purchase_order
  invoice
  notes
  posters_received
  sales_job_ref
  media_production_notes
  sub_teams_scotland
  photoPaidTotal
  nextcloud_share_url
  nextcloud_view_url
  epos_artwork_reviewed
  paymentTerms {
    id
    name
  }
  externalPortfolioUrl
  is_vat_exempt
  regionalAmAllocation(trashed: WITH) {
    ...RegionFull
  }
  currency(trashed: WITH) {
    ...CurrencyFull
  }
  currencies(trashed: WITH) {
    id
    label
    glyph
    trashed
  }
  clientSubType(trashed: WITH) {
    id
    name
    trashed
  }
  clientCompany(trashed: WITH) {
    ...ClientCompanyAndContactLookupCompany
  }
  clientCompanyContact(trashed: WITH) {
    ...ClientCompanyAndContactLookupContact
  }
  mediaProductions {
    id
    creation_id
    notes
    mediaType(trashed: WITH) {
      id
      label
      trashed
    }
    size(trashed: WITH) {
      id
      name
      customer_name
      trashed
    }
    campaignComponent {
      id
      region(trashed: WITH) {
        ...RegionFull
      }
      regionType(trashed: WITH) {
        ...RegionTypeFull
      }
      unit_value_local
      currency(trashed: WITH) {
        ...CurrencyFull
      }
      price_divisor
      qty
    }
  }
  creativeStudio {
    id
    creation_id
    notes
    campaignComponent {
      id
      region(trashed: WITH) {
        ...RegionFull
      }
      regionType(trashed: WITH) {
        ...RegionTypeFull
      }
      unit_value_local
      qty
      currency(trashed: WITH) {
        ...CurrencyFull
      }
    }
    creativeStudioType {
      id
      name
    }
    creativeStudioTypeDetail {
      id
      name
    }
    start_date
    end_date
    name
  }
  creativeStudioEntries {
    id
    creation_id
    name
    notes
    parent_id
    mode
    unit_value_estimated_local @include(if: $withEstimated)
    unit_value_actual @include(if: $withActual)
    children {
      id
      name
      notes
      parent_id
      unit_value_estimated_local @include(if: $withEstimated)
      unit_value_actual @include(if: $withActual)
    }
    campaignComponent {
      id
      unit_value_local
      unit_value_estimated_local @include(if: $withEstimated)
      unit_value_actual @include(if: $withActual)
      qty
      currency(trashed: WITH) {
        ...CurrencyFull
      }
    }
  }
  digitalBookings {
    id
    days
    cost_type
    start_date
    end_date
    is_photo_paid
    status
    site {
      id
      name
      is_3p
      boroughOrRegion
      siteStructure {
        name
      }
    }
    campaignComponent {
      id
      region {
        ...RegionFull
      }
      regionType {
        ...RegionTypeFull
      }
      unit_value_local
    }
  }
  experientials {
    id
    creation_id
    campaignComponent {
      id
      region(trashed: WITH) {
        ...RegionFull
      }
      regionType(trashed: WITH) {
        ...RegionTypeFull
      }
      unit_value_local
      currency(trashed: WITH) {
        ...CurrencyFull
      }
      qty
    }
    start_date
    end_date
    experientialType(trashed: WITH) {
      id
      name
      trashed
    }
  }
  ambients {
    id
    creation_id
    campaignComponent {
      id
      region(trashed: WITH) {
        ...RegionFull
      }
      regionType(trashed: WITH) {
        ...RegionTypeFull
      }
      unit_value_local
      currency(trashed: WITH) {
        ...CurrencyFull
      }
      qty
    }
    start_date
    end_date
    name
    ambientType(trashed: WITH) {
      ...AmbientTypeFull
    }
  }
  sundries {
    id
    creation_id
    name
    notes
    date_up
    date_down
    use_global_discount
    campaignComponent {
      id
      region(trashed: WITH) {
        ...RegionFull
      }
      regionType(trashed: WITH) {
        ...RegionTypeFull
      }
      unit_value_local
      currency(trashed: WITH) {
        ...CurrencyFull
      }
      qty
    }
    sundryType(trashed: WITH) {
      ...SundryTypeFull
    }
  }
  costs {
    id
    creation_id
    supplier_code
    invoice_number
    campaignComponent {
      id
      unit_value_local
      currency(trashed: WITH) {
        ...CurrencyFull
      }
      qty
    }
    costSupplier(trashed: WITH) {
      id
      label
      code
      costSupplierCategory(trashed: WITH) {
        id
        label
      }
    }
  }
  totalCost
  discountableTotal
  undiscountableTotal
  discount_percentage
  discount_final
  status
  type
  paid_date
  payment_bank
  is_locked
  manually_unlocked
  rigging_up_at
  rigging_down_at
  components {
    id
    type
    unit_value_local
    currency(trashed: WITH) {
      ...CurrencyFull
    }
    qty
  }
  areaBookings {
    id
    bay_number
    rating
    creation_id
    special_instructions
    london_instructions
    posters_received
    unit_value_local
    unit_value_prescribed_local
    is_photo_paid_ab
    currency {
      ...CurrencyFull
    }
    num_weeks
    first_up
    last_down
    num_posters
    total_value
    posterSize(trashed: WITH) {
      id
      name
      trashed
    }
    regionType(trashed: WITH) {
      ...RegionTypeFull
    }
    areaBookingItems {
      id
      creation_id
      campaignComponent {
        id
        region(trashed: WITH) {
          ...RegionFull
        }
        unit_value_prescribed_local
        currency {
          ...CurrencyFull
        }
        qty
      }
      date_up
      date_down
      notes
      qty_posters_per_site
      qty_sites
      areaBookingZone {
        id
        name
      }
      distributor(trashed: WITH) {
        id
        name
        trashed
      }
      is_received
      created_at
    }
  }
  ourContact(trashed: WITH) {
    ...UserShort
  }
  salesTeam(trashed: WITH) {
    ...SalesTeamFull
    trashed
  }
  panelBookings {
    ...panelBookingFull
  }
  authorizationFiles {
    creation_id
    id
    original_name
    url
    thumbnail_url
    uploaded
  }
  popsFiles {
    creation_id
    id
    original_name
    url
    thumbnail_url
    uploaded
  }
  invoiceFiles {
    creation_id
    id
    original_name
    url
    uploaded
    thumbnail_url
  }
  artworkFiles {
    creation_id
    id
    original_name
    url
    uploaded
    thumbnail_url
    distributor {
      id
      name
    }
  }
  inboundFiles {
    id
    original_name
    url
    uploaded
    thumbnail_url
  }
  outboundFiles {
    id
    original_name
    url
    uploaded
    thumbnail_url
  }
  portfolio_hash
  portfolio_show_impacts
  portfolio_small_sites
  portfolio_paris_insurance
  portfolio_summary
  portfolio_title
  campaignExchangeRates {
    from
    to
    rate
  }
  previewTags {
    ...CampaignTagFull
  }
  contractSections {
    id
    title
    show_title
    new_page
    sort
    creation_id
    blocks {
      id
      type
      title
      content
      sort
      creation_id
      files {
        id
        url
        thumbnail_url
        filename
        file_type
        creation_id
        distributor {
          id
          name
        }
      }
    }
  }
}
    ${RegionFullFragmentDoc}
${CurrencyFullFragmentDoc}
${ClientCompanyAndContactLookupCompanyFragmentDoc}
${ClientCompanyAndContactLookupContactFragmentDoc}
${RegionTypeFullFragmentDoc}
${AmbientTypeFullFragmentDoc}
${SundryTypeFullFragmentDoc}
${UserShortFragmentDoc}
${SalesTeamFullFragmentDoc}
${PanelBookingFullFragmentDoc}
${CampaignTagFullFragmentDoc}`;
export const ContractTemplateFullFragmentDoc = gql`
    fragment contractTemplateFull on ContractTemplate {
  id
  name
  description
  sort
  creation_id
  sections {
    id
    title
    show_title
    new_page
    sort
    creation_id
    blocks {
      id
      type
      title
      content
      sort
      creation_id
      files {
        id
        url
        thumbnail_url
        filename
        file_type
        creation_id
        distributor {
          id
          name
        }
      }
    }
  }
}
    `;
export const DaybookDocument = gql`
    query daybook {
  daybook {
    siteTitle
    abSplitAmounts
    hasSalesTax
    salesTaxAmount
    salesTaxLabel
    defaultSiteCurrency {
      id
      label
      glyph
    }
    areaBookingPricingModels {
      id
      code
      priority
      where {
        campaignField
        rowField
        compare
        value
      }
      locationsLessThanTrigger
      baseWeeks
      locationsLessThanPercentage
      weekOverrides {
        multiplier
        overrideWeeks
        weeks
      }
    }
    pusherConfig {
      wsPort
      wssPort
      wsHost
      forceTLS
      secret
      key
      appId
    }
    regionAreaBookingPricing
    assetUrl
    baseUrl
    previewUrl
    theme
    challengeEnabled
    jobListDefaultDistributor
    useCreativeStudio
    useAreaBookingToggle
    isFringebook
  }
}
    `;

/**
 * __useDaybookQuery__
 *
 * To run a query within a React component, call `useDaybookQuery` and pass it any options that fit your needs.
 * When your component renders, `useDaybookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDaybookQuery({
 *   variables: {
 *   },
 * });
 */
export function useDaybookQuery(baseOptions?: Apollo.QueryHookOptions<DaybookQuery, DaybookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DaybookQuery, DaybookQueryVariables>(DaybookDocument, options);
      }
export function useDaybookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DaybookQuery, DaybookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DaybookQuery, DaybookQueryVariables>(DaybookDocument, options);
        }
export type DaybookQueryHookResult = ReturnType<typeof useDaybookQuery>;
export type DaybookLazyQueryHookResult = ReturnType<typeof useDaybookLazyQuery>;
export type DaybookQueryResult = Apollo.QueryResult<DaybookQuery, DaybookQueryVariables>;
export const AddAuthenticatorDocument = gql`
    mutation addAuthenticator {
  addAuthenticatorCode {
    code
  }
}
    `;
export type AddAuthenticatorMutationFn = Apollo.MutationFunction<AddAuthenticatorMutation, AddAuthenticatorMutationVariables>;

/**
 * __useAddAuthenticatorMutation__
 *
 * To run a mutation, you first call `useAddAuthenticatorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAuthenticatorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAuthenticatorMutation, { data, loading, error }] = useAddAuthenticatorMutation({
 *   variables: {
 *   },
 * });
 */
export function useAddAuthenticatorMutation(baseOptions?: Apollo.MutationHookOptions<AddAuthenticatorMutation, AddAuthenticatorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAuthenticatorMutation, AddAuthenticatorMutationVariables>(AddAuthenticatorDocument, options);
      }
export type AddAuthenticatorMutationHookResult = ReturnType<typeof useAddAuthenticatorMutation>;
export type AddAuthenticatorMutationResult = Apollo.MutationResult<AddAuthenticatorMutation>;
export type AddAuthenticatorMutationOptions = Apollo.BaseMutationOptions<AddAuthenticatorMutation, AddAuthenticatorMutationVariables>;
export const AddShortcutMutationDocument = gql`
    mutation addShortcutMutation($id: ID!) {
  updateMe(input: {campaignShortcuts: {connect: [$id]}}) {
    id
    campaignShortcuts {
      id
      name
      job_reference
    }
  }
}
    `;
export type AddShortcutMutationMutationFn = Apollo.MutationFunction<AddShortcutMutationMutation, AddShortcutMutationMutationVariables>;

/**
 * __useAddShortcutMutationMutation__
 *
 * To run a mutation, you first call `useAddShortcutMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddShortcutMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addShortcutMutationMutation, { data, loading, error }] = useAddShortcutMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAddShortcutMutationMutation(baseOptions?: Apollo.MutationHookOptions<AddShortcutMutationMutation, AddShortcutMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddShortcutMutationMutation, AddShortcutMutationMutationVariables>(AddShortcutMutationDocument, options);
      }
export type AddShortcutMutationMutationHookResult = ReturnType<typeof useAddShortcutMutationMutation>;
export type AddShortcutMutationMutationResult = Apollo.MutationResult<AddShortcutMutationMutation>;
export type AddShortcutMutationMutationOptions = Apollo.BaseMutationOptions<AddShortcutMutationMutation, AddShortcutMutationMutationVariables>;
export const EmailLoginRequestDocument = gql`
    mutation emailLoginRequest {
  emailLoginRequest {
    success
    error
  }
}
    `;
export type EmailLoginRequestMutationFn = Apollo.MutationFunction<EmailLoginRequestMutation, EmailLoginRequestMutationVariables>;

/**
 * __useEmailLoginRequestMutation__
 *
 * To run a mutation, you first call `useEmailLoginRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailLoginRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailLoginRequestMutation, { data, loading, error }] = useEmailLoginRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function useEmailLoginRequestMutation(baseOptions?: Apollo.MutationHookOptions<EmailLoginRequestMutation, EmailLoginRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailLoginRequestMutation, EmailLoginRequestMutationVariables>(EmailLoginRequestDocument, options);
      }
export type EmailLoginRequestMutationHookResult = ReturnType<typeof useEmailLoginRequestMutation>;
export type EmailLoginRequestMutationResult = Apollo.MutationResult<EmailLoginRequestMutation>;
export type EmailLoginRequestMutationOptions = Apollo.BaseMutationOptions<EmailLoginRequestMutation, EmailLoginRequestMutationVariables>;
export const EmailLoginDocument = gql`
    mutation emailLogin($code: String) {
  emailLogin(code: $code) {
    success
    error
  }
}
    `;
export type EmailLoginMutationFn = Apollo.MutationFunction<EmailLoginMutation, EmailLoginMutationVariables>;

/**
 * __useEmailLoginMutation__
 *
 * To run a mutation, you first call `useEmailLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailLoginMutation, { data, loading, error }] = useEmailLoginMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEmailLoginMutation(baseOptions?: Apollo.MutationHookOptions<EmailLoginMutation, EmailLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmailLoginMutation, EmailLoginMutationVariables>(EmailLoginDocument, options);
      }
export type EmailLoginMutationHookResult = ReturnType<typeof useEmailLoginMutation>;
export type EmailLoginMutationResult = Apollo.MutationResult<EmailLoginMutation>;
export type EmailLoginMutationOptions = Apollo.BaseMutationOptions<EmailLoginMutation, EmailLoginMutationVariables>;
export const GetMeQueryDocument = gql`
    query getMeQuery {
  me {
    ...MeDetails
  }
}
    ${MeDetailsFragmentDoc}`;

/**
 * __useGetMeQueryQuery__
 *
 * To run a query within a React component, call `useGetMeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQueryQuery, GetMeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQueryQuery, GetMeQueryQueryVariables>(GetMeQueryDocument, options);
      }
export function useGetMeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQueryQuery, GetMeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQueryQuery, GetMeQueryQueryVariables>(GetMeQueryDocument, options);
        }
export type GetMeQueryQueryHookResult = ReturnType<typeof useGetMeQueryQuery>;
export type GetMeQueryLazyQueryHookResult = ReturnType<typeof useGetMeQueryLazyQuery>;
export type GetMeQueryQueryResult = Apollo.QueryResult<GetMeQueryQuery, GetMeQueryQueryVariables>;
export const LoginMutationDocument = gql`
    mutation loginMutation($username: String!, $password: String!) {
  login(data: {username: $username, password: $password}) {
    token_type
    access_token
    refresh_token
    expires_in
  }
}
    `;
export type LoginMutationMutationFn = Apollo.MutationFunction<LoginMutationMutation, LoginMutationMutationVariables>;

/**
 * __useLoginMutationMutation__
 *
 * To run a mutation, you first call `useLoginMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutationMutation, { data, loading, error }] = useLoginMutationMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutationMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutationMutation, LoginMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutationMutation, LoginMutationMutationVariables>(LoginMutationDocument, options);
      }
export type LoginMutationMutationHookResult = ReturnType<typeof useLoginMutationMutation>;
export type LoginMutationMutationResult = Apollo.MutationResult<LoginMutationMutation>;
export type LoginMutationMutationOptions = Apollo.BaseMutationOptions<LoginMutationMutation, LoginMutationMutationVariables>;
export const LogoutMutationDocument = gql`
    mutation logoutMutation {
  logout {
    status
    message
  }
}
    `;
export type LogoutMutationMutationFn = Apollo.MutationFunction<LogoutMutationMutation, LogoutMutationMutationVariables>;

/**
 * __useLogoutMutationMutation__
 *
 * To run a mutation, you first call `useLogoutMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutationMutation, { data, loading, error }] = useLogoutMutationMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutationMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutationMutation, LogoutMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutationMutation, LogoutMutationMutationVariables>(LogoutMutationDocument, options);
      }
export type LogoutMutationMutationHookResult = ReturnType<typeof useLogoutMutationMutation>;
export type LogoutMutationMutationResult = Apollo.MutationResult<LogoutMutationMutation>;
export type LogoutMutationMutationOptions = Apollo.BaseMutationOptions<LogoutMutationMutation, LogoutMutationMutationVariables>;
export const PasskeyDeleteDocument = gql`
    mutation passkeyDelete($id: ID!) {
  passkeyDelete(id: $id) {
    success
    error
  }
}
    `;
export type PasskeyDeleteMutationFn = Apollo.MutationFunction<PasskeyDeleteMutation, PasskeyDeleteMutationVariables>;

/**
 * __usePasskeyDeleteMutation__
 *
 * To run a mutation, you first call `usePasskeyDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyDeleteMutation, { data, loading, error }] = usePasskeyDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePasskeyDeleteMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyDeleteMutation, PasskeyDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyDeleteMutation, PasskeyDeleteMutationVariables>(PasskeyDeleteDocument, options);
      }
export type PasskeyDeleteMutationHookResult = ReturnType<typeof usePasskeyDeleteMutation>;
export type PasskeyDeleteMutationResult = Apollo.MutationResult<PasskeyDeleteMutation>;
export type PasskeyDeleteMutationOptions = Apollo.BaseMutationOptions<PasskeyDeleteMutation, PasskeyDeleteMutationVariables>;
export const PasskeyLoginRequestDocument = gql`
    mutation passkeyLoginRequest {
  passkeyLoginRequest {
    options
    challenge
  }
}
    `;
export type PasskeyLoginRequestMutationFn = Apollo.MutationFunction<PasskeyLoginRequestMutation, PasskeyLoginRequestMutationVariables>;

/**
 * __usePasskeyLoginRequestMutation__
 *
 * To run a mutation, you first call `usePasskeyLoginRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyLoginRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyLoginRequestMutation, { data, loading, error }] = usePasskeyLoginRequestMutation({
 *   variables: {
 *   },
 * });
 */
export function usePasskeyLoginRequestMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyLoginRequestMutation, PasskeyLoginRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyLoginRequestMutation, PasskeyLoginRequestMutationVariables>(PasskeyLoginRequestDocument, options);
      }
export type PasskeyLoginRequestMutationHookResult = ReturnType<typeof usePasskeyLoginRequestMutation>;
export type PasskeyLoginRequestMutationResult = Apollo.MutationResult<PasskeyLoginRequestMutation>;
export type PasskeyLoginRequestMutationOptions = Apollo.BaseMutationOptions<PasskeyLoginRequestMutation, PasskeyLoginRequestMutationVariables>;
export const PasskeyLoginDocument = gql`
    mutation passkeyLogin($credential: JSON!) {
  passkeyLogin(credential: $credential) {
    access_token
    refresh_token
    expires_in
    token_type
    user {
      id
      name
      email
    }
  }
}
    `;
export type PasskeyLoginMutationFn = Apollo.MutationFunction<PasskeyLoginMutation, PasskeyLoginMutationVariables>;

/**
 * __usePasskeyLoginMutation__
 *
 * To run a mutation, you first call `usePasskeyLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyLoginMutation, { data, loading, error }] = usePasskeyLoginMutation({
 *   variables: {
 *      credential: // value for 'credential'
 *   },
 * });
 */
export function usePasskeyLoginMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyLoginMutation, PasskeyLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyLoginMutation, PasskeyLoginMutationVariables>(PasskeyLoginDocument, options);
      }
export type PasskeyLoginMutationHookResult = ReturnType<typeof usePasskeyLoginMutation>;
export type PasskeyLoginMutationResult = Apollo.MutationResult<PasskeyLoginMutation>;
export type PasskeyLoginMutationOptions = Apollo.BaseMutationOptions<PasskeyLoginMutation, PasskeyLoginMutationVariables>;
export const PasskeyRegisterRequestDocument = gql`
    mutation passkeyRegisterRequest($name: String) {
  passkeyRegisterRequest(name: $name) {
    options
    challenge
  }
}
    `;
export type PasskeyRegisterRequestMutationFn = Apollo.MutationFunction<PasskeyRegisterRequestMutation, PasskeyRegisterRequestMutationVariables>;

/**
 * __usePasskeyRegisterRequestMutation__
 *
 * To run a mutation, you first call `usePasskeyRegisterRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyRegisterRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyRegisterRequestMutation, { data, loading, error }] = usePasskeyRegisterRequestMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePasskeyRegisterRequestMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyRegisterRequestMutation, PasskeyRegisterRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyRegisterRequestMutation, PasskeyRegisterRequestMutationVariables>(PasskeyRegisterRequestDocument, options);
      }
export type PasskeyRegisterRequestMutationHookResult = ReturnType<typeof usePasskeyRegisterRequestMutation>;
export type PasskeyRegisterRequestMutationResult = Apollo.MutationResult<PasskeyRegisterRequestMutation>;
export type PasskeyRegisterRequestMutationOptions = Apollo.BaseMutationOptions<PasskeyRegisterRequestMutation, PasskeyRegisterRequestMutationVariables>;
export const PasskeyRegisterDocument = gql`
    mutation passkeyRegister($credential: JSON!, $name: String) {
  passkeyRegister(credential: $credential, name: $name) {
    id
    credential_id
    name
    sign_count
    backup_eligible
    backup_status
    uv_initialized
    last_used_at
    created_at
  }
}
    `;
export type PasskeyRegisterMutationFn = Apollo.MutationFunction<PasskeyRegisterMutation, PasskeyRegisterMutationVariables>;

/**
 * __usePasskeyRegisterMutation__
 *
 * To run a mutation, you first call `usePasskeyRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyRegisterMutation, { data, loading, error }] = usePasskeyRegisterMutation({
 *   variables: {
 *      credential: // value for 'credential'
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePasskeyRegisterMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyRegisterMutation, PasskeyRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyRegisterMutation, PasskeyRegisterMutationVariables>(PasskeyRegisterDocument, options);
      }
export type PasskeyRegisterMutationHookResult = ReturnType<typeof usePasskeyRegisterMutation>;
export type PasskeyRegisterMutationResult = Apollo.MutationResult<PasskeyRegisterMutation>;
export type PasskeyRegisterMutationOptions = Apollo.BaseMutationOptions<PasskeyRegisterMutation, PasskeyRegisterMutationVariables>;
export const PasskeyRenameDocument = gql`
    mutation passkeyRename($id: ID!, $name: String!) {
  passkeyRename(id: $id, name: $name) {
    id
    name
  }
}
    `;
export type PasskeyRenameMutationFn = Apollo.MutationFunction<PasskeyRenameMutation, PasskeyRenameMutationVariables>;

/**
 * __usePasskeyRenameMutation__
 *
 * To run a mutation, you first call `usePasskeyRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePasskeyRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [passkeyRenameMutation, { data, loading, error }] = usePasskeyRenameMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function usePasskeyRenameMutation(baseOptions?: Apollo.MutationHookOptions<PasskeyRenameMutation, PasskeyRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PasskeyRenameMutation, PasskeyRenameMutationVariables>(PasskeyRenameDocument, options);
      }
export type PasskeyRenameMutationHookResult = ReturnType<typeof usePasskeyRenameMutation>;
export type PasskeyRenameMutationResult = Apollo.MutationResult<PasskeyRenameMutation>;
export type PasskeyRenameMutationOptions = Apollo.BaseMutationOptions<PasskeyRenameMutation, PasskeyRenameMutationVariables>;
export const RefreshTokenMutationDocument = gql`
    mutation refreshTokenMutation($refresh_token: String) {
  refreshToken(data: {refresh_token: $refresh_token}) {
    token_type
    access_token
    refresh_token
    expires_in
  }
}
    `;
export type RefreshTokenMutationMutationFn = Apollo.MutationFunction<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables>;

/**
 * __useRefreshTokenMutationMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutationMutation, { data, loading, error }] = useRefreshTokenMutationMutation({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *   },
 * });
 */
export function useRefreshTokenMutationMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables>(RefreshTokenMutationDocument, options);
      }
export type RefreshTokenMutationMutationHookResult = ReturnType<typeof useRefreshTokenMutationMutation>;
export type RefreshTokenMutationMutationResult = Apollo.MutationResult<RefreshTokenMutationMutation>;
export type RefreshTokenMutationMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutationMutation, RefreshTokenMutationMutationVariables>;
export const RemoveShortcutMutationDocument = gql`
    mutation removeShortcutMutation($id: ID!) {
  updateMe(input: {campaignShortcuts: {disconnect: [$id]}}) {
    id
    campaignShortcuts {
      id
      name
      job_reference
    }
  }
}
    `;
export type RemoveShortcutMutationMutationFn = Apollo.MutationFunction<RemoveShortcutMutationMutation, RemoveShortcutMutationMutationVariables>;

/**
 * __useRemoveShortcutMutationMutation__
 *
 * To run a mutation, you first call `useRemoveShortcutMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveShortcutMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeShortcutMutationMutation, { data, loading, error }] = useRemoveShortcutMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveShortcutMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveShortcutMutationMutation, RemoveShortcutMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveShortcutMutationMutation, RemoveShortcutMutationMutationVariables>(RemoveShortcutMutationDocument, options);
      }
export type RemoveShortcutMutationMutationHookResult = ReturnType<typeof useRemoveShortcutMutationMutation>;
export type RemoveShortcutMutationMutationResult = Apollo.MutationResult<RemoveShortcutMutationMutation>;
export type RemoveShortcutMutationMutationOptions = Apollo.BaseMutationOptions<RemoveShortcutMutationMutation, RemoveShortcutMutationMutationVariables>;
export const TwoFactorLoginDocument = gql`
    mutation twoFactorLogin($code: String) {
  twoFactorLogin(code: $code) {
    success
    error
  }
}
    `;
export type TwoFactorLoginMutationFn = Apollo.MutationFunction<TwoFactorLoginMutation, TwoFactorLoginMutationVariables>;

/**
 * __useTwoFactorLoginMutation__
 *
 * To run a mutation, you first call `useTwoFactorLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwoFactorLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twoFactorLoginMutation, { data, loading, error }] = useTwoFactorLoginMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useTwoFactorLoginMutation(baseOptions?: Apollo.MutationHookOptions<TwoFactorLoginMutation, TwoFactorLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TwoFactorLoginMutation, TwoFactorLoginMutationVariables>(TwoFactorLoginDocument, options);
      }
export type TwoFactorLoginMutationHookResult = ReturnType<typeof useTwoFactorLoginMutation>;
export type TwoFactorLoginMutationResult = Apollo.MutationResult<TwoFactorLoginMutation>;
export type TwoFactorLoginMutationOptions = Apollo.BaseMutationOptions<TwoFactorLoginMutation, TwoFactorLoginMutationVariables>;
export const TwoFactorResetDocument = gql`
    mutation twoFactorReset {
  twoFactorReset {
    success
    error
  }
}
    `;
export type TwoFactorResetMutationFn = Apollo.MutationFunction<TwoFactorResetMutation, TwoFactorResetMutationVariables>;

/**
 * __useTwoFactorResetMutation__
 *
 * To run a mutation, you first call `useTwoFactorResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTwoFactorResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [twoFactorResetMutation, { data, loading, error }] = useTwoFactorResetMutation({
 *   variables: {
 *   },
 * });
 */
export function useTwoFactorResetMutation(baseOptions?: Apollo.MutationHookOptions<TwoFactorResetMutation, TwoFactorResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TwoFactorResetMutation, TwoFactorResetMutationVariables>(TwoFactorResetDocument, options);
      }
export type TwoFactorResetMutationHookResult = ReturnType<typeof useTwoFactorResetMutation>;
export type TwoFactorResetMutationResult = Apollo.MutationResult<TwoFactorResetMutation>;
export type TwoFactorResetMutationOptions = Apollo.BaseMutationOptions<TwoFactorResetMutation, TwoFactorResetMutationVariables>;
export const UpdateOptionsMutationDocument = gql`
    mutation updateOptionsMutation($options: UpdateUserOptions) {
  updateMe(input: {options: $options}) {
    id
    options {
      id
      name
      value
      search_name
    }
  }
}
    `;
export type UpdateOptionsMutationMutationFn = Apollo.MutationFunction<UpdateOptionsMutationMutation, UpdateOptionsMutationMutationVariables>;

/**
 * __useUpdateOptionsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateOptionsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionsMutationMutation, { data, loading, error }] = useUpdateOptionsMutationMutation({
 *   variables: {
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpdateOptionsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOptionsMutationMutation, UpdateOptionsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOptionsMutationMutation, UpdateOptionsMutationMutationVariables>(UpdateOptionsMutationDocument, options);
      }
export type UpdateOptionsMutationMutationHookResult = ReturnType<typeof useUpdateOptionsMutationMutation>;
export type UpdateOptionsMutationMutationResult = Apollo.MutationResult<UpdateOptionsMutationMutation>;
export type UpdateOptionsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateOptionsMutationMutation, UpdateOptionsMutationMutationVariables>;
export const CurrenciesQueryDocument = gql`
    query currenciesQuery {
  currencies(orderBy: [{column: "label", order: ASC}]) {
    ...CurrencyFull
  }
}
    ${CurrencyFullFragmentDoc}`;

/**
 * __useCurrenciesQueryQuery__
 *
 * To run a query within a React component, call `useCurrenciesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrenciesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrenciesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrenciesQueryQuery(baseOptions?: Apollo.QueryHookOptions<CurrenciesQueryQuery, CurrenciesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrenciesQueryQuery, CurrenciesQueryQueryVariables>(CurrenciesQueryDocument, options);
      }
export function useCurrenciesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrenciesQueryQuery, CurrenciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrenciesQueryQuery, CurrenciesQueryQueryVariables>(CurrenciesQueryDocument, options);
        }
export type CurrenciesQueryQueryHookResult = ReturnType<typeof useCurrenciesQueryQuery>;
export type CurrenciesQueryLazyQueryHookResult = ReturnType<typeof useCurrenciesQueryLazyQuery>;
export type CurrenciesQueryQueryResult = Apollo.QueryResult<CurrenciesQueryQuery, CurrenciesQueryQueryVariables>;
export const CostSupplierQueryDocument = gql`
    query costSupplierQuery {
  costSuppliers(orderBy: [{column: "label", order: ASC}], first: 1000) {
    data {
      ...CostSupplierFull
    }
  }
}
    ${CostSupplierFullFragmentDoc}`;

/**
 * __useCostSupplierQueryQuery__
 *
 * To run a query within a React component, call `useCostSupplierQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostSupplierQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostSupplierQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCostSupplierQueryQuery(baseOptions?: Apollo.QueryHookOptions<CostSupplierQueryQuery, CostSupplierQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostSupplierQueryQuery, CostSupplierQueryQueryVariables>(CostSupplierQueryDocument, options);
      }
export function useCostSupplierQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostSupplierQueryQuery, CostSupplierQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostSupplierQueryQuery, CostSupplierQueryQueryVariables>(CostSupplierQueryDocument, options);
        }
export type CostSupplierQueryQueryHookResult = ReturnType<typeof useCostSupplierQueryQuery>;
export type CostSupplierQueryLazyQueryHookResult = ReturnType<typeof useCostSupplierQueryLazyQuery>;
export type CostSupplierQueryQueryResult = Apollo.QueryResult<CostSupplierQueryQuery, CostSupplierQueryQueryVariables>;
export const CostSupplierCategoriesQueryDocument = gql`
    query costSupplierCategoriesQuery {
  costSupplierCategories(orderBy: [{column: "label", order: ASC}], first: 1000) {
    data {
      ...CostSupplierCategoryFull
    }
  }
}
    ${CostSupplierCategoryFullFragmentDoc}`;

/**
 * __useCostSupplierCategoriesQueryQuery__
 *
 * To run a query within a React component, call `useCostSupplierCategoriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCostSupplierCategoriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCostSupplierCategoriesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCostSupplierCategoriesQueryQuery(baseOptions?: Apollo.QueryHookOptions<CostSupplierCategoriesQueryQuery, CostSupplierCategoriesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CostSupplierCategoriesQueryQuery, CostSupplierCategoriesQueryQueryVariables>(CostSupplierCategoriesQueryDocument, options);
      }
export function useCostSupplierCategoriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CostSupplierCategoriesQueryQuery, CostSupplierCategoriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CostSupplierCategoriesQueryQuery, CostSupplierCategoriesQueryQueryVariables>(CostSupplierCategoriesQueryDocument, options);
        }
export type CostSupplierCategoriesQueryQueryHookResult = ReturnType<typeof useCostSupplierCategoriesQueryQuery>;
export type CostSupplierCategoriesQueryLazyQueryHookResult = ReturnType<typeof useCostSupplierCategoriesQueryLazyQuery>;
export type CostSupplierCategoriesQueryQueryResult = Apollo.QueryResult<CostSupplierCategoriesQueryQuery, CostSupplierCategoriesQueryQueryVariables>;
export const AmbientTypeQueryDocument = gql`
    query ambientTypeQuery {
  ambientTypes {
    ...AmbientTypeFull
  }
}
    ${AmbientTypeFullFragmentDoc}`;

/**
 * __useAmbientTypeQueryQuery__
 *
 * To run a query within a React component, call `useAmbientTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmbientTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmbientTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAmbientTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<AmbientTypeQueryQuery, AmbientTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmbientTypeQueryQuery, AmbientTypeQueryQueryVariables>(AmbientTypeQueryDocument, options);
      }
export function useAmbientTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmbientTypeQueryQuery, AmbientTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmbientTypeQueryQuery, AmbientTypeQueryQueryVariables>(AmbientTypeQueryDocument, options);
        }
export type AmbientTypeQueryQueryHookResult = ReturnType<typeof useAmbientTypeQueryQuery>;
export type AmbientTypeQueryLazyQueryHookResult = ReturnType<typeof useAmbientTypeQueryLazyQuery>;
export type AmbientTypeQueryQueryResult = Apollo.QueryResult<AmbientTypeQueryQuery, AmbientTypeQueryQueryVariables>;
export const TvAreaQueryDocument = gql`
    query tvAreaQuery {
  tvAreas(orderBy: [{column: "label", order: ASC}]) {
    ...TVAreaFull
  }
}
    ${TvAreaFullFragmentDoc}`;

/**
 * __useTvAreaQueryQuery__
 *
 * To run a query within a React component, call `useTvAreaQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTvAreaQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTvAreaQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useTvAreaQueryQuery(baseOptions?: Apollo.QueryHookOptions<TvAreaQueryQuery, TvAreaQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TvAreaQueryQuery, TvAreaQueryQueryVariables>(TvAreaQueryDocument, options);
      }
export function useTvAreaQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TvAreaQueryQuery, TvAreaQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TvAreaQueryQuery, TvAreaQueryQueryVariables>(TvAreaQueryDocument, options);
        }
export type TvAreaQueryQueryHookResult = ReturnType<typeof useTvAreaQueryQuery>;
export type TvAreaQueryLazyQueryHookResult = ReturnType<typeof useTvAreaQueryLazyQuery>;
export type TvAreaQueryQueryResult = Apollo.QueryResult<TvAreaQueryQuery, TvAreaQueryQueryVariables>;
export const BoroughQueryDocument = gql`
    query boroughQuery {
  boroughs(orderBy: [{column: "label", order: ASC}], first: 1000) {
    data {
      ...BoroughFull
    }
  }
}
    ${BoroughFullFragmentDoc}`;

/**
 * __useBoroughQueryQuery__
 *
 * To run a query within a React component, call `useBoroughQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBoroughQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBoroughQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBoroughQueryQuery(baseOptions?: Apollo.QueryHookOptions<BoroughQueryQuery, BoroughQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BoroughQueryQuery, BoroughQueryQueryVariables>(BoroughQueryDocument, options);
      }
export function useBoroughQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BoroughQueryQuery, BoroughQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BoroughQueryQuery, BoroughQueryQueryVariables>(BoroughQueryDocument, options);
        }
export type BoroughQueryQueryHookResult = ReturnType<typeof useBoroughQueryQuery>;
export type BoroughQueryLazyQueryHookResult = ReturnType<typeof useBoroughQueryLazyQuery>;
export type BoroughQueryQueryResult = Apollo.QueryResult<BoroughQueryQuery, BoroughQueryQueryVariables>;
export const ClientCompanyGroupQueryDocument = gql`
    query clientCompanyGroupQuery {
  clientCompanyGroups(orderBy: [{column: "label", order: ASC}], first: 1000) {
    data {
      ...ClientCompanyGroupFull
    }
  }
}
    ${ClientCompanyGroupFullFragmentDoc}`;

/**
 * __useClientCompanyGroupQueryQuery__
 *
 * To run a query within a React component, call `useClientCompanyGroupQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCompanyGroupQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCompanyGroupQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientCompanyGroupQueryQuery(baseOptions?: Apollo.QueryHookOptions<ClientCompanyGroupQueryQuery, ClientCompanyGroupQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCompanyGroupQueryQuery, ClientCompanyGroupQueryQueryVariables>(ClientCompanyGroupQueryDocument, options);
      }
export function useClientCompanyGroupQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCompanyGroupQueryQuery, ClientCompanyGroupQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCompanyGroupQueryQuery, ClientCompanyGroupQueryQueryVariables>(ClientCompanyGroupQueryDocument, options);
        }
export type ClientCompanyGroupQueryQueryHookResult = ReturnType<typeof useClientCompanyGroupQueryQuery>;
export type ClientCompanyGroupQueryLazyQueryHookResult = ReturnType<typeof useClientCompanyGroupQueryLazyQuery>;
export type ClientCompanyGroupQueryQueryResult = Apollo.QueryResult<ClientCompanyGroupQueryQuery, ClientCompanyGroupQueryQueryVariables>;
export const MediaTypeQueryDocument = gql`
    query mediaTypeQuery {
  mediaTypes(orderBy: [{column: "label", order: ASC}], first: 1000) {
    data {
      ...MediaTypeFull
    }
  }
}
    ${MediaTypeFullFragmentDoc}`;

/**
 * __useMediaTypeQueryQuery__
 *
 * To run a query within a React component, call `useMediaTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMediaTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<MediaTypeQueryQuery, MediaTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaTypeQueryQuery, MediaTypeQueryQueryVariables>(MediaTypeQueryDocument, options);
      }
export function useMediaTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaTypeQueryQuery, MediaTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaTypeQueryQuery, MediaTypeQueryQueryVariables>(MediaTypeQueryDocument, options);
        }
export type MediaTypeQueryQueryHookResult = ReturnType<typeof useMediaTypeQueryQuery>;
export type MediaTypeQueryLazyQueryHookResult = ReturnType<typeof useMediaTypeQueryLazyQuery>;
export type MediaTypeQueryQueryResult = Apollo.QueryResult<MediaTypeQueryQuery, MediaTypeQueryQueryVariables>;
export const ContactsQueryDocument = gql`
    query contactsQuery($accountsCompany_like: String, $salesCompany_like: String, $contactName_like: String, $salesTeam_in: [ID], $user_in: [ID], $credit_limit_between: IntRange, $salesAddress_like: String, $accountsCode_exact: String, $accountsAddress_like: String) {
  clientCompanyContacts(
    accountsCompany_like: $accountsCompany_like
    salesCompany_like: $salesCompany_like
    contactName_like: $contactName_like
    credit_limit_between: $credit_limit_between
    salesAddress_like: $salesAddress_like
    accountsAddress_like: $accountsAddress_like
    accountsCode_exact: $accountsCode_exact
    salesTeam_in: $salesTeam_in
    user_in: $user_in
    first: 500
  ) {
    data {
      id
      name
      phone
      email
      clientCompany {
        id
        sales_company
        accounts_company
      }
      salesTeam {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useContactsQueryQuery__
 *
 * To run a query within a React component, call `useContactsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQueryQuery({
 *   variables: {
 *      accountsCompany_like: // value for 'accountsCompany_like'
 *      salesCompany_like: // value for 'salesCompany_like'
 *      contactName_like: // value for 'contactName_like'
 *      salesTeam_in: // value for 'salesTeam_in'
 *      user_in: // value for 'user_in'
 *      credit_limit_between: // value for 'credit_limit_between'
 *      salesAddress_like: // value for 'salesAddress_like'
 *      accountsCode_exact: // value for 'accountsCode_exact'
 *      accountsAddress_like: // value for 'accountsAddress_like'
 *   },
 * });
 */
export function useContactsQueryQuery(baseOptions?: Apollo.QueryHookOptions<ContactsQueryQuery, ContactsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQueryQuery, ContactsQueryQueryVariables>(ContactsQueryDocument, options);
      }
export function useContactsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQueryQuery, ContactsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQueryQuery, ContactsQueryQueryVariables>(ContactsQueryDocument, options);
        }
export type ContactsQueryQueryHookResult = ReturnType<typeof useContactsQueryQuery>;
export type ContactsQueryLazyQueryHookResult = ReturnType<typeof useContactsQueryLazyQuery>;
export type ContactsQueryQueryResult = Apollo.QueryResult<ContactsQueryQuery, ContactsQueryQueryVariables>;
export const ClientQueryDocument = gql`
    query clientQuery($name: String) {
  clientCompanyContacts(
    name: $name
    pairsOnly: true
    first: 50
    orderBy: [{column: "search_string", order: ASC}]
  ) {
    data {
      ...ClientCompanyAndContactLookup
    }
  }
}
    ${ClientCompanyAndContactLookupFragmentDoc}`;

/**
 * __useClientQueryQuery__
 *
 * To run a query within a React component, call `useClientQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientQueryQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClientQueryQuery(baseOptions?: Apollo.QueryHookOptions<ClientQueryQuery, ClientQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientQueryQuery, ClientQueryQueryVariables>(ClientQueryDocument, options);
      }
export function useClientQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientQueryQuery, ClientQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientQueryQuery, ClientQueryQueryVariables>(ClientQueryDocument, options);
        }
export type ClientQueryQueryHookResult = ReturnType<typeof useClientQueryQuery>;
export type ClientQueryLazyQueryHookResult = ReturnType<typeof useClientQueryLazyQuery>;
export type ClientQueryQueryResult = Apollo.QueryResult<ClientQueryQuery, ClientQueryQueryVariables>;
export const QuickExchangeRatesDocument = gql`
    query quickExchangeRates {
  exchangeRates {
    ...ExchangeRateShort
  }
}
    ${ExchangeRateShortFragmentDoc}`;

/**
 * __useQuickExchangeRatesQuery__
 *
 * To run a query within a React component, call `useQuickExchangeRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickExchangeRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickExchangeRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuickExchangeRatesQuery(baseOptions?: Apollo.QueryHookOptions<QuickExchangeRatesQuery, QuickExchangeRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickExchangeRatesQuery, QuickExchangeRatesQueryVariables>(QuickExchangeRatesDocument, options);
      }
export function useQuickExchangeRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickExchangeRatesQuery, QuickExchangeRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickExchangeRatesQuery, QuickExchangeRatesQueryVariables>(QuickExchangeRatesDocument, options);
        }
export type QuickExchangeRatesQueryHookResult = ReturnType<typeof useQuickExchangeRatesQuery>;
export type QuickExchangeRatesLazyQueryHookResult = ReturnType<typeof useQuickExchangeRatesLazyQuery>;
export type QuickExchangeRatesQueryResult = Apollo.QueryResult<QuickExchangeRatesQuery, QuickExchangeRatesQueryVariables>;
export const ExchangeRatesDocument = gql`
    query exchangeRates {
  exchangeRates {
    ...ExchangeRateFull
  }
}
    ${ExchangeRateFullFragmentDoc}`;

/**
 * __useExchangeRatesQuery__
 *
 * To run a query within a React component, call `useExchangeRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExchangeRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExchangeRatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useExchangeRatesQuery(baseOptions?: Apollo.QueryHookOptions<ExchangeRatesQuery, ExchangeRatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExchangeRatesQuery, ExchangeRatesQueryVariables>(ExchangeRatesDocument, options);
      }
export function useExchangeRatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExchangeRatesQuery, ExchangeRatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExchangeRatesQuery, ExchangeRatesQueryVariables>(ExchangeRatesDocument, options);
        }
export type ExchangeRatesQueryHookResult = ReturnType<typeof useExchangeRatesQuery>;
export type ExchangeRatesLazyQueryHookResult = ReturnType<typeof useExchangeRatesLazyQuery>;
export type ExchangeRatesQueryResult = Apollo.QueryResult<ExchangeRatesQuery, ExchangeRatesQueryVariables>;
export const ExchangeRatesMutationDocument = gql`
    mutation exchangeRatesMutation($update: UpdateExchangeRates!) {
  updateExchangeRates(input: $update) {
    ...ExchangeRateFull
  }
}
    ${ExchangeRateFullFragmentDoc}`;
export type ExchangeRatesMutationMutationFn = Apollo.MutationFunction<ExchangeRatesMutationMutation, ExchangeRatesMutationMutationVariables>;

/**
 * __useExchangeRatesMutationMutation__
 *
 * To run a mutation, you first call `useExchangeRatesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeRatesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeRatesMutationMutation, { data, loading, error }] = useExchangeRatesMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useExchangeRatesMutationMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeRatesMutationMutation, ExchangeRatesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeRatesMutationMutation, ExchangeRatesMutationMutationVariables>(ExchangeRatesMutationDocument, options);
      }
export type ExchangeRatesMutationMutationHookResult = ReturnType<typeof useExchangeRatesMutationMutation>;
export type ExchangeRatesMutationMutationResult = Apollo.MutationResult<ExchangeRatesMutationMutation>;
export type ExchangeRatesMutationMutationOptions = Apollo.BaseMutationOptions<ExchangeRatesMutationMutation, ExchangeRatesMutationMutationVariables>;
export const ClientCompaniesQueryDocument = gql`
    query clientCompaniesQuery($ids: [ID], $client_type_in: [ID], $salesCompany_like: String, $accountsCompany_like: String, $credit_limit_between: IntRange, $accountsAddress_like: String, $salesAddress_like: String, $accountsCode_exact: String, $name: String) {
  clientCompanies(
    orderBy: [{column: "sales_company", order: ASC}, {column: "accounts_company", order: ASC}]
    salesCompany_like: $salesCompany_like
    accountsCompany_like: $accountsCompany_like
    credit_limit_between: $credit_limit_between
    salesAddress_like: $salesAddress_like
    accountsAddress_like: $accountsAddress_like
    accountsCode_exact: $accountsCode_exact
    clientCompanyType_in: $client_type_in
    name: $name
    ids: $ids
    first: 500
  ) {
    data {
      ...ClientCompanyAndContactLookupCompany
    }
  }
}
    ${ClientCompanyAndContactLookupCompanyFragmentDoc}`;

/**
 * __useClientCompaniesQueryQuery__
 *
 * To run a query within a React component, call `useClientCompaniesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCompaniesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCompaniesQueryQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      client_type_in: // value for 'client_type_in'
 *      salesCompany_like: // value for 'salesCompany_like'
 *      accountsCompany_like: // value for 'accountsCompany_like'
 *      credit_limit_between: // value for 'credit_limit_between'
 *      accountsAddress_like: // value for 'accountsAddress_like'
 *      salesAddress_like: // value for 'salesAddress_like'
 *      accountsCode_exact: // value for 'accountsCode_exact'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClientCompaniesQueryQuery(baseOptions?: Apollo.QueryHookOptions<ClientCompaniesQueryQuery, ClientCompaniesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCompaniesQueryQuery, ClientCompaniesQueryQueryVariables>(ClientCompaniesQueryDocument, options);
      }
export function useClientCompaniesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCompaniesQueryQuery, ClientCompaniesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCompaniesQueryQuery, ClientCompaniesQueryQueryVariables>(ClientCompaniesQueryDocument, options);
        }
export type ClientCompaniesQueryQueryHookResult = ReturnType<typeof useClientCompaniesQueryQuery>;
export type ClientCompaniesQueryLazyQueryHookResult = ReturnType<typeof useClientCompaniesQueryLazyQuery>;
export type ClientCompaniesQueryQueryResult = Apollo.QueryResult<ClientCompaniesQueryQuery, ClientCompaniesQueryQueryVariables>;
export const ClientCompanyExtraDocument = gql`
    query clientCompanyExtra($id: ID!) {
  clientCompany(id: $id) {
    ...ClientCompanyFull
    contacts {
      id
      name
    }
    campaigns {
      id
      job_reference
      name
    }
  }
}
    ${ClientCompanyFullFragmentDoc}`;

/**
 * __useClientCompanyExtraQuery__
 *
 * To run a query within a React component, call `useClientCompanyExtraQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCompanyExtraQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCompanyExtraQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientCompanyExtraQuery(baseOptions: Apollo.QueryHookOptions<ClientCompanyExtraQuery, ClientCompanyExtraQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCompanyExtraQuery, ClientCompanyExtraQueryVariables>(ClientCompanyExtraDocument, options);
      }
export function useClientCompanyExtraLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCompanyExtraQuery, ClientCompanyExtraQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCompanyExtraQuery, ClientCompanyExtraQueryVariables>(ClientCompanyExtraDocument, options);
        }
export type ClientCompanyExtraQueryHookResult = ReturnType<typeof useClientCompanyExtraQuery>;
export type ClientCompanyExtraLazyQueryHookResult = ReturnType<typeof useClientCompanyExtraLazyQuery>;
export type ClientCompanyExtraQueryResult = Apollo.QueryResult<ClientCompanyExtraQuery, ClientCompanyExtraQueryVariables>;
export const ClientCompaniesDocument = gql`
    query clientCompanies($name: String) {
  clientCompanies(name: $name, first: 500) {
    data {
      ...ClientCompanyAndContactLookupCompany
    }
  }
}
    ${ClientCompanyAndContactLookupCompanyFragmentDoc}`;

/**
 * __useClientCompaniesQuery__
 *
 * To run a query within a React component, call `useClientCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCompaniesQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClientCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ClientCompaniesQuery, ClientCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCompaniesQuery, ClientCompaniesQueryVariables>(ClientCompaniesDocument, options);
      }
export function useClientCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCompaniesQuery, ClientCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCompaniesQuery, ClientCompaniesQueryVariables>(ClientCompaniesDocument, options);
        }
export type ClientCompaniesQueryHookResult = ReturnType<typeof useClientCompaniesQuery>;
export type ClientCompaniesLazyQueryHookResult = ReturnType<typeof useClientCompaniesLazyQuery>;
export type ClientCompaniesQueryResult = Apollo.QueryResult<ClientCompaniesQuery, ClientCompaniesQueryVariables>;
export const ClientCompanyDocument = gql`
    query clientCompany($id: ID!) {
  clientCompany(id: $id) {
    ...ClientCompanyFull
    contacts {
      id
      name
    }
    campaigns {
      id
      job_reference
      name
    }
  }
}
    ${ClientCompanyFullFragmentDoc}`;

/**
 * __useClientCompanyQuery__
 *
 * To run a query within a React component, call `useClientCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientCompanyQuery(baseOptions: Apollo.QueryHookOptions<ClientCompanyQuery, ClientCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCompanyQuery, ClientCompanyQueryVariables>(ClientCompanyDocument, options);
      }
export function useClientCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCompanyQuery, ClientCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCompanyQuery, ClientCompanyQueryVariables>(ClientCompanyDocument, options);
        }
export type ClientCompanyQueryHookResult = ReturnType<typeof useClientCompanyQuery>;
export type ClientCompanyLazyQueryHookResult = ReturnType<typeof useClientCompanyLazyQuery>;
export type ClientCompanyQueryResult = Apollo.QueryResult<ClientCompanyQuery, ClientCompanyQueryVariables>;
export const ClientCompanyContactQueryDocument = gql`
    query clientCompanyContactQuery($id: ID) {
  clientCompanyContact(id: $id) {
    ...ClientCompanyContactFull
  }
}
    ${ClientCompanyContactFullFragmentDoc}`;

/**
 * __useClientCompanyContactQueryQuery__
 *
 * To run a query within a React component, call `useClientCompanyContactQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCompanyContactQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCompanyContactQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientCompanyContactQueryQuery(baseOptions?: Apollo.QueryHookOptions<ClientCompanyContactQueryQuery, ClientCompanyContactQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCompanyContactQueryQuery, ClientCompanyContactQueryQueryVariables>(ClientCompanyContactQueryDocument, options);
      }
export function useClientCompanyContactQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCompanyContactQueryQuery, ClientCompanyContactQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCompanyContactQueryQuery, ClientCompanyContactQueryQueryVariables>(ClientCompanyContactQueryDocument, options);
        }
export type ClientCompanyContactQueryQueryHookResult = ReturnType<typeof useClientCompanyContactQueryQuery>;
export type ClientCompanyContactQueryLazyQueryHookResult = ReturnType<typeof useClientCompanyContactQueryLazyQuery>;
export type ClientCompanyContactQueryQueryResult = Apollo.QueryResult<ClientCompanyContactQueryQuery, ClientCompanyContactQueryQueryVariables>;
export const ClientCompanyContactListDocument = gql`
    query clientCompanyContactList($ids: [ID], $name: String) {
  clientCompanyContacts(
    ids: $ids
    contactName_like: $name
    orderBy: [{column: "name", order: ASC}]
    first: 1000
  ) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useClientCompanyContactListQuery__
 *
 * To run a query within a React component, call `useClientCompanyContactListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientCompanyContactListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientCompanyContactListQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useClientCompanyContactListQuery(baseOptions?: Apollo.QueryHookOptions<ClientCompanyContactListQuery, ClientCompanyContactListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientCompanyContactListQuery, ClientCompanyContactListQueryVariables>(ClientCompanyContactListDocument, options);
      }
export function useClientCompanyContactListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientCompanyContactListQuery, ClientCompanyContactListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientCompanyContactListQuery, ClientCompanyContactListQueryVariables>(ClientCompanyContactListDocument, options);
        }
export type ClientCompanyContactListQueryHookResult = ReturnType<typeof useClientCompanyContactListQuery>;
export type ClientCompanyContactListLazyQueryHookResult = ReturnType<typeof useClientCompanyContactListLazyQuery>;
export type ClientCompanyContactListQueryResult = Apollo.QueryResult<ClientCompanyContactListQuery, ClientCompanyContactListQueryVariables>;
export const ClientTypeQueryDocument = gql`
    query clientTypeQuery {
  clientTypes(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...ClientTypeFull
    }
  }
}
    ${ClientTypeFullFragmentDoc}`;

/**
 * __useClientTypeQueryQuery__
 *
 * To run a query within a React component, call `useClientTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<ClientTypeQueryQuery, ClientTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTypeQueryQuery, ClientTypeQueryQueryVariables>(ClientTypeQueryDocument, options);
      }
export function useClientTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTypeQueryQuery, ClientTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTypeQueryQuery, ClientTypeQueryQueryVariables>(ClientTypeQueryDocument, options);
        }
export type ClientTypeQueryQueryHookResult = ReturnType<typeof useClientTypeQueryQuery>;
export type ClientTypeQueryLazyQueryHookResult = ReturnType<typeof useClientTypeQueryLazyQuery>;
export type ClientTypeQueryQueryResult = Apollo.QueryResult<ClientTypeQueryQuery, ClientTypeQueryQueryVariables>;
export const ClientSubTypeQueryDocument = gql`
    query clientSubTypeQuery {
  clientSubTypes(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...ClientSubTypeFull
    }
  }
}
    ${ClientSubTypeFullFragmentDoc}`;

/**
 * __useClientSubTypeQueryQuery__
 *
 * To run a query within a React component, call `useClientSubTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientSubTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientSubTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientSubTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<ClientSubTypeQueryQuery, ClientSubTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientSubTypeQueryQuery, ClientSubTypeQueryQueryVariables>(ClientSubTypeQueryDocument, options);
      }
export function useClientSubTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientSubTypeQueryQuery, ClientSubTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientSubTypeQueryQuery, ClientSubTypeQueryQueryVariables>(ClientSubTypeQueryDocument, options);
        }
export type ClientSubTypeQueryQueryHookResult = ReturnType<typeof useClientSubTypeQueryQuery>;
export type ClientSubTypeQueryLazyQueryHookResult = ReturnType<typeof useClientSubTypeQueryLazyQuery>;
export type ClientSubTypeQueryQueryResult = Apollo.QueryResult<ClientSubTypeQueryQuery, ClientSubTypeQueryQueryVariables>;
export const DistributorsQueryDocument = gql`
    query distributorsQuery {
  distributors(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...DistributorMinimal
    }
  }
}
    ${DistributorMinimalFragmentDoc}`;

/**
 * __useDistributorsQueryQuery__
 *
 * To run a query within a React component, call `useDistributorsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDistributorsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDistributorsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDistributorsQueryQuery(baseOptions?: Apollo.QueryHookOptions<DistributorsQueryQuery, DistributorsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DistributorsQueryQuery, DistributorsQueryQueryVariables>(DistributorsQueryDocument, options);
      }
export function useDistributorsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DistributorsQueryQuery, DistributorsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DistributorsQueryQuery, DistributorsQueryQueryVariables>(DistributorsQueryDocument, options);
        }
export type DistributorsQueryQueryHookResult = ReturnType<typeof useDistributorsQueryQuery>;
export type DistributorsQueryLazyQueryHookResult = ReturnType<typeof useDistributorsQueryLazyQuery>;
export type DistributorsQueryQueryResult = Apollo.QueryResult<DistributorsQueryQuery, DistributorsQueryQueryVariables>;
export const AreaBookingZoneQueryDocument = gql`
    query areaBookingZoneQuery {
  areaBookingZone(orderBy: [{column: "name", order: ASC}]) {
    id
    name
  }
}
    `;

/**
 * __useAreaBookingZoneQueryQuery__
 *
 * To run a query within a React component, call `useAreaBookingZoneQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAreaBookingZoneQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAreaBookingZoneQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAreaBookingZoneQueryQuery(baseOptions?: Apollo.QueryHookOptions<AreaBookingZoneQueryQuery, AreaBookingZoneQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AreaBookingZoneQueryQuery, AreaBookingZoneQueryQueryVariables>(AreaBookingZoneQueryDocument, options);
      }
export function useAreaBookingZoneQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AreaBookingZoneQueryQuery, AreaBookingZoneQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AreaBookingZoneQueryQuery, AreaBookingZoneQueryQueryVariables>(AreaBookingZoneQueryDocument, options);
        }
export type AreaBookingZoneQueryQueryHookResult = ReturnType<typeof useAreaBookingZoneQueryQuery>;
export type AreaBookingZoneQueryLazyQueryHookResult = ReturnType<typeof useAreaBookingZoneQueryLazyQuery>;
export type AreaBookingZoneQueryQueryResult = Apollo.QueryResult<AreaBookingZoneQueryQuery, AreaBookingZoneQueryQueryVariables>;
export const ExperientialTypeQueryDocument = gql`
    query experientialTypeQuery {
  experientialTypes {
    ...ExperientialTypeFull
  }
}
    ${ExperientialTypeFullFragmentDoc}`;

/**
 * __useExperientialTypeQueryQuery__
 *
 * To run a query within a React component, call `useExperientialTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperientialTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperientialTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useExperientialTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<ExperientialTypeQueryQuery, ExperientialTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExperientialTypeQueryQuery, ExperientialTypeQueryQueryVariables>(ExperientialTypeQueryDocument, options);
      }
export function useExperientialTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExperientialTypeQueryQuery, ExperientialTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExperientialTypeQueryQuery, ExperientialTypeQueryQueryVariables>(ExperientialTypeQueryDocument, options);
        }
export type ExperientialTypeQueryQueryHookResult = ReturnType<typeof useExperientialTypeQueryQuery>;
export type ExperientialTypeQueryLazyQueryHookResult = ReturnType<typeof useExperientialTypeQueryLazyQuery>;
export type ExperientialTypeQueryQueryResult = Apollo.QueryResult<ExperientialTypeQueryQuery, ExperientialTypeQueryQueryVariables>;
export const PackQueryDocument = gql`
    query packQuery {
  packs(orderBy: [{column: "label", order: ASC}]) {
    ...PackFull
  }
}
    ${PackFullFragmentDoc}`;

/**
 * __usePackQueryQuery__
 *
 * To run a query within a React component, call `usePackQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePackQueryQuery(baseOptions?: Apollo.QueryHookOptions<PackQueryQuery, PackQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackQueryQuery, PackQueryQueryVariables>(PackQueryDocument, options);
      }
export function usePackQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackQueryQuery, PackQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackQueryQuery, PackQueryQueryVariables>(PackQueryDocument, options);
        }
export type PackQueryQueryHookResult = ReturnType<typeof usePackQueryQuery>;
export type PackQueryLazyQueryHookResult = ReturnType<typeof usePackQueryLazyQuery>;
export type PackQueryQueryResult = Apollo.QueryResult<PackQueryQuery, PackQueryQueryVariables>;
export const PostInstructionQueryDocument = gql`
    query postInstructionQuery {
  postInstructions(orderBy: [{column: "label", order: ASC}]) {
    ...PostInstructionFull
  }
}
    ${PostInstructionFullFragmentDoc}`;

/**
 * __usePostInstructionQueryQuery__
 *
 * To run a query within a React component, call `usePostInstructionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostInstructionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostInstructionQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePostInstructionQueryQuery(baseOptions?: Apollo.QueryHookOptions<PostInstructionQueryQuery, PostInstructionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostInstructionQueryQuery, PostInstructionQueryQueryVariables>(PostInstructionQueryDocument, options);
      }
export function usePostInstructionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostInstructionQueryQuery, PostInstructionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostInstructionQueryQuery, PostInstructionQueryQueryVariables>(PostInstructionQueryDocument, options);
        }
export type PostInstructionQueryQueryHookResult = ReturnType<typeof usePostInstructionQueryQuery>;
export type PostInstructionQueryLazyQueryHookResult = ReturnType<typeof usePostInstructionQueryLazyQuery>;
export type PostInstructionQueryQueryResult = Apollo.QueryResult<PostInstructionQueryQuery, PostInstructionQueryQueryVariables>;
export const StylesQueryDocument = gql`
    query stylesQuery {
  styles(orderBy: [{column: "label", order: ASC}]) {
    ...StyleFull
  }
}
    ${StyleFullFragmentDoc}`;

/**
 * __useStylesQueryQuery__
 *
 * To run a query within a React component, call `useStylesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useStylesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStylesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useStylesQueryQuery(baseOptions?: Apollo.QueryHookOptions<StylesQueryQuery, StylesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StylesQueryQuery, StylesQueryQueryVariables>(StylesQueryDocument, options);
      }
export function useStylesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StylesQueryQuery, StylesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StylesQueryQuery, StylesQueryQueryVariables>(StylesQueryDocument, options);
        }
export type StylesQueryQueryHookResult = ReturnType<typeof useStylesQueryQuery>;
export type StylesQueryLazyQueryHookResult = ReturnType<typeof useStylesQueryLazyQuery>;
export type StylesQueryQueryResult = Apollo.QueryResult<StylesQueryQuery, StylesQueryQueryVariables>;
export const PosterSizeDocument = gql`
    query posterSize($id: ID) {
  posterSize(id: $id) {
    id
    areaBookingRegionPricing {
      ...AreaBookingRegionPricingFull
    }
  }
}
    ${AreaBookingRegionPricingFullFragmentDoc}`;

/**
 * __usePosterSizeQuery__
 *
 * To run a query within a React component, call `usePosterSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosterSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosterSizeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePosterSizeQuery(baseOptions?: Apollo.QueryHookOptions<PosterSizeQuery, PosterSizeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PosterSizeQuery, PosterSizeQueryVariables>(PosterSizeDocument, options);
      }
export function usePosterSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PosterSizeQuery, PosterSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PosterSizeQuery, PosterSizeQueryVariables>(PosterSizeDocument, options);
        }
export type PosterSizeQueryHookResult = ReturnType<typeof usePosterSizeQuery>;
export type PosterSizeLazyQueryHookResult = ReturnType<typeof usePosterSizeLazyQuery>;
export type PosterSizeQueryResult = Apollo.QueryResult<PosterSizeQuery, PosterSizeQueryVariables>;
export const PosterSizesQueryDocument = gql`
    query posterSizesQuery($regions: [ID]) {
  posterSizes(orderBy: [{column: "name", order: ASC}]) {
    ...PosterSizeFull
  }
}
    ${PosterSizeFullFragmentDoc}`;

/**
 * __usePosterSizesQueryQuery__
 *
 * To run a query within a React component, call `usePosterSizesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePosterSizesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePosterSizesQueryQuery({
 *   variables: {
 *      regions: // value for 'regions'
 *   },
 * });
 */
export function usePosterSizesQueryQuery(baseOptions?: Apollo.QueryHookOptions<PosterSizesQueryQuery, PosterSizesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PosterSizesQueryQuery, PosterSizesQueryQueryVariables>(PosterSizesQueryDocument, options);
      }
export function usePosterSizesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PosterSizesQueryQuery, PosterSizesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PosterSizesQueryQuery, PosterSizesQueryQueryVariables>(PosterSizesQueryDocument, options);
        }
export type PosterSizesQueryQueryHookResult = ReturnType<typeof usePosterSizesQueryQuery>;
export type PosterSizesQueryLazyQueryHookResult = ReturnType<typeof usePosterSizesQueryLazyQuery>;
export type PosterSizesQueryQueryResult = Apollo.QueryResult<PosterSizesQueryQuery, PosterSizesQueryQueryVariables>;
export const RegionSelectGroupedQueryDocument = gql`
    query regionSelectGroupedQuery {
  regionTypes(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...RegionTypeFullWithRegions
    }
  }
}
    ${RegionTypeFullWithRegionsFragmentDoc}`;

/**
 * __useRegionSelectGroupedQueryQuery__
 *
 * To run a query within a React component, call `useRegionSelectGroupedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionSelectGroupedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionSelectGroupedQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionSelectGroupedQueryQuery(baseOptions?: Apollo.QueryHookOptions<RegionSelectGroupedQueryQuery, RegionSelectGroupedQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionSelectGroupedQueryQuery, RegionSelectGroupedQueryQueryVariables>(RegionSelectGroupedQueryDocument, options);
      }
export function useRegionSelectGroupedQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionSelectGroupedQueryQuery, RegionSelectGroupedQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionSelectGroupedQueryQuery, RegionSelectGroupedQueryQueryVariables>(RegionSelectGroupedQueryDocument, options);
        }
export type RegionSelectGroupedQueryQueryHookResult = ReturnType<typeof useRegionSelectGroupedQueryQuery>;
export type RegionSelectGroupedQueryLazyQueryHookResult = ReturnType<typeof useRegionSelectGroupedQueryLazyQuery>;
export type RegionSelectGroupedQueryQueryResult = Apollo.QueryResult<RegionSelectGroupedQueryQuery, RegionSelectGroupedQueryQueryVariables>;
export const RegionTypesQueryDocument = gql`
    query regionTypesQuery {
  regionTypes(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...RegionTypeFullWithRegions
    }
  }
}
    ${RegionTypeFullWithRegionsFragmentDoc}`;

/**
 * __useRegionTypesQueryQuery__
 *
 * To run a query within a React component, call `useRegionTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionTypesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRegionTypesQueryQuery(baseOptions?: Apollo.QueryHookOptions<RegionTypesQueryQuery, RegionTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionTypesQueryQuery, RegionTypesQueryQueryVariables>(RegionTypesQueryDocument, options);
      }
export function useRegionTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionTypesQueryQuery, RegionTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionTypesQueryQuery, RegionTypesQueryQueryVariables>(RegionTypesQueryDocument, options);
        }
export type RegionTypesQueryQueryHookResult = ReturnType<typeof useRegionTypesQueryQuery>;
export type RegionTypesQueryLazyQueryHookResult = ReturnType<typeof useRegionTypesQueryLazyQuery>;
export type RegionTypesQueryQueryResult = Apollo.QueryResult<RegionTypesQueryQuery, RegionTypesQueryQueryVariables>;
export const RegionsQueryDocument = gql`
    query regionsQuery($regionTypeId: ID) {
  regions(
    first: 1000
    region_type_id: $regionTypeId
    orderBy: [{column: "name", order: ASC}]
  ) {
    data {
      ...RegionFull
    }
  }
}
    ${RegionFullFragmentDoc}`;

/**
 * __useRegionsQueryQuery__
 *
 * To run a query within a React component, call `useRegionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsQueryQuery({
 *   variables: {
 *      regionTypeId: // value for 'regionTypeId'
 *   },
 * });
 */
export function useRegionsQueryQuery(baseOptions?: Apollo.QueryHookOptions<RegionsQueryQuery, RegionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsQueryQuery, RegionsQueryQueryVariables>(RegionsQueryDocument, options);
      }
export function useRegionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsQueryQuery, RegionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsQueryQuery, RegionsQueryQueryVariables>(RegionsQueryDocument, options);
        }
export type RegionsQueryQueryHookResult = ReturnType<typeof useRegionsQueryQuery>;
export type RegionsQueryLazyQueryHookResult = ReturnType<typeof useRegionsQueryLazyQuery>;
export type RegionsQueryQueryResult = Apollo.QueryResult<RegionsQueryQuery, RegionsQueryQueryVariables>;
export const CreativeStudioTypesQueryDocument = gql`
    query CreativeStudioTypesQuery {
  creativeStudioTypes {
    id
    name
  }
}
    `;

/**
 * __useCreativeStudioTypesQueryQuery__
 *
 * To run a query within a React component, call `useCreativeStudioTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeStudioTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeStudioTypesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreativeStudioTypesQueryQuery(baseOptions?: Apollo.QueryHookOptions<CreativeStudioTypesQueryQuery, CreativeStudioTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeStudioTypesQueryQuery, CreativeStudioTypesQueryQueryVariables>(CreativeStudioTypesQueryDocument, options);
      }
export function useCreativeStudioTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeStudioTypesQueryQuery, CreativeStudioTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeStudioTypesQueryQuery, CreativeStudioTypesQueryQueryVariables>(CreativeStudioTypesQueryDocument, options);
        }
export type CreativeStudioTypesQueryQueryHookResult = ReturnType<typeof useCreativeStudioTypesQueryQuery>;
export type CreativeStudioTypesQueryLazyQueryHookResult = ReturnType<typeof useCreativeStudioTypesQueryLazyQuery>;
export type CreativeStudioTypesQueryQueryResult = Apollo.QueryResult<CreativeStudioTypesQueryQuery, CreativeStudioTypesQueryQueryVariables>;
export const CreativeStudioTypesDetailsQueryDocument = gql`
    query CreativeStudioTypesDetailsQuery($creativeStudioTypeId: ID) {
  creativeStudioTypeDetails(creativeStudioTypeId: $creativeStudioTypeId) {
    id
    name
  }
}
    `;

/**
 * __useCreativeStudioTypesDetailsQueryQuery__
 *
 * To run a query within a React component, call `useCreativeStudioTypesDetailsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreativeStudioTypesDetailsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreativeStudioTypesDetailsQueryQuery({
 *   variables: {
 *      creativeStudioTypeId: // value for 'creativeStudioTypeId'
 *   },
 * });
 */
export function useCreativeStudioTypesDetailsQueryQuery(baseOptions?: Apollo.QueryHookOptions<CreativeStudioTypesDetailsQueryQuery, CreativeStudioTypesDetailsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreativeStudioTypesDetailsQueryQuery, CreativeStudioTypesDetailsQueryQueryVariables>(CreativeStudioTypesDetailsQueryDocument, options);
      }
export function useCreativeStudioTypesDetailsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreativeStudioTypesDetailsQueryQuery, CreativeStudioTypesDetailsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreativeStudioTypesDetailsQueryQuery, CreativeStudioTypesDetailsQueryQueryVariables>(CreativeStudioTypesDetailsQueryDocument, options);
        }
export type CreativeStudioTypesDetailsQueryQueryHookResult = ReturnType<typeof useCreativeStudioTypesDetailsQueryQuery>;
export type CreativeStudioTypesDetailsQueryLazyQueryHookResult = ReturnType<typeof useCreativeStudioTypesDetailsQueryLazyQuery>;
export type CreativeStudioTypesDetailsQueryQueryResult = Apollo.QueryResult<CreativeStudioTypesDetailsQueryQuery, CreativeStudioTypesDetailsQueryQueryVariables>;
export const UpdateAreaBookingRegionPricingDocument = gql`
    mutation updateAreaBookingRegionPricing($update: UpdateAreaBookingRegionPricings) {
  updateAreaBookingRegionPricing(input: $update) {
    ...AreaBookingRegionPricingFull
  }
}
    ${AreaBookingRegionPricingFullFragmentDoc}`;
export type UpdateAreaBookingRegionPricingMutationFn = Apollo.MutationFunction<UpdateAreaBookingRegionPricingMutation, UpdateAreaBookingRegionPricingMutationVariables>;

/**
 * __useUpdateAreaBookingRegionPricingMutation__
 *
 * To run a mutation, you first call `useUpdateAreaBookingRegionPricingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAreaBookingRegionPricingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAreaBookingRegionPricingMutation, { data, loading, error }] = useUpdateAreaBookingRegionPricingMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateAreaBookingRegionPricingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAreaBookingRegionPricingMutation, UpdateAreaBookingRegionPricingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAreaBookingRegionPricingMutation, UpdateAreaBookingRegionPricingMutationVariables>(UpdateAreaBookingRegionPricingDocument, options);
      }
export type UpdateAreaBookingRegionPricingMutationHookResult = ReturnType<typeof useUpdateAreaBookingRegionPricingMutation>;
export type UpdateAreaBookingRegionPricingMutationResult = Apollo.MutationResult<UpdateAreaBookingRegionPricingMutation>;
export type UpdateAreaBookingRegionPricingMutationOptions = Apollo.BaseMutationOptions<UpdateAreaBookingRegionPricingMutation, UpdateAreaBookingRegionPricingMutationVariables>;
export const CostSuppliersMutationDocument = gql`
    mutation costSuppliersMutation($update: UpdateCostSuppliersInput) {
  updateCostSuppliers(input: $update) {
    ...CostSupplierFull
  }
}
    ${CostSupplierFullFragmentDoc}`;
export type CostSuppliersMutationMutationFn = Apollo.MutationFunction<CostSuppliersMutationMutation, CostSuppliersMutationMutationVariables>;

/**
 * __useCostSuppliersMutationMutation__
 *
 * To run a mutation, you first call `useCostSuppliersMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCostSuppliersMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [costSuppliersMutationMutation, { data, loading, error }] = useCostSuppliersMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useCostSuppliersMutationMutation(baseOptions?: Apollo.MutationHookOptions<CostSuppliersMutationMutation, CostSuppliersMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CostSuppliersMutationMutation, CostSuppliersMutationMutationVariables>(CostSuppliersMutationDocument, options);
      }
export type CostSuppliersMutationMutationHookResult = ReturnType<typeof useCostSuppliersMutationMutation>;
export type CostSuppliersMutationMutationResult = Apollo.MutationResult<CostSuppliersMutationMutation>;
export type CostSuppliersMutationMutationOptions = Apollo.BaseMutationOptions<CostSuppliersMutationMutation, CostSuppliersMutationMutationVariables>;
export const CostSupplierCategoriesMutationDocument = gql`
    mutation costSupplierCategoriesMutation($update: UpdateCostSupplierCategoriesInput) {
  updateCostSupplierCategories(input: $update) {
    ...CostSupplierCategoryFull
  }
}
    ${CostSupplierCategoryFullFragmentDoc}`;
export type CostSupplierCategoriesMutationMutationFn = Apollo.MutationFunction<CostSupplierCategoriesMutationMutation, CostSupplierCategoriesMutationMutationVariables>;

/**
 * __useCostSupplierCategoriesMutationMutation__
 *
 * To run a mutation, you first call `useCostSupplierCategoriesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCostSupplierCategoriesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [costSupplierCategoriesMutationMutation, { data, loading, error }] = useCostSupplierCategoriesMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useCostSupplierCategoriesMutationMutation(baseOptions?: Apollo.MutationHookOptions<CostSupplierCategoriesMutationMutation, CostSupplierCategoriesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CostSupplierCategoriesMutationMutation, CostSupplierCategoriesMutationMutationVariables>(CostSupplierCategoriesMutationDocument, options);
      }
export type CostSupplierCategoriesMutationMutationHookResult = ReturnType<typeof useCostSupplierCategoriesMutationMutation>;
export type CostSupplierCategoriesMutationMutationResult = Apollo.MutationResult<CostSupplierCategoriesMutationMutation>;
export type CostSupplierCategoriesMutationMutationOptions = Apollo.BaseMutationOptions<CostSupplierCategoriesMutationMutation, CostSupplierCategoriesMutationMutationVariables>;
export const SitesMutationDocument = gql`
    mutation sitesMutation($input: UpdateSites!) {
  updateSites(input: $input) {
    ...SiteFull
  }
}
    ${SiteFullFragmentDoc}`;
export type SitesMutationMutationFn = Apollo.MutationFunction<SitesMutationMutation, SitesMutationMutationVariables>;

/**
 * __useSitesMutationMutation__
 *
 * To run a mutation, you first call `useSitesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSitesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sitesMutationMutation, { data, loading, error }] = useSitesMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSitesMutationMutation(baseOptions?: Apollo.MutationHookOptions<SitesMutationMutation, SitesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SitesMutationMutation, SitesMutationMutationVariables>(SitesMutationDocument, options);
      }
export type SitesMutationMutationHookResult = ReturnType<typeof useSitesMutationMutation>;
export type SitesMutationMutationResult = Apollo.MutationResult<SitesMutationMutation>;
export type SitesMutationMutationOptions = Apollo.BaseMutationOptions<SitesMutationMutation, SitesMutationMutationVariables>;
export const CreateRoleDocument = gql`
    mutation createRole($input: CreateRoleInput) {
  createRole(input: $input) {
    ...RoleFull
  }
}
    ${RoleFullFragmentDoc}`;
export type CreateRoleMutationFn = Apollo.MutationFunction<CreateRoleMutation, CreateRoleMutationVariables>;

/**
 * __useCreateRoleMutation__
 *
 * To run a mutation, you first call `useCreateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoleMutation, { data, loading, error }] = useCreateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRoleMutation, CreateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRoleMutation, CreateRoleMutationVariables>(CreateRoleDocument, options);
      }
export type CreateRoleMutationHookResult = ReturnType<typeof useCreateRoleMutation>;
export type CreateRoleMutationResult = Apollo.MutationResult<CreateRoleMutation>;
export type CreateRoleMutationOptions = Apollo.BaseMutationOptions<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = gql`
    mutation updateRole($input: UpdateRoleInput) {
  updateRole(input: $input) {
    ...RoleFull
  }
}
    ${RoleFullFragmentDoc}`;
export type UpdateRoleMutationFn = Apollo.MutationFunction<UpdateRoleMutation, UpdateRoleMutationVariables>;

/**
 * __useUpdateRoleMutation__
 *
 * To run a mutation, you first call `useUpdateRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoleMutation, { data, loading, error }] = useUpdateRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRoleMutation, UpdateRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRoleMutation, UpdateRoleMutationVariables>(UpdateRoleDocument, options);
      }
export type UpdateRoleMutationHookResult = ReturnType<typeof useUpdateRoleMutation>;
export type UpdateRoleMutationResult = Apollo.MutationResult<UpdateRoleMutation>;
export type UpdateRoleMutationOptions = Apollo.BaseMutationOptions<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const RolesMutationDocument = gql`
    mutation rolesMutation($input: UpdateRoles!) {
  updateRoles(input: $input) {
    ...RoleFull
  }
}
    ${RoleFullFragmentDoc}`;
export type RolesMutationMutationFn = Apollo.MutationFunction<RolesMutationMutation, RolesMutationMutationVariables>;

/**
 * __useRolesMutationMutation__
 *
 * To run a mutation, you first call `useRolesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRolesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rolesMutationMutation, { data, loading, error }] = useRolesMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRolesMutationMutation(baseOptions?: Apollo.MutationHookOptions<RolesMutationMutation, RolesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RolesMutationMutation, RolesMutationMutationVariables>(RolesMutationDocument, options);
      }
export type RolesMutationMutationHookResult = ReturnType<typeof useRolesMutationMutation>;
export type RolesMutationMutationResult = Apollo.MutationResult<RolesMutationMutation>;
export type RolesMutationMutationOptions = Apollo.BaseMutationOptions<RolesMutationMutation, RolesMutationMutationVariables>;
export const GetRoleDocument = gql`
    query getRole($id: ID) {
  role(id: $id) {
    ...RoleFull
  }
}
    ${RoleFullFragmentDoc}`;

/**
 * __useGetRoleQuery__
 *
 * To run a query within a React component, call `useGetRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
      }
export function useGetRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRoleQuery, GetRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRoleQuery, GetRoleQueryVariables>(GetRoleDocument, options);
        }
export type GetRoleQueryHookResult = ReturnType<typeof useGetRoleQuery>;
export type GetRoleLazyQueryHookResult = ReturnType<typeof useGetRoleLazyQuery>;
export type GetRoleQueryResult = Apollo.QueryResult<GetRoleQuery, GetRoleQueryVariables>;
export const LogEntriesQueryDocument = gql`
    query logEntriesQuery($campaignId: ID!, $after: String, $archived: Boolean) {
  logEntries(
    campaignId: $campaignId
    after: $after
    archived: $archived
    first: 50
  ) {
    ...LogEntry
  }
}
    ${LogEntryFragmentDoc}`;

/**
 * __useLogEntriesQueryQuery__
 *
 * To run a query within a React component, call `useLogEntriesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogEntriesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogEntriesQueryQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      after: // value for 'after'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useLogEntriesQueryQuery(baseOptions: Apollo.QueryHookOptions<LogEntriesQueryQuery, LogEntriesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogEntriesQueryQuery, LogEntriesQueryQueryVariables>(LogEntriesQueryDocument, options);
      }
export function useLogEntriesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogEntriesQueryQuery, LogEntriesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogEntriesQueryQuery, LogEntriesQueryQueryVariables>(LogEntriesQueryDocument, options);
        }
export type LogEntriesQueryQueryHookResult = ReturnType<typeof useLogEntriesQueryQuery>;
export type LogEntriesQueryLazyQueryHookResult = ReturnType<typeof useLogEntriesQueryLazyQuery>;
export type LogEntriesQueryQueryResult = Apollo.QueryResult<LogEntriesQueryQuery, LogEntriesQueryQueryVariables>;
export const LogEntryDetailQueryDocument = gql`
    query logEntryDetailQuery($campaignId: ID!, $id: ID!) {
  logEntryDetail(campaignId: $campaignId, id: $id) {
    ...LogEntry
    payload
    fields {
      subject
      field
      label
      oldValue
      newValue
    }
  }
}
    ${LogEntryFragmentDoc}`;

/**
 * __useLogEntryDetailQueryQuery__
 *
 * To run a query within a React component, call `useLogEntryDetailQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useLogEntryDetailQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogEntryDetailQueryQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLogEntryDetailQueryQuery(baseOptions: Apollo.QueryHookOptions<LogEntryDetailQueryQuery, LogEntryDetailQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LogEntryDetailQueryQuery, LogEntryDetailQueryQueryVariables>(LogEntryDetailQueryDocument, options);
      }
export function useLogEntryDetailQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LogEntryDetailQueryQuery, LogEntryDetailQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LogEntryDetailQueryQuery, LogEntryDetailQueryQueryVariables>(LogEntryDetailQueryDocument, options);
        }
export type LogEntryDetailQueryQueryHookResult = ReturnType<typeof useLogEntryDetailQueryQuery>;
export type LogEntryDetailQueryLazyQueryHookResult = ReturnType<typeof useLogEntryDetailQueryLazyQuery>;
export type LogEntryDetailQueryQueryResult = Apollo.QueryResult<LogEntryDetailQueryQuery, LogEntryDetailQueryQueryVariables>;
export const GetAreaBookingRegionPricingsDocument = gql`
    query getAreaBookingRegionPricings($region_id: ID, $poster_size_id: ID) {
  getAreaBookingRegionPricings(
    region_id: $region_id
    poster_size_id: $poster_size_id
  ) {
    id
    region {
      id
    }
    posterSize {
      id
    }
    unit_value
    currency {
      ...CurrencyFull
    }
  }
}
    ${CurrencyFullFragmentDoc}`;

/**
 * __useGetAreaBookingRegionPricingsQuery__
 *
 * To run a query within a React component, call `useGetAreaBookingRegionPricingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAreaBookingRegionPricingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAreaBookingRegionPricingsQuery({
 *   variables: {
 *      region_id: // value for 'region_id'
 *      poster_size_id: // value for 'poster_size_id'
 *   },
 * });
 */
export function useGetAreaBookingRegionPricingsQuery(baseOptions?: Apollo.QueryHookOptions<GetAreaBookingRegionPricingsQuery, GetAreaBookingRegionPricingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAreaBookingRegionPricingsQuery, GetAreaBookingRegionPricingsQueryVariables>(GetAreaBookingRegionPricingsDocument, options);
      }
export function useGetAreaBookingRegionPricingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAreaBookingRegionPricingsQuery, GetAreaBookingRegionPricingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAreaBookingRegionPricingsQuery, GetAreaBookingRegionPricingsQueryVariables>(GetAreaBookingRegionPricingsDocument, options);
        }
export type GetAreaBookingRegionPricingsQueryHookResult = ReturnType<typeof useGetAreaBookingRegionPricingsQuery>;
export type GetAreaBookingRegionPricingsLazyQueryHookResult = ReturnType<typeof useGetAreaBookingRegionPricingsLazyQuery>;
export type GetAreaBookingRegionPricingsQueryResult = Apollo.QueryResult<GetAreaBookingRegionPricingsQuery, GetAreaBookingRegionPricingsQueryVariables>;
export const PermissionsQueryDocument = gql`
    query permissionsQuery {
  permissions(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...PermissionFull
    }
  }
}
    ${PermissionFullFragmentDoc}`;

/**
 * __usePermissionsQueryQuery__
 *
 * To run a query within a React component, call `usePermissionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQueryQuery(baseOptions?: Apollo.QueryHookOptions<PermissionsQueryQuery, PermissionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PermissionsQueryQuery, PermissionsQueryQueryVariables>(PermissionsQueryDocument, options);
      }
export function usePermissionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PermissionsQueryQuery, PermissionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PermissionsQueryQuery, PermissionsQueryQueryVariables>(PermissionsQueryDocument, options);
        }
export type PermissionsQueryQueryHookResult = ReturnType<typeof usePermissionsQueryQuery>;
export type PermissionsQueryLazyQueryHookResult = ReturnType<typeof usePermissionsQueryLazyQuery>;
export type PermissionsQueryQueryResult = Apollo.QueryResult<PermissionsQueryQuery, PermissionsQueryQueryVariables>;
export const RolesQueryDocument = gql`
    query rolesQuery {
  roles(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useRolesQueryQuery__
 *
 * To run a query within a React component, call `useRolesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQueryQuery(baseOptions?: Apollo.QueryHookOptions<RolesQueryQuery, RolesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQueryQuery, RolesQueryQueryVariables>(RolesQueryDocument, options);
      }
export function useRolesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQueryQuery, RolesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQueryQuery, RolesQueryQueryVariables>(RolesQueryDocument, options);
        }
export type RolesQueryQueryHookResult = ReturnType<typeof useRolesQueryQuery>;
export type RolesQueryLazyQueryHookResult = ReturnType<typeof useRolesQueryLazyQuery>;
export type RolesQueryQueryResult = Apollo.QueryResult<RolesQueryQuery, RolesQueryQueryVariables>;
export const PaymentTermQueryDocument = gql`
    query paymentTermQuery {
  paymentTerm {
    id
    name
  }
}
    `;

/**
 * __usePaymentTermQueryQuery__
 *
 * To run a query within a React component, call `usePaymentTermQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentTermQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentTermQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentTermQueryQuery(baseOptions?: Apollo.QueryHookOptions<PaymentTermQueryQuery, PaymentTermQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentTermQueryQuery, PaymentTermQueryQueryVariables>(PaymentTermQueryDocument, options);
      }
export function usePaymentTermQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentTermQueryQuery, PaymentTermQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentTermQueryQuery, PaymentTermQueryQueryVariables>(PaymentTermQueryDocument, options);
        }
export type PaymentTermQueryQueryHookResult = ReturnType<typeof usePaymentTermQueryQuery>;
export type PaymentTermQueryLazyQueryHookResult = ReturnType<typeof usePaymentTermQueryLazyQuery>;
export type PaymentTermQueryQueryResult = Apollo.QueryResult<PaymentTermQueryQuery, PaymentTermQueryQueryVariables>;
export const SubletterQueryDocument = gql`
    query subletterQuery {
  subletters(orderBy: [{column: "name", order: ASC}]) {
    ...SubletterMinimal
  }
}
    ${SubletterMinimalFragmentDoc}`;

/**
 * __useSubletterQueryQuery__
 *
 * To run a query within a React component, call `useSubletterQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSubletterQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubletterQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSubletterQueryQuery(baseOptions?: Apollo.QueryHookOptions<SubletterQueryQuery, SubletterQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubletterQueryQuery, SubletterQueryQueryVariables>(SubletterQueryDocument, options);
      }
export function useSubletterQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubletterQueryQuery, SubletterQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubletterQueryQuery, SubletterQueryQueryVariables>(SubletterQueryDocument, options);
        }
export type SubletterQueryQueryHookResult = ReturnType<typeof useSubletterQueryQuery>;
export type SubletterQueryLazyQueryHookResult = ReturnType<typeof useSubletterQueryLazyQuery>;
export type SubletterQueryQueryResult = Apollo.QueryResult<SubletterQueryQuery, SubletterQueryQueryVariables>;
export const SubletterMutationDocument = gql`
    mutation subletterMutation($input: UpdateSubletter) {
  updateSubletters(input: $input) {
    ...SubletterFull
  }
}
    ${SubletterFullFragmentDoc}`;
export type SubletterMutationMutationFn = Apollo.MutationFunction<SubletterMutationMutation, SubletterMutationMutationVariables>;

/**
 * __useSubletterMutationMutation__
 *
 * To run a mutation, you first call `useSubletterMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubletterMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subletterMutationMutation, { data, loading, error }] = useSubletterMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubletterMutationMutation(baseOptions?: Apollo.MutationHookOptions<SubletterMutationMutation, SubletterMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubletterMutationMutation, SubletterMutationMutationVariables>(SubletterMutationDocument, options);
      }
export type SubletterMutationMutationHookResult = ReturnType<typeof useSubletterMutationMutation>;
export type SubletterMutationMutationResult = Apollo.MutationResult<SubletterMutationMutation>;
export type SubletterMutationMutationOptions = Apollo.BaseMutationOptions<SubletterMutationMutation, SubletterMutationMutationVariables>;
export const ProposalOptionsQueryDocument = gql`
    query proposalOptionsQuery {
  proposalOptions(orderBy: [{column: "label", order: ASC}]) {
    ...ProposalOptionFull
  }
}
    ${ProposalOptionFullFragmentDoc}`;

/**
 * __useProposalOptionsQueryQuery__
 *
 * To run a query within a React component, call `useProposalOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalOptionsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useProposalOptionsQueryQuery(baseOptions?: Apollo.QueryHookOptions<ProposalOptionsQueryQuery, ProposalOptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalOptionsQueryQuery, ProposalOptionsQueryQueryVariables>(ProposalOptionsQueryDocument, options);
      }
export function useProposalOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalOptionsQueryQuery, ProposalOptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalOptionsQueryQuery, ProposalOptionsQueryQueryVariables>(ProposalOptionsQueryDocument, options);
        }
export type ProposalOptionsQueryQueryHookResult = ReturnType<typeof useProposalOptionsQueryQuery>;
export type ProposalOptionsQueryLazyQueryHookResult = ReturnType<typeof useProposalOptionsQueryLazyQuery>;
export type ProposalOptionsQueryQueryResult = Apollo.QueryResult<ProposalOptionsQueryQuery, ProposalOptionsQueryQueryVariables>;
export const SalesTeamQueryDocument = gql`
    query salesTeamQuery {
  salesTeams(orderBy: [{column: "name", order: ASC}]) {
    ...SalesTeamFull
  }
}
    ${SalesTeamFullFragmentDoc}`;

/**
 * __useSalesTeamQueryQuery__
 *
 * To run a query within a React component, call `useSalesTeamQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSalesTeamQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSalesTeamQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSalesTeamQueryQuery(baseOptions?: Apollo.QueryHookOptions<SalesTeamQueryQuery, SalesTeamQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SalesTeamQueryQuery, SalesTeamQueryQueryVariables>(SalesTeamQueryDocument, options);
      }
export function useSalesTeamQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SalesTeamQueryQuery, SalesTeamQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SalesTeamQueryQuery, SalesTeamQueryQueryVariables>(SalesTeamQueryDocument, options);
        }
export type SalesTeamQueryQueryHookResult = ReturnType<typeof useSalesTeamQueryQuery>;
export type SalesTeamQueryLazyQueryHookResult = ReturnType<typeof useSalesTeamQueryLazyQuery>;
export type SalesTeamQueryQueryResult = Apollo.QueryResult<SalesTeamQueryQuery, SalesTeamQueryQueryVariables>;
export const GetSalesTeamQueryDocument = gql`
    query getSalesTeamQuery($id: ID!) {
  salesTeam(id: $id) {
    ...SalesTeamFull
  }
}
    ${SalesTeamFullFragmentDoc}`;

/**
 * __useGetSalesTeamQueryQuery__
 *
 * To run a query within a React component, call `useGetSalesTeamQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTeamQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTeamQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSalesTeamQueryQuery(baseOptions: Apollo.QueryHookOptions<GetSalesTeamQueryQuery, GetSalesTeamQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTeamQueryQuery, GetSalesTeamQueryQueryVariables>(GetSalesTeamQueryDocument, options);
      }
export function useGetSalesTeamQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTeamQueryQuery, GetSalesTeamQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTeamQueryQuery, GetSalesTeamQueryQueryVariables>(GetSalesTeamQueryDocument, options);
        }
export type GetSalesTeamQueryQueryHookResult = ReturnType<typeof useGetSalesTeamQueryQuery>;
export type GetSalesTeamQueryLazyQueryHookResult = ReturnType<typeof useGetSalesTeamQueryLazyQuery>;
export type GetSalesTeamQueryQueryResult = Apollo.QueryResult<GetSalesTeamQueryQuery, GetSalesTeamQueryQueryVariables>;
export const SalesTeamMutationDocument = gql`
    mutation salesTeamMutation($input: UpdateSalesTeam!) {
  updateSalesTeams(input: $input) {
    ...SalesTeamFull
  }
}
    ${SalesTeamFullFragmentDoc}`;
export type SalesTeamMutationMutationFn = Apollo.MutationFunction<SalesTeamMutationMutation, SalesTeamMutationMutationVariables>;

/**
 * __useSalesTeamMutationMutation__
 *
 * To run a mutation, you first call `useSalesTeamMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesTeamMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesTeamMutationMutation, { data, loading, error }] = useSalesTeamMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSalesTeamMutationMutation(baseOptions?: Apollo.MutationHookOptions<SalesTeamMutationMutation, SalesTeamMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SalesTeamMutationMutation, SalesTeamMutationMutationVariables>(SalesTeamMutationDocument, options);
      }
export type SalesTeamMutationMutationHookResult = ReturnType<typeof useSalesTeamMutationMutation>;
export type SalesTeamMutationMutationResult = Apollo.MutationResult<SalesTeamMutationMutation>;
export type SalesTeamMutationMutationOptions = Apollo.BaseMutationOptions<SalesTeamMutationMutation, SalesTeamMutationMutationVariables>;
export const CreateSalesTeamMutationDocument = gql`
    mutation createSalesTeamMutation($input: CreateSalesTeamInput!) {
  createSalesTeam(input: $input) {
    ...SalesTeamFull
  }
}
    ${SalesTeamFullFragmentDoc}`;
export type CreateSalesTeamMutationMutationFn = Apollo.MutationFunction<CreateSalesTeamMutationMutation, CreateSalesTeamMutationMutationVariables>;

/**
 * __useCreateSalesTeamMutationMutation__
 *
 * To run a mutation, you first call `useCreateSalesTeamMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesTeamMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesTeamMutationMutation, { data, loading, error }] = useCreateSalesTeamMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSalesTeamMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesTeamMutationMutation, CreateSalesTeamMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesTeamMutationMutation, CreateSalesTeamMutationMutationVariables>(CreateSalesTeamMutationDocument, options);
      }
export type CreateSalesTeamMutationMutationHookResult = ReturnType<typeof useCreateSalesTeamMutationMutation>;
export type CreateSalesTeamMutationMutationResult = Apollo.MutationResult<CreateSalesTeamMutationMutation>;
export type CreateSalesTeamMutationMutationOptions = Apollo.BaseMutationOptions<CreateSalesTeamMutationMutation, CreateSalesTeamMutationMutationVariables>;
export const UpdateSalesTeamMutationDocument = gql`
    mutation updateSalesTeamMutation($input: UpdateSalesTeamInput!) {
  updateSalesTeam(input: $input) {
    ...SalesTeamFull
  }
}
    ${SalesTeamFullFragmentDoc}`;
export type UpdateSalesTeamMutationMutationFn = Apollo.MutationFunction<UpdateSalesTeamMutationMutation, UpdateSalesTeamMutationMutationVariables>;

/**
 * __useUpdateSalesTeamMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSalesTeamMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSalesTeamMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSalesTeamMutationMutation, { data, loading, error }] = useUpdateSalesTeamMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSalesTeamMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSalesTeamMutationMutation, UpdateSalesTeamMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSalesTeamMutationMutation, UpdateSalesTeamMutationMutationVariables>(UpdateSalesTeamMutationDocument, options);
      }
export type UpdateSalesTeamMutationMutationHookResult = ReturnType<typeof useUpdateSalesTeamMutationMutation>;
export type UpdateSalesTeamMutationMutationResult = Apollo.MutationResult<UpdateSalesTeamMutationMutation>;
export type UpdateSalesTeamMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSalesTeamMutationMutation, UpdateSalesTeamMutationMutationVariables>;
export const OptionsQueryDocument = gql`
    query optionsQuery {
  options(orderBy: [{column: "label", order: ASC}]) {
    id
    label
    type
  }
}
    `;

/**
 * __useOptionsQueryQuery__
 *
 * To run a query within a React component, call `useOptionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useOptionsQueryQuery(baseOptions?: Apollo.QueryHookOptions<OptionsQueryQuery, OptionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptionsQueryQuery, OptionsQueryQueryVariables>(OptionsQueryDocument, options);
      }
export function useOptionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptionsQueryQuery, OptionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptionsQueryQuery, OptionsQueryQueryVariables>(OptionsQueryDocument, options);
        }
export type OptionsQueryQueryHookResult = ReturnType<typeof useOptionsQueryQuery>;
export type OptionsQueryLazyQueryHookResult = ReturnType<typeof useOptionsQueryLazyQuery>;
export type OptionsQueryQueryResult = Apollo.QueryResult<OptionsQueryQuery, OptionsQueryQueryVariables>;
export const UpdateDistributorsMutationDocument = gql`
    mutation updateDistributorsMutation($input: UpdateDistributor!) {
  updateDistributors(input: $input) {
    ...DistributorFull
  }
}
    ${DistributorFullFragmentDoc}`;
export type UpdateDistributorsMutationMutationFn = Apollo.MutationFunction<UpdateDistributorsMutationMutation, UpdateDistributorsMutationMutationVariables>;

/**
 * __useUpdateDistributorsMutationMutation__
 *
 * To run a mutation, you first call `useUpdateDistributorsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributorsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributorsMutationMutation, { data, loading, error }] = useUpdateDistributorsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDistributorsMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDistributorsMutationMutation, UpdateDistributorsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDistributorsMutationMutation, UpdateDistributorsMutationMutationVariables>(UpdateDistributorsMutationDocument, options);
      }
export type UpdateDistributorsMutationMutationHookResult = ReturnType<typeof useUpdateDistributorsMutationMutation>;
export type UpdateDistributorsMutationMutationResult = Apollo.MutationResult<UpdateDistributorsMutationMutation>;
export type UpdateDistributorsMutationMutationOptions = Apollo.BaseMutationOptions<UpdateDistributorsMutationMutation, UpdateDistributorsMutationMutationVariables>;
export const SiteHealthAndSafetyTypeQueryDocument = gql`
    query siteHealthAndSafetyTypeQuery {
  siteHealthAndSafetyTypes {
    ...SiteHealthAndSafetyTypeFull
  }
}
    ${SiteHealthAndSafetyTypeFullFragmentDoc}`;

/**
 * __useSiteHealthAndSafetyTypeQueryQuery__
 *
 * To run a query within a React component, call `useSiteHealthAndSafetyTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteHealthAndSafetyTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteHealthAndSafetyTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteHealthAndSafetyTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteHealthAndSafetyTypeQueryQuery, SiteHealthAndSafetyTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteHealthAndSafetyTypeQueryQuery, SiteHealthAndSafetyTypeQueryQueryVariables>(SiteHealthAndSafetyTypeQueryDocument, options);
      }
export function useSiteHealthAndSafetyTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteHealthAndSafetyTypeQueryQuery, SiteHealthAndSafetyTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteHealthAndSafetyTypeQueryQuery, SiteHealthAndSafetyTypeQueryQueryVariables>(SiteHealthAndSafetyTypeQueryDocument, options);
        }
export type SiteHealthAndSafetyTypeQueryQueryHookResult = ReturnType<typeof useSiteHealthAndSafetyTypeQueryQuery>;
export type SiteHealthAndSafetyTypeQueryLazyQueryHookResult = ReturnType<typeof useSiteHealthAndSafetyTypeQueryLazyQuery>;
export type SiteHealthAndSafetyTypeQueryQueryResult = Apollo.QueryResult<SiteHealthAndSafetyTypeQueryQuery, SiteHealthAndSafetyTypeQueryQueryVariables>;
export const SitePlanningOutcomeQueryDocument = gql`
    query sitePlanningOutcomeQuery {
  sitePlanningOutcomes {
    ...SitePlanningOutcomeFull
  }
}
    ${SitePlanningOutcomeFullFragmentDoc}`;

/**
 * __useSitePlanningOutcomeQueryQuery__
 *
 * To run a query within a React component, call `useSitePlanningOutcomeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePlanningOutcomeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePlanningOutcomeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitePlanningOutcomeQueryQuery(baseOptions?: Apollo.QueryHookOptions<SitePlanningOutcomeQueryQuery, SitePlanningOutcomeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitePlanningOutcomeQueryQuery, SitePlanningOutcomeQueryQueryVariables>(SitePlanningOutcomeQueryDocument, options);
      }
export function useSitePlanningOutcomeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitePlanningOutcomeQueryQuery, SitePlanningOutcomeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitePlanningOutcomeQueryQuery, SitePlanningOutcomeQueryQueryVariables>(SitePlanningOutcomeQueryDocument, options);
        }
export type SitePlanningOutcomeQueryQueryHookResult = ReturnType<typeof useSitePlanningOutcomeQueryQuery>;
export type SitePlanningOutcomeQueryLazyQueryHookResult = ReturnType<typeof useSitePlanningOutcomeQueryLazyQuery>;
export type SitePlanningOutcomeQueryQueryResult = Apollo.QueryResult<SitePlanningOutcomeQueryQuery, SitePlanningOutcomeQueryQueryVariables>;
export const SitePlanningStagesQueryDocument = gql`
    query sitePlanningStagesQuery {
  sitePlanningStages {
    ...SitePlanningStageFull
  }
}
    ${SitePlanningStageFullFragmentDoc}`;

/**
 * __useSitePlanningStagesQueryQuery__
 *
 * To run a query within a React component, call `useSitePlanningStagesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePlanningStagesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePlanningStagesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitePlanningStagesQueryQuery(baseOptions?: Apollo.QueryHookOptions<SitePlanningStagesQueryQuery, SitePlanningStagesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitePlanningStagesQueryQuery, SitePlanningStagesQueryQueryVariables>(SitePlanningStagesQueryDocument, options);
      }
export function useSitePlanningStagesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitePlanningStagesQueryQuery, SitePlanningStagesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitePlanningStagesQueryQuery, SitePlanningStagesQueryQueryVariables>(SitePlanningStagesQueryDocument, options);
        }
export type SitePlanningStagesQueryQueryHookResult = ReturnType<typeof useSitePlanningStagesQueryQuery>;
export type SitePlanningStagesQueryLazyQueryHookResult = ReturnType<typeof useSitePlanningStagesQueryLazyQuery>;
export type SitePlanningStagesQueryQueryResult = Apollo.QueryResult<SitePlanningStagesQueryQuery, SitePlanningStagesQueryQueryVariables>;
export const SitePricingsMutationDocument = gql`
    mutation sitePricingsMutation($update: UpdateSitePricings) {
  updateSitePricings(input: $update) {
    ...SitePricingFull
  }
}
    ${SitePricingFullFragmentDoc}`;
export type SitePricingsMutationMutationFn = Apollo.MutationFunction<SitePricingsMutationMutation, SitePricingsMutationMutationVariables>;

/**
 * __useSitePricingsMutationMutation__
 *
 * To run a mutation, you first call `useSitePricingsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSitePricingsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sitePricingsMutationMutation, { data, loading, error }] = useSitePricingsMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useSitePricingsMutationMutation(baseOptions?: Apollo.MutationHookOptions<SitePricingsMutationMutation, SitePricingsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SitePricingsMutationMutation, SitePricingsMutationMutationVariables>(SitePricingsMutationDocument, options);
      }
export type SitePricingsMutationMutationHookResult = ReturnType<typeof useSitePricingsMutationMutation>;
export type SitePricingsMutationMutationResult = Apollo.MutationResult<SitePricingsMutationMutation>;
export type SitePricingsMutationMutationOptions = Apollo.BaseMutationOptions<SitePricingsMutationMutation, SitePricingsMutationMutationVariables>;
export const SitePricingQueryDocument = gql`
    query sitePricingQuery {
  sitePricings {
    ...SitePricingFull
  }
}
    ${SitePricingFullFragmentDoc}`;

/**
 * __useSitePricingQueryQuery__
 *
 * To run a query within a React component, call `useSitePricingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePricingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePricingQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitePricingQueryQuery(baseOptions?: Apollo.QueryHookOptions<SitePricingQueryQuery, SitePricingQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitePricingQueryQuery, SitePricingQueryQueryVariables>(SitePricingQueryDocument, options);
      }
export function useSitePricingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitePricingQueryQuery, SitePricingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitePricingQueryQuery, SitePricingQueryQueryVariables>(SitePricingQueryDocument, options);
        }
export type SitePricingQueryQueryHookResult = ReturnType<typeof useSitePricingQueryQuery>;
export type SitePricingQueryLazyQueryHookResult = ReturnType<typeof useSitePricingQueryLazyQuery>;
export type SitePricingQueryQueryResult = Apollo.QueryResult<SitePricingQueryQuery, SitePricingQueryQueryVariables>;
export const SiteRentalPaymentFrequenciesQueryDocument = gql`
    query siteRentalPaymentFrequenciesQuery {
  siteRentalPaymentFrequencies {
    ...SiteRentalPaymentFrequencyFull
  }
}
    ${SiteRentalPaymentFrequencyFullFragmentDoc}`;

/**
 * __useSiteRentalPaymentFrequenciesQueryQuery__
 *
 * To run a query within a React component, call `useSiteRentalPaymentFrequenciesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteRentalPaymentFrequenciesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteRentalPaymentFrequenciesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteRentalPaymentFrequenciesQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteRentalPaymentFrequenciesQueryQuery, SiteRentalPaymentFrequenciesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteRentalPaymentFrequenciesQueryQuery, SiteRentalPaymentFrequenciesQueryQueryVariables>(SiteRentalPaymentFrequenciesQueryDocument, options);
      }
export function useSiteRentalPaymentFrequenciesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteRentalPaymentFrequenciesQueryQuery, SiteRentalPaymentFrequenciesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteRentalPaymentFrequenciesQueryQuery, SiteRentalPaymentFrequenciesQueryQueryVariables>(SiteRentalPaymentFrequenciesQueryDocument, options);
        }
export type SiteRentalPaymentFrequenciesQueryQueryHookResult = ReturnType<typeof useSiteRentalPaymentFrequenciesQueryQuery>;
export type SiteRentalPaymentFrequenciesQueryLazyQueryHookResult = ReturnType<typeof useSiteRentalPaymentFrequenciesQueryLazyQuery>;
export type SiteRentalPaymentFrequenciesQueryQueryResult = Apollo.QueryResult<SiteRentalPaymentFrequenciesQueryQuery, SiteRentalPaymentFrequenciesQueryQueryVariables>;
export const SiteRentalPaymentMethodsQueryDocument = gql`
    query siteRentalPaymentMethodsQuery {
  siteRentalPaymentMethods {
    ...SiteRentalPaymentMethodFull
  }
}
    ${SiteRentalPaymentMethodFullFragmentDoc}`;

/**
 * __useSiteRentalPaymentMethodsQueryQuery__
 *
 * To run a query within a React component, call `useSiteRentalPaymentMethodsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteRentalPaymentMethodsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteRentalPaymentMethodsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteRentalPaymentMethodsQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteRentalPaymentMethodsQueryQuery, SiteRentalPaymentMethodsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteRentalPaymentMethodsQueryQuery, SiteRentalPaymentMethodsQueryQueryVariables>(SiteRentalPaymentMethodsQueryDocument, options);
      }
export function useSiteRentalPaymentMethodsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteRentalPaymentMethodsQueryQuery, SiteRentalPaymentMethodsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteRentalPaymentMethodsQueryQuery, SiteRentalPaymentMethodsQueryQueryVariables>(SiteRentalPaymentMethodsQueryDocument, options);
        }
export type SiteRentalPaymentMethodsQueryQueryHookResult = ReturnType<typeof useSiteRentalPaymentMethodsQueryQuery>;
export type SiteRentalPaymentMethodsQueryLazyQueryHookResult = ReturnType<typeof useSiteRentalPaymentMethodsQueryLazyQuery>;
export type SiteRentalPaymentMethodsQueryQueryResult = Apollo.QueryResult<SiteRentalPaymentMethodsQueryQuery, SiteRentalPaymentMethodsQueryQueryVariables>;
export const SiteRentalTypesQueryDocument = gql`
    query siteRentalTypesQuery {
  siteRentalTypes {
    ...SiteRentalTypeFull
  }
}
    ${SiteRentalTypeFullFragmentDoc}`;

/**
 * __useSiteRentalTypesQueryQuery__
 *
 * To run a query within a React component, call `useSiteRentalTypesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteRentalTypesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteRentalTypesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteRentalTypesQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteRentalTypesQueryQuery, SiteRentalTypesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteRentalTypesQueryQuery, SiteRentalTypesQueryQueryVariables>(SiteRentalTypesQueryDocument, options);
      }
export function useSiteRentalTypesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteRentalTypesQueryQuery, SiteRentalTypesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteRentalTypesQueryQuery, SiteRentalTypesQueryQueryVariables>(SiteRentalTypesQueryDocument, options);
        }
export type SiteRentalTypesQueryQueryHookResult = ReturnType<typeof useSiteRentalTypesQueryQuery>;
export type SiteRentalTypesQueryLazyQueryHookResult = ReturnType<typeof useSiteRentalTypesQueryLazyQuery>;
export type SiteRentalTypesQueryQueryResult = Apollo.QueryResult<SiteRentalTypesQueryQuery, SiteRentalTypesQueryQueryVariables>;
export const SiteStructureTypeQueryDocument = gql`
    query siteStructureTypeQuery {
  siteStructureTypes(orderBy: [{column: "name", order: ASC}]) {
    ...SiteStructureTypeFull
  }
}
    ${SiteStructureTypeFullFragmentDoc}`;

/**
 * __useSiteStructureTypeQueryQuery__
 *
 * To run a query within a React component, call `useSiteStructureTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteStructureTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStructureTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteStructureTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteStructureTypeQueryQuery, SiteStructureTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteStructureTypeQueryQuery, SiteStructureTypeQueryQueryVariables>(SiteStructureTypeQueryDocument, options);
      }
export function useSiteStructureTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteStructureTypeQueryQuery, SiteStructureTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteStructureTypeQueryQuery, SiteStructureTypeQueryQueryVariables>(SiteStructureTypeQueryDocument, options);
        }
export type SiteStructureTypeQueryQueryHookResult = ReturnType<typeof useSiteStructureTypeQueryQuery>;
export type SiteStructureTypeQueryLazyQueryHookResult = ReturnType<typeof useSiteStructureTypeQueryLazyQuery>;
export type SiteStructureTypeQueryQueryResult = Apollo.QueryResult<SiteStructureTypeQueryQuery, SiteStructureTypeQueryQueryVariables>;
export const SiteStructureGroupQueryDocument = gql`
    query siteStructureGroupQuery {
  siteStructureGroups(orderBy: [{column: "name", order: ASC}]) {
    id
    name
  }
}
    `;

/**
 * __useSiteStructureGroupQueryQuery__
 *
 * To run a query within a React component, call `useSiteStructureGroupQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteStructureGroupQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStructureGroupQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteStructureGroupQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteStructureGroupQueryQuery, SiteStructureGroupQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteStructureGroupQueryQuery, SiteStructureGroupQueryQueryVariables>(SiteStructureGroupQueryDocument, options);
      }
export function useSiteStructureGroupQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteStructureGroupQueryQuery, SiteStructureGroupQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteStructureGroupQueryQuery, SiteStructureGroupQueryQueryVariables>(SiteStructureGroupQueryDocument, options);
        }
export type SiteStructureGroupQueryQueryHookResult = ReturnType<typeof useSiteStructureGroupQueryQuery>;
export type SiteStructureGroupQueryLazyQueryHookResult = ReturnType<typeof useSiteStructureGroupQueryLazyQuery>;
export type SiteStructureGroupQueryQueryResult = Apollo.QueryResult<SiteStructureGroupQueryQuery, SiteStructureGroupQueryQueryVariables>;
export const SiteStructureQueryDocument = gql`
    query siteStructureQuery {
  siteStructures(orderBy: [{column: "name", order: ASC}]) {
    ...SiteStructureFullWithPosterSize
  }
}
    ${SiteStructureFullWithPosterSizeFragmentDoc}`;

/**
 * __useSiteStructureQueryQuery__
 *
 * To run a query within a React component, call `useSiteStructureQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteStructureQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteStructureQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteStructureQueryQuery(baseOptions?: Apollo.QueryHookOptions<SiteStructureQueryQuery, SiteStructureQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteStructureQueryQuery, SiteStructureQueryQueryVariables>(SiteStructureQueryDocument, options);
      }
export function useSiteStructureQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteStructureQueryQuery, SiteStructureQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteStructureQueryQuery, SiteStructureQueryQueryVariables>(SiteStructureQueryDocument, options);
        }
export type SiteStructureQueryQueryHookResult = ReturnType<typeof useSiteStructureQueryQuery>;
export type SiteStructureQueryLazyQueryHookResult = ReturnType<typeof useSiteStructureQueryLazyQuery>;
export type SiteStructureQueryQueryResult = Apollo.QueryResult<SiteStructureQueryQuery, SiteStructureQueryQueryVariables>;
export const SiteStructuresMutationDocument = gql`
    mutation siteStructuresMutation($update: UpdateSiteStructure) {
  updateSiteStructure(input: $update) {
    ...SiteStructureFullWithPosterSize
  }
}
    ${SiteStructureFullWithPosterSizeFragmentDoc}`;
export type SiteStructuresMutationMutationFn = Apollo.MutationFunction<SiteStructuresMutationMutation, SiteStructuresMutationMutationVariables>;

/**
 * __useSiteStructuresMutationMutation__
 *
 * To run a mutation, you first call `useSiteStructuresMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteStructuresMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteStructuresMutationMutation, { data, loading, error }] = useSiteStructuresMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useSiteStructuresMutationMutation(baseOptions?: Apollo.MutationHookOptions<SiteStructuresMutationMutation, SiteStructuresMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteStructuresMutationMutation, SiteStructuresMutationMutationVariables>(SiteStructuresMutationDocument, options);
      }
export type SiteStructuresMutationMutationHookResult = ReturnType<typeof useSiteStructuresMutationMutation>;
export type SiteStructuresMutationMutationResult = Apollo.MutationResult<SiteStructuresMutationMutation>;
export type SiteStructuresMutationMutationOptions = Apollo.BaseMutationOptions<SiteStructuresMutationMutation, SiteStructuresMutationMutationVariables>;
export const SundryTypeQueryDocument = gql`
    query sundryTypeQuery {
  sundryTypes(orderBy: [{column: "name", order: ASC}]) {
    ...SundryTypeFull
  }
}
    ${SundryTypeFullFragmentDoc}`;

/**
 * __useSundryTypeQueryQuery__
 *
 * To run a query within a React component, call `useSundryTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSundryTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSundryTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useSundryTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<SundryTypeQueryQuery, SundryTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SundryTypeQueryQuery, SundryTypeQueryQueryVariables>(SundryTypeQueryDocument, options);
      }
export function useSundryTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SundryTypeQueryQuery, SundryTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SundryTypeQueryQuery, SundryTypeQueryQueryVariables>(SundryTypeQueryDocument, options);
        }
export type SundryTypeQueryQueryHookResult = ReturnType<typeof useSundryTypeQueryQuery>;
export type SundryTypeQueryLazyQueryHookResult = ReturnType<typeof useSundryTypeQueryLazyQuery>;
export type SundryTypeQueryQueryResult = Apollo.QueryResult<SundryTypeQueryQuery, SundryTypeQueryQueryVariables>;
export const BuildTypeQueryDocument = gql`
    query buildTypeQuery {
  siteBuildTypes(orderBy: [{column: "label", order: ASC}]) {
    ...SiteBuildTypeFull
  }
}
    ${SiteBuildTypeFullFragmentDoc}`;

/**
 * __useBuildTypeQueryQuery__
 *
 * To run a query within a React component, call `useBuildTypeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildTypeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildTypeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuildTypeQueryQuery(baseOptions?: Apollo.QueryHookOptions<BuildTypeQueryQuery, BuildTypeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildTypeQueryQuery, BuildTypeQueryQueryVariables>(BuildTypeQueryDocument, options);
      }
export function useBuildTypeQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildTypeQueryQuery, BuildTypeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildTypeQueryQuery, BuildTypeQueryQueryVariables>(BuildTypeQueryDocument, options);
        }
export type BuildTypeQueryQueryHookResult = ReturnType<typeof useBuildTypeQueryQuery>;
export type BuildTypeQueryLazyQueryHookResult = ReturnType<typeof useBuildTypeQueryLazyQuery>;
export type BuildTypeQueryQueryResult = Apollo.QueryResult<BuildTypeQueryQuery, BuildTypeQueryQueryVariables>;
export const BuildContractorQueryDocument = gql`
    query buildContractorQuery {
  siteBuildContractors(orderBy: [{column: "label", order: ASC}]) {
    ...SiteBuildContractorFull
  }
}
    ${SiteBuildContractorFullFragmentDoc}`;

/**
 * __useBuildContractorQueryQuery__
 *
 * To run a query within a React component, call `useBuildContractorQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBuildContractorQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBuildContractorQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBuildContractorQueryQuery(baseOptions?: Apollo.QueryHookOptions<BuildContractorQueryQuery, BuildContractorQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BuildContractorQueryQuery, BuildContractorQueryQueryVariables>(BuildContractorQueryDocument, options);
      }
export function useBuildContractorQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BuildContractorQueryQuery, BuildContractorQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BuildContractorQueryQuery, BuildContractorQueryQueryVariables>(BuildContractorQueryDocument, options);
        }
export type BuildContractorQueryQueryHookResult = ReturnType<typeof useBuildContractorQueryQuery>;
export type BuildContractorQueryLazyQueryHookResult = ReturnType<typeof useBuildContractorQueryLazyQuery>;
export type BuildContractorQueryQueryResult = Apollo.QueryResult<BuildContractorQueryQuery, BuildContractorQueryQueryVariables>;
export const UserQueryDocument = gql`
    query userQuery {
  users(orderBy: [{column: "name", order: ASC}]) {
    ...UserShort
  }
}
    ${UserShortFragmentDoc}`;

/**
 * __useUserQueryQuery__
 *
 * To run a query within a React component, call `useUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQueryQuery(baseOptions?: Apollo.QueryHookOptions<UserQueryQuery, UserQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
      }
export function useUserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQueryQuery, UserQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQueryQuery, UserQueryQueryVariables>(UserQueryDocument, options);
        }
export type UserQueryQueryHookResult = ReturnType<typeof useUserQueryQuery>;
export type UserQueryLazyQueryHookResult = ReturnType<typeof useUserQueryLazyQuery>;
export type UserQueryQueryResult = Apollo.QueryResult<UserQueryQuery, UserQueryQueryVariables>;
export const GetUserQueryDocument = gql`
    query getUserQuery($id: ID) {
  user(id: $id) {
    ...UserFull
  }
}
    ${UserFullFragmentDoc}`;

/**
 * __useGetUserQueryQuery__
 *
 * To run a query within a React component, call `useGetUserQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetUserQueryQuery, GetUserQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQueryQuery, GetUserQueryQueryVariables>(GetUserQueryDocument, options);
      }
export function useGetUserQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQueryQuery, GetUserQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQueryQuery, GetUserQueryQueryVariables>(GetUserQueryDocument, options);
        }
export type GetUserQueryQueryHookResult = ReturnType<typeof useGetUserQueryQuery>;
export type GetUserQueryLazyQueryHookResult = ReturnType<typeof useGetUserQueryLazyQuery>;
export type GetUserQueryQueryResult = Apollo.QueryResult<GetUserQueryQuery, GetUserQueryQueryVariables>;
export const CreateUserMutationDocument = gql`
    mutation createUserMutation($input: CreateUserInput!) {
  createUser(input: $input) {
    ...UserFull
  }
}
    ${UserFullFragmentDoc}`;
export type CreateUserMutationMutationFn = Apollo.MutationFunction<CreateUserMutationMutation, CreateUserMutationMutationVariables>;

/**
 * __useCreateUserMutationMutation__
 *
 * To run a mutation, you first call `useCreateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutationMutation, { data, loading, error }] = useCreateUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutationMutation, CreateUserMutationMutationVariables>(CreateUserMutationDocument, options);
      }
export type CreateUserMutationMutationHookResult = ReturnType<typeof useCreateUserMutationMutation>;
export type CreateUserMutationMutationResult = Apollo.MutationResult<CreateUserMutationMutation>;
export type CreateUserMutationMutationOptions = Apollo.BaseMutationOptions<CreateUserMutationMutation, CreateUserMutationMutationVariables>;
export const UpdateUserMutationDocument = gql`
    mutation updateUserMutation($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...UserFull
  }
}
    ${UserFullFragmentDoc}`;
export type UpdateUserMutationMutationFn = Apollo.MutationFunction<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>;

/**
 * __useUpdateUserMutationMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutationMutation, { data, loading, error }] = useUpdateUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>(UpdateUserMutationDocument, options);
      }
export type UpdateUserMutationMutationHookResult = ReturnType<typeof useUpdateUserMutationMutation>;
export type UpdateUserMutationMutationResult = Apollo.MutationResult<UpdateUserMutationMutation>;
export type UpdateUserMutationMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutationMutation, UpdateUserMutationMutationVariables>;
export const PingQueryDocument = gql`
    query pingQuery {
  ping {
    JSVersion
  }
}
    `;

/**
 * __usePingQueryQuery__
 *
 * To run a query within a React component, call `usePingQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePingQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePingQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function usePingQueryQuery(baseOptions?: Apollo.QueryHookOptions<PingQueryQuery, PingQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PingQueryQuery, PingQueryQueryVariables>(PingQueryDocument, options);
      }
export function usePingQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PingQueryQuery, PingQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PingQueryQuery, PingQueryQueryVariables>(PingQueryDocument, options);
        }
export type PingQueryQueryHookResult = ReturnType<typeof usePingQueryQuery>;
export type PingQueryLazyQueryHookResult = ReturnType<typeof usePingQueryLazyQuery>;
export type PingQueryQueryResult = Apollo.QueryResult<PingQueryQuery, PingQueryQueryVariables>;
export const UserMutationDocument = gql`
    mutation userMutation($input: UpdateUser!) {
  updateUsers(input: $input) {
    ...UserFull
  }
}
    ${UserFullFragmentDoc}`;
export type UserMutationMutationFn = Apollo.MutationFunction<UserMutationMutation, UserMutationMutationVariables>;

/**
 * __useUserMutationMutation__
 *
 * To run a mutation, you first call `useUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userMutationMutation, { data, loading, error }] = useUserMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<UserMutationMutation, UserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserMutationMutation, UserMutationMutationVariables>(UserMutationDocument, options);
      }
export type UserMutationMutationHookResult = ReturnType<typeof useUserMutationMutation>;
export type UserMutationMutationResult = Apollo.MutationResult<UserMutationMutation>;
export type UserMutationMutationOptions = Apollo.BaseMutationOptions<UserMutationMutation, UserMutationMutationVariables>;
export const ChangeCompanyMutationDocument = gql`
    mutation changeCompanyMutation($contact: UpdateClientCompanyContactInput) {
  updateClientCompanyContact(input: $contact) {
    id
    ...ClientCompanyContactFull
  }
}
    ${ClientCompanyContactFullFragmentDoc}`;
export type ChangeCompanyMutationMutationFn = Apollo.MutationFunction<ChangeCompanyMutationMutation, ChangeCompanyMutationMutationVariables>;

/**
 * __useChangeCompanyMutationMutation__
 *
 * To run a mutation, you first call `useChangeCompanyMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeCompanyMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeCompanyMutationMutation, { data, loading, error }] = useChangeCompanyMutationMutation({
 *   variables: {
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useChangeCompanyMutationMutation(baseOptions?: Apollo.MutationHookOptions<ChangeCompanyMutationMutation, ChangeCompanyMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeCompanyMutationMutation, ChangeCompanyMutationMutationVariables>(ChangeCompanyMutationDocument, options);
      }
export type ChangeCompanyMutationMutationHookResult = ReturnType<typeof useChangeCompanyMutationMutation>;
export type ChangeCompanyMutationMutationResult = Apollo.MutationResult<ChangeCompanyMutationMutation>;
export type ChangeCompanyMutationMutationOptions = Apollo.BaseMutationOptions<ChangeCompanyMutationMutation, ChangeCompanyMutationMutationVariables>;
export const CompaniesMutationDocument = gql`
    mutation companiesMutation($input: UpdateClientCompany) {
  updateClientCompanies(input: $input) {
    ...ClientCompanyFull
  }
}
    ${ClientCompanyFullFragmentDoc}`;
export type CompaniesMutationMutationFn = Apollo.MutationFunction<CompaniesMutationMutation, CompaniesMutationMutationVariables>;

/**
 * __useCompaniesMutationMutation__
 *
 * To run a mutation, you first call `useCompaniesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompaniesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [companiesMutationMutation, { data, loading, error }] = useCompaniesMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompaniesMutationMutation(baseOptions?: Apollo.MutationHookOptions<CompaniesMutationMutation, CompaniesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompaniesMutationMutation, CompaniesMutationMutationVariables>(CompaniesMutationDocument, options);
      }
export type CompaniesMutationMutationHookResult = ReturnType<typeof useCompaniesMutationMutation>;
export type CompaniesMutationMutationResult = Apollo.MutationResult<CompaniesMutationMutation>;
export type CompaniesMutationMutationOptions = Apollo.BaseMutationOptions<CompaniesMutationMutation, CompaniesMutationMutationVariables>;
export const BoroughsMutationDocument = gql`
    mutation boroughsMutation($update: UpdateBorough) {
  updateBoroughs(input: $update) {
    ...BoroughFull
  }
}
    ${BoroughFullFragmentDoc}`;
export type BoroughsMutationMutationFn = Apollo.MutationFunction<BoroughsMutationMutation, BoroughsMutationMutationVariables>;

/**
 * __useBoroughsMutationMutation__
 *
 * To run a mutation, you first call `useBoroughsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBoroughsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [boroughsMutationMutation, { data, loading, error }] = useBoroughsMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useBoroughsMutationMutation(baseOptions?: Apollo.MutationHookOptions<BoroughsMutationMutation, BoroughsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BoroughsMutationMutation, BoroughsMutationMutationVariables>(BoroughsMutationDocument, options);
      }
export type BoroughsMutationMutationHookResult = ReturnType<typeof useBoroughsMutationMutation>;
export type BoroughsMutationMutationResult = Apollo.MutationResult<BoroughsMutationMutation>;
export type BoroughsMutationMutationOptions = Apollo.BaseMutationOptions<BoroughsMutationMutation, BoroughsMutationMutationVariables>;
export const ClientCompanyGroupsMutationDocument = gql`
    mutation clientCompanyGroupsMutation($update: UpdateClientCompanyGroup) {
  updateClientCompanyGroups(input: $update) {
    ...ClientCompanyGroupFull
  }
}
    ${ClientCompanyGroupFullFragmentDoc}`;
export type ClientCompanyGroupsMutationMutationFn = Apollo.MutationFunction<ClientCompanyGroupsMutationMutation, ClientCompanyGroupsMutationMutationVariables>;

/**
 * __useClientCompanyGroupsMutationMutation__
 *
 * To run a mutation, you first call `useClientCompanyGroupsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClientCompanyGroupsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clientCompanyGroupsMutationMutation, { data, loading, error }] = useClientCompanyGroupsMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useClientCompanyGroupsMutationMutation(baseOptions?: Apollo.MutationHookOptions<ClientCompanyGroupsMutationMutation, ClientCompanyGroupsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClientCompanyGroupsMutationMutation, ClientCompanyGroupsMutationMutationVariables>(ClientCompanyGroupsMutationDocument, options);
      }
export type ClientCompanyGroupsMutationMutationHookResult = ReturnType<typeof useClientCompanyGroupsMutationMutation>;
export type ClientCompanyGroupsMutationMutationResult = Apollo.MutationResult<ClientCompanyGroupsMutationMutation>;
export type ClientCompanyGroupsMutationMutationOptions = Apollo.BaseMutationOptions<ClientCompanyGroupsMutationMutation, ClientCompanyGroupsMutationMutationVariables>;
export const MediaTypesMutationDocument = gql`
    mutation mediaTypesMutation($update: UpdateMediaTypes) {
  updateMediaTypes(input: $update) {
    ...MediaTypeFull
  }
}
    ${MediaTypeFullFragmentDoc}`;
export type MediaTypesMutationMutationFn = Apollo.MutationFunction<MediaTypesMutationMutation, MediaTypesMutationMutationVariables>;

/**
 * __useMediaTypesMutationMutation__
 *
 * To run a mutation, you first call `useMediaTypesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMediaTypesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mediaTypesMutationMutation, { data, loading, error }] = useMediaTypesMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useMediaTypesMutationMutation(baseOptions?: Apollo.MutationHookOptions<MediaTypesMutationMutation, MediaTypesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MediaTypesMutationMutation, MediaTypesMutationMutationVariables>(MediaTypesMutationDocument, options);
      }
export type MediaTypesMutationMutationHookResult = ReturnType<typeof useMediaTypesMutationMutation>;
export type MediaTypesMutationMutationResult = Apollo.MutationResult<MediaTypesMutationMutation>;
export type MediaTypesMutationMutationOptions = Apollo.BaseMutationOptions<MediaTypesMutationMutation, MediaTypesMutationMutationVariables>;
export const UpdateClientCompanyContactDocument = gql`
    mutation updateClientCompanyContact($input: UpdateClientCompanyContactInput) {
  updateClientCompanyContact(input: $input) {
    ...ClientCompanyContactFull
  }
}
    ${ClientCompanyContactFullFragmentDoc}`;
export type UpdateClientCompanyContactMutationFn = Apollo.MutationFunction<UpdateClientCompanyContactMutation, UpdateClientCompanyContactMutationVariables>;

/**
 * __useUpdateClientCompanyContactMutation__
 *
 * To run a mutation, you first call `useUpdateClientCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCompanyContactMutation, { data, loading, error }] = useUpdateClientCompanyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCompanyContactMutation, UpdateClientCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCompanyContactMutation, UpdateClientCompanyContactMutationVariables>(UpdateClientCompanyContactDocument, options);
      }
export type UpdateClientCompanyContactMutationHookResult = ReturnType<typeof useUpdateClientCompanyContactMutation>;
export type UpdateClientCompanyContactMutationResult = Apollo.MutationResult<UpdateClientCompanyContactMutation>;
export type UpdateClientCompanyContactMutationOptions = Apollo.BaseMutationOptions<UpdateClientCompanyContactMutation, UpdateClientCompanyContactMutationVariables>;
export const CreateClientCompanyContactDocument = gql`
    mutation createClientCompanyContact($input: CreateClientCompanyContactInput) {
  createClientCompanyContact(input: $input) {
    ...ClientCompanyContactFull
  }
}
    ${ClientCompanyContactFullFragmentDoc}`;
export type CreateClientCompanyContactMutationFn = Apollo.MutationFunction<CreateClientCompanyContactMutation, CreateClientCompanyContactMutationVariables>;

/**
 * __useCreateClientCompanyContactMutation__
 *
 * To run a mutation, you first call `useCreateClientCompanyContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientCompanyContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientCompanyContactMutation, { data, loading, error }] = useCreateClientCompanyContactMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientCompanyContactMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientCompanyContactMutation, CreateClientCompanyContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientCompanyContactMutation, CreateClientCompanyContactMutationVariables>(CreateClientCompanyContactDocument, options);
      }
export type CreateClientCompanyContactMutationHookResult = ReturnType<typeof useCreateClientCompanyContactMutation>;
export type CreateClientCompanyContactMutationResult = Apollo.MutationResult<CreateClientCompanyContactMutation>;
export type CreateClientCompanyContactMutationOptions = Apollo.BaseMutationOptions<CreateClientCompanyContactMutation, CreateClientCompanyContactMutationVariables>;
export const ContactsMutationNewDocument = gql`
    mutation contactsMutationNew($input: UpdateClientCompanyContact) {
  updateClientCompanyContacts(input: $input) {
    ...ClientCompanyContactFull
  }
}
    ${ClientCompanyContactFullFragmentDoc}`;
export type ContactsMutationNewMutationFn = Apollo.MutationFunction<ContactsMutationNewMutation, ContactsMutationNewMutationVariables>;

/**
 * __useContactsMutationNewMutation__
 *
 * To run a mutation, you first call `useContactsMutationNewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactsMutationNewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactsMutationNewMutation, { data, loading, error }] = useContactsMutationNewMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactsMutationNewMutation(baseOptions?: Apollo.MutationHookOptions<ContactsMutationNewMutation, ContactsMutationNewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactsMutationNewMutation, ContactsMutationNewMutationVariables>(ContactsMutationNewDocument, options);
      }
export type ContactsMutationNewMutationHookResult = ReturnType<typeof useContactsMutationNewMutation>;
export type ContactsMutationNewMutationResult = Apollo.MutationResult<ContactsMutationNewMutation>;
export type ContactsMutationNewMutationOptions = Apollo.BaseMutationOptions<ContactsMutationNewMutation, ContactsMutationNewMutationVariables>;
export const ContactsMutationDocument = gql`
    mutation contactsMutation($input: UpdateClientCompanyContact) {
  updateClientCompanyContacts(input: $input) {
    ...ClientCompanyContactFull
  }
}
    ${ClientCompanyContactFullFragmentDoc}`;
export type ContactsMutationMutationFn = Apollo.MutationFunction<ContactsMutationMutation, ContactsMutationMutationVariables>;

/**
 * __useContactsMutationMutation__
 *
 * To run a mutation, you first call `useContactsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactsMutationMutation, { data, loading, error }] = useContactsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactsMutationMutation(baseOptions?: Apollo.MutationHookOptions<ContactsMutationMutation, ContactsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactsMutationMutation, ContactsMutationMutationVariables>(ContactsMutationDocument, options);
      }
export type ContactsMutationMutationHookResult = ReturnType<typeof useContactsMutationMutation>;
export type ContactsMutationMutationResult = Apollo.MutationResult<ContactsMutationMutation>;
export type ContactsMutationMutationOptions = Apollo.BaseMutationOptions<ContactsMutationMutation, ContactsMutationMutationVariables>;
export const PosterSizesMutationDocument = gql`
    mutation posterSizesMutation($update: UpdatePosterSize, $regions: [ID!]) {
  updatePosterSizes(input: $update) {
    ...PosterSizeFull
  }
}
    ${PosterSizeFullFragmentDoc}`;
export type PosterSizesMutationMutationFn = Apollo.MutationFunction<PosterSizesMutationMutation, PosterSizesMutationMutationVariables>;

/**
 * __usePosterSizesMutationMutation__
 *
 * To run a mutation, you first call `usePosterSizesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePosterSizesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [posterSizesMutationMutation, { data, loading, error }] = usePosterSizesMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *      regions: // value for 'regions'
 *   },
 * });
 */
export function usePosterSizesMutationMutation(baseOptions?: Apollo.MutationHookOptions<PosterSizesMutationMutation, PosterSizesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PosterSizesMutationMutation, PosterSizesMutationMutationVariables>(PosterSizesMutationDocument, options);
      }
export type PosterSizesMutationMutationHookResult = ReturnType<typeof usePosterSizesMutationMutation>;
export type PosterSizesMutationMutationResult = Apollo.MutationResult<PosterSizesMutationMutation>;
export type PosterSizesMutationMutationOptions = Apollo.BaseMutationOptions<PosterSizesMutationMutation, PosterSizesMutationMutationVariables>;
export const PacksMutationDocument = gql`
    mutation packsMutation($update: UpdatePacks) {
  updatePacks(input: $update) {
    ...PackFull
  }
}
    ${PackFullFragmentDoc}`;
export type PacksMutationMutationFn = Apollo.MutationFunction<PacksMutationMutation, PacksMutationMutationVariables>;

/**
 * __usePacksMutationMutation__
 *
 * To run a mutation, you first call `usePacksMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePacksMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packsMutationMutation, { data, loading, error }] = usePacksMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function usePacksMutationMutation(baseOptions?: Apollo.MutationHookOptions<PacksMutationMutation, PacksMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PacksMutationMutation, PacksMutationMutationVariables>(PacksMutationDocument, options);
      }
export type PacksMutationMutationHookResult = ReturnType<typeof usePacksMutationMutation>;
export type PacksMutationMutationResult = Apollo.MutationResult<PacksMutationMutation>;
export type PacksMutationMutationOptions = Apollo.BaseMutationOptions<PacksMutationMutation, PacksMutationMutationVariables>;
export const OptionsMutationDocument = gql`
    mutation optionsMutation($input: UpdateOptions) {
  updateOptions(input: $input) {
    ...OptionFull
  }
}
    ${OptionFullFragmentDoc}`;
export type OptionsMutationMutationFn = Apollo.MutationFunction<OptionsMutationMutation, OptionsMutationMutationVariables>;

/**
 * __useOptionsMutationMutation__
 *
 * To run a mutation, you first call `useOptionsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOptionsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [optionsMutationMutation, { data, loading, error }] = useOptionsMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOptionsMutationMutation(baseOptions?: Apollo.MutationHookOptions<OptionsMutationMutation, OptionsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OptionsMutationMutation, OptionsMutationMutationVariables>(OptionsMutationDocument, options);
      }
export type OptionsMutationMutationHookResult = ReturnType<typeof useOptionsMutationMutation>;
export type OptionsMutationMutationResult = Apollo.MutationResult<OptionsMutationMutation>;
export type OptionsMutationMutationOptions = Apollo.BaseMutationOptions<OptionsMutationMutation, OptionsMutationMutationVariables>;
export const CreatePanelBookingMutationDocument = gql`
    mutation createPanelBookingMutation($campaignId: ID, $weekNumber: Int, $numWeeks: Int, $panelId: ID, $isSlot: Boolean, $posterSizeId: ID, $status: String) {
  createPanelBooking(
    input: {campaignId: $campaignId, weekNumber: $weekNumber, numWeeks: $numWeeks, panelId: $panelId, isSlot: $isSlot, posterSizeId: $posterSizeId, status: $status}
  ) {
    ...PanelBookingDateSummaryFull
  }
}
    ${PanelBookingDateSummaryFullFragmentDoc}`;
export type CreatePanelBookingMutationMutationFn = Apollo.MutationFunction<CreatePanelBookingMutationMutation, CreatePanelBookingMutationMutationVariables>;

/**
 * __useCreatePanelBookingMutationMutation__
 *
 * To run a mutation, you first call `useCreatePanelBookingMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePanelBookingMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPanelBookingMutationMutation, { data, loading, error }] = useCreatePanelBookingMutationMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      weekNumber: // value for 'weekNumber'
 *      numWeeks: // value for 'numWeeks'
 *      panelId: // value for 'panelId'
 *      isSlot: // value for 'isSlot'
 *      posterSizeId: // value for 'posterSizeId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useCreatePanelBookingMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreatePanelBookingMutationMutation, CreatePanelBookingMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePanelBookingMutationMutation, CreatePanelBookingMutationMutationVariables>(CreatePanelBookingMutationDocument, options);
      }
export type CreatePanelBookingMutationMutationHookResult = ReturnType<typeof useCreatePanelBookingMutationMutation>;
export type CreatePanelBookingMutationMutationResult = Apollo.MutationResult<CreatePanelBookingMutationMutation>;
export type CreatePanelBookingMutationMutationOptions = Apollo.BaseMutationOptions<CreatePanelBookingMutationMutation, CreatePanelBookingMutationMutationVariables>;
export const SearchPanelsQueryDocument = gql`
    query searchPanelsQuery($region_in: [ID], $region_type_in: [ID], $site_name_like: String, $site_id: ID, $site_tags_in: [ID], $site_structure_in: [ID], $site_structure_like: String, $site_structure_group: [ID], $status_in: [String], $campaign_like: String, $pack_in: [ID], $pack_not: [ID], $panel_number: String, $distributor_in: [ID], $start_week: Int, $num_weeks: Int, $postcode_like: String, $postcode_rlike: String, $borough_in: [ID], $panel_search_type_s: String, $panel_search_type_w: ID, $frozen_as: String, $frozen_week: Int) {
  panelSearch(
    region: $region_in
    region_type: $region_type_in
    site_name: $site_name_like
    site_id: $site_id
    site_tags: $site_tags_in
    site_structure: $site_structure_in
    site_structure_like: $site_structure_like
    site_structure_group: $site_structure_group
    status: $status_in
    campaign_name: $campaign_like
    pack: $pack_in
    pack_not: $pack_not
    panel: $panel_number
    distributor: $distributor_in
    start_week: $start_week
    num_weeks: $num_weeks
    postcode: $postcode_like
    postcode_rlike: $postcode_rlike
    borough: $borough_in
    panel_search_type: $panel_search_type_s
    panel_search_type_weeks: $panel_search_type_w
    frozen_key: $frozen_as
    frozen_week: $frozen_week
  ) {
    id
    panel
    pack {
      id
      label
      style {
        id
        label
      }
    }
    number_of_slots
    site {
      id
      name
      address1
      address2
      postcode
      site_code
      boroughOrRegion
      thumbnail
      externalLink
      descriptionHTML
      is_dashboard_site
      distributor {
        id
        name
      }
      siteStructure {
        id
        name
      }
      style(trashed: WITH) {
        ...StyleFull
      }
    }
    id
    panelBookingDatesSummary {
      ...PanelBookingDateSummaryFull
    }
  }
}
    ${StyleFullFragmentDoc}
${PanelBookingDateSummaryFullFragmentDoc}`;

/**
 * __useSearchPanelsQueryQuery__
 *
 * To run a query within a React component, call `useSearchPanelsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPanelsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPanelsQueryQuery({
 *   variables: {
 *      region_in: // value for 'region_in'
 *      region_type_in: // value for 'region_type_in'
 *      site_name_like: // value for 'site_name_like'
 *      site_id: // value for 'site_id'
 *      site_tags_in: // value for 'site_tags_in'
 *      site_structure_in: // value for 'site_structure_in'
 *      site_structure_like: // value for 'site_structure_like'
 *      site_structure_group: // value for 'site_structure_group'
 *      status_in: // value for 'status_in'
 *      campaign_like: // value for 'campaign_like'
 *      pack_in: // value for 'pack_in'
 *      pack_not: // value for 'pack_not'
 *      panel_number: // value for 'panel_number'
 *      distributor_in: // value for 'distributor_in'
 *      start_week: // value for 'start_week'
 *      num_weeks: // value for 'num_weeks'
 *      postcode_like: // value for 'postcode_like'
 *      postcode_rlike: // value for 'postcode_rlike'
 *      borough_in: // value for 'borough_in'
 *      panel_search_type_s: // value for 'panel_search_type_s'
 *      panel_search_type_w: // value for 'panel_search_type_w'
 *      frozen_as: // value for 'frozen_as'
 *      frozen_week: // value for 'frozen_week'
 *   },
 * });
 */
export function useSearchPanelsQueryQuery(baseOptions?: Apollo.QueryHookOptions<SearchPanelsQueryQuery, SearchPanelsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPanelsQueryQuery, SearchPanelsQueryQueryVariables>(SearchPanelsQueryDocument, options);
      }
export function useSearchPanelsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPanelsQueryQuery, SearchPanelsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPanelsQueryQuery, SearchPanelsQueryQueryVariables>(SearchPanelsQueryDocument, options);
        }
export type SearchPanelsQueryQueryHookResult = ReturnType<typeof useSearchPanelsQueryQuery>;
export type SearchPanelsQueryLazyQueryHookResult = ReturnType<typeof useSearchPanelsQueryLazyQuery>;
export type SearchPanelsQueryQueryResult = Apollo.QueryResult<SearchPanelsQueryQuery, SearchPanelsQueryQueryVariables>;
export const GetSiteQueryDocument = gql`
    query getSiteQuery($id: ID, $site_code: String) {
  site(site_code: $site_code, id: $id) {
    ...SiteFull
  }
}
    ${SiteFullFragmentDoc}`;

/**
 * __useGetSiteQueryQuery__
 *
 * To run a query within a React component, call `useGetSiteQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *      site_code: // value for 'site_code'
 *   },
 * });
 */
export function useGetSiteQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetSiteQueryQuery, GetSiteQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteQueryQuery, GetSiteQueryQueryVariables>(GetSiteQueryDocument, options);
      }
export function useGetSiteQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteQueryQuery, GetSiteQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteQueryQuery, GetSiteQueryQueryVariables>(GetSiteQueryDocument, options);
        }
export type GetSiteQueryQueryHookResult = ReturnType<typeof useGetSiteQueryQuery>;
export type GetSiteQueryLazyQueryHookResult = ReturnType<typeof useGetSiteQueryLazyQuery>;
export type GetSiteQueryQueryResult = Apollo.QueryResult<GetSiteQueryQuery, GetSiteQueryQueryVariables>;
export const UpdateSiteMutationDocument = gql`
    mutation updateSiteMutation($input: UpdateSiteInput!) {
  updateSite(input: $input) {
    ...SiteFull
  }
}
    ${SiteFullFragmentDoc}`;
export type UpdateSiteMutationMutationFn = Apollo.MutationFunction<UpdateSiteMutationMutation, UpdateSiteMutationMutationVariables>;

/**
 * __useUpdateSiteMutationMutation__
 *
 * To run a mutation, you first call `useUpdateSiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteMutationMutation, { data, loading, error }] = useUpdateSiteMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteMutationMutation, UpdateSiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteMutationMutation, UpdateSiteMutationMutationVariables>(UpdateSiteMutationDocument, options);
      }
export type UpdateSiteMutationMutationHookResult = ReturnType<typeof useUpdateSiteMutationMutation>;
export type UpdateSiteMutationMutationResult = Apollo.MutationResult<UpdateSiteMutationMutation>;
export type UpdateSiteMutationMutationOptions = Apollo.BaseMutationOptions<UpdateSiteMutationMutation, UpdateSiteMutationMutationVariables>;
export const SiteMaintenanceInspectionTypesDocument = gql`
    query siteMaintenanceInspectionTypes {
  inspectionTypes {
    id
    label
  }
}
    `;

/**
 * __useSiteMaintenanceInspectionTypesQuery__
 *
 * To run a query within a React component, call `useSiteMaintenanceInspectionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteMaintenanceInspectionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteMaintenanceInspectionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteMaintenanceInspectionTypesQuery(baseOptions?: Apollo.QueryHookOptions<SiteMaintenanceInspectionTypesQuery, SiteMaintenanceInspectionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteMaintenanceInspectionTypesQuery, SiteMaintenanceInspectionTypesQueryVariables>(SiteMaintenanceInspectionTypesDocument, options);
      }
export function useSiteMaintenanceInspectionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteMaintenanceInspectionTypesQuery, SiteMaintenanceInspectionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteMaintenanceInspectionTypesQuery, SiteMaintenanceInspectionTypesQueryVariables>(SiteMaintenanceInspectionTypesDocument, options);
        }
export type SiteMaintenanceInspectionTypesQueryHookResult = ReturnType<typeof useSiteMaintenanceInspectionTypesQuery>;
export type SiteMaintenanceInspectionTypesLazyQueryHookResult = ReturnType<typeof useSiteMaintenanceInspectionTypesLazyQuery>;
export type SiteMaintenanceInspectionTypesQueryResult = Apollo.QueryResult<SiteMaintenanceInspectionTypesQuery, SiteMaintenanceInspectionTypesQueryVariables>;
export const CreateMaintenanceInspectionLogDocument = gql`
    mutation createMaintenanceInspectionLog($input: CreateMaintenanceInspectionInput!) {
  createMaintenanceInspectionLog(input: $input) {
    id
  }
}
    `;
export type CreateMaintenanceInspectionLogMutationFn = Apollo.MutationFunction<CreateMaintenanceInspectionLogMutation, CreateMaintenanceInspectionLogMutationVariables>;

/**
 * __useCreateMaintenanceInspectionLogMutation__
 *
 * To run a mutation, you first call `useCreateMaintenanceInspectionLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMaintenanceInspectionLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMaintenanceInspectionLogMutation, { data, loading, error }] = useCreateMaintenanceInspectionLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMaintenanceInspectionLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateMaintenanceInspectionLogMutation, CreateMaintenanceInspectionLogMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMaintenanceInspectionLogMutation, CreateMaintenanceInspectionLogMutationVariables>(CreateMaintenanceInspectionLogDocument, options);
      }
export type CreateMaintenanceInspectionLogMutationHookResult = ReturnType<typeof useCreateMaintenanceInspectionLogMutation>;
export type CreateMaintenanceInspectionLogMutationResult = Apollo.MutationResult<CreateMaintenanceInspectionLogMutation>;
export type CreateMaintenanceInspectionLogMutationOptions = Apollo.BaseMutationOptions<CreateMaintenanceInspectionLogMutation, CreateMaintenanceInspectionLogMutationVariables>;
export const CreateSiteMutationDocument = gql`
    mutation createSiteMutation($input: CreateSiteInput!) {
  createSite(input: $input) {
    ...SiteFull
  }
}
    ${SiteFullFragmentDoc}`;
export type CreateSiteMutationMutationFn = Apollo.MutationFunction<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>;

/**
 * __useCreateSiteMutationMutation__
 *
 * To run a mutation, you first call `useCreateSiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSiteMutationMutation, { data, loading, error }] = useCreateSiteMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>(CreateSiteMutationDocument, options);
      }
export type CreateSiteMutationMutationHookResult = ReturnType<typeof useCreateSiteMutationMutation>;
export type CreateSiteMutationMutationResult = Apollo.MutationResult<CreateSiteMutationMutation>;
export type CreateSiteMutationMutationOptions = Apollo.BaseMutationOptions<CreateSiteMutationMutation, CreateSiteMutationMutationVariables>;
export const CreateDigitalBookingDocument = gql`
    mutation createDigitalBooking($input: CreateDigitalBookingInput!) {
  createDigitalBookings(input: $input) {
    id
    days
    cost_type
    start_date
    end_date
  }
}
    `;
export type CreateDigitalBookingMutationFn = Apollo.MutationFunction<CreateDigitalBookingMutation, CreateDigitalBookingMutationVariables>;

/**
 * __useCreateDigitalBookingMutation__
 *
 * To run a mutation, you first call `useCreateDigitalBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDigitalBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDigitalBookingMutation, { data, loading, error }] = useCreateDigitalBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDigitalBookingMutation(baseOptions?: Apollo.MutationHookOptions<CreateDigitalBookingMutation, CreateDigitalBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDigitalBookingMutation, CreateDigitalBookingMutationVariables>(CreateDigitalBookingDocument, options);
      }
export type CreateDigitalBookingMutationHookResult = ReturnType<typeof useCreateDigitalBookingMutation>;
export type CreateDigitalBookingMutationResult = Apollo.MutationResult<CreateDigitalBookingMutation>;
export type CreateDigitalBookingMutationOptions = Apollo.BaseMutationOptions<CreateDigitalBookingMutation, CreateDigitalBookingMutationVariables>;
export const GetSiteDigitalBookingsDocument = gql`
    query GetSiteDigitalBookings($siteId: ID!) {
  getSiteDigitalBookings(site_id: $siteId) {
    id
    campaign {
      id
      status
    }
    site {
      id
      name
    }
    start_date
    end_date
    status
  }
}
    `;

/**
 * __useGetSiteDigitalBookingsQuery__
 *
 * To run a query within a React component, call `useGetSiteDigitalBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSiteDigitalBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSiteDigitalBookingsQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGetSiteDigitalBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetSiteDigitalBookingsQuery, GetSiteDigitalBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSiteDigitalBookingsQuery, GetSiteDigitalBookingsQueryVariables>(GetSiteDigitalBookingsDocument, options);
      }
export function useGetSiteDigitalBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSiteDigitalBookingsQuery, GetSiteDigitalBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSiteDigitalBookingsQuery, GetSiteDigitalBookingsQueryVariables>(GetSiteDigitalBookingsDocument, options);
        }
export type GetSiteDigitalBookingsQueryHookResult = ReturnType<typeof useGetSiteDigitalBookingsQuery>;
export type GetSiteDigitalBookingsLazyQueryHookResult = ReturnType<typeof useGetSiteDigitalBookingsLazyQuery>;
export type GetSiteDigitalBookingsQueryResult = Apollo.QueryResult<GetSiteDigitalBookingsQuery, GetSiteDigitalBookingsQueryVariables>;
export const GetCampaignDigitalBookingsDocument = gql`
    query GetCampaignDigitalBookings($campaignId: ID!) {
  getCampaignDigitalBookings(campaign_id: $campaignId) {
    id
    campaign {
      id
      job_reference
    }
    site {
      id
      name
    }
    start_date
    end_date
    status
  }
}
    `;

/**
 * __useGetCampaignDigitalBookingsQuery__
 *
 * To run a query within a React component, call `useGetCampaignDigitalBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDigitalBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDigitalBookingsQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignDigitalBookingsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignDigitalBookingsQuery, GetCampaignDigitalBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDigitalBookingsQuery, GetCampaignDigitalBookingsQueryVariables>(GetCampaignDigitalBookingsDocument, options);
      }
export function useGetCampaignDigitalBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDigitalBookingsQuery, GetCampaignDigitalBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDigitalBookingsQuery, GetCampaignDigitalBookingsQueryVariables>(GetCampaignDigitalBookingsDocument, options);
        }
export type GetCampaignDigitalBookingsQueryHookResult = ReturnType<typeof useGetCampaignDigitalBookingsQuery>;
export type GetCampaignDigitalBookingsLazyQueryHookResult = ReturnType<typeof useGetCampaignDigitalBookingsLazyQuery>;
export type GetCampaignDigitalBookingsQueryResult = Apollo.QueryResult<GetCampaignDigitalBookingsQuery, GetCampaignDigitalBookingsQueryVariables>;
export const SitesQueryDocument = gql`
    query sitesQuery($regionId_in: [ID], $region_type_in: [ID], $subletterId_in: [ID], $postcode_like: String, $postcode_rlike: String, $borough_in: [ID], $name_like: String, $structureId_in: [ID], $address1_like: String, $structureType_in: [ID], $tvArea_in: [ID], $status_in: [String], $pack_in: [ID], $m4_like: String, $frameId_in: [ID], $distributor_in: [ID], $site_code_like: String, $tags_in: [ID], $build_date_between: DateRange, $digital_search_default: Boolean) {
  sites(
    regionId: $regionId_in
    region_type_id: $region_type_in
    subletterId: $subletterId_in
    name: $name_like
    site_code: $site_code_like
    borough: $borough_in
    postcode: $postcode_like
    postcode_rlike: $postcode_rlike
    address1: $address1_like
    structureId: $structureId_in
    structureType: $structureType_in
    tvArea: $tvArea_in
    pack: $pack_in
    m4: $m4_like
    frameId: $frameId_in
    status: $status_in
    distributor: $distributor_in
    tags: $tags_in
    build_date_between: $build_date_between
    digital_search_default: $digital_search_default
  ) {
    name
    id
    numPanels
    region {
      id
      name
    }
    borough {
      id
      label
    }
    postcode
    site_code
    siteStructure {
      id
      name
    }
    siteStructureType {
      id
      name
    }
    subletter {
      id
      name
    }
    distributor {
      id
      name
    }
    sitePricing {
      id
      label
      panel
      currency {
        ...CurrencyFull
      }
    }
    rental
    rates
    rental_start
    rental_end
    externalThumbnail
    latitude
    longitude
    three_words
    externalLink
  }
}
    ${CurrencyFullFragmentDoc}`;

/**
 * __useSitesQueryQuery__
 *
 * To run a query within a React component, call `useSitesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesQueryQuery({
 *   variables: {
 *      regionId_in: // value for 'regionId_in'
 *      region_type_in: // value for 'region_type_in'
 *      subletterId_in: // value for 'subletterId_in'
 *      postcode_like: // value for 'postcode_like'
 *      postcode_rlike: // value for 'postcode_rlike'
 *      borough_in: // value for 'borough_in'
 *      name_like: // value for 'name_like'
 *      structureId_in: // value for 'structureId_in'
 *      address1_like: // value for 'address1_like'
 *      structureType_in: // value for 'structureType_in'
 *      tvArea_in: // value for 'tvArea_in'
 *      status_in: // value for 'status_in'
 *      pack_in: // value for 'pack_in'
 *      m4_like: // value for 'm4_like'
 *      frameId_in: // value for 'frameId_in'
 *      distributor_in: // value for 'distributor_in'
 *      site_code_like: // value for 'site_code_like'
 *      tags_in: // value for 'tags_in'
 *      build_date_between: // value for 'build_date_between'
 *      digital_search_default: // value for 'digital_search_default'
 *   },
 * });
 */
export function useSitesQueryQuery(baseOptions?: Apollo.QueryHookOptions<SitesQueryQuery, SitesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesQueryQuery, SitesQueryQueryVariables>(SitesQueryDocument, options);
      }
export function useSitesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesQueryQuery, SitesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesQueryQuery, SitesQueryQueryVariables>(SitesQueryDocument, options);
        }
export type SitesQueryQueryHookResult = ReturnType<typeof useSitesQueryQuery>;
export type SitesQueryLazyQueryHookResult = ReturnType<typeof useSitesQueryLazyQuery>;
export type SitesQueryQueryResult = Apollo.QueryResult<SitesQueryQuery, SitesQueryQueryVariables>;
export const SitesQueryShortDocument = gql`
    query sitesQueryShort {
  sites {
    name
    id
  }
}
    `;

/**
 * __useSitesQueryShortQuery__
 *
 * To run a query within a React component, call `useSitesQueryShortQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitesQueryShortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitesQueryShortQuery({
 *   variables: {
 *   },
 * });
 */
export function useSitesQueryShortQuery(baseOptions?: Apollo.QueryHookOptions<SitesQueryShortQuery, SitesQueryShortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitesQueryShortQuery, SitesQueryShortQueryVariables>(SitesQueryShortDocument, options);
      }
export function useSitesQueryShortLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitesQueryShortQuery, SitesQueryShortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitesQueryShortQuery, SitesQueryShortQueryVariables>(SitesQueryShortDocument, options);
        }
export type SitesQueryShortQueryHookResult = ReturnType<typeof useSitesQueryShortQuery>;
export type SitesQueryShortLazyQueryHookResult = ReturnType<typeof useSitesQueryShortLazyQuery>;
export type SitesQueryShortQueryResult = Apollo.QueryResult<SitesQueryShortQuery, SitesQueryShortQueryVariables>;
export const MaintenanceInspectionSitesQueryDocument = gql`
    query maintenanceInspectionSitesQuery($regionId_in: [ID!]) {
  sites(maintenance_inspection_region_id: $regionId_in) {
    id
    name
    siteStructure {
      id
      name
    }
  }
}
    `;

/**
 * __useMaintenanceInspectionSitesQueryQuery__
 *
 * To run a query within a React component, call `useMaintenanceInspectionSitesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMaintenanceInspectionSitesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMaintenanceInspectionSitesQueryQuery({
 *   variables: {
 *      regionId_in: // value for 'regionId_in'
 *   },
 * });
 */
export function useMaintenanceInspectionSitesQueryQuery(baseOptions?: Apollo.QueryHookOptions<MaintenanceInspectionSitesQueryQuery, MaintenanceInspectionSitesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MaintenanceInspectionSitesQueryQuery, MaintenanceInspectionSitesQueryQueryVariables>(MaintenanceInspectionSitesQueryDocument, options);
      }
export function useMaintenanceInspectionSitesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MaintenanceInspectionSitesQueryQuery, MaintenanceInspectionSitesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MaintenanceInspectionSitesQueryQuery, MaintenanceInspectionSitesQueryQueryVariables>(MaintenanceInspectionSitesQueryDocument, options);
        }
export type MaintenanceInspectionSitesQueryQueryHookResult = ReturnType<typeof useMaintenanceInspectionSitesQueryQuery>;
export type MaintenanceInspectionSitesQueryLazyQueryHookResult = ReturnType<typeof useMaintenanceInspectionSitesQueryLazyQuery>;
export type MaintenanceInspectionSitesQueryQueryResult = Apollo.QueryResult<MaintenanceInspectionSitesQueryQuery, MaintenanceInspectionSitesQueryQueryVariables>;
export const QuantitiesReportDocument = gql`
    mutation quantitiesReport($dateFrom: String, $dateTo: String) {
  quantitiesReport(dateFrom: $dateFrom, dateTo: $dateTo) {
    reportData
  }
}
    `;
export type QuantitiesReportMutationFn = Apollo.MutationFunction<QuantitiesReportMutation, QuantitiesReportMutationVariables>;

/**
 * __useQuantitiesReportMutation__
 *
 * To run a mutation, you first call `useQuantitiesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQuantitiesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [quantitiesReportMutation, { data, loading, error }] = useQuantitiesReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useQuantitiesReportMutation(baseOptions?: Apollo.MutationHookOptions<QuantitiesReportMutation, QuantitiesReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<QuantitiesReportMutation, QuantitiesReportMutationVariables>(QuantitiesReportDocument, options);
      }
export type QuantitiesReportMutationHookResult = ReturnType<typeof useQuantitiesReportMutation>;
export type QuantitiesReportMutationResult = Apollo.MutationResult<QuantitiesReportMutation>;
export type QuantitiesReportMutationOptions = Apollo.BaseMutationOptions<QuantitiesReportMutation, QuantitiesReportMutationVariables>;
export const ProPhotosReportAreaBookingDocument = gql`
    mutation proPhotosReportAreaBooking($dateFrom: String, $dateTo: String) {
  proPhotosReportAreaBooking(dateFrom: $dateFrom, dateTo: $dateTo) {
    reportData
  }
}
    `;
export type ProPhotosReportAreaBookingMutationFn = Apollo.MutationFunction<ProPhotosReportAreaBookingMutation, ProPhotosReportAreaBookingMutationVariables>;

/**
 * __useProPhotosReportAreaBookingMutation__
 *
 * To run a mutation, you first call `useProPhotosReportAreaBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProPhotosReportAreaBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proPhotosReportAreaBookingMutation, { data, loading, error }] = useProPhotosReportAreaBookingMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useProPhotosReportAreaBookingMutation(baseOptions?: Apollo.MutationHookOptions<ProPhotosReportAreaBookingMutation, ProPhotosReportAreaBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProPhotosReportAreaBookingMutation, ProPhotosReportAreaBookingMutationVariables>(ProPhotosReportAreaBookingDocument, options);
      }
export type ProPhotosReportAreaBookingMutationHookResult = ReturnType<typeof useProPhotosReportAreaBookingMutation>;
export type ProPhotosReportAreaBookingMutationResult = Apollo.MutationResult<ProPhotosReportAreaBookingMutation>;
export type ProPhotosReportAreaBookingMutationOptions = Apollo.BaseMutationOptions<ProPhotosReportAreaBookingMutation, ProPhotosReportAreaBookingMutationVariables>;
export const ProPhotosReportDocument = gql`
    mutation proPhotosReport($dateFrom: String) {
  proPhotosReport(dateFrom: $dateFrom) {
    reportData
  }
}
    `;
export type ProPhotosReportMutationFn = Apollo.MutationFunction<ProPhotosReportMutation, ProPhotosReportMutationVariables>;

/**
 * __useProPhotosReportMutation__
 *
 * To run a mutation, you first call `useProPhotosReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProPhotosReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proPhotosReportMutation, { data, loading, error }] = useProPhotosReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *   },
 * });
 */
export function useProPhotosReportMutation(baseOptions?: Apollo.MutationHookOptions<ProPhotosReportMutation, ProPhotosReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProPhotosReportMutation, ProPhotosReportMutationVariables>(ProPhotosReportDocument, options);
      }
export type ProPhotosReportMutationHookResult = ReturnType<typeof useProPhotosReportMutation>;
export type ProPhotosReportMutationResult = Apollo.MutationResult<ProPhotosReportMutation>;
export type ProPhotosReportMutationOptions = Apollo.BaseMutationOptions<ProPhotosReportMutation, ProPhotosReportMutationVariables>;
export const ProPhotosReportDigitalDocument = gql`
    mutation proPhotosReportDigital($dateFrom: String) {
  proPhotosReportDigital(dateFrom: $dateFrom) {
    reportData
  }
}
    `;
export type ProPhotosReportDigitalMutationFn = Apollo.MutationFunction<ProPhotosReportDigitalMutation, ProPhotosReportDigitalMutationVariables>;

/**
 * __useProPhotosReportDigitalMutation__
 *
 * To run a mutation, you first call `useProPhotosReportDigitalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProPhotosReportDigitalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [proPhotosReportDigitalMutation, { data, loading, error }] = useProPhotosReportDigitalMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *   },
 * });
 */
export function useProPhotosReportDigitalMutation(baseOptions?: Apollo.MutationHookOptions<ProPhotosReportDigitalMutation, ProPhotosReportDigitalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ProPhotosReportDigitalMutation, ProPhotosReportDigitalMutationVariables>(ProPhotosReportDigitalDocument, options);
      }
export type ProPhotosReportDigitalMutationHookResult = ReturnType<typeof useProPhotosReportDigitalMutation>;
export type ProPhotosReportDigitalMutationResult = Apollo.MutationResult<ProPhotosReportDigitalMutation>;
export type ProPhotosReportDigitalMutationOptions = Apollo.BaseMutationOptions<ProPhotosReportDigitalMutation, ProPhotosReportDigitalMutationVariables>;
export const MailChimpReportDocument = gql`
    mutation mailChimpReport {
  mailChimpReport {
    reportData
  }
}
    `;
export type MailChimpReportMutationFn = Apollo.MutationFunction<MailChimpReportMutation, MailChimpReportMutationVariables>;

/**
 * __useMailChimpReportMutation__
 *
 * To run a mutation, you first call `useMailChimpReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMailChimpReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mailChimpReportMutation, { data, loading, error }] = useMailChimpReportMutation({
 *   variables: {
 *   },
 * });
 */
export function useMailChimpReportMutation(baseOptions?: Apollo.MutationHookOptions<MailChimpReportMutation, MailChimpReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MailChimpReportMutation, MailChimpReportMutationVariables>(MailChimpReportDocument, options);
      }
export type MailChimpReportMutationHookResult = ReturnType<typeof useMailChimpReportMutation>;
export type MailChimpReportMutationResult = Apollo.MutationResult<MailChimpReportMutation>;
export type MailChimpReportMutationOptions = Apollo.BaseMutationOptions<MailChimpReportMutation, MailChimpReportMutationVariables>;
export const RegionalRevenueReportDocument = gql`
    mutation regionalRevenueReport($dateFrom: String, $dateTo: String, $status_in: [String], $salesTeam_in: [ID], $includeQuoteCurrency: Boolean, $includeClientType: Boolean) {
  regionalRevenueReport(
    dateFrom: $dateFrom
    dateTo: $dateTo
    status_in: $status_in
    salesTeam_in: $salesTeam_in
    includeClientType: $includeClientType
    includeQuoteCurrency: $includeQuoteCurrency
  ) {
    reportData
  }
}
    `;
export type RegionalRevenueReportMutationFn = Apollo.MutationFunction<RegionalRevenueReportMutation, RegionalRevenueReportMutationVariables>;

/**
 * __useRegionalRevenueReportMutation__
 *
 * To run a mutation, you first call `useRegionalRevenueReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegionalRevenueReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regionalRevenueReportMutation, { data, loading, error }] = useRegionalRevenueReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      status_in: // value for 'status_in'
 *      salesTeam_in: // value for 'salesTeam_in'
 *      includeQuoteCurrency: // value for 'includeQuoteCurrency'
 *      includeClientType: // value for 'includeClientType'
 *   },
 * });
 */
export function useRegionalRevenueReportMutation(baseOptions?: Apollo.MutationHookOptions<RegionalRevenueReportMutation, RegionalRevenueReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegionalRevenueReportMutation, RegionalRevenueReportMutationVariables>(RegionalRevenueReportDocument, options);
      }
export type RegionalRevenueReportMutationHookResult = ReturnType<typeof useRegionalRevenueReportMutation>;
export type RegionalRevenueReportMutationResult = Apollo.MutationResult<RegionalRevenueReportMutation>;
export type RegionalRevenueReportMutationOptions = Apollo.BaseMutationOptions<RegionalRevenueReportMutation, RegionalRevenueReportMutationVariables>;
export const SiteRevenueReportDocument = gql`
    mutation siteRevenueReport($dateFrom: String, $dateTo: String, $selectedIds: [ID!]) {
  siteRevenueReport(
    dateFrom: $dateFrom
    dateTo: $dateTo
    selectedIds: $selectedIds
  ) {
    reportData
  }
}
    `;
export type SiteRevenueReportMutationFn = Apollo.MutationFunction<SiteRevenueReportMutation, SiteRevenueReportMutationVariables>;

/**
 * __useSiteRevenueReportMutation__
 *
 * To run a mutation, you first call `useSiteRevenueReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteRevenueReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteRevenueReportMutation, { data, loading, error }] = useSiteRevenueReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      selectedIds: // value for 'selectedIds'
 *   },
 * });
 */
export function useSiteRevenueReportMutation(baseOptions?: Apollo.MutationHookOptions<SiteRevenueReportMutation, SiteRevenueReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteRevenueReportMutation, SiteRevenueReportMutationVariables>(SiteRevenueReportDocument, options);
      }
export type SiteRevenueReportMutationHookResult = ReturnType<typeof useSiteRevenueReportMutation>;
export type SiteRevenueReportMutationResult = Apollo.MutationResult<SiteRevenueReportMutation>;
export type SiteRevenueReportMutationOptions = Apollo.BaseMutationOptions<SiteRevenueReportMutation, SiteRevenueReportMutationVariables>;
export const SiteMaintenanceReportDocument = gql`
    mutation siteMaintenanceReport($dateFrom: String, $dateTo: String, $selectedIds: [ID!]) {
  siteMaintenanceReport(
    dateFrom: $dateFrom
    dateTo: $dateTo
    selectedIds: $selectedIds
  ) {
    reportData
  }
}
    `;
export type SiteMaintenanceReportMutationFn = Apollo.MutationFunction<SiteMaintenanceReportMutation, SiteMaintenanceReportMutationVariables>;

/**
 * __useSiteMaintenanceReportMutation__
 *
 * To run a mutation, you first call `useSiteMaintenanceReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteMaintenanceReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteMaintenanceReportMutation, { data, loading, error }] = useSiteMaintenanceReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      selectedIds: // value for 'selectedIds'
 *   },
 * });
 */
export function useSiteMaintenanceReportMutation(baseOptions?: Apollo.MutationHookOptions<SiteMaintenanceReportMutation, SiteMaintenanceReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteMaintenanceReportMutation, SiteMaintenanceReportMutationVariables>(SiteMaintenanceReportDocument, options);
      }
export type SiteMaintenanceReportMutationHookResult = ReturnType<typeof useSiteMaintenanceReportMutation>;
export type SiteMaintenanceReportMutationResult = Apollo.MutationResult<SiteMaintenanceReportMutation>;
export type SiteMaintenanceReportMutationOptions = Apollo.BaseMutationOptions<SiteMaintenanceReportMutation, SiteMaintenanceReportMutationVariables>;
export const SiteStatusReportDocument = gql`
    mutation siteStatusReport($dateFrom: String, $dateTo: String, $selectedIds: [ID!]) {
  siteStatusReport(
    dateFrom: $dateFrom
    dateTo: $dateTo
    selectedIds: $selectedIds
  ) {
    reportData
  }
}
    `;
export type SiteStatusReportMutationFn = Apollo.MutationFunction<SiteStatusReportMutation, SiteStatusReportMutationVariables>;

/**
 * __useSiteStatusReportMutation__
 *
 * To run a mutation, you first call `useSiteStatusReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteStatusReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteStatusReportMutation, { data, loading, error }] = useSiteStatusReportMutation({
 *   variables: {
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      selectedIds: // value for 'selectedIds'
 *   },
 * });
 */
export function useSiteStatusReportMutation(baseOptions?: Apollo.MutationHookOptions<SiteStatusReportMutation, SiteStatusReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteStatusReportMutation, SiteStatusReportMutationVariables>(SiteStatusReportDocument, options);
      }
export type SiteStatusReportMutationHookResult = ReturnType<typeof useSiteStatusReportMutation>;
export type SiteStatusReportMutationResult = Apollo.MutationResult<SiteStatusReportMutation>;
export type SiteStatusReportMutationOptions = Apollo.BaseMutationOptions<SiteStatusReportMutation, SiteStatusReportMutationVariables>;
export const SiteHsReportDocument = gql`
    mutation siteHSReport($selectedIds: [ID!]) {
  siteHSReport(selectedIds: $selectedIds) {
    reportData
  }
}
    `;
export type SiteHsReportMutationFn = Apollo.MutationFunction<SiteHsReportMutation, SiteHsReportMutationVariables>;

/**
 * __useSiteHsReportMutation__
 *
 * To run a mutation, you first call `useSiteHsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteHsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteHsReportMutation, { data, loading, error }] = useSiteHsReportMutation({
 *   variables: {
 *      selectedIds: // value for 'selectedIds'
 *   },
 * });
 */
export function useSiteHsReportMutation(baseOptions?: Apollo.MutationHookOptions<SiteHsReportMutation, SiteHsReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteHsReportMutation, SiteHsReportMutationVariables>(SiteHsReportDocument, options);
      }
export type SiteHsReportMutationHookResult = ReturnType<typeof useSiteHsReportMutation>;
export type SiteHsReportMutationResult = Apollo.MutationResult<SiteHsReportMutation>;
export type SiteHsReportMutationOptions = Apollo.BaseMutationOptions<SiteHsReportMutation, SiteHsReportMutationVariables>;
export const SiteMainExportReportDocument = gql`
    mutation siteMainExportReport($selectedIds: [ID!]) {
  siteMainExportReport(selectedIds: $selectedIds) {
    reportData
  }
}
    `;
export type SiteMainExportReportMutationFn = Apollo.MutationFunction<SiteMainExportReportMutation, SiteMainExportReportMutationVariables>;

/**
 * __useSiteMainExportReportMutation__
 *
 * To run a mutation, you first call `useSiteMainExportReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteMainExportReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteMainExportReportMutation, { data, loading, error }] = useSiteMainExportReportMutation({
 *   variables: {
 *      selectedIds: // value for 'selectedIds'
 *   },
 * });
 */
export function useSiteMainExportReportMutation(baseOptions?: Apollo.MutationHookOptions<SiteMainExportReportMutation, SiteMainExportReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteMainExportReportMutation, SiteMainExportReportMutationVariables>(SiteMainExportReportDocument, options);
      }
export type SiteMainExportReportMutationHookResult = ReturnType<typeof useSiteMainExportReportMutation>;
export type SiteMainExportReportMutationResult = Apollo.MutationResult<SiteMainExportReportMutation>;
export type SiteMainExportReportMutationOptions = Apollo.BaseMutationOptions<SiteMainExportReportMutation, SiteMainExportReportMutationVariables>;
export const CampaignCostsReportDocument = gql`
    mutation campaignCostsReport($ids: [ID!]) {
  campaignCostsReport(ids: $ids) {
    reportData
  }
}
    `;
export type CampaignCostsReportMutationFn = Apollo.MutationFunction<CampaignCostsReportMutation, CampaignCostsReportMutationVariables>;

/**
 * __useCampaignCostsReportMutation__
 *
 * To run a mutation, you first call `useCampaignCostsReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCostsReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCostsReportMutation, { data, loading, error }] = useCampaignCostsReportMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCampaignCostsReportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCostsReportMutation, CampaignCostsReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCostsReportMutation, CampaignCostsReportMutationVariables>(CampaignCostsReportDocument, options);
      }
export type CampaignCostsReportMutationHookResult = ReturnType<typeof useCampaignCostsReportMutation>;
export type CampaignCostsReportMutationResult = Apollo.MutationResult<CampaignCostsReportMutation>;
export type CampaignCostsReportMutationOptions = Apollo.BaseMutationOptions<CampaignCostsReportMutation, CampaignCostsReportMutationVariables>;
export const CampaignCreativeReportDocument = gql`
    mutation campaignCreativeReport($ids: [ID!]) {
  campaignCreativeReport(ids: $ids) {
    reportData
  }
}
    `;
export type CampaignCreativeReportMutationFn = Apollo.MutationFunction<CampaignCreativeReportMutation, CampaignCreativeReportMutationVariables>;

/**
 * __useCampaignCreativeReportMutation__
 *
 * To run a mutation, you first call `useCampaignCreativeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignCreativeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignCreativeReportMutation, { data, loading, error }] = useCampaignCreativeReportMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCampaignCreativeReportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignCreativeReportMutation, CampaignCreativeReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignCreativeReportMutation, CampaignCreativeReportMutationVariables>(CampaignCreativeReportDocument, options);
      }
export type CampaignCreativeReportMutationHookResult = ReturnType<typeof useCampaignCreativeReportMutation>;
export type CampaignCreativeReportMutationResult = Apollo.MutationResult<CampaignCreativeReportMutation>;
export type CampaignCreativeReportMutationOptions = Apollo.BaseMutationOptions<CampaignCreativeReportMutation, CampaignCreativeReportMutationVariables>;
export const CampaignDigitalReportDocument = gql`
    mutation campaignDigitalReport($ids: [ID!]) {
  campaignDigitalReport(ids: $ids) {
    reportData
  }
}
    `;
export type CampaignDigitalReportMutationFn = Apollo.MutationFunction<CampaignDigitalReportMutation, CampaignDigitalReportMutationVariables>;

/**
 * __useCampaignDigitalReportMutation__
 *
 * To run a mutation, you first call `useCampaignDigitalReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDigitalReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDigitalReportMutation, { data, loading, error }] = useCampaignDigitalReportMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCampaignDigitalReportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDigitalReportMutation, CampaignDigitalReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDigitalReportMutation, CampaignDigitalReportMutationVariables>(CampaignDigitalReportDocument, options);
      }
export type CampaignDigitalReportMutationHookResult = ReturnType<typeof useCampaignDigitalReportMutation>;
export type CampaignDigitalReportMutationResult = Apollo.MutationResult<CampaignDigitalReportMutation>;
export type CampaignDigitalReportMutationOptions = Apollo.BaseMutationOptions<CampaignDigitalReportMutation, CampaignDigitalReportMutationVariables>;
export const CampaignAreaBookingReportDocument = gql`
    mutation campaignAreaBookingReport($ids: [ID!]) {
  campaignAreaBookingReport(ids: $ids) {
    reportData
  }
}
    `;
export type CampaignAreaBookingReportMutationFn = Apollo.MutationFunction<CampaignAreaBookingReportMutation, CampaignAreaBookingReportMutationVariables>;

/**
 * __useCampaignAreaBookingReportMutation__
 *
 * To run a mutation, you first call `useCampaignAreaBookingReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignAreaBookingReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignAreaBookingReportMutation, { data, loading, error }] = useCampaignAreaBookingReportMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCampaignAreaBookingReportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignAreaBookingReportMutation, CampaignAreaBookingReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignAreaBookingReportMutation, CampaignAreaBookingReportMutationVariables>(CampaignAreaBookingReportDocument, options);
      }
export type CampaignAreaBookingReportMutationHookResult = ReturnType<typeof useCampaignAreaBookingReportMutation>;
export type CampaignAreaBookingReportMutationResult = Apollo.MutationResult<CampaignAreaBookingReportMutation>;
export type CampaignAreaBookingReportMutationOptions = Apollo.BaseMutationOptions<CampaignAreaBookingReportMutation, CampaignAreaBookingReportMutationVariables>;
export const CampaignSundriesReportDocument = gql`
    mutation campaignSundriesReport($ids: [ID!]) {
  campaignSundriesReport(ids: $ids) {
    reportData
  }
}
    `;
export type CampaignSundriesReportMutationFn = Apollo.MutationFunction<CampaignSundriesReportMutation, CampaignSundriesReportMutationVariables>;

/**
 * __useCampaignSundriesReportMutation__
 *
 * To run a mutation, you first call `useCampaignSundriesReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignSundriesReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignSundriesReportMutation, { data, loading, error }] = useCampaignSundriesReportMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCampaignSundriesReportMutation(baseOptions?: Apollo.MutationHookOptions<CampaignSundriesReportMutation, CampaignSundriesReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignSundriesReportMutation, CampaignSundriesReportMutationVariables>(CampaignSundriesReportDocument, options);
      }
export type CampaignSundriesReportMutationHookResult = ReturnType<typeof useCampaignSundriesReportMutation>;
export type CampaignSundriesReportMutationResult = Apollo.MutationResult<CampaignSundriesReportMutation>;
export type CampaignSundriesReportMutationOptions = Apollo.BaseMutationOptions<CampaignSundriesReportMutation, CampaignSundriesReportMutationVariables>;
export const JobListReportDocument = gql`
    mutation jobListReport($date: String, $special_announcement: String, $distributor: ID, $ongoing: Boolean, $regions: [ID]) {
  jobListReport(
    date: $date
    special_announcement: $special_announcement
    distributor: $distributor
    ongoing: $ongoing
    regions: $regions
  ) {
    reportData
  }
}
    `;
export type JobListReportMutationFn = Apollo.MutationFunction<JobListReportMutation, JobListReportMutationVariables>;

/**
 * __useJobListReportMutation__
 *
 * To run a mutation, you first call `useJobListReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobListReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobListReportMutation, { data, loading, error }] = useJobListReportMutation({
 *   variables: {
 *      date: // value for 'date'
 *      special_announcement: // value for 'special_announcement'
 *      distributor: // value for 'distributor'
 *      ongoing: // value for 'ongoing'
 *      regions: // value for 'regions'
 *   },
 * });
 */
export function useJobListReportMutation(baseOptions?: Apollo.MutationHookOptions<JobListReportMutation, JobListReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobListReportMutation, JobListReportMutationVariables>(JobListReportDocument, options);
      }
export type JobListReportMutationHookResult = ReturnType<typeof useJobListReportMutation>;
export type JobListReportMutationResult = Apollo.MutationResult<JobListReportMutation>;
export type JobListReportMutationOptions = Apollo.BaseMutationOptions<JobListReportMutation, JobListReportMutationVariables>;
export const JobSheetReportDocument = gql`
    mutation jobSheetReport($date: String, $regionId: ID, $distributorId: ID, $landscape: Boolean, $boroughs: [ID], $isNew: Boolean) {
  jobSheetReport(
    date: $date
    regionId: $regionId
    distributorId: $distributorId
    landscape: $landscape
    boroughs: $boroughs
    isNew: $isNew
  ) {
    reportData
  }
}
    `;
export type JobSheetReportMutationFn = Apollo.MutationFunction<JobSheetReportMutation, JobSheetReportMutationVariables>;

/**
 * __useJobSheetReportMutation__
 *
 * To run a mutation, you first call `useJobSheetReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJobSheetReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [jobSheetReportMutation, { data, loading, error }] = useJobSheetReportMutation({
 *   variables: {
 *      date: // value for 'date'
 *      regionId: // value for 'regionId'
 *      distributorId: // value for 'distributorId'
 *      landscape: // value for 'landscape'
 *      boroughs: // value for 'boroughs'
 *      isNew: // value for 'isNew'
 *   },
 * });
 */
export function useJobSheetReportMutation(baseOptions?: Apollo.MutationHookOptions<JobSheetReportMutation, JobSheetReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<JobSheetReportMutation, JobSheetReportMutationVariables>(JobSheetReportDocument, options);
      }
export type JobSheetReportMutationHookResult = ReturnType<typeof useJobSheetReportMutation>;
export type JobSheetReportMutationResult = Apollo.MutationResult<JobSheetReportMutation>;
export type JobSheetReportMutationOptions = Apollo.BaseMutationOptions<JobSheetReportMutation, JobSheetReportMutationVariables>;
export const SiteReportDocument = gql`
    mutation siteReport($siteId: ID) {
  siteReport(landscape: true, siteId: $siteId, hide_header_footer: true) {
    reportData
  }
}
    `;
export type SiteReportMutationFn = Apollo.MutationFunction<SiteReportMutation, SiteReportMutationVariables>;

/**
 * __useSiteReportMutation__
 *
 * To run a mutation, you first call `useSiteReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSiteReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [siteReportMutation, { data, loading, error }] = useSiteReportMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useSiteReportMutation(baseOptions?: Apollo.MutationHookOptions<SiteReportMutation, SiteReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SiteReportMutation, SiteReportMutationVariables>(SiteReportDocument, options);
      }
export type SiteReportMutationHookResult = ReturnType<typeof useSiteReportMutation>;
export type SiteReportMutationResult = Apollo.MutationResult<SiteReportMutation>;
export type SiteReportMutationOptions = Apollo.BaseMutationOptions<SiteReportMutation, SiteReportMutationVariables>;
export const GetAffectedBookingsDocument = gql`
    mutation getAffectedBookings($input: [AffectedPanelBookingsDateInput]) {
  affectedPanelBookings(input: $input) {
    id
    first_week
    last_week
    panel {
      site {
        name
      }
    }
    campaign {
      id
      name
      ourContact {
        id
        name
        email
      }
    }
  }
}
    `;
export type GetAffectedBookingsMutationFn = Apollo.MutationFunction<GetAffectedBookingsMutation, GetAffectedBookingsMutationVariables>;

/**
 * __useGetAffectedBookingsMutation__
 *
 * To run a mutation, you first call `useGetAffectedBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetAffectedBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getAffectedBookingsMutation, { data, loading, error }] = useGetAffectedBookingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAffectedBookingsMutation(baseOptions?: Apollo.MutationHookOptions<GetAffectedBookingsMutation, GetAffectedBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetAffectedBookingsMutation, GetAffectedBookingsMutationVariables>(GetAffectedBookingsDocument, options);
      }
export type GetAffectedBookingsMutationHookResult = ReturnType<typeof useGetAffectedBookingsMutation>;
export type GetAffectedBookingsMutationResult = Apollo.MutationResult<GetAffectedBookingsMutation>;
export type GetAffectedBookingsMutationOptions = Apollo.BaseMutationOptions<GetAffectedBookingsMutation, GetAffectedBookingsMutationVariables>;
export const PdfDownloadDocument = gql`
    mutation pdfDownload($host: String, $url: String, $outline: Boolean, $expectText: String) {
  pdfDownload(host: $host, url: $url, outline: $outline, expectText: $expectText) {
    data
  }
}
    `;
export type PdfDownloadMutationFn = Apollo.MutationFunction<PdfDownloadMutation, PdfDownloadMutationVariables>;

/**
 * __usePdfDownloadMutation__
 *
 * To run a mutation, you first call `usePdfDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePdfDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pdfDownloadMutation, { data, loading, error }] = usePdfDownloadMutation({
 *   variables: {
 *      host: // value for 'host'
 *      url: // value for 'url'
 *      outline: // value for 'outline'
 *      expectText: // value for 'expectText'
 *   },
 * });
 */
export function usePdfDownloadMutation(baseOptions?: Apollo.MutationHookOptions<PdfDownloadMutation, PdfDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PdfDownloadMutation, PdfDownloadMutationVariables>(PdfDownloadDocument, options);
      }
export type PdfDownloadMutationHookResult = ReturnType<typeof usePdfDownloadMutation>;
export type PdfDownloadMutationResult = Apollo.MutationResult<PdfDownloadMutation>;
export type PdfDownloadMutationOptions = Apollo.BaseMutationOptions<PdfDownloadMutation, PdfDownloadMutationVariables>;
export const DeletePanelBookingDocument = gql`
    mutation deletePanelBooking($id: ID!) {
  deletePanelBooking(id: $id) {
    ...PanelBookingDateSummaryFull
  }
}
    ${PanelBookingDateSummaryFullFragmentDoc}`;
export type DeletePanelBookingMutationFn = Apollo.MutationFunction<DeletePanelBookingMutation, DeletePanelBookingMutationVariables>;

/**
 * __useDeletePanelBookingMutation__
 *
 * To run a mutation, you first call `useDeletePanelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePanelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePanelBookingMutation, { data, loading, error }] = useDeletePanelBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePanelBookingMutation(baseOptions?: Apollo.MutationHookOptions<DeletePanelBookingMutation, DeletePanelBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePanelBookingMutation, DeletePanelBookingMutationVariables>(DeletePanelBookingDocument, options);
      }
export type DeletePanelBookingMutationHookResult = ReturnType<typeof useDeletePanelBookingMutation>;
export type DeletePanelBookingMutationResult = Apollo.MutationResult<DeletePanelBookingMutation>;
export type DeletePanelBookingMutationOptions = Apollo.BaseMutationOptions<DeletePanelBookingMutation, DeletePanelBookingMutationVariables>;
export const GetPanelBookingDatesDocument = gql`
    query getPanelBookingDates($panel_id: ID, $week_number: Int) {
  panel(id: $panel_id) {
    id
    site {
      id
      name
    }
  }
  panelBookingDates(first: 500, panel_id: $panel_id, week_number: $week_number) {
    data {
      id
      week_number
      panel_id
      priority
      hasPole
      panelBooking {
        id
        first_week
        last_week
        lastDate
        weeks
        status
        is_slot
        panel {
          id
          number_of_slots
        }
        posterSize {
          id
          name
        }
        campaign {
          id
          name
          job_reference
          status
          ourContact {
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPanelBookingDatesQuery__
 *
 * To run a query within a React component, call `useGetPanelBookingDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPanelBookingDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPanelBookingDatesQuery({
 *   variables: {
 *      panel_id: // value for 'panel_id'
 *      week_number: // value for 'week_number'
 *   },
 * });
 */
export function useGetPanelBookingDatesQuery(baseOptions?: Apollo.QueryHookOptions<GetPanelBookingDatesQuery, GetPanelBookingDatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPanelBookingDatesQuery, GetPanelBookingDatesQueryVariables>(GetPanelBookingDatesDocument, options);
      }
export function useGetPanelBookingDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPanelBookingDatesQuery, GetPanelBookingDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPanelBookingDatesQuery, GetPanelBookingDatesQueryVariables>(GetPanelBookingDatesDocument, options);
        }
export type GetPanelBookingDatesQueryHookResult = ReturnType<typeof useGetPanelBookingDatesQuery>;
export type GetPanelBookingDatesLazyQueryHookResult = ReturnType<typeof useGetPanelBookingDatesLazyQuery>;
export type GetPanelBookingDatesQueryResult = Apollo.QueryResult<GetPanelBookingDatesQuery, GetPanelBookingDatesQueryVariables>;
export const UpdatePanelBookingDateDocument = gql`
    mutation updatePanelBookingDate($id: ID, $increasePriority: Boolean) {
  updatePanelBookingDate(input: {id: $id, increasePriority: $increasePriority}) {
    ...PanelBookingDateSummaryFull
  }
}
    ${PanelBookingDateSummaryFullFragmentDoc}`;
export type UpdatePanelBookingDateMutationFn = Apollo.MutationFunction<UpdatePanelBookingDateMutation, UpdatePanelBookingDateMutationVariables>;

/**
 * __useUpdatePanelBookingDateMutation__
 *
 * To run a mutation, you first call `useUpdatePanelBookingDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePanelBookingDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePanelBookingDateMutation, { data, loading, error }] = useUpdatePanelBookingDateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      increasePriority: // value for 'increasePriority'
 *   },
 * });
 */
export function useUpdatePanelBookingDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePanelBookingDateMutation, UpdatePanelBookingDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePanelBookingDateMutation, UpdatePanelBookingDateMutationVariables>(UpdatePanelBookingDateDocument, options);
      }
export type UpdatePanelBookingDateMutationHookResult = ReturnType<typeof useUpdatePanelBookingDateMutation>;
export type UpdatePanelBookingDateMutationResult = Apollo.MutationResult<UpdatePanelBookingDateMutation>;
export type UpdatePanelBookingDateMutationOptions = Apollo.BaseMutationOptions<UpdatePanelBookingDateMutation, UpdatePanelBookingDateMutationVariables>;
export const ContractVersionsQueryDocument = gql`
    query contractVersionsQuery($campaignId: ID!, $after: String, $first: Int) {
  contractVersions(campaignId: $campaignId, after: $after, first: $first) {
    id
    occurredAt
    user {
      id
      name
    }
  }
}
    `;

/**
 * __useContractVersionsQueryQuery__
 *
 * To run a query within a React component, call `useContractVersionsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractVersionsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractVersionsQueryQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useContractVersionsQueryQuery(baseOptions: Apollo.QueryHookOptions<ContractVersionsQueryQuery, ContractVersionsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractVersionsQueryQuery, ContractVersionsQueryQueryVariables>(ContractVersionsQueryDocument, options);
      }
export function useContractVersionsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractVersionsQueryQuery, ContractVersionsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractVersionsQueryQuery, ContractVersionsQueryQueryVariables>(ContractVersionsQueryDocument, options);
        }
export type ContractVersionsQueryQueryHookResult = ReturnType<typeof useContractVersionsQueryQuery>;
export type ContractVersionsQueryLazyQueryHookResult = ReturnType<typeof useContractVersionsQueryLazyQuery>;
export type ContractVersionsQueryQueryResult = Apollo.QueryResult<ContractVersionsQueryQuery, ContractVersionsQueryQueryVariables>;
export const ContractVersionQueryDocument = gql`
    query contractVersionQuery($campaignId: ID!, $id: ID!) {
  contractVersion(campaignId: $campaignId, id: $id) {
    id
    occurredAt
    tree
    user {
      id
      name
    }
  }
}
    `;

/**
 * __useContractVersionQueryQuery__
 *
 * To run a query within a React component, call `useContractVersionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractVersionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractVersionQueryQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractVersionQueryQuery(baseOptions: Apollo.QueryHookOptions<ContractVersionQueryQuery, ContractVersionQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractVersionQueryQuery, ContractVersionQueryQueryVariables>(ContractVersionQueryDocument, options);
      }
export function useContractVersionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractVersionQueryQuery, ContractVersionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractVersionQueryQuery, ContractVersionQueryQueryVariables>(ContractVersionQueryDocument, options);
        }
export type ContractVersionQueryQueryHookResult = ReturnType<typeof useContractVersionQueryQuery>;
export type ContractVersionQueryLazyQueryHookResult = ReturnType<typeof useContractVersionQueryLazyQuery>;
export type ContractVersionQueryQueryResult = Apollo.QueryResult<ContractVersionQueryQuery, ContractVersionQueryQueryVariables>;
export const AmbientTypesMutationDocument = gql`
    mutation ambientTypesMutation($update: UpdateAmbientTypesInput) {
  updateAmbientTypes(input: $update) {
    ...AmbientTypeFull
  }
}
    ${AmbientTypeFullFragmentDoc}`;
export type AmbientTypesMutationMutationFn = Apollo.MutationFunction<AmbientTypesMutationMutation, AmbientTypesMutationMutationVariables>;

/**
 * __useAmbientTypesMutationMutation__
 *
 * To run a mutation, you first call `useAmbientTypesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAmbientTypesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ambientTypesMutationMutation, { data, loading, error }] = useAmbientTypesMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useAmbientTypesMutationMutation(baseOptions?: Apollo.MutationHookOptions<AmbientTypesMutationMutation, AmbientTypesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AmbientTypesMutationMutation, AmbientTypesMutationMutationVariables>(AmbientTypesMutationDocument, options);
      }
export type AmbientTypesMutationMutationHookResult = ReturnType<typeof useAmbientTypesMutationMutation>;
export type AmbientTypesMutationMutationResult = Apollo.MutationResult<AmbientTypesMutationMutation>;
export type AmbientTypesMutationMutationOptions = Apollo.BaseMutationOptions<AmbientTypesMutationMutation, AmbientTypesMutationMutationVariables>;
export const GetCampaignChallengeDocument = gql`
    query getCampaignChallenge($id: ID!) {
  getCampaignChallenge(id: $id) {
    id
    message
    status
    user {
      id
      name
    }
    campaign {
      job_reference
      name
      start_date
      ourContact {
        id
        email
        name
      }
    }
    bookingChallenges {
      id
      date_start
      date_end
      status
      sourcePanelBooking {
        id
      }
      targetCampaign {
        id
        job_reference
        name
        ourContact {
          id
          name
          proxyUser {
            id
            name
          }
        }
      }
      targetPanelBooking {
        id
        panel {
          id
          panel
          site {
            id
            name
          }
        }
        posterSize {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignChallengeQuery__
 *
 * To run a query within a React component, call `useGetCampaignChallengeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignChallengeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignChallengeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignChallengeQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignChallengeQuery, GetCampaignChallengeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignChallengeQuery, GetCampaignChallengeQueryVariables>(GetCampaignChallengeDocument, options);
      }
export function useGetCampaignChallengeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignChallengeQuery, GetCampaignChallengeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignChallengeQuery, GetCampaignChallengeQueryVariables>(GetCampaignChallengeDocument, options);
        }
export type GetCampaignChallengeQueryHookResult = ReturnType<typeof useGetCampaignChallengeQuery>;
export type GetCampaignChallengeLazyQueryHookResult = ReturnType<typeof useGetCampaignChallengeLazyQuery>;
export type GetCampaignChallengeQueryResult = Apollo.QueryResult<GetCampaignChallengeQuery, GetCampaignChallengeQueryVariables>;
export const RespondToCampaignChallengeDocument = gql`
    mutation respondToCampaignChallenge($input: RespondToChallengeInput!) {
  respondToCampaignChallenge(input: $input) {
    id
    message
    status
    campaign {
      job_reference
      name
      start_date
      ourContact {
        id
        name
      }
    }
    user {
      id
      name
    }
    bookingChallenges {
      id
      week_end
      week_start
      status
      sourcePanelBooking {
        id
      }
      targetPanelBooking {
        id
        campaign {
          ourContact {
            id
            name
          }
        }
        panel {
          id
          panel
          site {
            id
            name
          }
        }
        posterSize {
          id
          name
        }
      }
    }
  }
}
    `;
export type RespondToCampaignChallengeMutationFn = Apollo.MutationFunction<RespondToCampaignChallengeMutation, RespondToCampaignChallengeMutationVariables>;

/**
 * __useRespondToCampaignChallengeMutation__
 *
 * To run a mutation, you first call `useRespondToCampaignChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToCampaignChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToCampaignChallengeMutation, { data, loading, error }] = useRespondToCampaignChallengeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToCampaignChallengeMutation(baseOptions?: Apollo.MutationHookOptions<RespondToCampaignChallengeMutation, RespondToCampaignChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToCampaignChallengeMutation, RespondToCampaignChallengeMutationVariables>(RespondToCampaignChallengeDocument, options);
      }
export type RespondToCampaignChallengeMutationHookResult = ReturnType<typeof useRespondToCampaignChallengeMutation>;
export type RespondToCampaignChallengeMutationResult = Apollo.MutationResult<RespondToCampaignChallengeMutation>;
export type RespondToCampaignChallengeMutationOptions = Apollo.BaseMutationOptions<RespondToCampaignChallengeMutation, RespondToCampaignChallengeMutationVariables>;
export const CampaignChallengesDocument = gql`
    query campaignChallenges($user_id: ID!, $direction: String, $markViewed: Boolean) {
  campaignChallenges(
    user_id: $user_id
    markViewed: $markViewed
    direction: $direction
    orderBy: [{column: "id", order: DESC}]
  ) {
    ...campaignChallengeFull
  }
}
    ${CampaignChallengeFullFragmentDoc}`;

/**
 * __useCampaignChallengesQuery__
 *
 * To run a query within a React component, call `useCampaignChallengesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignChallengesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignChallengesQuery({
 *   variables: {
 *      user_id: // value for 'user_id'
 *      direction: // value for 'direction'
 *      markViewed: // value for 'markViewed'
 *   },
 * });
 */
export function useCampaignChallengesQuery(baseOptions: Apollo.QueryHookOptions<CampaignChallengesQuery, CampaignChallengesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignChallengesQuery, CampaignChallengesQueryVariables>(CampaignChallengesDocument, options);
      }
export function useCampaignChallengesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignChallengesQuery, CampaignChallengesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignChallengesQuery, CampaignChallengesQueryVariables>(CampaignChallengesDocument, options);
        }
export type CampaignChallengesQueryHookResult = ReturnType<typeof useCampaignChallengesQuery>;
export type CampaignChallengesLazyQueryHookResult = ReturnType<typeof useCampaignChallengesLazyQuery>;
export type CampaignChallengesQueryResult = Apollo.QueryResult<CampaignChallengesQuery, CampaignChallengesQueryVariables>;
export const UpdateCampaignChallengeDocument = gql`
    mutation updateCampaignChallenge($id: ID!, $hide: Boolean, $status: String, $cancelPanelBookings: [ID]) {
  updateCampaignChallenge(
    input: {id: $id, hide: $hide, status: $status, cancelPanelBookings: $cancelPanelBookings}
  ) {
    ...campaignChallengeFull
  }
}
    ${CampaignChallengeFullFragmentDoc}`;
export type UpdateCampaignChallengeMutationFn = Apollo.MutationFunction<UpdateCampaignChallengeMutation, UpdateCampaignChallengeMutationVariables>;

/**
 * __useUpdateCampaignChallengeMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignChallengeMutation, { data, loading, error }] = useUpdateCampaignChallengeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hide: // value for 'hide'
 *      status: // value for 'status'
 *      cancelPanelBookings: // value for 'cancelPanelBookings'
 *   },
 * });
 */
export function useUpdateCampaignChallengeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignChallengeMutation, UpdateCampaignChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignChallengeMutation, UpdateCampaignChallengeMutationVariables>(UpdateCampaignChallengeDocument, options);
      }
export type UpdateCampaignChallengeMutationHookResult = ReturnType<typeof useUpdateCampaignChallengeMutation>;
export type UpdateCampaignChallengeMutationResult = Apollo.MutationResult<UpdateCampaignChallengeMutation>;
export type UpdateCampaignChallengeMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignChallengeMutation, UpdateCampaignChallengeMutationVariables>;
export const CampaignTagsDocument = gql`
    query campaignTags($name: String, $ids: [ID], $section_code: String) {
  campaignTags(
    name: $name
    ids: $ids
    section_code: $section_code
    first: 200
    orderBy: [{column: "name", order: ASC}]
  ) {
    data {
      id
      name
      section_code
      description
      code
      creation_id
    }
  }
}
    `;

/**
 * __useCampaignTagsQuery__
 *
 * To run a query within a React component, call `useCampaignTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignTagsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      ids: // value for 'ids'
 *      section_code: // value for 'section_code'
 *   },
 * });
 */
export function useCampaignTagsQuery(baseOptions?: Apollo.QueryHookOptions<CampaignTagsQuery, CampaignTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignTagsQuery, CampaignTagsQueryVariables>(CampaignTagsDocument, options);
      }
export function useCampaignTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignTagsQuery, CampaignTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignTagsQuery, CampaignTagsQueryVariables>(CampaignTagsDocument, options);
        }
export type CampaignTagsQueryHookResult = ReturnType<typeof useCampaignTagsQuery>;
export type CampaignTagsLazyQueryHookResult = ReturnType<typeof useCampaignTagsLazyQuery>;
export type CampaignTagsQueryResult = Apollo.QueryResult<CampaignTagsQuery, CampaignTagsQueryVariables>;
export const CampaignTagsFullDocument = gql`
    query campaignTagsFull($name: String) {
  campaignTags(
    name: $name
    first: 9000
    orderBy: [{column: "section_code", order: ASC}, {column: "name", order: ASC}]
  ) {
    data {
      id
      name
      section_code
      description
      code
      creation_id
    }
  }
}
    `;

/**
 * __useCampaignTagsFullQuery__
 *
 * To run a query within a React component, call `useCampaignTagsFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignTagsFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignTagsFullQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCampaignTagsFullQuery(baseOptions?: Apollo.QueryHookOptions<CampaignTagsFullQuery, CampaignTagsFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignTagsFullQuery, CampaignTagsFullQueryVariables>(CampaignTagsFullDocument, options);
      }
export function useCampaignTagsFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignTagsFullQuery, CampaignTagsFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignTagsFullQuery, CampaignTagsFullQueryVariables>(CampaignTagsFullDocument, options);
        }
export type CampaignTagsFullQueryHookResult = ReturnType<typeof useCampaignTagsFullQuery>;
export type CampaignTagsFullLazyQueryHookResult = ReturnType<typeof useCampaignTagsFullLazyQuery>;
export type CampaignTagsFullQueryResult = Apollo.QueryResult<CampaignTagsFullQuery, CampaignTagsFullQueryVariables>;
export const UpdateCampaignTagsDocument = gql`
    mutation updateCampaignTags($update: UpdateCampaignTag) {
  updateCampaignTags(input: $update) {
    id
    name
    section_code
    description
    code
    creation_id
  }
}
    `;
export type UpdateCampaignTagsMutationFn = Apollo.MutationFunction<UpdateCampaignTagsMutation, UpdateCampaignTagsMutationVariables>;

/**
 * __useUpdateCampaignTagsMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignTagsMutation, { data, loading, error }] = useUpdateCampaignTagsMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateCampaignTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignTagsMutation, UpdateCampaignTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignTagsMutation, UpdateCampaignTagsMutationVariables>(UpdateCampaignTagsDocument, options);
      }
export type UpdateCampaignTagsMutationHookResult = ReturnType<typeof useUpdateCampaignTagsMutation>;
export type UpdateCampaignTagsMutationResult = Apollo.MutationResult<UpdateCampaignTagsMutation>;
export type UpdateCampaignTagsMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignTagsMutation, UpdateCampaignTagsMutationVariables>;
export const GetCampaignPanelBookingsQueryDocument = gql`
    query getCampaignPanelBookingsQuery($ref: String) {
  campaign(ref: $ref) {
    ...campaignPanelBookingsFull
  }
}
    ${CampaignPanelBookingsFullFragmentDoc}`;

/**
 * __useGetCampaignPanelBookingsQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignPanelBookingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignPanelBookingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignPanelBookingsQueryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCampaignPanelBookingsQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignPanelBookingsQueryQuery, GetCampaignPanelBookingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignPanelBookingsQueryQuery, GetCampaignPanelBookingsQueryQueryVariables>(GetCampaignPanelBookingsQueryDocument, options);
      }
export function useGetCampaignPanelBookingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignPanelBookingsQueryQuery, GetCampaignPanelBookingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignPanelBookingsQueryQuery, GetCampaignPanelBookingsQueryQueryVariables>(GetCampaignPanelBookingsQueryDocument, options);
        }
export type GetCampaignPanelBookingsQueryQueryHookResult = ReturnType<typeof useGetCampaignPanelBookingsQueryQuery>;
export type GetCampaignPanelBookingsQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignPanelBookingsQueryLazyQuery>;
export type GetCampaignPanelBookingsQueryQueryResult = Apollo.QueryResult<GetCampaignPanelBookingsQueryQuery, GetCampaignPanelBookingsQueryQueryVariables>;
export const GetCampaignDigitalBookingsQueryDocument = gql`
    query getCampaignDigitalBookingsQuery($ref: String) {
  campaign(ref: $ref) {
    digitalBookings {
      id
      days
      cost_type
      start_date
      end_date
      status
      is_photo_paid
      campaignComponent {
        id
        unit_value_local
      }
      site {
        id
        name
        boroughOrRegion
        siteStructure {
          id
          name
        }
      }
      campaign {
        id
        job_reference
      }
    }
  }
}
    `;

/**
 * __useGetCampaignDigitalBookingsQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignDigitalBookingsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignDigitalBookingsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignDigitalBookingsQueryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCampaignDigitalBookingsQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignDigitalBookingsQueryQuery, GetCampaignDigitalBookingsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignDigitalBookingsQueryQuery, GetCampaignDigitalBookingsQueryQueryVariables>(GetCampaignDigitalBookingsQueryDocument, options);
      }
export function useGetCampaignDigitalBookingsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignDigitalBookingsQueryQuery, GetCampaignDigitalBookingsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignDigitalBookingsQueryQuery, GetCampaignDigitalBookingsQueryQueryVariables>(GetCampaignDigitalBookingsQueryDocument, options);
        }
export type GetCampaignDigitalBookingsQueryQueryHookResult = ReturnType<typeof useGetCampaignDigitalBookingsQueryQuery>;
export type GetCampaignDigitalBookingsQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignDigitalBookingsQueryLazyQuery>;
export type GetCampaignDigitalBookingsQueryQueryResult = Apollo.QueryResult<GetCampaignDigitalBookingsQueryQuery, GetCampaignDigitalBookingsQueryQueryVariables>;
export const GetCampaignCostPaneQueryDocument = gql`
    query getCampaignCostPaneQuery($ref: String) {
  campaign(ref: $ref) {
    costs {
      id
      creation_id
      supplier_code
      invoice_number
      campaignComponent {
        id
        unit_value_local
        currency(trashed: WITH) {
          ...CurrencyFull
        }
        qty
      }
      costSupplier(trashed: WITH) {
        id
        label
        code
        costSupplierCategory(trashed: WITH) {
          id
          label
        }
      }
    }
  }
}
    ${CurrencyFullFragmentDoc}`;

/**
 * __useGetCampaignCostPaneQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignCostPaneQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignCostPaneQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignCostPaneQueryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCampaignCostPaneQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignCostPaneQueryQuery, GetCampaignCostPaneQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignCostPaneQueryQuery, GetCampaignCostPaneQueryQueryVariables>(GetCampaignCostPaneQueryDocument, options);
      }
export function useGetCampaignCostPaneQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignCostPaneQueryQuery, GetCampaignCostPaneQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignCostPaneQueryQuery, GetCampaignCostPaneQueryQueryVariables>(GetCampaignCostPaneQueryDocument, options);
        }
export type GetCampaignCostPaneQueryQueryHookResult = ReturnType<typeof useGetCampaignCostPaneQueryQuery>;
export type GetCampaignCostPaneQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignCostPaneQueryLazyQuery>;
export type GetCampaignCostPaneQueryQueryResult = Apollo.QueryResult<GetCampaignCostPaneQueryQuery, GetCampaignCostPaneQueryQueryVariables>;
export const GetCampaignSignaturesQueryDocument = gql`
    query getCampaignSignaturesQuery($ref: String) {
  campaign(ref: $ref) {
    ...campaignSignatures
  }
}
    ${CampaignSignaturesFragmentDoc}`;

/**
 * __useGetCampaignSignaturesQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignSignaturesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignSignaturesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignSignaturesQueryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *   },
 * });
 */
export function useGetCampaignSignaturesQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignSignaturesQueryQuery, GetCampaignSignaturesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignSignaturesQueryQuery, GetCampaignSignaturesQueryQueryVariables>(GetCampaignSignaturesQueryDocument, options);
      }
export function useGetCampaignSignaturesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignSignaturesQueryQuery, GetCampaignSignaturesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignSignaturesQueryQuery, GetCampaignSignaturesQueryQueryVariables>(GetCampaignSignaturesQueryDocument, options);
        }
export type GetCampaignSignaturesQueryQueryHookResult = ReturnType<typeof useGetCampaignSignaturesQueryQuery>;
export type GetCampaignSignaturesQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignSignaturesQueryLazyQuery>;
export type GetCampaignSignaturesQueryQueryResult = Apollo.QueryResult<GetCampaignSignaturesQueryQuery, GetCampaignSignaturesQueryQueryVariables>;
export const CreateCampaignSignatureDocument = gql`
    mutation createCampaignSignature($campaign_id: ID, $email: String, $is_manual: Boolean) {
  createCampaignSignature(
    input: {campaign_id: $campaign_id, email: $email, is_manual: $is_manual}
  ) {
    id
    graphqlContractUrl
  }
}
    `;
export type CreateCampaignSignatureMutationFn = Apollo.MutationFunction<CreateCampaignSignatureMutation, CreateCampaignSignatureMutationVariables>;

/**
 * __useCreateCampaignSignatureMutation__
 *
 * To run a mutation, you first call `useCreateCampaignSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignSignatureMutation, { data, loading, error }] = useCreateCampaignSignatureMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      email: // value for 'email'
 *      is_manual: // value for 'is_manual'
 *   },
 * });
 */
export function useCreateCampaignSignatureMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignSignatureMutation, CreateCampaignSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignSignatureMutation, CreateCampaignSignatureMutationVariables>(CreateCampaignSignatureDocument, options);
      }
export type CreateCampaignSignatureMutationHookResult = ReturnType<typeof useCreateCampaignSignatureMutation>;
export type CreateCampaignSignatureMutationResult = Apollo.MutationResult<CreateCampaignSignatureMutation>;
export type CreateCampaignSignatureMutationOptions = Apollo.BaseMutationOptions<CreateCampaignSignatureMutation, CreateCampaignSignatureMutationVariables>;
export const GetCampaignQueryDocument = gql`
    query getCampaignQuery($ref: String, $withEstimated: Boolean = true, $withActual: Boolean = true) {
  campaign(ref: $ref) {
    ...campaignFull
  }
}
    ${CampaignFullFragmentDoc}`;

/**
 * __useGetCampaignQueryQuery__
 *
 * To run a query within a React component, call `useGetCampaignQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQueryQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      withEstimated: // value for 'withEstimated'
 *      withActual: // value for 'withActual'
 *   },
 * });
 */
export function useGetCampaignQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>(GetCampaignQueryDocument, options);
      }
export function useGetCampaignQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>(GetCampaignQueryDocument, options);
        }
export type GetCampaignQueryQueryHookResult = ReturnType<typeof useGetCampaignQueryQuery>;
export type GetCampaignQueryLazyQueryHookResult = ReturnType<typeof useGetCampaignQueryLazyQuery>;
export type GetCampaignQueryQueryResult = Apollo.QueryResult<GetCampaignQueryQuery, GetCampaignQueryQueryVariables>;
export const UpdateCampaignMutationDocument = gql`
    mutation updateCampaignMutation($input: UpdateCampaignInput!, $withEstimated: Boolean = true, $withActual: Boolean = true) {
  updateCampaign(input: $input) {
    ...campaignFull
  }
}
    ${CampaignFullFragmentDoc}`;
export type UpdateCampaignMutationMutationFn = Apollo.MutationFunction<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>;

/**
 * __useUpdateCampaignMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignMutationMutation, { data, loading, error }] = useUpdateCampaignMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      withEstimated: // value for 'withEstimated'
 *      withActual: // value for 'withActual'
 *   },
 * });
 */
export function useUpdateCampaignMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>(UpdateCampaignMutationDocument, options);
      }
export type UpdateCampaignMutationMutationHookResult = ReturnType<typeof useUpdateCampaignMutationMutation>;
export type UpdateCampaignMutationMutationResult = Apollo.MutationResult<UpdateCampaignMutationMutation>;
export type UpdateCampaignMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutationMutation, UpdateCampaignMutationMutationVariables>;
export const DeleteCampaignMutationDocument = gql`
    mutation deleteCampaignMutation($input: ID!) {
  deleteCampaign(id: $input) {
    id
  }
}
    `;
export type DeleteCampaignMutationMutationFn = Apollo.MutationFunction<DeleteCampaignMutationMutation, DeleteCampaignMutationMutationVariables>;

/**
 * __useDeleteCampaignMutationMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignMutationMutation, { data, loading, error }] = useDeleteCampaignMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCampaignMutationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignMutationMutation, DeleteCampaignMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignMutationMutation, DeleteCampaignMutationMutationVariables>(DeleteCampaignMutationDocument, options);
      }
export type DeleteCampaignMutationMutationHookResult = ReturnType<typeof useDeleteCampaignMutationMutation>;
export type DeleteCampaignMutationMutationResult = Apollo.MutationResult<DeleteCampaignMutationMutation>;
export type DeleteCampaignMutationMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignMutationMutation, DeleteCampaignMutationMutationVariables>;
export const CreateCampaignMutationDocument = gql`
    mutation createCampaignMutation($input: CreateCampaignInput!, $withEstimated: Boolean = true, $withActual: Boolean = true) {
  createCampaign(input: $input) {
    ...campaignFull
  }
}
    ${CampaignFullFragmentDoc}`;
export type CreateCampaignMutationMutationFn = Apollo.MutationFunction<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>;

/**
 * __useCreateCampaignMutationMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutationMutation, { data, loading, error }] = useCreateCampaignMutationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      withEstimated: // value for 'withEstimated'
 *      withActual: // value for 'withActual'
 *   },
 * });
 */
export function useCreateCampaignMutationMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>(CreateCampaignMutationDocument, options);
      }
export type CreateCampaignMutationMutationHookResult = ReturnType<typeof useCreateCampaignMutationMutation>;
export type CreateCampaignMutationMutationResult = Apollo.MutationResult<CreateCampaignMutationMutation>;
export type CreateCampaignMutationMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutationMutation, CreateCampaignMutationMutationVariables>;
export const CampaignDeletePanelsMutationDocument = gql`
    mutation campaignDeletePanelsMutation($deletes: [ID]) {
  campaignDeletePanelBooking(input: {deletes: $deletes}) {
    deletePanelBookingErrors {
      message
    }
    panelBookings {
      ...panelBookingFull
    }
  }
}
    ${PanelBookingFullFragmentDoc}`;
export type CampaignDeletePanelsMutationMutationFn = Apollo.MutationFunction<CampaignDeletePanelsMutationMutation, CampaignDeletePanelsMutationMutationVariables>;

/**
 * __useCampaignDeletePanelsMutationMutation__
 *
 * To run a mutation, you first call `useCampaignDeletePanelsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignDeletePanelsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignDeletePanelsMutationMutation, { data, loading, error }] = useCampaignDeletePanelsMutationMutation({
 *   variables: {
 *      deletes: // value for 'deletes'
 *   },
 * });
 */
export function useCampaignDeletePanelsMutationMutation(baseOptions?: Apollo.MutationHookOptions<CampaignDeletePanelsMutationMutation, CampaignDeletePanelsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignDeletePanelsMutationMutation, CampaignDeletePanelsMutationMutationVariables>(CampaignDeletePanelsMutationDocument, options);
      }
export type CampaignDeletePanelsMutationMutationHookResult = ReturnType<typeof useCampaignDeletePanelsMutationMutation>;
export type CampaignDeletePanelsMutationMutationResult = Apollo.MutationResult<CampaignDeletePanelsMutationMutation>;
export type CampaignDeletePanelsMutationMutationOptions = Apollo.BaseMutationOptions<CampaignDeletePanelsMutationMutation, CampaignDeletePanelsMutationMutationVariables>;
export const DeleteDigitalBookingDocument = gql`
    mutation DeleteDigitalBooking($input: DeleteDigitalBookingArrayInput!) {
  deleteDigitalBooking(input: $input) {
    digitalBookings {
      id
      campaignComponent {
        id
        unit_value_local
        currency {
          ...CurrencyFull
        }
        qty
        region(trashed: WITH) {
          ...RegionFull
        }
        regionType(trashed: WITH) {
          ...RegionTypeFull
        }
      }
      days
      cost_type
      start_date
      end_date
      site {
        id
        name
        address1
        externalLink
        boroughOrRegion
        postcode
        borough(trashed: WITH) {
          id
          label
          trashed
        }
        siteStructure(trashed: WITH) {
          id
          name
          trashed
        }
        distributor(trashed: WITH) {
          id
          name
          trashed
          is_inhouse
        }
      }
    }
    deleteDigitalBookingErrors {
      message
    }
  }
}
    ${CurrencyFullFragmentDoc}
${RegionFullFragmentDoc}
${RegionTypeFullFragmentDoc}`;
export type DeleteDigitalBookingMutationFn = Apollo.MutationFunction<DeleteDigitalBookingMutation, DeleteDigitalBookingMutationVariables>;

/**
 * __useDeleteDigitalBookingMutation__
 *
 * To run a mutation, you first call `useDeleteDigitalBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDigitalBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDigitalBookingMutation, { data, loading, error }] = useDeleteDigitalBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDigitalBookingMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDigitalBookingMutation, DeleteDigitalBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDigitalBookingMutation, DeleteDigitalBookingMutationVariables>(DeleteDigitalBookingDocument, options);
      }
export type DeleteDigitalBookingMutationHookResult = ReturnType<typeof useDeleteDigitalBookingMutation>;
export type DeleteDigitalBookingMutationResult = Apollo.MutationResult<DeleteDigitalBookingMutation>;
export type DeleteDigitalBookingMutationOptions = Apollo.BaseMutationOptions<DeleteDigitalBookingMutation, DeleteDigitalBookingMutationVariables>;
export const TweakDigitalBookingsDocument = gql`
    mutation TweakDigitalBookings($input: TweakDigitalBookingArrayInput!) {
  tweakDigitalBookings(input: $input) {
    updatedDigitalBookings {
      id
      campaignComponent {
        id
        unit_value_local
        currency {
          ...CurrencyFull
        }
        qty
        region(trashed: WITH) {
          ...RegionFull
        }
        regionType(trashed: WITH) {
          ...RegionTypeFull
        }
      }
      days
      cost_type
      start_date
      end_date
      status
      is_photo_paid
      site {
        id
        name
        address1
        externalLink
        boroughOrRegion
        postcode
        borough(trashed: WITH) {
          id
          label
          trashed
        }
        siteStructure(trashed: WITH) {
          id
          name
          trashed
        }
        distributor(trashed: WITH) {
          id
          name
          trashed
          is_inhouse
        }
      }
      campaign {
        id
        name
      }
    }
    tweakErrors {
      id
      message
    }
  }
}
    ${CurrencyFullFragmentDoc}
${RegionFullFragmentDoc}
${RegionTypeFullFragmentDoc}`;
export type TweakDigitalBookingsMutationFn = Apollo.MutationFunction<TweakDigitalBookingsMutation, TweakDigitalBookingsMutationVariables>;

/**
 * __useTweakDigitalBookingsMutation__
 *
 * To run a mutation, you first call `useTweakDigitalBookingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTweakDigitalBookingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tweakDigitalBookingsMutation, { data, loading, error }] = useTweakDigitalBookingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTweakDigitalBookingsMutation(baseOptions?: Apollo.MutationHookOptions<TweakDigitalBookingsMutation, TweakDigitalBookingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TweakDigitalBookingsMutation, TweakDigitalBookingsMutationVariables>(TweakDigitalBookingsDocument, options);
      }
export type TweakDigitalBookingsMutationHookResult = ReturnType<typeof useTweakDigitalBookingsMutation>;
export type TweakDigitalBookingsMutationResult = Apollo.MutationResult<TweakDigitalBookingsMutation>;
export type TweakDigitalBookingsMutationOptions = Apollo.BaseMutationOptions<TweakDigitalBookingsMutation, TweakDigitalBookingsMutationVariables>;
export const CampaignTweakPanelsMutationDocument = gql`
    mutation campaignTweakPanelsMutation($tweaks: [TweakPanelBookingInput]) {
  campaignUpdatePanelBooking(input: {tweaks: $tweaks}) {
    tweakPanelBookingErrors {
      id
      message
      category
      siteName
    }
    panelBookings {
      ...panelBookingFull
    }
  }
}
    ${PanelBookingFullFragmentDoc}`;
export type CampaignTweakPanelsMutationMutationFn = Apollo.MutationFunction<CampaignTweakPanelsMutationMutation, CampaignTweakPanelsMutationMutationVariables>;

/**
 * __useCampaignTweakPanelsMutationMutation__
 *
 * To run a mutation, you first call `useCampaignTweakPanelsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignTweakPanelsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignTweakPanelsMutationMutation, { data, loading, error }] = useCampaignTweakPanelsMutationMutation({
 *   variables: {
 *      tweaks: // value for 'tweaks'
 *   },
 * });
 */
export function useCampaignTweakPanelsMutationMutation(baseOptions?: Apollo.MutationHookOptions<CampaignTweakPanelsMutationMutation, CampaignTweakPanelsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignTweakPanelsMutationMutation, CampaignTweakPanelsMutationMutationVariables>(CampaignTweakPanelsMutationDocument, options);
      }
export type CampaignTweakPanelsMutationMutationHookResult = ReturnType<typeof useCampaignTweakPanelsMutationMutation>;
export type CampaignTweakPanelsMutationMutationResult = Apollo.MutationResult<CampaignTweakPanelsMutationMutation>;
export type CampaignTweakPanelsMutationMutationOptions = Apollo.BaseMutationOptions<CampaignTweakPanelsMutationMutation, CampaignTweakPanelsMutationMutationVariables>;
export const CampaignsNameAndRefDocument = gql`
    query campaignsNameAndRef($name_or_reference_like: String) {
  campaigns(first: 1000, name_or_reference: $name_or_reference_like) {
    data {
      id
      name
      job_reference
      salesTeam {
        name
        id
      }
    }
  }
}
    `;

/**
 * __useCampaignsNameAndRefQuery__
 *
 * To run a query within a React component, call `useCampaignsNameAndRefQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsNameAndRefQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsNameAndRefQuery({
 *   variables: {
 *      name_or_reference_like: // value for 'name_or_reference_like'
 *   },
 * });
 */
export function useCampaignsNameAndRefQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsNameAndRefQuery, CampaignsNameAndRefQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsNameAndRefQuery, CampaignsNameAndRefQueryVariables>(CampaignsNameAndRefDocument, options);
      }
export function useCampaignsNameAndRefLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsNameAndRefQuery, CampaignsNameAndRefQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsNameAndRefQuery, CampaignsNameAndRefQueryVariables>(CampaignsNameAndRefDocument, options);
        }
export type CampaignsNameAndRefQueryHookResult = ReturnType<typeof useCampaignsNameAndRefQuery>;
export type CampaignsNameAndRefLazyQueryHookResult = ReturnType<typeof useCampaignsNameAndRefLazyQuery>;
export type CampaignsNameAndRefQueryResult = Apollo.QueryResult<CampaignsNameAndRefQuery, CampaignsNameAndRefQueryVariables>;
export const CampaignChangeSalesTeamDocument = gql`
    mutation campaignChangeSalesTeam($campaign_id: ID, $campaign_ref: String, $sales_team_id: ID) {
  campaignChangeSalesTeam(
    campaignId: $campaign_id
    campaignRef: $campaign_ref
    salesTeamId: $sales_team_id
  ) {
    name
    job_reference
  }
}
    `;
export type CampaignChangeSalesTeamMutationFn = Apollo.MutationFunction<CampaignChangeSalesTeamMutation, CampaignChangeSalesTeamMutationVariables>;

/**
 * __useCampaignChangeSalesTeamMutation__
 *
 * To run a mutation, you first call `useCampaignChangeSalesTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignChangeSalesTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignChangeSalesTeamMutation, { data, loading, error }] = useCampaignChangeSalesTeamMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      campaign_ref: // value for 'campaign_ref'
 *      sales_team_id: // value for 'sales_team_id'
 *   },
 * });
 */
export function useCampaignChangeSalesTeamMutation(baseOptions?: Apollo.MutationHookOptions<CampaignChangeSalesTeamMutation, CampaignChangeSalesTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CampaignChangeSalesTeamMutation, CampaignChangeSalesTeamMutationVariables>(CampaignChangeSalesTeamDocument, options);
      }
export type CampaignChangeSalesTeamMutationHookResult = ReturnType<typeof useCampaignChangeSalesTeamMutation>;
export type CampaignChangeSalesTeamMutationResult = Apollo.MutationResult<CampaignChangeSalesTeamMutation>;
export type CampaignChangeSalesTeamMutationOptions = Apollo.BaseMutationOptions<CampaignChangeSalesTeamMutation, CampaignChangeSalesTeamMutationVariables>;
export const CampaignsQueryDocument = gql`
    query campaignsQuery($name_like: String, $job_reference_like: String, $name_or_reference_like: String, $sales_job_ref_like: String, $completion_date_between: DateRange, $start_date_between: DateRange, $artwork_received_date_between: DateRange, $area_booking_date_up_between: DateRange, $area_booking_date_down_between: DateRange, $area_booking_distributor_in: [ID], $area_booking_poster_size_in: [ID], $area_booking_region_in: [ID], $status_in: [String!], $type_in: [String!], $purchase_order_exact: String, $invoice_exact: String, $total_price_exact: ID, $total_price_between: IntRange, $total_price_exact_no_vat: ID, $total_price_range_no_vat: IntRange, $discount_percentage: Float, $sales_team_in: [ID], $our_contact_in: [ID], $client_in: [ID], $client_like: String, $contact_in: [ID], $client_sub_type_in: [ID], $regional_am_revenue_id_in: [ID], $with_costs: Boolean = false, $with_creative: Boolean = false, $with_digital: Boolean = false, $with_sundries: Boolean = false, $with_areaBooking: Boolean = false) {
  campaigns(
    first: 10000
    name: $name_like
    name_or_reference: $name_or_reference_like
    job_reference: $job_reference_like
    sales_job_ref: $sales_job_ref_like
    completion_date_between: $completion_date_between
    start_date_between: $start_date_between
    artwork_received_date_between: $artwork_received_date_between
    area_booking_date_up_between: $area_booking_date_up_between
    area_booking_date_down_between: $area_booking_date_down_between
    area_booking_region_in: $area_booking_region_in
    status_in: $status_in
    type_in: $type_in
    purchase_order: $purchase_order_exact
    invoice: $invoice_exact
    area_booking_poster_size_in: $area_booking_poster_size_in
    area_booking_distributor_in: $area_booking_distributor_in
    total_price: $total_price_exact_no_vat
    total_price_between: $total_price_range_no_vat
    total_price_vat: $total_price_exact
    total_price_vat_between: $total_price_between
    discount_percentage: $discount_percentage
    sales_team_in: $sales_team_in
    our_contact_in: $our_contact_in
    client_company_in: $client_in
    client_company_name: $client_like
    client_company_contact_in: $contact_in
    client_sub_type_in: $client_sub_type_in
    regional_am_revenue_id_in: $regional_am_revenue_id_in
  ) {
    data {
      id
      name
      job_reference
      start_date
      status
      type
      total_price
      photo_paid_total
      purchase_order
      invoice
      completion_date
      posters_received
      discount_final
      discountableTotal
      discount_percentage
      sub_teams_scotland
      notes
      confirmationEntry {
        occurredAt
      }
      clientSubType {
        name
      }
      regionalAmAllocation {
        name
      }
      salesTeam {
        name
        id
      }
      ourContact {
        name
        id
      }
      clientCompany(trashed: WITH) {
        id
        sales_company
        trashed
        clientType(trashed: WITH) {
          id
          name
        }
      }
      currency(trashed: WITH) {
        ...CurrencyFull
      }
      totals {
        id
        panel_booking
        experiential
        media_production
        creativestudio
        area_booking
        ambient
        sundry
        digital_booking
      }
      costs @include(if: $with_costs) {
        costSupplier {
          label
          code
          costSupplierCategory {
            label
          }
        }
        invoice_number
        campaignComponent {
          unit_value_local
          currency {
            ...CurrencyFull
          }
          qty
        }
      }
      digitalBookings @include(if: $with_digital) {
        campaignComponent {
          region {
            name
          }
          regionType {
            name
          }
          unit_value_local
          currency {
            ...CurrencyFull
          }
          qty
        }
        days
        start_date
        end_date
        cost_type
        site {
          name
          siteStructure {
            name
          }
          sitePricing {
            label
          }
          externalLink
        }
      }
      creativeStudio @include(if: $with_creative) {
        creativeStudioType {
          name
        }
        creativeStudioTypeDetail {
          name
        }
        start_date
        end_date
        campaignComponent {
          region {
            name
          }
          regionType {
            name
          }
          unit_value_local
          currency {
            ...CurrencyFull
          }
          qty
        }
      }
      areaBookings @include(if: $with_areaBooking) {
        areaBookingItems {
          campaignComponent {
            total
            qty
            unit_value
            region {
              name
            }
            currency {
              ...CurrencyFull
            }
          }
        }
        posterSize(trashed: WITH) {
          id
          name
          trashed
        }
        regionType(trashed: WITH) {
          name
        }
      }
      sundries @include(if: $with_sundries) {
        sundryType {
          ...SundryTypeFull
        }
        name
        notes
        date_up
        date_down
        use_global_discount
        campaignComponent {
          unit_value_local
          currency {
            ...CurrencyFull
          }
          region {
            ...RegionFull
          }
          regionType {
            ...RegionTypeFull
          }
          qty
        }
      }
    }
  }
}
    ${CurrencyFullFragmentDoc}
${SundryTypeFullFragmentDoc}
${RegionFullFragmentDoc}
${RegionTypeFullFragmentDoc}`;

/**
 * __useCampaignsQueryQuery__
 *
 * To run a query within a React component, call `useCampaignsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQueryQuery({
 *   variables: {
 *      name_like: // value for 'name_like'
 *      job_reference_like: // value for 'job_reference_like'
 *      name_or_reference_like: // value for 'name_or_reference_like'
 *      sales_job_ref_like: // value for 'sales_job_ref_like'
 *      completion_date_between: // value for 'completion_date_between'
 *      start_date_between: // value for 'start_date_between'
 *      artwork_received_date_between: // value for 'artwork_received_date_between'
 *      area_booking_date_up_between: // value for 'area_booking_date_up_between'
 *      area_booking_date_down_between: // value for 'area_booking_date_down_between'
 *      area_booking_distributor_in: // value for 'area_booking_distributor_in'
 *      area_booking_poster_size_in: // value for 'area_booking_poster_size_in'
 *      area_booking_region_in: // value for 'area_booking_region_in'
 *      status_in: // value for 'status_in'
 *      type_in: // value for 'type_in'
 *      purchase_order_exact: // value for 'purchase_order_exact'
 *      invoice_exact: // value for 'invoice_exact'
 *      total_price_exact: // value for 'total_price_exact'
 *      total_price_between: // value for 'total_price_between'
 *      total_price_exact_no_vat: // value for 'total_price_exact_no_vat'
 *      total_price_range_no_vat: // value for 'total_price_range_no_vat'
 *      discount_percentage: // value for 'discount_percentage'
 *      sales_team_in: // value for 'sales_team_in'
 *      our_contact_in: // value for 'our_contact_in'
 *      client_in: // value for 'client_in'
 *      client_like: // value for 'client_like'
 *      contact_in: // value for 'contact_in'
 *      client_sub_type_in: // value for 'client_sub_type_in'
 *      regional_am_revenue_id_in: // value for 'regional_am_revenue_id_in'
 *      with_costs: // value for 'with_costs'
 *      with_creative: // value for 'with_creative'
 *      with_digital: // value for 'with_digital'
 *      with_sundries: // value for 'with_sundries'
 *      with_areaBooking: // value for 'with_areaBooking'
 *   },
 * });
 */
export function useCampaignsQueryQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsQueryQuery, CampaignsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQueryQuery, CampaignsQueryQueryVariables>(CampaignsQueryDocument, options);
      }
export function useCampaignsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQueryQuery, CampaignsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQueryQuery, CampaignsQueryQueryVariables>(CampaignsQueryDocument, options);
        }
export type CampaignsQueryQueryHookResult = ReturnType<typeof useCampaignsQueryQuery>;
export type CampaignsQueryLazyQueryHookResult = ReturnType<typeof useCampaignsQueryLazyQuery>;
export type CampaignsQueryQueryResult = Apollo.QueryResult<CampaignsQueryQuery, CampaignsQueryQueryVariables>;
export const CampaignsSearchQueryDocument = gql`
    query campaignsSearchQuery($name_like: String, $job_reference_like: String, $name_or_reference_like: String, $sales_job_ref_like: String, $completion_date_between: DateRange, $start_date_between: DateRange, $artwork_received_date_between: DateRange, $area_booking_date_up_between: DateRange, $area_booking_date_down_between: DateRange, $area_booking_distributor_in: [ID], $area_booking_poster_size_in: [ID], $area_booking_region_in: [ID], $status_in: [String!], $type_in: [String!], $purchase_order_exact: String, $invoice_exact: String, $total_price_exact: ID, $total_price_between: IntRange, $total_price_exact_no_vat: ID, $total_price_range_no_vat: IntRange, $discount_percentage: Float, $sales_team_in: [ID], $our_contact_in: [ID], $client_in: [ID], $client_like: String, $contact_in: [ID], $client_sub_type_in: [ID], $regional_am_revenue_id_in: [ID]) {
  campaigns(
    first: 10000
    name: $name_like
    name_or_reference: $name_or_reference_like
    job_reference: $job_reference_like
    sales_job_ref: $sales_job_ref_like
    completion_date_between: $completion_date_between
    start_date_between: $start_date_between
    artwork_received_date_between: $artwork_received_date_between
    area_booking_date_up_between: $area_booking_date_up_between
    area_booking_date_down_between: $area_booking_date_down_between
    area_booking_region_in: $area_booking_region_in
    status_in: $status_in
    type_in: $type_in
    purchase_order: $purchase_order_exact
    invoice: $invoice_exact
    area_booking_poster_size_in: $area_booking_poster_size_in
    area_booking_distributor_in: $area_booking_distributor_in
    total_price: $total_price_exact_no_vat
    total_price_between: $total_price_range_no_vat
    total_price_vat: $total_price_exact
    total_price_vat_between: $total_price_between
    discount_percentage: $discount_percentage
    sales_team_in: $sales_team_in
    our_contact_in: $our_contact_in
    client_company_in: $client_in
    client_company_name: $client_like
    client_company_contact_in: $contact_in
    client_sub_type_in: $client_sub_type_in
    regional_am_revenue_id_in: $regional_am_revenue_id_in
  ) {
    data {
      id
      name
      job_reference
      start_date
      status
      type
      total_price
      photo_paid_total
      purchase_order
      invoice
      completion_date
      posters_received
      discount_final
      discountableTotal
      discount_percentage
      sub_teams_scotland
      notes
      confirmationEntry {
        occurredAt
      }
      clientSubType {
        name
      }
      regionalAmAllocation {
        name
      }
      salesTeam {
        name
        id
      }
      ourContact {
        name
        id
      }
      clientCompany(trashed: WITH) {
        id
        sales_company
        trashed
        clientType(trashed: WITH) {
          id
          name
        }
      }
      currency(trashed: WITH) {
        ...CurrencyFull
      }
      totals {
        id
        panel_booking
        experiential
        media_production
        creativestudio
        area_booking
        ambient
        sundry
        digital_booking
      }
    }
  }
}
    ${CurrencyFullFragmentDoc}`;

/**
 * __useCampaignsSearchQueryQuery__
 *
 * To run a query within a React component, call `useCampaignsSearchQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsSearchQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsSearchQueryQuery({
 *   variables: {
 *      name_like: // value for 'name_like'
 *      job_reference_like: // value for 'job_reference_like'
 *      name_or_reference_like: // value for 'name_or_reference_like'
 *      sales_job_ref_like: // value for 'sales_job_ref_like'
 *      completion_date_between: // value for 'completion_date_between'
 *      start_date_between: // value for 'start_date_between'
 *      artwork_received_date_between: // value for 'artwork_received_date_between'
 *      area_booking_date_up_between: // value for 'area_booking_date_up_between'
 *      area_booking_date_down_between: // value for 'area_booking_date_down_between'
 *      area_booking_distributor_in: // value for 'area_booking_distributor_in'
 *      area_booking_poster_size_in: // value for 'area_booking_poster_size_in'
 *      area_booking_region_in: // value for 'area_booking_region_in'
 *      status_in: // value for 'status_in'
 *      type_in: // value for 'type_in'
 *      purchase_order_exact: // value for 'purchase_order_exact'
 *      invoice_exact: // value for 'invoice_exact'
 *      total_price_exact: // value for 'total_price_exact'
 *      total_price_between: // value for 'total_price_between'
 *      total_price_exact_no_vat: // value for 'total_price_exact_no_vat'
 *      total_price_range_no_vat: // value for 'total_price_range_no_vat'
 *      discount_percentage: // value for 'discount_percentage'
 *      sales_team_in: // value for 'sales_team_in'
 *      our_contact_in: // value for 'our_contact_in'
 *      client_in: // value for 'client_in'
 *      client_like: // value for 'client_like'
 *      contact_in: // value for 'contact_in'
 *      client_sub_type_in: // value for 'client_sub_type_in'
 *      regional_am_revenue_id_in: // value for 'regional_am_revenue_id_in'
 *   },
 * });
 */
export function useCampaignsSearchQueryQuery(baseOptions?: Apollo.QueryHookOptions<CampaignsSearchQueryQuery, CampaignsSearchQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsSearchQueryQuery, CampaignsSearchQueryQueryVariables>(CampaignsSearchQueryDocument, options);
      }
export function useCampaignsSearchQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsSearchQueryQuery, CampaignsSearchQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsSearchQueryQuery, CampaignsSearchQueryQueryVariables>(CampaignsSearchQueryDocument, options);
        }
export type CampaignsSearchQueryQueryHookResult = ReturnType<typeof useCampaignsSearchQueryQuery>;
export type CampaignsSearchQueryLazyQueryHookResult = ReturnType<typeof useCampaignsSearchQueryLazyQuery>;
export type CampaignsSearchQueryQueryResult = Apollo.QueryResult<CampaignsSearchQueryQuery, CampaignsSearchQueryQueryVariables>;
export const GetPanelBookingsForChallengeEmailDocument = gql`
    query getPanelBookingsForChallengeEmail($ref: String, $bookings: [ID]) {
  campaign(ref: $ref) {
    job_reference
    id
    name
    ourContact {
      id
      name
      email
    }
    panelBookings(ids: $bookings) {
      id
      challengeable_status
      first_week
      last_week
      panel {
        panel
        site {
          id
          name
          region {
            id
            name
            regionType {
              id
              name
            }
          }
        }
      }
      posterSize {
        id
        name
        slotPosterSize {
          id
          name
        }
      }
      poleBookings {
        id
        first_week
        last_week
        posterSize {
          id
          name
        }
        campaign {
          job_reference
          name
          id
          ourContact {
            id
            name
            email
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetPanelBookingsForChallengeEmailQuery__
 *
 * To run a query within a React component, call `useGetPanelBookingsForChallengeEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPanelBookingsForChallengeEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPanelBookingsForChallengeEmailQuery({
 *   variables: {
 *      ref: // value for 'ref'
 *      bookings: // value for 'bookings'
 *   },
 * });
 */
export function useGetPanelBookingsForChallengeEmailQuery(baseOptions?: Apollo.QueryHookOptions<GetPanelBookingsForChallengeEmailQuery, GetPanelBookingsForChallengeEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPanelBookingsForChallengeEmailQuery, GetPanelBookingsForChallengeEmailQueryVariables>(GetPanelBookingsForChallengeEmailDocument, options);
      }
export function useGetPanelBookingsForChallengeEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPanelBookingsForChallengeEmailQuery, GetPanelBookingsForChallengeEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPanelBookingsForChallengeEmailQuery, GetPanelBookingsForChallengeEmailQueryVariables>(GetPanelBookingsForChallengeEmailDocument, options);
        }
export type GetPanelBookingsForChallengeEmailQueryHookResult = ReturnType<typeof useGetPanelBookingsForChallengeEmailQuery>;
export type GetPanelBookingsForChallengeEmailLazyQueryHookResult = ReturnType<typeof useGetPanelBookingsForChallengeEmailLazyQuery>;
export type GetPanelBookingsForChallengeEmailQueryResult = Apollo.QueryResult<GetPanelBookingsForChallengeEmailQuery, GetPanelBookingsForChallengeEmailQueryVariables>;
export const CreateCampaignChallengeDocument = gql`
    mutation createCampaignChallenge($campaign_id: ID, $message: String, $panelBookings: [ID]) {
  createCampaignChallenge(
    input: {campaign_id: $campaign_id, message: $message, panelBookings: $panelBookings}
  ) {
    campaign {
      job_reference
    }
    id
    bookingChallenges {
      id
      week_end
      week_start
      sourcePanelBooking {
        id
      }
      targetPanelBooking {
        id
      }
    }
  }
}
    `;
export type CreateCampaignChallengeMutationFn = Apollo.MutationFunction<CreateCampaignChallengeMutation, CreateCampaignChallengeMutationVariables>;

/**
 * __useCreateCampaignChallengeMutation__
 *
 * To run a mutation, you first call `useCreateCampaignChallengeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignChallengeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignChallengeMutation, { data, loading, error }] = useCreateCampaignChallengeMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *      message: // value for 'message'
 *      panelBookings: // value for 'panelBookings'
 *   },
 * });
 */
export function useCreateCampaignChallengeMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignChallengeMutation, CreateCampaignChallengeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignChallengeMutation, CreateCampaignChallengeMutationVariables>(CreateCampaignChallengeDocument, options);
      }
export type CreateCampaignChallengeMutationHookResult = ReturnType<typeof useCreateCampaignChallengeMutation>;
export type CreateCampaignChallengeMutationResult = Apollo.MutationResult<CreateCampaignChallengeMutation>;
export type CreateCampaignChallengeMutationOptions = Apollo.BaseMutationOptions<CreateCampaignChallengeMutation, CreateCampaignChallengeMutationVariables>;
export const GetCampaignNextcloudUrlsDocument = gql`
    query getCampaignNextcloudUrls($id: ID!) {
  campaign(id: $id) {
    id
    nextcloud_share_url
    nextcloud_view_url
  }
}
    `;

/**
 * __useGetCampaignNextcloudUrlsQuery__
 *
 * To run a query within a React component, call `useGetCampaignNextcloudUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignNextcloudUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignNextcloudUrlsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCampaignNextcloudUrlsQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignNextcloudUrlsQuery, GetCampaignNextcloudUrlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignNextcloudUrlsQuery, GetCampaignNextcloudUrlsQueryVariables>(GetCampaignNextcloudUrlsDocument, options);
      }
export function useGetCampaignNextcloudUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignNextcloudUrlsQuery, GetCampaignNextcloudUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignNextcloudUrlsQuery, GetCampaignNextcloudUrlsQueryVariables>(GetCampaignNextcloudUrlsDocument, options);
        }
export type GetCampaignNextcloudUrlsQueryHookResult = ReturnType<typeof useGetCampaignNextcloudUrlsQuery>;
export type GetCampaignNextcloudUrlsLazyQueryHookResult = ReturnType<typeof useGetCampaignNextcloudUrlsLazyQuery>;
export type GetCampaignNextcloudUrlsQueryResult = Apollo.QueryResult<GetCampaignNextcloudUrlsQuery, GetCampaignNextcloudUrlsQueryVariables>;
export const RegenerateCampaignNextcloudDocument = gql`
    mutation regenerateCampaignNextcloud($campaign_id: ID!) {
  regenerateCampaignNextcloud(campaignId: $campaign_id) {
    id
    nextcloud_share_url
    nextcloud_view_url
  }
}
    `;
export type RegenerateCampaignNextcloudMutationFn = Apollo.MutationFunction<RegenerateCampaignNextcloudMutation, RegenerateCampaignNextcloudMutationVariables>;

/**
 * __useRegenerateCampaignNextcloudMutation__
 *
 * To run a mutation, you first call `useRegenerateCampaignNextcloudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateCampaignNextcloudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateCampaignNextcloudMutation, { data, loading, error }] = useRegenerateCampaignNextcloudMutation({
 *   variables: {
 *      campaign_id: // value for 'campaign_id'
 *   },
 * });
 */
export function useRegenerateCampaignNextcloudMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateCampaignNextcloudMutation, RegenerateCampaignNextcloudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateCampaignNextcloudMutation, RegenerateCampaignNextcloudMutationVariables>(RegenerateCampaignNextcloudDocument, options);
      }
export type RegenerateCampaignNextcloudMutationHookResult = ReturnType<typeof useRegenerateCampaignNextcloudMutation>;
export type RegenerateCampaignNextcloudMutationResult = Apollo.MutationResult<RegenerateCampaignNextcloudMutation>;
export type RegenerateCampaignNextcloudMutationOptions = Apollo.BaseMutationOptions<RegenerateCampaignNextcloudMutation, RegenerateCampaignNextcloudMutationVariables>;
export const GetNextcloudEnabledDocument = gql`
    query getNextcloudEnabled {
  nextcloudEnabled
}
    `;

/**
 * __useGetNextcloudEnabledQuery__
 *
 * To run a query within a React component, call `useGetNextcloudEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNextcloudEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNextcloudEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNextcloudEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GetNextcloudEnabledQuery, GetNextcloudEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNextcloudEnabledQuery, GetNextcloudEnabledQueryVariables>(GetNextcloudEnabledDocument, options);
      }
export function useGetNextcloudEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNextcloudEnabledQuery, GetNextcloudEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNextcloudEnabledQuery, GetNextcloudEnabledQueryVariables>(GetNextcloudEnabledDocument, options);
        }
export type GetNextcloudEnabledQueryHookResult = ReturnType<typeof useGetNextcloudEnabledQuery>;
export type GetNextcloudEnabledLazyQueryHookResult = ReturnType<typeof useGetNextcloudEnabledLazyQuery>;
export type GetNextcloudEnabledQueryResult = Apollo.QueryResult<GetNextcloudEnabledQuery, GetNextcloudEnabledQueryVariables>;
export const UpdateClientSubTypeDocument = gql`
    mutation updateClientSubType($update: UpdateClientSubTypes) {
  updateClientSubTypes(input: $update) {
    ...ClientSubTypeFull
  }
}
    ${ClientSubTypeFullFragmentDoc}`;
export type UpdateClientSubTypeMutationFn = Apollo.MutationFunction<UpdateClientSubTypeMutation, UpdateClientSubTypeMutationVariables>;

/**
 * __useUpdateClientSubTypeMutation__
 *
 * To run a mutation, you first call `useUpdateClientSubTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientSubTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientSubTypeMutation, { data, loading, error }] = useUpdateClientSubTypeMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateClientSubTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientSubTypeMutation, UpdateClientSubTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientSubTypeMutation, UpdateClientSubTypeMutationVariables>(UpdateClientSubTypeDocument, options);
      }
export type UpdateClientSubTypeMutationHookResult = ReturnType<typeof useUpdateClientSubTypeMutation>;
export type UpdateClientSubTypeMutationResult = Apollo.MutationResult<UpdateClientSubTypeMutation>;
export type UpdateClientSubTypeMutationOptions = Apollo.BaseMutationOptions<UpdateClientSubTypeMutation, UpdateClientSubTypeMutationVariables>;
export const CreateClientCompanyDocument = gql`
    mutation createClientCompany($input: CreateClientCompanyInput) {
  createClientCompany(input: $input) {
    ...ClientCompanyFull
    contacts {
      id
      name
    }
    campaigns {
      id
      job_reference
      name
    }
  }
}
    ${ClientCompanyFullFragmentDoc}`;
export type CreateClientCompanyMutationFn = Apollo.MutationFunction<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>;

/**
 * __useCreateClientCompanyMutation__
 *
 * To run a mutation, you first call `useCreateClientCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientCompanyMutation, { data, loading, error }] = useCreateClientCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>(CreateClientCompanyDocument, options);
      }
export type CreateClientCompanyMutationHookResult = ReturnType<typeof useCreateClientCompanyMutation>;
export type CreateClientCompanyMutationResult = Apollo.MutationResult<CreateClientCompanyMutation>;
export type CreateClientCompanyMutationOptions = Apollo.BaseMutationOptions<CreateClientCompanyMutation, CreateClientCompanyMutationVariables>;
export const GetClientCompanyDocument = gql`
    query getClientCompany($id: ID) {
  clientCompany(id: $id) {
    ...ClientCompanyFull
    contacts {
      id
      name
    }
    campaigns {
      id
      job_reference
      name
    }
  }
}
    ${ClientCompanyFullFragmentDoc}`;

/**
 * __useGetClientCompanyQuery__
 *
 * To run a query within a React component, call `useGetClientCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetClientCompanyQuery, GetClientCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientCompanyQuery, GetClientCompanyQueryVariables>(GetClientCompanyDocument, options);
      }
export function useGetClientCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientCompanyQuery, GetClientCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientCompanyQuery, GetClientCompanyQueryVariables>(GetClientCompanyDocument, options);
        }
export type GetClientCompanyQueryHookResult = ReturnType<typeof useGetClientCompanyQuery>;
export type GetClientCompanyLazyQueryHookResult = ReturnType<typeof useGetClientCompanyLazyQuery>;
export type GetClientCompanyQueryResult = Apollo.QueryResult<GetClientCompanyQuery, GetClientCompanyQueryVariables>;
export const UpdateClientCompanyDocument = gql`
    mutation updateClientCompany($input: UpdateClientCompanyInput) {
  updateClientCompany(input: $input) {
    ...ClientCompanyFull
    contacts {
      id
      name
    }
    campaigns {
      id
      job_reference
      name
    }
  }
}
    ${ClientCompanyFullFragmentDoc}`;
export type UpdateClientCompanyMutationFn = Apollo.MutationFunction<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>;

/**
 * __useUpdateClientCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateClientCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientCompanyMutation, { data, loading, error }] = useUpdateClientCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>(UpdateClientCompanyDocument, options);
      }
export type UpdateClientCompanyMutationHookResult = ReturnType<typeof useUpdateClientCompanyMutation>;
export type UpdateClientCompanyMutationResult = Apollo.MutationResult<UpdateClientCompanyMutation>;
export type UpdateClientCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateClientCompanyMutation, UpdateClientCompanyMutationVariables>;
export const GetContractTemplatesQueryDocument = gql`
    query getContractTemplatesQuery {
  contractTemplates(orderBy: [{column: "sort", order: ASC}]) {
    ...contractTemplateFull
  }
}
    ${ContractTemplateFullFragmentDoc}`;

/**
 * __useGetContractTemplatesQueryQuery__
 *
 * To run a query within a React component, call `useGetContractTemplatesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTemplatesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTemplatesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContractTemplatesQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetContractTemplatesQueryQuery, GetContractTemplatesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractTemplatesQueryQuery, GetContractTemplatesQueryQueryVariables>(GetContractTemplatesQueryDocument, options);
      }
export function useGetContractTemplatesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractTemplatesQueryQuery, GetContractTemplatesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractTemplatesQueryQuery, GetContractTemplatesQueryQueryVariables>(GetContractTemplatesQueryDocument, options);
        }
export type GetContractTemplatesQueryQueryHookResult = ReturnType<typeof useGetContractTemplatesQueryQuery>;
export type GetContractTemplatesQueryLazyQueryHookResult = ReturnType<typeof useGetContractTemplatesQueryLazyQuery>;
export type GetContractTemplatesQueryQueryResult = Apollo.QueryResult<GetContractTemplatesQueryQuery, GetContractTemplatesQueryQueryVariables>;
export const GetContractTemplateQueryDocument = gql`
    query getContractTemplateQuery($id: ID) {
  getContractTemplate(id: $id) {
    ...contractTemplateFull
  }
}
    ${ContractTemplateFullFragmentDoc}`;

/**
 * __useGetContractTemplateQueryQuery__
 *
 * To run a query within a React component, call `useGetContractTemplateQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContractTemplateQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContractTemplateQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetContractTemplateQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetContractTemplateQueryQuery, GetContractTemplateQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContractTemplateQueryQuery, GetContractTemplateQueryQueryVariables>(GetContractTemplateQueryDocument, options);
      }
export function useGetContractTemplateQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContractTemplateQueryQuery, GetContractTemplateQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContractTemplateQueryQuery, GetContractTemplateQueryQueryVariables>(GetContractTemplateQueryDocument, options);
        }
export type GetContractTemplateQueryQueryHookResult = ReturnType<typeof useGetContractTemplateQueryQuery>;
export type GetContractTemplateQueryLazyQueryHookResult = ReturnType<typeof useGetContractTemplateQueryLazyQuery>;
export type GetContractTemplateQueryQueryResult = Apollo.QueryResult<GetContractTemplateQueryQuery, GetContractTemplateQueryQueryVariables>;
export const CreateContractTemplateDocument = gql`
    mutation createContractTemplate($input: CreateContractTemplateInput!) {
  createContractTemplate(input: $input) {
    ...contractTemplateFull
  }
}
    ${ContractTemplateFullFragmentDoc}`;
export type CreateContractTemplateMutationFn = Apollo.MutationFunction<CreateContractTemplateMutation, CreateContractTemplateMutationVariables>;

/**
 * __useCreateContractTemplateMutation__
 *
 * To run a mutation, you first call `useCreateContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractTemplateMutation, { data, loading, error }] = useCreateContractTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractTemplateMutation, CreateContractTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractTemplateMutation, CreateContractTemplateMutationVariables>(CreateContractTemplateDocument, options);
      }
export type CreateContractTemplateMutationHookResult = ReturnType<typeof useCreateContractTemplateMutation>;
export type CreateContractTemplateMutationResult = Apollo.MutationResult<CreateContractTemplateMutation>;
export type CreateContractTemplateMutationOptions = Apollo.BaseMutationOptions<CreateContractTemplateMutation, CreateContractTemplateMutationVariables>;
export const UpdateContractTemplateDocument = gql`
    mutation updateContractTemplate($input: UpdateContractTemplateInput!) {
  updateContractTemplate(input: $input) {
    ...contractTemplateFull
  }
}
    ${ContractTemplateFullFragmentDoc}`;
export type UpdateContractTemplateMutationFn = Apollo.MutationFunction<UpdateContractTemplateMutation, UpdateContractTemplateMutationVariables>;

/**
 * __useUpdateContractTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractTemplateMutation, { data, loading, error }] = useUpdateContractTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractTemplateMutation, UpdateContractTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractTemplateMutation, UpdateContractTemplateMutationVariables>(UpdateContractTemplateDocument, options);
      }
export type UpdateContractTemplateMutationHookResult = ReturnType<typeof useUpdateContractTemplateMutation>;
export type UpdateContractTemplateMutationResult = Apollo.MutationResult<UpdateContractTemplateMutation>;
export type UpdateContractTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateContractTemplateMutation, UpdateContractTemplateMutationVariables>;
export const DeleteContractTemplateDocument = gql`
    mutation deleteContractTemplate($id: ID!) {
  deleteContractTemplate(id: $id) {
    id
  }
}
    `;
export type DeleteContractTemplateMutationFn = Apollo.MutationFunction<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables>;

/**
 * __useDeleteContractTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteContractTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContractTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContractTemplateMutation, { data, loading, error }] = useDeleteContractTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContractTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables>(DeleteContractTemplateDocument, options);
      }
export type DeleteContractTemplateMutationHookResult = ReturnType<typeof useDeleteContractTemplateMutation>;
export type DeleteContractTemplateMutationResult = Apollo.MutationResult<DeleteContractTemplateMutation>;
export type DeleteContractTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteContractTemplateMutation, DeleteContractTemplateMutationVariables>;
export const UpdateCurrenciesDocument = gql`
    mutation UpdateCurrencies($update: UpdateCurrencies) {
  updateCurrencies(input: $update) {
    ...CurrencyFull
  }
}
    ${CurrencyFullFragmentDoc}`;
export type UpdateCurrenciesMutationFn = Apollo.MutationFunction<UpdateCurrenciesMutation, UpdateCurrenciesMutationVariables>;

/**
 * __useUpdateCurrenciesMutation__
 *
 * To run a mutation, you first call `useUpdateCurrenciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrenciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrenciesMutation, { data, loading, error }] = useUpdateCurrenciesMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateCurrenciesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrenciesMutation, UpdateCurrenciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrenciesMutation, UpdateCurrenciesMutationVariables>(UpdateCurrenciesDocument, options);
      }
export type UpdateCurrenciesMutationHookResult = ReturnType<typeof useUpdateCurrenciesMutation>;
export type UpdateCurrenciesMutationResult = Apollo.MutationResult<UpdateCurrenciesMutation>;
export type UpdateCurrenciesMutationOptions = Apollo.BaseMutationOptions<UpdateCurrenciesMutation, UpdateCurrenciesMutationVariables>;
export const SearchCrmQueryDocument = gql`
    query searchCrmQuery($sales_team_ids: [ID], $account_manager_ids: [ID], $client_sub_type_ids: [ID], $contact_ids: [ID], $client_ids: [ID], $sales_team_all: Boolean, $sales_team_core: Boolean, $status_in: [String!], $completion_date_between: DateRange, $completion_date_in: [DateRange!]) {
  campaigns(
    first: 10000
    client_sub_type_in: $client_sub_type_ids
    sales_team_in: $sales_team_ids
    status_in: $status_in
    our_contact_in: $account_manager_ids
    sales_team_all: $sales_team_all
    sales_team_core: $sales_team_core
    client_company_contact_in: $contact_ids
    client_company_in: $client_ids
    completion_date_between: $completion_date_between
    completion_date_in: $completion_date_in
  ) {
    data {
      id
      name
      job_reference
      start_date
      status
      total_price_reporting
      discount_percentage
      margin
      totalCostsReporting
      clientCompany {
        id
        accounts_company
      }
      clientSubType {
        id
        name
      }
      reportingCurrency {
        ...CurrencyFull
      }
      invoice
      purchase_order
      completion_date
      salesTeam {
        id
        name
        prefix
        include_dashboard_core
      }
      ourContact {
        name
      }
    }
  }
}
    ${CurrencyFullFragmentDoc}`;

/**
 * __useSearchCrmQueryQuery__
 *
 * To run a query within a React component, call `useSearchCrmQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCrmQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCrmQueryQuery({
 *   variables: {
 *      sales_team_ids: // value for 'sales_team_ids'
 *      account_manager_ids: // value for 'account_manager_ids'
 *      client_sub_type_ids: // value for 'client_sub_type_ids'
 *      contact_ids: // value for 'contact_ids'
 *      client_ids: // value for 'client_ids'
 *      sales_team_all: // value for 'sales_team_all'
 *      sales_team_core: // value for 'sales_team_core'
 *      status_in: // value for 'status_in'
 *      completion_date_between: // value for 'completion_date_between'
 *      completion_date_in: // value for 'completion_date_in'
 *   },
 * });
 */
export function useSearchCrmQueryQuery(baseOptions?: Apollo.QueryHookOptions<SearchCrmQueryQuery, SearchCrmQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCrmQueryQuery, SearchCrmQueryQueryVariables>(SearchCrmQueryDocument, options);
      }
export function useSearchCrmQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCrmQueryQuery, SearchCrmQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCrmQueryQuery, SearchCrmQueryQueryVariables>(SearchCrmQueryDocument, options);
        }
export type SearchCrmQueryQueryHookResult = ReturnType<typeof useSearchCrmQueryQuery>;
export type SearchCrmQueryLazyQueryHookResult = ReturnType<typeof useSearchCrmQueryLazyQuery>;
export type SearchCrmQueryQueryResult = Apollo.QueryResult<SearchCrmQueryQuery, SearchCrmQueryQueryVariables>;
export const DashboardSitesQueryDocument = gql`
    query DashboardSitesQuery {
  sites(is_dashboard_site: true) {
    id
    name
    region {
      name
    }
    siteStructure {
      name
    }
    is_dashboard_site
    externalLink
  }
}
    `;

/**
 * __useDashboardSitesQueryQuery__
 *
 * To run a query within a React component, call `useDashboardSitesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardSitesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardSitesQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useDashboardSitesQueryQuery(baseOptions?: Apollo.QueryHookOptions<DashboardSitesQueryQuery, DashboardSitesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardSitesQueryQuery, DashboardSitesQueryQueryVariables>(DashboardSitesQueryDocument, options);
      }
export function useDashboardSitesQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardSitesQueryQuery, DashboardSitesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardSitesQueryQuery, DashboardSitesQueryQueryVariables>(DashboardSitesQueryDocument, options);
        }
export type DashboardSitesQueryQueryHookResult = ReturnType<typeof useDashboardSitesQueryQuery>;
export type DashboardSitesQueryLazyQueryHookResult = ReturnType<typeof useDashboardSitesQueryLazyQuery>;
export type DashboardSitesQueryQueryResult = Apollo.QueryResult<DashboardSitesQueryQuery, DashboardSitesQueryQueryVariables>;
export const ToggleDashboardSiteMutationDocument = gql`
    mutation ToggleDashboardSiteMutation($id: ID!, $is_dashboard_site: Boolean!) {
  toggleDashboardSite(id: $id, is_dashboard_site: $is_dashboard_site) {
    id
    is_dashboard_site
  }
}
    `;
export type ToggleDashboardSiteMutationMutationFn = Apollo.MutationFunction<ToggleDashboardSiteMutationMutation, ToggleDashboardSiteMutationMutationVariables>;

/**
 * __useToggleDashboardSiteMutationMutation__
 *
 * To run a mutation, you first call `useToggleDashboardSiteMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleDashboardSiteMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleDashboardSiteMutationMutation, { data, loading, error }] = useToggleDashboardSiteMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      is_dashboard_site: // value for 'is_dashboard_site'
 *   },
 * });
 */
export function useToggleDashboardSiteMutationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleDashboardSiteMutationMutation, ToggleDashboardSiteMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleDashboardSiteMutationMutation, ToggleDashboardSiteMutationMutationVariables>(ToggleDashboardSiteMutationDocument, options);
      }
export type ToggleDashboardSiteMutationMutationHookResult = ReturnType<typeof useToggleDashboardSiteMutationMutation>;
export type ToggleDashboardSiteMutationMutationResult = Apollo.MutationResult<ToggleDashboardSiteMutationMutation>;
export type ToggleDashboardSiteMutationMutationOptions = Apollo.BaseMutationOptions<ToggleDashboardSiteMutationMutation, ToggleDashboardSiteMutationMutationVariables>;
export const SearchCampaignQueryDocument = gql`
    query searchCampaignQuery($completion_date_between: DateRange, $sales_team_ids: [ID], $status_in: [String!], $sales_team_all: Boolean, $sales_team_core: Boolean, $regional_am_revenue_id_in: [ID]) {
  campaigns(
    first: 10000
    completion_date_between: $completion_date_between
    sales_team_in: $sales_team_ids
    status_in: $status_in
    sales_team_all: $sales_team_all
    sales_team_core: $sales_team_core
    regional_am_revenue_id_in: $regional_am_revenue_id_in
  ) {
    data {
      id
      name
      job_reference
      start_date
      status
      total_price_reporting
      discount_percentage
      margin
      totalCostsReporting
      clientCompany {
        accounts_company
        sales_company
      }
      reportingCurrency {
        ...CurrencyFull
      }
      invoice
      purchase_order
      completion_date
      salesTeam {
        id
        name
      }
      ourContact {
        name
      }
    }
  }
}
    ${CurrencyFullFragmentDoc}`;

/**
 * __useSearchCampaignQueryQuery__
 *
 * To run a query within a React component, call `useSearchCampaignQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCampaignQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCampaignQueryQuery({
 *   variables: {
 *      completion_date_between: // value for 'completion_date_between'
 *      sales_team_ids: // value for 'sales_team_ids'
 *      status_in: // value for 'status_in'
 *      sales_team_all: // value for 'sales_team_all'
 *      sales_team_core: // value for 'sales_team_core'
 *      regional_am_revenue_id_in: // value for 'regional_am_revenue_id_in'
 *   },
 * });
 */
export function useSearchCampaignQueryQuery(baseOptions?: Apollo.QueryHookOptions<SearchCampaignQueryQuery, SearchCampaignQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCampaignQueryQuery, SearchCampaignQueryQueryVariables>(SearchCampaignQueryDocument, options);
      }
export function useSearchCampaignQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCampaignQueryQuery, SearchCampaignQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCampaignQueryQuery, SearchCampaignQueryQueryVariables>(SearchCampaignQueryDocument, options);
        }
export type SearchCampaignQueryQueryHookResult = ReturnType<typeof useSearchCampaignQueryQuery>;
export type SearchCampaignQueryLazyQueryHookResult = ReturnType<typeof useSearchCampaignQueryLazyQuery>;
export type SearchCampaignQueryQueryResult = Apollo.QueryResult<SearchCampaignQueryQuery, SearchCampaignQueryQueryVariables>;
export const GetShortcutsQueryDocument = gql`
    query getShortcutsQuery {
  me {
    id
    campaignShortcuts {
      id
      name
      job_reference
      status
      start_date
    }
  }
}
    `;

/**
 * __useGetShortcutsQueryQuery__
 *
 * To run a query within a React component, call `useGetShortcutsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShortcutsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShortcutsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetShortcutsQueryQuery(baseOptions?: Apollo.QueryHookOptions<GetShortcutsQueryQuery, GetShortcutsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShortcutsQueryQuery, GetShortcutsQueryQueryVariables>(GetShortcutsQueryDocument, options);
      }
export function useGetShortcutsQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShortcutsQueryQuery, GetShortcutsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShortcutsQueryQuery, GetShortcutsQueryQueryVariables>(GetShortcutsQueryDocument, options);
        }
export type GetShortcutsQueryQueryHookResult = ReturnType<typeof useGetShortcutsQueryQuery>;
export type GetShortcutsQueryLazyQueryHookResult = ReturnType<typeof useGetShortcutsQueryLazyQuery>;
export type GetShortcutsQueryQueryResult = Apollo.QueryResult<GetShortcutsQueryQuery, GetShortcutsQueryQueryVariables>;
export const CreateDistributorDocument = gql`
    mutation createDistributor($input: CreateDistributorInput!) {
  createDistributor(input: $input) {
    ...DistributorFull
  }
}
    ${DistributorFullFragmentDoc}`;
export type CreateDistributorMutationFn = Apollo.MutationFunction<CreateDistributorMutation, CreateDistributorMutationVariables>;

/**
 * __useCreateDistributorMutation__
 *
 * To run a mutation, you first call `useCreateDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDistributorMutation, { data, loading, error }] = useCreateDistributorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDistributorMutation(baseOptions?: Apollo.MutationHookOptions<CreateDistributorMutation, CreateDistributorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDistributorMutation, CreateDistributorMutationVariables>(CreateDistributorDocument, options);
      }
export type CreateDistributorMutationHookResult = ReturnType<typeof useCreateDistributorMutation>;
export type CreateDistributorMutationResult = Apollo.MutationResult<CreateDistributorMutation>;
export type CreateDistributorMutationOptions = Apollo.BaseMutationOptions<CreateDistributorMutation, CreateDistributorMutationVariables>;
export const GetDistributorDocument = gql`
    query getDistributor($id: ID!) {
  distributor(id: $id) {
    ...DistributorFull
  }
}
    ${DistributorFullFragmentDoc}`;

/**
 * __useGetDistributorQuery__
 *
 * To run a query within a React component, call `useGetDistributorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDistributorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDistributorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDistributorQuery(baseOptions: Apollo.QueryHookOptions<GetDistributorQuery, GetDistributorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDistributorQuery, GetDistributorQueryVariables>(GetDistributorDocument, options);
      }
export function useGetDistributorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDistributorQuery, GetDistributorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDistributorQuery, GetDistributorQueryVariables>(GetDistributorDocument, options);
        }
export type GetDistributorQueryHookResult = ReturnType<typeof useGetDistributorQuery>;
export type GetDistributorLazyQueryHookResult = ReturnType<typeof useGetDistributorLazyQuery>;
export type GetDistributorQueryResult = Apollo.QueryResult<GetDistributorQuery, GetDistributorQueryVariables>;
export const UpdateDistributorDocument = gql`
    mutation updateDistributor($input: UpdateDistributorInput!) {
  updateDistributor(input: $input) {
    ...DistributorFull
  }
}
    ${DistributorFullFragmentDoc}`;
export type UpdateDistributorMutationFn = Apollo.MutationFunction<UpdateDistributorMutation, UpdateDistributorMutationVariables>;

/**
 * __useUpdateDistributorMutation__
 *
 * To run a mutation, you first call `useUpdateDistributorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDistributorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDistributorMutation, { data, loading, error }] = useUpdateDistributorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDistributorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDistributorMutation, UpdateDistributorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDistributorMutation, UpdateDistributorMutationVariables>(UpdateDistributorDocument, options);
      }
export type UpdateDistributorMutationHookResult = ReturnType<typeof useUpdateDistributorMutation>;
export type UpdateDistributorMutationResult = Apollo.MutationResult<UpdateDistributorMutation>;
export type UpdateDistributorMutationOptions = Apollo.BaseMutationOptions<UpdateDistributorMutation, UpdateDistributorMutationVariables>;
export const ExperientialTypesMutationDocument = gql`
    mutation experientialTypesMutation($update: UpdateExperientialTypesInput) {
  updateExperientialTypes(input: $update) {
    ...ExperientialTypeFull
  }
}
    ${ExperientialTypeFullFragmentDoc}`;
export type ExperientialTypesMutationMutationFn = Apollo.MutationFunction<ExperientialTypesMutationMutation, ExperientialTypesMutationMutationVariables>;

/**
 * __useExperientialTypesMutationMutation__
 *
 * To run a mutation, you first call `useExperientialTypesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExperientialTypesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [experientialTypesMutationMutation, { data, loading, error }] = useExperientialTypesMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useExperientialTypesMutationMutation(baseOptions?: Apollo.MutationHookOptions<ExperientialTypesMutationMutation, ExperientialTypesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExperientialTypesMutationMutation, ExperientialTypesMutationMutationVariables>(ExperientialTypesMutationDocument, options);
      }
export type ExperientialTypesMutationMutationHookResult = ReturnType<typeof useExperientialTypesMutationMutation>;
export type ExperientialTypesMutationMutationResult = Apollo.MutationResult<ExperientialTypesMutationMutation>;
export type ExperientialTypesMutationMutationOptions = Apollo.BaseMutationOptions<ExperientialTypesMutationMutation, ExperientialTypesMutationMutationVariables>;
export const ImportFileDataDocument = gql`
    mutation importFileData($file: Upload!) {
  importFileData(file: $file) {
    success
    failedJobs
  }
}
    `;
export type ImportFileDataMutationFn = Apollo.MutationFunction<ImportFileDataMutation, ImportFileDataMutationVariables>;

/**
 * __useImportFileDataMutation__
 *
 * To run a mutation, you first call `useImportFileDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportFileDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importFileDataMutation, { data, loading, error }] = useImportFileDataMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportFileDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportFileDataMutation, ImportFileDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportFileDataMutation, ImportFileDataMutationVariables>(ImportFileDataDocument, options);
      }
export type ImportFileDataMutationHookResult = ReturnType<typeof useImportFileDataMutation>;
export type ImportFileDataMutationResult = Apollo.MutationResult<ImportFileDataMutation>;
export type ImportFileDataMutationOptions = Apollo.BaseMutationOptions<ImportFileDataMutation, ImportFileDataMutationVariables>;
export const ImportInvoiceDataDocument = gql`
    mutation importInvoiceData($file: Upload!) {
  importInvoiceData(file: $file)
}
    `;
export type ImportInvoiceDataMutationFn = Apollo.MutationFunction<ImportInvoiceDataMutation, ImportInvoiceDataMutationVariables>;

/**
 * __useImportInvoiceDataMutation__
 *
 * To run a mutation, you first call `useImportInvoiceDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportInvoiceDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importInvoiceDataMutation, { data, loading, error }] = useImportInvoiceDataMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportInvoiceDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportInvoiceDataMutation, ImportInvoiceDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportInvoiceDataMutation, ImportInvoiceDataMutationVariables>(ImportInvoiceDataDocument, options);
      }
export type ImportInvoiceDataMutationHookResult = ReturnType<typeof useImportInvoiceDataMutation>;
export type ImportInvoiceDataMutationResult = Apollo.MutationResult<ImportInvoiceDataMutation>;
export type ImportInvoiceDataMutationOptions = Apollo.BaseMutationOptions<ImportInvoiceDataMutation, ImportInvoiceDataMutationVariables>;
export const ImportPopsDataDocument = gql`
    mutation importPopsData($file: Upload!) {
  importPopsData(file: $file)
}
    `;
export type ImportPopsDataMutationFn = Apollo.MutationFunction<ImportPopsDataMutation, ImportPopsDataMutationVariables>;

/**
 * __useImportPopsDataMutation__
 *
 * To run a mutation, you first call `useImportPopsDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportPopsDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importPopsDataMutation, { data, loading, error }] = useImportPopsDataMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useImportPopsDataMutation(baseOptions?: Apollo.MutationHookOptions<ImportPopsDataMutation, ImportPopsDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportPopsDataMutation, ImportPopsDataMutationVariables>(ImportPopsDataDocument, options);
      }
export type ImportPopsDataMutationHookResult = ReturnType<typeof useImportPopsDataMutation>;
export type ImportPopsDataMutationResult = Apollo.MutationResult<ImportPopsDataMutation>;
export type ImportPopsDataMutationOptions = Apollo.BaseMutationOptions<ImportPopsDataMutation, ImportPopsDataMutationVariables>;
export const CreateLandlordDocument = gql`
    mutation createLandlord($input: CreateSubletterInput!) {
  createSubletter(input: $input) {
    ...SubletterFull
  }
}
    ${SubletterFullFragmentDoc}`;
export type CreateLandlordMutationFn = Apollo.MutationFunction<CreateLandlordMutation, CreateLandlordMutationVariables>;

/**
 * __useCreateLandlordMutation__
 *
 * To run a mutation, you first call `useCreateLandlordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLandlordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLandlordMutation, { data, loading, error }] = useCreateLandlordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLandlordMutation(baseOptions?: Apollo.MutationHookOptions<CreateLandlordMutation, CreateLandlordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLandlordMutation, CreateLandlordMutationVariables>(CreateLandlordDocument, options);
      }
export type CreateLandlordMutationHookResult = ReturnType<typeof useCreateLandlordMutation>;
export type CreateLandlordMutationResult = Apollo.MutationResult<CreateLandlordMutation>;
export type CreateLandlordMutationOptions = Apollo.BaseMutationOptions<CreateLandlordMutation, CreateLandlordMutationVariables>;
export const GetLandlordDocument = gql`
    query getLandlord($id: ID!) {
  subletter(id: $id) {
    ...SubletterFull
  }
}
    ${SubletterFullFragmentDoc}`;

/**
 * __useGetLandlordQuery__
 *
 * To run a query within a React component, call `useGetLandlordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandlordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandlordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLandlordQuery(baseOptions: Apollo.QueryHookOptions<GetLandlordQuery, GetLandlordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandlordQuery, GetLandlordQueryVariables>(GetLandlordDocument, options);
      }
export function useGetLandlordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandlordQuery, GetLandlordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandlordQuery, GetLandlordQueryVariables>(GetLandlordDocument, options);
        }
export type GetLandlordQueryHookResult = ReturnType<typeof useGetLandlordQuery>;
export type GetLandlordLazyQueryHookResult = ReturnType<typeof useGetLandlordLazyQuery>;
export type GetLandlordQueryResult = Apollo.QueryResult<GetLandlordQuery, GetLandlordQueryVariables>;
export const UpdateLandlordDocument = gql`
    mutation updateLandlord($input: UpdateSubletterInput!) {
  updateSubletter(input: $input) {
    ...SubletterFull
  }
}
    ${SubletterFullFragmentDoc}`;
export type UpdateLandlordMutationFn = Apollo.MutationFunction<UpdateLandlordMutation, UpdateLandlordMutationVariables>;

/**
 * __useUpdateLandlordMutation__
 *
 * To run a mutation, you first call `useUpdateLandlordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandlordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandlordMutation, { data, loading, error }] = useUpdateLandlordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLandlordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandlordMutation, UpdateLandlordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandlordMutation, UpdateLandlordMutationVariables>(UpdateLandlordDocument, options);
      }
export type UpdateLandlordMutationHookResult = ReturnType<typeof useUpdateLandlordMutation>;
export type UpdateLandlordMutationResult = Apollo.MutationResult<UpdateLandlordMutation>;
export type UpdateLandlordMutationOptions = Apollo.BaseMutationOptions<UpdateLandlordMutation, UpdateLandlordMutationVariables>;
export const RemoveOtherUserProxyDocument = gql`
    mutation removeOtherUserProxy($input: RemoveUserProxyInput!) {
  removeOtherUserProxy(input: $input) {
    ...MeDetails
  }
}
    ${MeDetailsFragmentDoc}`;
export type RemoveOtherUserProxyMutationFn = Apollo.MutationFunction<RemoveOtherUserProxyMutation, RemoveOtherUserProxyMutationVariables>;

/**
 * __useRemoveOtherUserProxyMutation__
 *
 * To run a mutation, you first call `useRemoveOtherUserProxyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOtherUserProxyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOtherUserProxyMutation, { data, loading, error }] = useRemoveOtherUserProxyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOtherUserProxyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveOtherUserProxyMutation, RemoveOtherUserProxyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveOtherUserProxyMutation, RemoveOtherUserProxyMutationVariables>(RemoveOtherUserProxyDocument, options);
      }
export type RemoveOtherUserProxyMutationHookResult = ReturnType<typeof useRemoveOtherUserProxyMutation>;
export type RemoveOtherUserProxyMutationResult = Apollo.MutationResult<RemoveOtherUserProxyMutation>;
export type RemoveOtherUserProxyMutationOptions = Apollo.BaseMutationOptions<RemoveOtherUserProxyMutation, RemoveOtherUserProxyMutationVariables>;
export const UpdateMeDocument = gql`
    mutation updateMe($input: UpdateMeInput!) {
  updateMe(input: $input) {
    ...MeDetails
  }
}
    ${MeDetailsFragmentDoc}`;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const CreateOptionDocument = gql`
    mutation createOption($input: CreateOptionInput!) {
  createOption(input: $input) {
    ...OptionFull
  }
}
    ${OptionFullFragmentDoc}`;
export type CreateOptionMutationFn = Apollo.MutationFunction<CreateOptionMutation, CreateOptionMutationVariables>;

/**
 * __useCreateOptionMutation__
 *
 * To run a mutation, you first call `useCreateOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOptionMutation, { data, loading, error }] = useCreateOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOptionMutation, CreateOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOptionMutation, CreateOptionMutationVariables>(CreateOptionDocument, options);
      }
export type CreateOptionMutationHookResult = ReturnType<typeof useCreateOptionMutation>;
export type CreateOptionMutationResult = Apollo.MutationResult<CreateOptionMutation>;
export type CreateOptionMutationOptions = Apollo.BaseMutationOptions<CreateOptionMutation, CreateOptionMutationVariables>;
export const GetOptionDocument = gql`
    query getOption($id: ID, $code: String) {
  option(id: $id, code: $code) {
    ...OptionFull
  }
}
    ${OptionFullFragmentDoc}`;

/**
 * __useGetOptionQuery__
 *
 * To run a query within a React component, call `useGetOptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useGetOptionQuery(baseOptions?: Apollo.QueryHookOptions<GetOptionQuery, GetOptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOptionQuery, GetOptionQueryVariables>(GetOptionDocument, options);
      }
export function useGetOptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOptionQuery, GetOptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOptionQuery, GetOptionQueryVariables>(GetOptionDocument, options);
        }
export type GetOptionQueryHookResult = ReturnType<typeof useGetOptionQuery>;
export type GetOptionLazyQueryHookResult = ReturnType<typeof useGetOptionLazyQuery>;
export type GetOptionQueryResult = Apollo.QueryResult<GetOptionQuery, GetOptionQueryVariables>;
export const UpdateOptionDocument = gql`
    mutation updateOption($input: UpdateOptionInput!) {
  updateOption(input: $input) {
    ...OptionFull
  }
}
    ${OptionFullFragmentDoc}`;
export type UpdateOptionMutationFn = Apollo.MutationFunction<UpdateOptionMutation, UpdateOptionMutationVariables>;

/**
 * __useUpdateOptionMutation__
 *
 * To run a mutation, you first call `useUpdateOptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionMutation, { data, loading, error }] = useUpdateOptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOptionMutation, UpdateOptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOptionMutation, UpdateOptionMutationVariables>(UpdateOptionDocument, options);
      }
export type UpdateOptionMutationHookResult = ReturnType<typeof useUpdateOptionMutation>;
export type UpdateOptionMutationResult = Apollo.MutationResult<UpdateOptionMutation>;
export type UpdateOptionMutationOptions = Apollo.BaseMutationOptions<UpdateOptionMutation, UpdateOptionMutationVariables>;
export const SundryTypesMutationDocument = gql`
    mutation sundryTypesMutation($update: UpdateSundryTypesInput) {
  updateSundryTypes(input: $update) {
    ...SundryTypeFull
  }
}
    ${SundryTypeFullFragmentDoc}`;
export type SundryTypesMutationMutationFn = Apollo.MutationFunction<SundryTypesMutationMutation, SundryTypesMutationMutationVariables>;

/**
 * __useSundryTypesMutationMutation__
 *
 * To run a mutation, you first call `useSundryTypesMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSundryTypesMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sundryTypesMutationMutation, { data, loading, error }] = useSundryTypesMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useSundryTypesMutationMutation(baseOptions?: Apollo.MutationHookOptions<SundryTypesMutationMutation, SundryTypesMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SundryTypesMutationMutation, SundryTypesMutationMutationVariables>(SundryTypesMutationDocument, options);
      }
export type SundryTypesMutationMutationHookResult = ReturnType<typeof useSundryTypesMutationMutation>;
export type SundryTypesMutationMutationResult = Apollo.MutationResult<SundryTypesMutationMutation>;
export type SundryTypesMutationMutationOptions = Apollo.BaseMutationOptions<SundryTypesMutationMutation, SundryTypesMutationMutationVariables>;
export const UpdatePanelBookingDocument = gql`
    mutation updatePanelBooking($id: ID, $week_number: Int, $num_weeks: Int, $trim: Int, $ignore_loss_of_pole: Boolean) {
  updatePanelBooking(
    input: {id: $id, week_number: $week_number, num_weeks: $num_weeks, trim: $trim, ignore_loss_of_pole: $ignore_loss_of_pole}
  ) {
    ...PanelBookingDateSummaryFull
  }
}
    ${PanelBookingDateSummaryFullFragmentDoc}`;
export type UpdatePanelBookingMutationFn = Apollo.MutationFunction<UpdatePanelBookingMutation, UpdatePanelBookingMutationVariables>;

/**
 * __useUpdatePanelBookingMutation__
 *
 * To run a mutation, you first call `useUpdatePanelBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePanelBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePanelBookingMutation, { data, loading, error }] = useUpdatePanelBookingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      week_number: // value for 'week_number'
 *      num_weeks: // value for 'num_weeks'
 *      trim: // value for 'trim'
 *      ignore_loss_of_pole: // value for 'ignore_loss_of_pole'
 *   },
 * });
 */
export function useUpdatePanelBookingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePanelBookingMutation, UpdatePanelBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePanelBookingMutation, UpdatePanelBookingMutationVariables>(UpdatePanelBookingDocument, options);
      }
export type UpdatePanelBookingMutationHookResult = ReturnType<typeof useUpdatePanelBookingMutation>;
export type UpdatePanelBookingMutationResult = Apollo.MutationResult<UpdatePanelBookingMutation>;
export type UpdatePanelBookingMutationOptions = Apollo.BaseMutationOptions<UpdatePanelBookingMutation, UpdatePanelBookingMutationVariables>;
export const GetPosterSizesForImagesDocument = gql`
    query getPosterSizesForImages {
  posterSizes {
    id
    name
  }
}
    `;

/**
 * __useGetPosterSizesForImagesQuery__
 *
 * To run a query within a React component, call `useGetPosterSizesForImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosterSizesForImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosterSizesForImagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPosterSizesForImagesQuery(baseOptions?: Apollo.QueryHookOptions<GetPosterSizesForImagesQuery, GetPosterSizesForImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosterSizesForImagesQuery, GetPosterSizesForImagesQueryVariables>(GetPosterSizesForImagesDocument, options);
      }
export function useGetPosterSizesForImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosterSizesForImagesQuery, GetPosterSizesForImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosterSizesForImagesQuery, GetPosterSizesForImagesQueryVariables>(GetPosterSizesForImagesDocument, options);
        }
export type GetPosterSizesForImagesQueryHookResult = ReturnType<typeof useGetPosterSizesForImagesQuery>;
export type GetPosterSizesForImagesLazyQueryHookResult = ReturnType<typeof useGetPosterSizesForImagesLazyQuery>;
export type GetPosterSizesForImagesQueryResult = Apollo.QueryResult<GetPosterSizesForImagesQuery, GetPosterSizesForImagesQueryVariables>;
export const GetPosterSizeImageDocument = gql`
    query getPosterSizeImage($id: ID!) {
  posterSize(id: $id) {
    id
    name
    images {
      id
      original_name
      url
      thumbnail_url
      uploaded
      creation_id
    }
    image_caption
  }
}
    `;

/**
 * __useGetPosterSizeImageQuery__
 *
 * To run a query within a React component, call `useGetPosterSizeImageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPosterSizeImageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPosterSizeImageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPosterSizeImageQuery(baseOptions: Apollo.QueryHookOptions<GetPosterSizeImageQuery, GetPosterSizeImageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPosterSizeImageQuery, GetPosterSizeImageQueryVariables>(GetPosterSizeImageDocument, options);
      }
export function useGetPosterSizeImageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPosterSizeImageQuery, GetPosterSizeImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPosterSizeImageQuery, GetPosterSizeImageQueryVariables>(GetPosterSizeImageDocument, options);
        }
export type GetPosterSizeImageQueryHookResult = ReturnType<typeof useGetPosterSizeImageQuery>;
export type GetPosterSizeImageLazyQueryHookResult = ReturnType<typeof useGetPosterSizeImageLazyQuery>;
export type GetPosterSizeImageQueryResult = Apollo.QueryResult<GetPosterSizeImageQuery, GetPosterSizeImageQueryVariables>;
export const UpdatePosterSizeDocument = gql`
    mutation updatePosterSize($input: UpdatePosterSizeInput) {
  updatePosterSize(input: $input) {
    id
    name
    images {
      id
      original_name
      url
      thumbnail_url
      uploaded
      creation_id
    }
    image_caption
  }
}
    `;
export type UpdatePosterSizeMutationFn = Apollo.MutationFunction<UpdatePosterSizeMutation, UpdatePosterSizeMutationVariables>;

/**
 * __useUpdatePosterSizeMutation__
 *
 * To run a mutation, you first call `useUpdatePosterSizeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePosterSizeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePosterSizeMutation, { data, loading, error }] = useUpdatePosterSizeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePosterSizeMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePosterSizeMutation, UpdatePosterSizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePosterSizeMutation, UpdatePosterSizeMutationVariables>(UpdatePosterSizeDocument, options);
      }
export type UpdatePosterSizeMutationHookResult = ReturnType<typeof useUpdatePosterSizeMutation>;
export type UpdatePosterSizeMutationResult = Apollo.MutationResult<UpdatePosterSizeMutation>;
export type UpdatePosterSizeMutationOptions = Apollo.BaseMutationOptions<UpdatePosterSizeMutation, UpdatePosterSizeMutationVariables>;
export const ListRegionTypesDocument = gql`
    query ListRegionTypes {
  regionTypes(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...RegionTypeFull
    }
  }
}
    ${RegionTypeFullFragmentDoc}`;

/**
 * __useListRegionTypesQuery__
 *
 * To run a query within a React component, call `useListRegionTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListRegionTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListRegionTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useListRegionTypesQuery(baseOptions?: Apollo.QueryHookOptions<ListRegionTypesQuery, ListRegionTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListRegionTypesQuery, ListRegionTypesQueryVariables>(ListRegionTypesDocument, options);
      }
export function useListRegionTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListRegionTypesQuery, ListRegionTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListRegionTypesQuery, ListRegionTypesQueryVariables>(ListRegionTypesDocument, options);
        }
export type ListRegionTypesQueryHookResult = ReturnType<typeof useListRegionTypesQuery>;
export type ListRegionTypesLazyQueryHookResult = ReturnType<typeof useListRegionTypesLazyQuery>;
export type ListRegionTypesQueryResult = Apollo.QueryResult<ListRegionTypesQuery, ListRegionTypesQueryVariables>;
export const UpdateRegionTypesDocument = gql`
    mutation updateRegionTypes($update: UpdateRegionTypesInput) {
  updateRegionTypes(input: $update) {
    ...RegionTypeFull
  }
}
    ${RegionTypeFullFragmentDoc}`;
export type UpdateRegionTypesMutationFn = Apollo.MutationFunction<UpdateRegionTypesMutation, UpdateRegionTypesMutationVariables>;

/**
 * __useUpdateRegionTypesMutation__
 *
 * To run a mutation, you first call `useUpdateRegionTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegionTypesMutation, { data, loading, error }] = useUpdateRegionTypesMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateRegionTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegionTypesMutation, UpdateRegionTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegionTypesMutation, UpdateRegionTypesMutationVariables>(UpdateRegionTypesDocument, options);
      }
export type UpdateRegionTypesMutationHookResult = ReturnType<typeof useUpdateRegionTypesMutation>;
export type UpdateRegionTypesMutationResult = Apollo.MutationResult<UpdateRegionTypesMutation>;
export type UpdateRegionTypesMutationOptions = Apollo.BaseMutationOptions<UpdateRegionTypesMutation, UpdateRegionTypesMutationVariables>;
export const RegionsMutationDocument = gql`
    mutation regionsMutation($update: UpdateRegion) {
  updateRegions(input: $update) {
    ...RegionFull
  }
}
    ${RegionFullFragmentDoc}`;
export type RegionsMutationMutationFn = Apollo.MutationFunction<RegionsMutationMutation, RegionsMutationMutationVariables>;

/**
 * __useRegionsMutationMutation__
 *
 * To run a mutation, you first call `useRegionsMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegionsMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regionsMutationMutation, { data, loading, error }] = useRegionsMutationMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useRegionsMutationMutation(baseOptions?: Apollo.MutationHookOptions<RegionsMutationMutation, RegionsMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegionsMutationMutation, RegionsMutationMutationVariables>(RegionsMutationDocument, options);
      }
export type RegionsMutationMutationHookResult = ReturnType<typeof useRegionsMutationMutation>;
export type RegionsMutationMutationResult = Apollo.MutationResult<RegionsMutationMutation>;
export type RegionsMutationMutationOptions = Apollo.BaseMutationOptions<RegionsMutationMutation, RegionsMutationMutationVariables>;
export const RegionsForListDocument = gql`
    query regionsForList($map_string: String) {
  regions(first: 1000, orderBy: [{column: "name", order: ASC}]) {
    data {
      ...RegionFull
    }
  }
}
    ${RegionFullFragmentDoc}`;

/**
 * __useRegionsForListQuery__
 *
 * To run a query within a React component, call `useRegionsForListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsForListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegionsForListQuery({
 *   variables: {
 *      map_string: // value for 'map_string'
 *   },
 * });
 */
export function useRegionsForListQuery(baseOptions?: Apollo.QueryHookOptions<RegionsForListQuery, RegionsForListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegionsForListQuery, RegionsForListQueryVariables>(RegionsForListDocument, options);
      }
export function useRegionsForListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegionsForListQuery, RegionsForListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegionsForListQuery, RegionsForListQueryVariables>(RegionsForListDocument, options);
        }
export type RegionsForListQueryHookResult = ReturnType<typeof useRegionsForListQuery>;
export type RegionsForListLazyQueryHookResult = ReturnType<typeof useRegionsForListLazyQuery>;
export type RegionsForListQueryResult = Apollo.QueryResult<RegionsForListQuery, RegionsForListQueryVariables>;
export const CampaignFinancialLookupDocument = gql`
    query campaignFinancialLookup($completion_date_between: DateRange, $start_date_between: DateRange, $status_in: [String!], $sales_team_id_in: [ID!]) {
  campaigns(
    first: 100
    completion_date_between: $completion_date_between
    start_date_between: $start_date_between
    status_in: $status_in
    sales_team_in: $sales_team_id_in
  ) {
    data {
      id
      name
      job_reference
      start_date
      status
      total_price
      purchase_order
      clientCompany(trashed: WITH) {
        id
        sales_company
        accounts_account_code
        trashed
      }
    }
  }
}
    `;

/**
 * __useCampaignFinancialLookupQuery__
 *
 * To run a query within a React component, call `useCampaignFinancialLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignFinancialLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignFinancialLookupQuery({
 *   variables: {
 *      completion_date_between: // value for 'completion_date_between'
 *      start_date_between: // value for 'start_date_between'
 *      status_in: // value for 'status_in'
 *      sales_team_id_in: // value for 'sales_team_id_in'
 *   },
 * });
 */
export function useCampaignFinancialLookupQuery(baseOptions?: Apollo.QueryHookOptions<CampaignFinancialLookupQuery, CampaignFinancialLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignFinancialLookupQuery, CampaignFinancialLookupQueryVariables>(CampaignFinancialLookupDocument, options);
      }
export function useCampaignFinancialLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignFinancialLookupQuery, CampaignFinancialLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignFinancialLookupQuery, CampaignFinancialLookupQueryVariables>(CampaignFinancialLookupDocument, options);
        }
export type CampaignFinancialLookupQueryHookResult = ReturnType<typeof useCampaignFinancialLookupQuery>;
export type CampaignFinancialLookupLazyQueryHookResult = ReturnType<typeof useCampaignFinancialLookupLazyQuery>;
export type CampaignFinancialLookupQueryResult = Apollo.QueryResult<CampaignFinancialLookupQuery, CampaignFinancialLookupQueryVariables>;
export const UpdateSiteBuildContractorDocument = gql`
    mutation updateSiteBuildContractor($update: UpdateSiteBuildContractor!) {
  updateSiteBuildContractors(input: $update) {
    ...SiteBuildContractorFull
  }
}
    ${SiteBuildContractorFullFragmentDoc}`;
export type UpdateSiteBuildContractorMutationFn = Apollo.MutationFunction<UpdateSiteBuildContractorMutation, UpdateSiteBuildContractorMutationVariables>;

/**
 * __useUpdateSiteBuildContractorMutation__
 *
 * To run a mutation, you first call `useUpdateSiteBuildContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteBuildContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteBuildContractorMutation, { data, loading, error }] = useUpdateSiteBuildContractorMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateSiteBuildContractorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteBuildContractorMutation, UpdateSiteBuildContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteBuildContractorMutation, UpdateSiteBuildContractorMutationVariables>(UpdateSiteBuildContractorDocument, options);
      }
export type UpdateSiteBuildContractorMutationHookResult = ReturnType<typeof useUpdateSiteBuildContractorMutation>;
export type UpdateSiteBuildContractorMutationResult = Apollo.MutationResult<UpdateSiteBuildContractorMutation>;
export type UpdateSiteBuildContractorMutationOptions = Apollo.BaseMutationOptions<UpdateSiteBuildContractorMutation, UpdateSiteBuildContractorMutationVariables>;
export const UpdateSiteStructureTypeDocument = gql`
    mutation updateSiteStructureType($update: UpdateSiteStructureTypesInput) {
  updateSiteStructureType(input: $update) {
    ...SiteStructureTypeFull
  }
}
    ${SiteStructureTypeFullFragmentDoc}`;
export type UpdateSiteStructureTypeMutationFn = Apollo.MutationFunction<UpdateSiteStructureTypeMutation, UpdateSiteStructureTypeMutationVariables>;

/**
 * __useUpdateSiteStructureTypeMutation__
 *
 * To run a mutation, you first call `useUpdateSiteStructureTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteStructureTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteStructureTypeMutation, { data, loading, error }] = useUpdateSiteStructureTypeMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateSiteStructureTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteStructureTypeMutation, UpdateSiteStructureTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteStructureTypeMutation, UpdateSiteStructureTypeMutationVariables>(UpdateSiteStructureTypeDocument, options);
      }
export type UpdateSiteStructureTypeMutationHookResult = ReturnType<typeof useUpdateSiteStructureTypeMutation>;
export type UpdateSiteStructureTypeMutationResult = Apollo.MutationResult<UpdateSiteStructureTypeMutation>;
export type UpdateSiteStructureTypeMutationOptions = Apollo.BaseMutationOptions<UpdateSiteStructureTypeMutation, UpdateSiteStructureTypeMutationVariables>;
export const PlanningReportDocument = gql`
    query planningReport($ids: [ID]) {
  sites(ids: $ids) {
    id
    name
    sitePlannings {
      id
      notes
      outcome_notes
      planning_date
      amount
      outcome_date
      planningStage(trashed: WITH) {
        label
      }
      planningOutcome(trashed: WITH) {
        label
      }
    }
  }
}
    `;

/**
 * __usePlanningReportQuery__
 *
 * To run a query within a React component, call `usePlanningReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningReportQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePlanningReportQuery(baseOptions?: Apollo.QueryHookOptions<PlanningReportQuery, PlanningReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningReportQuery, PlanningReportQueryVariables>(PlanningReportDocument, options);
      }
export function usePlanningReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningReportQuery, PlanningReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningReportQuery, PlanningReportQueryVariables>(PlanningReportDocument, options);
        }
export type PlanningReportQueryHookResult = ReturnType<typeof usePlanningReportQuery>;
export type PlanningReportLazyQueryHookResult = ReturnType<typeof usePlanningReportLazyQuery>;
export type PlanningReportQueryResult = Apollo.QueryResult<PlanningReportQuery, PlanningReportQueryVariables>;
export const SiteTagsDocument = gql`
    query siteTags($name: String, $ids: [ID]) {
  siteTags(
    name: $name
    ids: $ids
    first: 200
    orderBy: [{column: "name", order: ASC}]
  ) {
    data {
      id
      name
      section
      creation_id
    }
  }
}
    `;

/**
 * __useSiteTagsQuery__
 *
 * To run a query within a React component, call `useSiteTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteTagsQuery({
 *   variables: {
 *      name: // value for 'name'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useSiteTagsQuery(baseOptions?: Apollo.QueryHookOptions<SiteTagsQuery, SiteTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteTagsQuery, SiteTagsQueryVariables>(SiteTagsDocument, options);
      }
export function useSiteTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteTagsQuery, SiteTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteTagsQuery, SiteTagsQueryVariables>(SiteTagsDocument, options);
        }
export type SiteTagsQueryHookResult = ReturnType<typeof useSiteTagsQuery>;
export type SiteTagsLazyQueryHookResult = ReturnType<typeof useSiteTagsLazyQuery>;
export type SiteTagsQueryResult = Apollo.QueryResult<SiteTagsQuery, SiteTagsQueryVariables>;
export const SiteTagsFullDocument = gql`
    query siteTagsFull($name: String) {
  siteTags(
    name: $name
    first: 9000
    orderBy: [{column: "section", order: ASC}, {column: "name", order: ASC}]
  ) {
    data {
      id
      name
      section
      code
      creation_id
    }
  }
}
    `;

/**
 * __useSiteTagsFullQuery__
 *
 * To run a query within a React component, call `useSiteTagsFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteTagsFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteTagsFullQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSiteTagsFullQuery(baseOptions?: Apollo.QueryHookOptions<SiteTagsFullQuery, SiteTagsFullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteTagsFullQuery, SiteTagsFullQueryVariables>(SiteTagsFullDocument, options);
      }
export function useSiteTagsFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteTagsFullQuery, SiteTagsFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteTagsFullQuery, SiteTagsFullQueryVariables>(SiteTagsFullDocument, options);
        }
export type SiteTagsFullQueryHookResult = ReturnType<typeof useSiteTagsFullQuery>;
export type SiteTagsFullLazyQueryHookResult = ReturnType<typeof useSiteTagsFullLazyQuery>;
export type SiteTagsFullQueryResult = Apollo.QueryResult<SiteTagsFullQuery, SiteTagsFullQueryVariables>;
export const UpdateSiteTagsDocument = gql`
    mutation updateSiteTags($update: UpdateSiteTag) {
  updateSiteTags(input: $update) {
    id
    name
    section
    code
    creation_id
  }
}
    `;
export type UpdateSiteTagsMutationFn = Apollo.MutationFunction<UpdateSiteTagsMutation, UpdateSiteTagsMutationVariables>;

/**
 * __useUpdateSiteTagsMutation__
 *
 * To run a mutation, you first call `useUpdateSiteTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSiteTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSiteTagsMutation, { data, loading, error }] = useUpdateSiteTagsMutation({
 *   variables: {
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateSiteTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSiteTagsMutation, UpdateSiteTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSiteTagsMutation, UpdateSiteTagsMutationVariables>(UpdateSiteTagsDocument, options);
      }
export type UpdateSiteTagsMutationHookResult = ReturnType<typeof useUpdateSiteTagsMutation>;
export type UpdateSiteTagsMutationResult = Apollo.MutationResult<UpdateSiteTagsMutation>;
export type UpdateSiteTagsMutationOptions = Apollo.BaseMutationOptions<UpdateSiteTagsMutation, UpdateSiteTagsMutationVariables>;